/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s) {
  "use strict";
  function o(t, e) {
    let i;
    return function () {
      if (t) {
        const s = () => t.apply(this, arguments);
        clearTimeout(i), (i = setTimeout(s, e));
      }
    };
  }
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 768,
      large: 1024,
      widescreen: 1440,
    }),
    (window.theme.keyboardKeys = {
      TAB: "Tab",
      ENTER: "Enter",
      NUMPADENTER: "NumpadEnter",
      ESCAPE: "Escape",
      SPACE: "Space",
      LEFTARROW: "ArrowLeft",
      RIGHTARROW: "ArrowRight",
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const n = "body",
    r = "[data-main]",
    a = "[data-site-header]",
    l = "[data-prevent-transparent-header]",
    c = "supports-transparent-header",
    h = "data-transparent",
    d = () => {
      const t = document.querySelector(n),
        e = t.querySelector(a);
      if (!e) return;
      const i = "true" === e.getAttribute(h),
        s = t.querySelector(r).children[0];
      if (!s) return;
      const o = s.querySelector(`${l}:first-of-type`);
      window.isHeaderTransparent = i && s.classList.contains(c) && !o;
    },
    u = ".section-footer--parallax",
    p = "[data-section-type]",
    m = ":scope > [data-wave]",
    g = ".wavy:not(.site-footer)",
    f = ".parallax-shadow:not(.site-footer)",
    y = "wavy",
    v = "parallax-shadow",
    b = "parallax-rounded-corners",
    w = "section-footer--parallax",
    S = "body--rounded-corners-large",
    E = "data-parallax-wavy",
    L = (t) => {
      const e = t,
        i = document.querySelectorAll(g),
        s = document.querySelectorAll(f);
      i.forEach((t) => {
        t.classList.remove(y);
        [...t.querySelectorAll(m)].map((t) => t.remove());
      }),
        s.forEach((t) => {
          t.classList.remove(v),
            t.classList.remove(b),
            document.body.classList.remove(S);
          [...t.querySelectorAll(m)].map((t) => t.remove());
        });
      const o = document.querySelectorAll(u);
      if (o.length > 0) {
        const t = o[0].querySelector(p);
        t.hasAttribute(E) && t.classList.add(y);
      }
      e.classList.contains(w) ||
        document.dispatchEvent(new CustomEvent("theme:footer:unload"));
    };
  (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const k = window.Shopify.theme.sections.registered,
    A = window.Shopify.theme.sections.instances,
    C = { id: "data-section-id", type: "data-section-type" };
  let q = class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, i] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof i
                ? t.push(i)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(i));
            }
          });
      }
    },
    T = class {
      callFunctions(t, e = null) {
        this.callStack[t].forEach((t) => {
          const i = { id: this.id, type: this.type, container: this.container };
          e ? t.call(i, e) : t.call(i);
        });
      }
      onLoad() {
        this.callFunctions("onLoad");
      }
      onUnload() {
        this.callFunctions("onUnload");
      }
      onSelect(t) {
        this.callFunctions("onSelect", t);
      }
      onDeselect(t) {
        this.callFunctions("onDeselect", t);
      }
      onBlockSelect(t) {
        this.callFunctions("onBlockSelect", t);
      }
      onBlockDeselect(t) {
        this.callFunctions("onBlockDeselect", t);
      }
      onReorder(t) {
        this.callFunctions("onReorder", t);
      }
      constructor(t, e) {
        (this.container = (function (t) {
          if (!(t instanceof Element))
            throw new TypeError(
              "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
            );
          if (null === t.getAttribute(C.id))
            throw new Error(
              "Theme Sections: The section container provided does not have an id assigned to the " +
                C.id +
                " attribute."
            );
          return t;
        })(t)),
          (this.id = t.getAttribute(C.id)),
          (this.type = e.type),
          (this.callStack = e.getStack());
        try {
          this.onLoad();
        } catch (t) {
          console.warn(`Error in section: ${this.id}`),
            console.warn(this),
            console.warn(t);
        }
      }
    };
  function P(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== k[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const i = new q(t, e);
    return (k[t] = i), k;
  }
  function x(t, e) {
    (t = M(t)),
      void 0 === e && (e = document.querySelectorAll("[" + C.type + "]")),
      (e = D(e)),
      t.forEach(function (t) {
        const i = k[t];
        void 0 !== i &&
          (e = e.filter(function (e) {
            return (
              !(H(e).length > 0) &&
              null !== e.getAttribute(C.type) &&
              (e.getAttribute(C.type) !== t || (A.push(new T(e, i)), !1))
            );
          }));
      });
  }
  function I(t) {
    H(t).forEach(function (t) {
      var e = A.map(function (t) {
        return t.id;
      }).indexOf(t.id);
      A.splice(e, 1), t.onUnload();
    });
  }
  function H(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
    if (t instanceof Element || i instanceof Element)
      D(t).forEach(function (t) {
        e = e.concat(
          A.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof i) {
      M(t).forEach(function (t) {
        e = e.concat(
          A.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function F(t) {
    for (var e, i = 0; i < A.length; i++)
      if (A[i].id === t) {
        e = A[i];
        break;
      }
    return e;
  }
  function M(t) {
    return (
      "*" === t
        ? (t = Object.keys(k))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === T
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === T &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function D(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + C.id + '="' + e + '"]');
      !0 === window.Shopify.visualPreviewMode &&
        null === i &&
        (i = t.target.querySelector(`[${C.id}]`)),
        null !== i && x(i.getAttribute(C.type), i);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + C.id + '="' + e + '"]');
      "object" == typeof H(i)[0] &&
        H(i).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + C.id + '="' + e + '"]');
      "object" == typeof H(i)[0] && I(i);
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = F(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = F(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = F(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = F(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const O = '[data-parallax="card-scrolling"]',
    B = () => {
      setTimeout(() => {
        window.Shopify.theme.sections.instances
          .filter((t) => {
            const e = "slider" === t.type,
              i = "banner-image" === t.type,
              s = t.container.matches(O);
            return (e && s) || (i && s);
          })
          .forEach((t) => {
            I(t.id), setTimeout(() => x(t.id));
          });
      });
    };
  let z = K();
  const _ = {
      body: "body",
      main: "[data-main]",
      collectionFilters: "[data-collection-filters]",
      footer: '[data-section-type*="footer"]',
      header: "[data-header-height]",
      stickyHeader: '[data-site-header][data-position="fixed"]',
      announcementBar: "[data-announcement-bar]",
      collectionStickyBar: "[data-collection-sticky-bar]",
      logoTextLink: "[data-logo-text-link]",
    },
    $ = {
      templateCollection: "template-collection",
      templateSearch: "template-search",
      supportsTransparentHeader: "supports-transparent-header",
    };
  function R() {
    var t, e;
    const i = {};
    return (
      (i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (i.footerHeight = j(_.footer)),
      (i.headerHeight = j(_.header)),
      (i.stickyHeaderHeight = G() ? window.stickyHeaderHeight : 0),
      (i.headerInitialHeight =
        parseInt(
          (null === (t = document.querySelector(_.header)) || void 0 === t
            ? void 0
            : t.dataset.height) ||
            (null === (e = document.querySelector(_.header)) || void 0 === e
              ? void 0
              : e.offsetHeight)
        ) || 0),
      (i.announcementBarHeight = j(_.announcementBar)),
      (i.collectionStickyBarHeight = j(_.collectionStickyBar)),
      i
    );
  }
  function V() {
    document.addEventListener("theme:resize", W),
      N(),
      document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 });
  }
  function N() {
    U();
  }
  function W() {
    U(!0);
  }
  function U(t = !1) {
    const e = document.querySelector(_.body),
      i = document.querySelector(_.collectionFilters),
      s = null !== document.querySelector(_.logoTextLink);
    let {
      windowHeight: o,
      headerHeight: n,
      headerInitialHeight: r,
      announcementBarHeight: a,
      footerHeight: l,
      collectionStickyBarHeight: c,
    } = R();
    s &&
      (n = (function () {
        document.documentElement.style.setProperty("--header-height", "auto"),
          document.documentElement.style.setProperty(
            "--header-sticky-height",
            "auto"
          );
        const t = document.querySelector(_.header).offsetHeight;
        return (
          requestAnimationFrame(() => {
            document.documentElement.style.setProperty(
              "--header-height",
              `${t}px`
            ),
              document.documentElement.style.setProperty(
                "--header-sticky-height",
                `${t}px`
              );
          }),
          t
        );
      })());
    const h =
      window.isHeaderTransparent &&
      document
        .querySelector(_.main)
        .firstElementChild.classList.contains($.supportsTransparentHeader)
        ? o - a
        : o - r - a;
    let d = G() ? o - window.stickyHeaderHeight : o;
    const u = e.classList.contains($.templateCollection),
      p = e.classList.contains($.templateSearch),
      m = (u && i) || (p && i);
    if (
      (document.documentElement.style.setProperty("--footer-height", `${l}px`),
      document.documentElement.style.setProperty("--content-full", `${h}px`),
      document.documentElement.style.setProperty(
        "--content-min",
        o - n - l + "px"
      ),
      document.documentElement.style.setProperty(
        "--collection-sticky-bar-height",
        `${c}px`
      ),
      m && (d = o),
      !t)
    )
      return void document.documentElement.style.setProperty(
        "--full-height",
        `${d}px`
      );
    const g = K();
    g !== z &&
      (document.documentElement.style.setProperty("--full-height", `${d}px`),
      (z = g));
  }
  function j(t) {
    const e = document.querySelector(t);
    return e ? e.clientHeight : 0;
  }
  function G() {
    return document.querySelector(_.stickyHeader);
  }
  function K() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  const Q = {
    overflowBackground: "[data-overflow-background]",
    overflowFrame: "[data-overflow-frame]",
    overflowContent: "[data-overflow-content]",
    overflowContainer: "[data-overflow-container]",
    overflowWrapper: "[data-overflow-wrapper]",
  };
  function X(t, e) {
    let i = 0;
    e.forEach((t) => {
      i = t.offsetHeight > i ? t.offsetHeight : i;
    });
    const s = t.querySelectorAll(Q.overflowBackground);
    [t, ...s].forEach((t) => {
      t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
    });
  }
  function Y(t) {
    if (window.innerWidth < window.theme.sizes.small) {
      return void t.querySelectorAll(Q.overflowFrame).forEach((t) => {
        const e = t.querySelectorAll(Q.overflowContent);
        X(t, e);
      });
    }
    let e = 0;
    const i = t.querySelectorAll(Q.overflowFrame);
    t.querySelectorAll(Q.overflowContent).forEach((t) => {
      t.offsetHeight > e && (e = t.offsetHeight);
    });
    [...i, ...t.querySelectorAll(Q.overflowBackground)].forEach((t) => {
      t.style.setProperty("min-height", `${e}px`);
    }),
      t.style.setProperty("min-height", `${e}px`);
  }
  function J(t) {
    const e = t.querySelectorAll(Q.overflowContainer);
    e &&
      e.forEach((t) => {
        const e = t.querySelectorAll(Q.overflowContent);
        X(t, e),
          document.addEventListener("theme:resize", () => {
            X(t, e);
          });
      });
    const i = t.querySelectorAll(Q.overflowWrapper);
    i &&
      i.forEach((t) => {
        Y(t),
          document.addEventListener("theme:resize", () => {
            Y(t);
          });
      });
  }
  function Z() {
    document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      window.lastWindowWidth !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", { bubbles: !0 })
        ),
        (window.lastWindowWidth = window.innerWidth));
  }
  window.lastWindowWidth = window.innerWidth;
  let tt = window.pageYOffset,
    et = null,
    it = null,
    st = null,
    ot = null,
    nt = 0;
  const rt = {
    quickViewVisible: "js-quick-view-visible",
    cartDrawerOpen: "js-drawer-open-cart",
  };
  function at(e) {
    setTimeout(() => {
      nt && clearTimeout(nt),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function lt(t) {
    const e = t.detail;
    e ? (nt = setTimeout(ct, e)) : ct();
  }
  function ct() {
    document.body.classList.contains(rt.quickViewVisible) ||
      document.body.classList.contains(rt.cartDrawerOpen) ||
      (t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked"));
  }
  const ht = (t, e = "", i) => {
    const s = i || document.createElement("div");
    return (
      s.classList.add(e),
      s.setAttribute("data-scroll-lock-scrollable", ""),
      t.parentNode.insertBefore(s, t),
      s.appendChild(t)
    );
  };
  function dt(t) {
    t.querySelectorAll("table").forEach((t) => {
      ht(t, "table-wrapper");
    });
  }
  const ut = { loading: "is-loading", imgIn: "img-in" },
    pt = { img: "img.is-loading", section: "[data-section-type]" };
  function mt(t) {
    t.querySelectorAll(pt.img).forEach((t) => {
      if (t.complete) {
        t.classList.remove(ut.loading),
          t.parentNode.classList.remove(ut.loading);
        const e = t.closest(pt.section);
        e && e.classList.add(ut.imgIn);
      }
    });
  }
  const gt = "img",
    ft = "template",
    yt = ".shopify-section",
    vt = "[data-deferred-content]",
    bt = "[data-product-image]",
    wt = "srcset",
    St = "data-loaded",
    Et = "data-deferred-container";
  let Lt = class extends HTMLElement {
    connectedCallback() {
      0 != this.deferredTriggers.length
        ? this.deferredTriggers.forEach((t) => {
            t.addEventListener(
              "mouseenter",
              () => {
                this.hasAttribute(St) || this.loadTemplate();
              },
              { once: !0 }
            );
          })
        : this.container.addEventListener(
            "mouseenter",
            () => {
              this.hasAttribute(St) || this.loadTemplate();
            },
            { once: !0 }
          );
    }
    loadTemplate() {
      var t;
      const e = document.createElement("div"),
        i = this.querySelector(ft);
      if (
        !i ||
        !(null == i || null === (t = i.content) || void 0 === t
          ? void 0
          : t.firstElementChild)
      )
        return;
      e.appendChild(i.content.firstElementChild.cloneNode(!0));
      const s = e.querySelector(vt);
      if (!s) return;
      this.append(s), this.setAttribute(St, !0);
      s.querySelectorAll(gt).length > 0 && this.reloadSrcset(this);
    }
    reloadSrcset(t) {
      t &&
        t.querySelectorAll(gt).forEach((t) => {
          if (!t.parentNode.matches(bt)) {
            const e = t.getAttribute(wt);
            t.setAttribute(wt, ""), t.setAttribute(wt, e);
          }
        });
    }
    constructor() {
      super(),
        (this.container = this),
        this.hasAttribute(Et) &&
          (this.container =
            this.closest(this.getAttribute(Et)) || this.closest(yt)),
        (this.deferredTriggers = this.container.querySelectorAll(
          this.dataset.deferredTriggers
        ));
    }
  };
  function kt(t) {
    return new Promise((e) => {
      function i(s) {
        s.target == t &&
          (t.removeEventListener("animationend", i),
          t.removeEventListener("transitionend", i),
          e());
      }
      null == t || t.addEventListener("animationend", i),
        null == t || t.addEventListener("transitionend", i);
    });
  }
  const At = "[data-aos]",
    Ct = "[data-has-highlight]",
    qt = "[data-highlight-holder]",
    Tt = "path",
    Pt = "sup",
    xt = ".flickity-enabled",
    It = "[data-slide].is-selected",
    Ht = "[data-sticky-text]",
    Ft = "text-count-up",
    Mt = ".text-reveal__cropper",
    Dt = "data-highlight-type",
    Ot = "data-is-active",
    Bt = "is-active",
    zt = "overflow-hidden",
    _t = {
      "circle-hand-drawn": {
        keyframes: [
          { strokeDashoffset: "1", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: {
          duration: 1e3,
          delay: 0,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.7, 0, 0.3, 1)",
        },
      },
      circle: {
        keyframes: [
          { strokeDashoffset: "506", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: {
          duration: 800,
          delay: 0,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.6, 0, 0.4, 1)",
        },
      },
      highlight: {
        keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
        timing: {
          duration: 600,
          delay: 200,
          iterations: 1,
          fill: "forwards",
          easing: "ease",
          pseudoElement: "::before",
        },
        keyframesHover: [
          { transform: "scaleY(0.1)" },
          { transform: "scaleY(1)" },
        ],
      },
      "highlight-color": {
        keyframes: [
          { backgroundSize: "200% 100%", backgroundPosition: "100% 0" },
          {
            backgroundSize: "200% 100%",
            backgroundPosition: "0 0",
            offset: 0.2,
          },
          { backgroundSize: "1100% 100%", backgroundPosition: "0 0" },
        ],
        timing: {
          duration: 2e3,
          delay: 200,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0, 0, 0.9, 0.4)",
        },
      },
      "alternate-font": {
        keyframes: [{ opacity: "0" }, { opacity: "1" }],
        timing: {
          duration: 400,
          delay: 0,
          iterations: 1,
          fill: "forwards",
          easing: "ease-out",
        },
        keyframesHover: [{ opacity: "1" }, { opacity: "0.7" }],
      },
      squiggle: {
        keyframes: [{ maskPosition: "100% 0" }, { maskPosition: "0 0" }],
        timing: {
          duration: 1200,
          delay: 200,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.6, 0, 0.4, 1)",
        },
      },
      stroke: {
        keyframes: [
          { backgroundPosition: "100% 0" },
          { backgroundPosition: "0 0" },
        ],
        timing: {
          duration: 1200,
          delay: 0,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.25, 0.1, 0.9, 0.3)",
        },
      },
      underline: {
        keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
        timing: {
          duration: 900,
          delay: 200,
          iterations: 1,
          fill: "forwards",
          easing: "ease",
          pseudoElement: "::before",
        },
      },
      "underline-hand-drawn": {
        keyframes: [
          { strokeDashoffset: "1", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: {
          duration: 1e3,
          delay: 0,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.7, 0, 0.3, 1)",
        },
      },
    };
  let $t = class extends HTMLElement {
    connectedCallback() {
      (this.timeout = null),
        (this.controller = new AbortController()),
        this.type &&
          this.target &&
          ((this.animation = this.target.animate(
            _t[this.type].keyframes,
            _t[this.type].timing
          )),
          this.animation.pause(),
          this.bindAnimation("init"),
          this.bindAnimation("pause"),
          this.modifyDefaults("slider"),
          this.animation &&
            (this.link && this.listen(),
            theme.settings.animationsEnabled ||
              (this.animation.play(), this.bindAnimation("play"))));
    }
    disconnectedCallback() {
      this.controller.abort();
    }
    attributeChangedCallback(t, e, i) {
      const s = t === Ot,
        o = null === e && s,
        n = "true" === i;
      s && n && !("true" === e && "true" === i) && this.triggerAnimation(),
        o || n || this.reset();
    }
    triggerAnimation() {
      const t = this.closest(At);
      var e;
      t
        ? (null === (e = this.textRevealCropper) ||
            void 0 === e ||
            e.classList.add(zt),
          this.textCountUp
            ? (clearTimeout(this.timeout),
              (this.timeout = setTimeout(() => {
                var t;
                null === (t = this.textRevealCropper) ||
                  void 0 === t ||
                  t.classList.remove(zt),
                  this.setAnimationDelay(0),
                  this.animate();
              }, 100)))
            : kt(t).then(() => {
                var e;
                const i =
                    1e3 *
                    (
                      window
                        .getComputedStyle(t)
                        .getPropertyValue("animation-delay") || 0
                    ).replace("s", ""),
                  s = Math.max(i - 250, 0);
                null === (e = this.textRevealCropper) ||
                  void 0 === e ||
                  e.classList.remove(zt),
                  this.setAnimationDelay(s),
                  this.animate();
              }))
        : this.animate();
    }
    listen() {
      this.link.addEventListener("mouseenter", (t) => this.onMouseenter(t), {
        signal: this.controller.signal,
      }),
        this.link.addEventListener("mouseleave", (t) => this.onMouseleave(t), {
          signal: this.controller.signal,
        });
    }
    animate() {
      this.animation &&
        (this.animation.play(),
        this.bindAnimation("play"),
        (this.animation.onfinish = () => this.onFinish()));
    }
    shouldAnimate() {
      requestAnimationFrame(() => {
        let t = !0;
        Boolean(this.closest(xt)) && (t = Boolean(this.closest(It)));
        const e = this.closest(Ht);
        e && (t = Boolean(e.classList.contains(Bt))),
          this.setTriggerAttribute(t);
      });
    }
    setTriggerAttribute(t = !0) {
      this.setAttribute(Ot, t);
    }
    reset() {
      this.animation &&
        (this.animation.cancel(),
        this.bindAnimation("cancel"),
        this.setAnimationDelay(_t[this.type].timing.delay));
    }
    onMouseenter(t) {
      t.stopImmediatePropagation(),
        this.setAnimationDelay(0),
        this.modifyDefaults("mouseenter"),
        "alternate-font" !== this.type && this.animation.reverse(),
        this.bindAnimation("mouseenter");
    }
    onMouseleave(t) {
      t.stopImmediatePropagation(),
        this.modifyDefaults("mouseleave"),
        "alternate-font" !== this.type && this.animation.reverse(),
        this.bindAnimation("mouseleave");
    }
    onFinish() {
      if (this.hasAttribute(Ot)) {
        const t =
          "true" === this.getAttribute(Ot) ? 0 : _t[this.type].timing.delay;
        this.setAnimationDelay(t);
      } else this.setAnimationDelay(0);
    }
    setAnimationDelay(t = 0) {
      this.animation.effect.getTiming().delay !== t &&
        (this.animation.effect.updateTiming({ delay: t }),
        this.bindAnimation("delay"));
    }
    modifyDefaults(t = "mouseenter", e) {
      if ((e || (e = this.animation), "mouseenter" === t))
        return (
          _t[this.type].keyframesHover &&
            e.effect.setKeyframes(_t[this.type].keyframesHover),
          "highlight" === this.type &&
            e.effect.updateTiming({ duration: 350, fill: "both" }),
          "highlight-color" === this.type &&
            e.effect.updateTiming({ duration: 800 }),
          void (
            "underline" === this.type &&
            e.effect.updateTiming({ duration: 400 })
          )
        );
      if ("mouseleave" === t)
        return (
          _t[this.type].keyframesHover &&
            e.effect.setKeyframes(_t[this.type].keyframes),
          void (
            ("highlight" !== this.type &&
              "highlight-color" !== this.type &&
              "underline" !== this.type) ||
            e.effect.updateTiming({ duration: _t[this.type].timing.duration })
          )
        );
      if (
        "slider" === t &&
        (theme.settings.animationsEnabled ||
          ((_t[this.type].timing.delay = 300),
          e.effect.updateTiming({ delay: _t[this.type].timing.delay })),
        this.closest(xt))
      ) {
        const t = _t[this.type].timing.delay + 200;
        "highlight" === this.type && e.effect.updateTiming({ delay: t });
      }
    }
    bindAnimation(t = !1) {
      if (
        this.bind &&
        t &&
        ("init" === t &&
          (this.boundAnimation = this.bind.animate(
            _t[this.type].keyframes,
            _t[this.type].timing
          )),
        "pause" === t && this.boundAnimation.pause(),
        "play" === t && this.boundAnimation.play(),
        "cancel" === t && this.boundAnimation.cancel(),
        "mouseenter" === t &&
          (this.modifyDefaults("mouseenter", this.boundAnimation),
          this.boundAnimation.reverse()),
        "mouseleave" === t &&
          (this.modifyDefaults("mouseleave", this.boundAnimation),
          this.boundAnimation.reverse()),
        "delay" === t)
      ) {
        const t = this.animation.effect.getTiming().delay;
        this.boundAnimation.effect.getTiming().delay !== t &&
          this.boundAnimation.effect.updateTiming({ delay: t });
      }
    }
    constructor() {
      super(),
        (this.animation = null),
        (this.bind = null),
        (this.boundAnimation = null),
        (this.link = this.closest(Ct)),
        (this.type = this.getAttribute(Dt)),
        (this.highlightHolder = this.querySelector(qt)),
        (this.textCountUp = this.closest(Ft)),
        (this.sup = this.querySelector(Pt)),
        (this.textRevealCropper = this.closest(Mt)),
        (this.target = this.highlightHolder),
        ("circle-hand-drawn" !== this.type &&
          "circle" !== this.type &&
          "underline-hand-drawn" !== this.type) ||
          (this.target = this.querySelector(Tt)),
        ("highlight-color" !== this.type &&
          "stroke" !== this.type &&
          "alternate-font" !== this.type) ||
          (this.sup && (this.bind = this.sup));
    }
  };
  var Rt, Vt, Nt;
  (Nt = [Ot]),
    (Vt = "observedAttributes") in (Rt = $t)
      ? Object.defineProperty(Rt, Vt, {
          value: Nt,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (Rt[Vt] = Nt);
  const Wt = ".shopify-section",
    Ut = "[data-slider]",
    jt = "[data-hover-slideshow-holder]",
    Gt = "[data-hover-slideshow-item]",
    Kt = "[data-hover-slideshow-progress]",
    Qt = ".flickity-button",
    Xt = "fill";
  let Yt = class extends HTMLElement {
    get holder() {
      return this.querySelector(jt);
    }
    get items() {
      return [...this.querySelectorAll(Gt)];
    }
    get progress() {
      return this.querySelector(Kt);
    }
    connectedCallback() {
      "slideshow" !== theme.settings.productGridHover ||
        window.theme.touch ||
        this.init();
    }
    init() {
      (this.section = this.closest(Wt)),
        (this.outerSliders = this.section.querySelectorAll(Ut)),
        (this.autoplaySpeed = 2200),
        (this.timer = 0),
        (this.flkty = new e.data(this.holder)),
        !this.flkty.isActive &&
          this.items.length > 1 &&
          ((this.flkty = new e(this.holder, {
            draggable: !this.outerSliders.length,
            cellSelector: Gt,
            contain: !0,
            wrapAround: !0,
            imagesLoaded: !0,
            pageDots: !1,
            prevNextButtons: !1,
            adaptiveHeight: !1,
            pauseAutoPlayOnHover: !1,
            selectedAttraction: 0.2,
            friction: 1,
            on: {
              ready: () => {
                this.section.style.setProperty(
                  "--autoplay-speed",
                  `${this.autoplaySpeed}ms`
                ),
                  setTimeout(() => this.flkty.resize(), 1e3);
              },
              change: () => {
                this.timer && clearTimeout(this.timer),
                  this.progress.classList.remove(Xt),
                  this.progress.offsetWidth,
                  requestAnimationFrame(() => this.progress.classList.add(Xt)),
                  (this.timer = setTimeout(
                    () => this.progress.classList.remove(Xt),
                    this.autoplaySpeed
                  ));
              },
              dragEnd: () => {
                this.flkty.playPlayer();
              },
            },
          })),
          this.addEventListener("mouseenter", () => {
            this.progress.classList.add(Xt),
              this.timer && clearTimeout(this.timer),
              (this.timer = setTimeout(
                () => this.progress.classList.remove(Xt),
                this.autoplaySpeed
              )),
              (this.flkty.options.autoPlay = this.autoplaySpeed),
              this.flkty.playPlayer();
          }),
          this.addEventListener("mouseleave", () => {
            this.flkty.stopPlayer(),
              this.timer && clearTimeout(this.timer),
              this.progress.classList.remove(Xt);
          })),
        this.addEventListener("click", (t) => {
          t.target.matches(Qt) && t.preventDefault();
        });
    }
    constructor() {
      super();
    }
  };
  const Jt = "btn--top",
    Zt = "btn--right",
    te = "btn--bottom",
    ee = "btn--left",
    ie = "btn--text";
  let se = class extends HTMLElement {
    connectedCallback() {
      this.button.classList.contains(ie) ||
        this.button.addEventListener("mouseenter", this.detectEntrySide);
    }
    detectEntrySide(t) {
      const e = this.button.getBoundingClientRect();
      this.class && this.button.classList.remove(this.class);
      const i = t.clientX,
        s = t.clientY,
        o = i - e.left,
        n = e.right - i,
        r = s - e.top,
        a = e.bottom - s;
      (this.class =
        o < n && o < r && o < a
          ? ee
          : n < o && n < r && n < a
          ? Zt
          : r < o && r < n && r < a
          ? Jt
          : te),
        this.button.classList.add(this.class);
    }
    disconnectedCallback() {
      this.button.removeEventListener("mouseenter", this.detectEntrySide);
    }
    constructor() {
      super(),
        (this.button = this.parentElement),
        (this.class = ""),
        (this.detectEntrySide = this.detectEntrySide.bind(this));
    }
  };
  const oe = {
      inputSearch: 'input[type="search"]',
      inputType: 'input[name="type"]',
      form: "form",
      allVisibleElements: '[role="option"]',
      ariaSelected: '[aria-selected="true"]',
      selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
      popularSearches: "[data-popular-searches]",
      popdownBody: "[data-popdown-body]",
      mainInputSearch: "[data-main-input-search]",
      predictiveSearchResults: "[data-predictive-search-results]",
      predictiveSearch: "predictive-search",
      searchForm: "search-form",
    },
    ne = "is-searched",
    re = "template-search";
  let ae = class extends HTMLElement {
    getQuery() {
      return this.input.value.trim();
    }
    onFocus() {
      this.currentSearchTerm = this.getQuery();
    }
    onChange() {
      this.classList.toggle(ne, !this.isFormCleared()),
        (this.searchTerm = this.getQuery());
    }
    isFormCleared() {
      return 0 === this.input.value.length;
    }
    submit() {
      this.form.submit();
    }
    reset() {
      this.input.val = "";
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(oe.selectedLink)) ||
        t.preventDefault();
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    onKeyup(t) {
      switch (
        (!this.getQuery().length && this.predictiveSearch && this.close(!0),
        t.preventDefault(),
        t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    switchOption(t) {
      const e = "up" === t,
        i =
          this.classList.contains(ne) && this.predictiveSearchResults
            ? this.predictiveSearchResults
            : this.popularSearches;
      if (!i) return;
      this.selectedElement = i.querySelector(oe.ariaSelected);
      const s = Array.from(i.querySelectorAll(oe.allVisibleElements)).filter(
        (t) => null !== t.offsetParent
      );
      let o = 0;
      if (e && !this.selectedElement) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= s.length; )
        s[r] === this.selectedElement && (n = r), r++;
      !e && this.selectedElement
        ? (o = n === s.length - 1 ? 0 : n + 1)
        : e && (o = 0 === n ? s.length - 1 : n - 1),
        o !== n &&
          ((this.activeElement = s[o]), this.handleFocusableDescendants());
    }
    selectOption() {
      const t = this.querySelector(oe.selectedOption);
      t && t.click();
    }
    handleFocusableDescendants(t = !1) {
      const e = this.selectedElement
        ? this.selectedElement
        : this.querySelector(oe.ariaSelected);
      var i;
      if ((e && e.setAttribute("aria-selected", !1), !this.activeElement || t))
        return (
          (this.selectedElement = null),
          null === (i = this.activeElement) ||
            void 0 === i ||
            i.setAttribute("aria-selected", !1),
          this.input.setAttribute("aria-expanded", !1),
          void this.input.setAttribute("aria-activedescendant", "")
        );
      this.activeElement.setAttribute("aria-selected", !0),
        this.input.setAttribute("aria-activedescendant", this.activeElement.id);
    }
    constructor() {
      var t;
      super(),
        (this.input = this.querySelector(oe.inputSearch)),
        (this.form = this.querySelector(oe.form)),
        (this.popdownBody = this.closest(oe.popdownBody)),
        (this.popularSearches =
          null === (t = this.popdownBody) || void 0 === t
            ? void 0
            : t.querySelector(oe.popularSearches)),
        (this.predictiveSearchResults = this.querySelector(
          oe.predictiveSearchResults
        )),
        (this.predictiveSearch = this.matches(oe.predictiveSearch)),
        (this.searchForm = this.matches(oe.searchForm)),
        (this.selectedElement = null),
        (this.activeElement = null),
        (this.searchTerm = ""),
        (this.currentSearchTerm = ""),
        (this.isSearchPage = document.body.classList.contains(re)),
        this.input.addEventListener(
          "input",
          o((t) => {
            this.onChange(t);
          }, 300).bind(this)
        ),
        this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this)),
        this.isSearchPage &&
          ((this.mainInputType = document.querySelector(
            `${oe.mainInputSearch} ${oe.inputType}`
          )),
          (this.inputType = this.querySelector(oe.inputType)),
          (this.inputType.value = this.mainInputType.value));
    }
  };
  customElements.define("search-form", ae);
  const le = "predictive-search",
    ce = "#shopify-section-api-predictive-search",
    he = "[data-predictive-search-results]",
    de = "[data-predictive-search-status]",
    ue = "[data-predictive-search-live-region-count-value]",
    pe = "[data-search-results-wrapper]",
    me = "reset",
    ge = "data-aos-anchor",
    fe = "aria-hidden",
    ye = "open",
    ve = "loading",
    be = "data-loading-text",
    we = "results";
  customElements.define(
    "predictive-search",
    class extends ae {
      connectedCallback() {
        this.predictiveSearchResults.addEventListener("transitionend", (t) => {
          t.target !== this.predictiveSearchResults ||
            this.getQuery().length ||
            (this.classList.remove(me),
            requestAnimationFrame(() => this.clearResultsHTML()));
        });
      }
      onChange() {
        super.onChange(),
          this.classList.remove(me),
          this.searchTerm.length
            ? requestAnimationFrame(() =>
                this.getSearchResults(this.searchTerm)
              )
            : this.classList.add(me);
      }
      onFocus() {
        super.onFocus(),
          this.currentSearchTerm.length &&
            (this.searchTerm !== this.currentSearchTerm
              ? this.onChange()
              : "true" === this.getAttribute(we)
              ? this.open()
              : this.getSearchResults(this.searchTerm));
      }
      getSearchResults(t) {
        const e = t.replace(" ", "-").toLowerCase(),
          i = parseInt(window.theme.settings.suggestionsResultsLimit);
        let s = "query";
        (s += window.theme.settings.suggestArticles ? ",article" : ""),
          (s += window.theme.settings.suggestCollections ? ",collection" : ""),
          (s += window.theme.settings.suggestProducts ? ",product" : ""),
          (s += window.theme.settings.suggestPages ? ",page" : ""),
          this.setLiveRegionLoadingState(),
          this.cachedResults[e]
            ? this.renderSearchResults(this.cachedResults[e])
            : fetch(
                `${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(
                  t
                )}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`,
                { signal: this.abortController.signal }
              )
                .then((t) => {
                  if (!t.ok) {
                    var e = new Error(t.status);
                    throw (this.close(), e);
                  }
                  return t.text();
                })
                .then((t) => {
                  const i = new DOMParser()
                    .parseFromString(t, "text/html")
                    .querySelector(ce).innerHTML;
                  this.allPredictiveSearchInstances.forEach((t) => {
                    t.cachedResults[e] = i;
                  }),
                    this.renderSearchResults(i);
                })
                .catch((t) => {
                  if (20 !== (null == t ? void 0 : t.code))
                    throw (this.close(), t);
                });
      }
      switchOption(t) {
        super.switchOption(t),
          this.statusElement && (this.statusElement.textContent = "");
      }
      setLiveRegionLoadingState() {
        (this.statusElement = this.statusElement || this.querySelector(de)),
          (this.loadingText = this.loadingText || this.getAttribute(be)),
          this.setLiveRegionText(this.loadingText),
          this.setAttribute(ve, !0);
      }
      setLiveRegionText(t) {
        this.statusElement.setAttribute(fe, "false"),
          (this.statusElement.textContent = t),
          setTimeout(() => {
            this.statusElement.setAttribute(fe, "true");
          }, 1e3);
      }
      renderSearchResults(t) {
        this.predictiveSearchResults.innerHTML = t;
        const e = this.predictiveSearchResults.parentElement.id,
          i = this.predictiveSearchResults.querySelector(pe),
          s = i.id;
        (i.id = `${s}--${e}`),
          i.setAttribute(ge, `#${i.id}`),
          this.setAttribute(we, !0),
          this.setLiveRegionResults(),
          this.open();
      }
      setLiveRegionResults() {
        this.removeAttribute(ve),
          this.setLiveRegionText(this.querySelector(ue).textContent);
      }
      open() {
        this.setAttribute(ye, !0);
      }
      close(t = !1) {
        this.closeResults(t);
      }
      closeResults(t = !1) {
        t &&
          (this.reset(), this.removeAttribute(we), this.classList.remove(me)),
          this.removeAttribute(ve),
          this.removeAttribute(ye);
      }
      clearResultsHTML() {
        this.predictiveSearchResults.innerHTML = "";
      }
      constructor() {
        super(),
          (this.abortController = new AbortController()),
          (this.allPredictiveSearchInstances = document.querySelectorAll(le)),
          (this.predictiveSearchResults = this.querySelector(he)),
          (this.cachedResults = {});
      }
    }
  );
  let Se = class extends HTMLElement {
    constructor() {
      super(),
        document.addEventListener("DOMContentLoaded", () => {
          document.documentElement.classList.remove("page-loading");
        });
    }
  };
  function Ee() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }
  function Le() {
    return Ee() >= window.theme.sizes.small;
  }
  function ke() {
    return Ee() < window.theme.sizes.small;
  }
  const Ae = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
      animatable: "[data-aos], [data-aos-anchor]",
      watchMutations:
        '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop, [data-tab="resultsProducts"]',
      textHighlight: "text-highlight",
      counterUps: "text-count-up",
      flickitySlider: ".flickity-slider",
      slide: "[data-slide]",
      carouselMobile: ".carousel--mobile",
    },
    Ce = {
      aosAnimate: "aos-animate",
      isLoading: "is-loading",
      isSelected: ".is-selected",
    },
    qe = {
      aos: "data-aos",
      aosAnchor: "data-aos-anchor",
      aosIntersection: "data-aos-intersection",
      aosDebounce: "data-aos-debounce",
      aosCustomInit: "data-aos-custom-init",
      aosWatchAnchors: "data-aos-watch-anchors",
      aosTrigger: "data-aos-trigger",
      aosCarouselMobile: "data-aos-carousel-mobile",
      aosCarouselDesktop: "data-aos-carousel-desktop",
    },
    Te = 0.1,
    Pe = 0;
  let xe = new Set();
  function Ie(t) {
    t.length &&
      (t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        let i;
        "" != e && (i = document.querySelector(e)),
          i && !xe.has(t) && xe.add(i);
      }),
      xe.forEach((t) => {
        He.observe(t);
      }));
  }
  const He = new IntersectionObserver(
    (t, e) => {
      t.forEach((t) => {
        const i = t.target,
          s = t.intersectionRatio,
          o = t.isIntersecting;
        let n,
          r = Te;
        i.hasAttribute(qe.aosIntersection) &&
          (r = Number(i.getAttribute(qe.aosIntersection)));
        let a = Pe;
        i.hasAttribute(qe.aosDebounce) &&
          (a = Number(i.getAttribute(qe.aosDebounce))),
          o &&
            s > r &&
            (0 !== a
              ? (n && clearTimeout(n), (n = setTimeout(() => Fe(i), a)))
              : Fe(i),
            e.unobserve(i),
            xe.delete(i));
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1],
    }
  );
  function Fe(t) {
    if (!t) return;
    if ((Me(t), t.hasAttribute(qe.aosCarouselDesktop) && Le())) {
      if (t.querySelector(Ae.flickitySlider)) {
        const e = t.querySelectorAll(Ae.slide),
          i = [...e].filter((t) => {
            if (t.matches(Ce.isSelected)) return t;
          }),
          s = [...e].filter((t) => {
            if (!t.matches(Ce.isSelected)) return t;
          });
        if (i.length > 0) {
          const t = i[i.length - 1].id;
          i[i.length - 1].setAttribute(qe.aosTrigger, `#${t}`),
            s.forEach((e) => {
              e.querySelectorAll(Ae.animatable).forEach((e) => {
                e.setAttribute(qe.aosAnchor, `#${t}`);
              });
            });
        }
      }
    }
    if (t.hasAttribute(qe.aosCarouselMobile) && ke()) {
      const e = t.querySelector(Ae.carouselMobile);
      if (e) {
        const t = [...e.children],
          i = t[0].id;
        t.length > 1 &&
          (t[0].setAttribute(qe.aosTrigger, `#${i}`),
          t.forEach((t) => {
            t.querySelectorAll(Ae.animatable).forEach((t) => {
              t.setAttribute(qe.aosAnchor, `#${i}`);
            });
          }));
      }
    }
    if (t.hasAttribute(qe.aosTrigger)) {
      const e = t.getAttribute(qe.aosTrigger);
      document
        .querySelectorAll(`[${qe.aosAnchor}="${e}"]`)
        .forEach((t) => Me(t));
    }
    let e = t.querySelectorAll(Ae.aos);
    if (t.hasAttribute(qe.aosWatchAnchors)) {
      e = [...e].filter((e) => {
        const i =
          !!e.hasAttribute(qe.aosAnchor) && e.getAttribute(qe.aosAnchor);
        if (i && `#${t.id}` === i) return e;
      });
    }
    e.forEach((e) => {
      e.hasAttribute(qe.aosCustomInit)
        ? t.dispatchEvent(
            new CustomEvent("theme:target:animate", { bubbles: !0, detail: e })
          )
        : Me(e);
    });
  }
  function Me(t) {
    requestAnimationFrame(() => t.classList.add(Ce.aosAnimate)),
      (function (t) {
        const e = t.querySelectorAll(Ae.textHighlight);
        e.forEach((t) => t.shouldAnimate());
      })(t),
      (function (t) {
        const e = t.querySelectorAll(Ae.counterUps);
        e.forEach((t) => t.shouldAnimate());
      })(t);
  }
  function De() {
    Ie(document.querySelectorAll(Ae.aosAnchor)),
      (function () {
        const t = (t) => t instanceof HTMLElement;
        new MutationObserver((e) => {
          for (const i of e) {
            if ("childList" === !i.type) return;
            const e = i.target,
              s = [...i.addedNodes],
              o = [...i.removedNodes],
              n =
                e.matches(Ae.watchMutations) ||
                s.some((e) => !!t(e) && e.matches(Ae.watchMutations)) ||
                o.some((e) => !!t(e) && e.matches(Ae.watchMutations)),
              r =
                e.matches(Ae.animatable) ||
                s.some((e) => !!t(e) && e.matches(Ae.animatable)),
              a = null !== e.querySelector(`[${qe.aosAnchor}="#${e.id}"]`);
            (r || a || n) && Ie(e.querySelectorAll(Ae.aosAnchor));
          }
        }).observe(document.body, {
          attributes: !1,
          childList: !0,
          subtree: !0,
        });
      })();
  }
  const Oe = (t) => {
      clearTimeout(t.countUpTimeout),
        t._countUpOrigInnerHTML &&
          ((t.innerHTML = t._countUpOrigInnerHTML),
          (t._countUpOrigInnerHTML = void 0)),
        (t.style.visibility = "");
    },
    Be = (t, e = {}) => {
      const { duration: i = 1e3, delay: s = 16 } = e,
        o = i / s,
        n = t.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
        r = [];
      for (let t = 0; t < o; t++) r.push("");
      for (let t = 0; t < n.length; t++)
        if (/([0-9.][,.0-9]*[0-9]*)/.test(n[t]) && !/<[^>]+>/.test(n[t])) {
          let e = n[t];
          const i = [...e.matchAll(/[.,]/g)]
            .map((t) => ({ char: t[0], i: e.length - t.index - 1 }))
            .sort((t, e) => t.i - e.i);
          e = e.replace(/[.,]/g, "");
          let s = r.length - 1;
          for (let t = o; t >= 1; t--) {
            let n = parseInt((e / o) * t, 10);
            (n = i.reduce(
              (t, { char: e, i: i }) =>
                t.length <= i ? t : t.slice(0, -i) + e + t.slice(-i),
              n.toString()
            )),
              (r[s--] += n);
          }
        } else for (let e = 0; e < o; e++) r[e] += n[t];
      return (r[r.length] = t.toString()), r;
    };
  const ze = "data-count-up-duration",
    _e = "data-count-up-init";
  let $e = class extends HTMLElement {
    connectedCallback() {
      theme.settings.animationsEnabled || this.startCountUp();
    }
    attributeChangedCallback(t, e, i) {
      null === e && t === _e && "true" === i && this.startCountUp();
    }
    shouldAnimate() {
      requestAnimationFrame(() => this.setTriggerAttribute());
    }
    setTriggerAttribute(t = !0) {
      this.setAttribute(_e, t);
    }
    startCountUp() {
      ((t, e = {}) => {
        const { action: i = "start", duration: s = 1e3, delay: o = 16 } = e;
        if ("stop" === i) return void Oe(t);
        if ((Oe(t), !/[0-9]/.test(t.innerHTML))) return;
        const n = Be(t.innerHTML, {
          duration: s || t.getAttribute("data-duration"),
          delay: o || t.getAttribute("data-delay"),
        });
        (t._countUpOrigInnerHTML = t.innerHTML),
          (t.innerHTML = n[0] || "&nbsp;"),
          (t.style.visibility = "visible");
        const r = function () {
          (t.innerHTML = n.shift() || "&nbsp;"),
            n.length
              ? (clearTimeout(t.countUpTimeout),
                (t.countUpTimeout = setTimeout(r, o)))
              : (t._countUpOrigInnerHTML = void 0);
        };
        t.countUpTimeout = setTimeout(r, o);
      })(this, { duration: this.duration, delay: 0.016 * this.duration });
    }
    constructor() {
      super(),
        (this.container = this),
        (this.countUpDuration = this.getAttribute(ze)),
        (this.duration = (100 / parseInt(this.countUpDuration, 10)) * 1e3);
    }
  };
  !(function (t, e, i) {
    e in t
      ? Object.defineProperty(t, e, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[e] = i);
  })($e, "observedAttributes", [_e]),
    (window.requestIdleCallback =
      window.requestIdleCallback ||
      function (t) {
        var e = Date.now();
        return setTimeout(function () {
          t({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - e));
            },
          });
        }, 1);
      }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.addEventListener("resize", o(Z, 50)),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.pageYOffset;
                t > tt
                  ? ((it = !0), (et = !1))
                  : t < tt
                  ? ((it = !1), (et = !0))
                  : ((et = null), (it = null)),
                  (tt = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: et, down: it, position: t },
                      bubbles: !1,
                    })
                  ),
                  et &&
                    !st &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  it &&
                    !ot &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (ot = it),
                  (st = et);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", at),
        window.addEventListener("theme:scroll:unlock", lt);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    document.addEventListener(
      "load",
      (t) => {
        if (
          "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(ut.loading)
        ) {
          t.target.classList.remove(ut.loading),
            t.target.parentNode.classList.remove(ut.loading);
          const e = t.target.closest(pt.section);
          e && e.classList.add(ut.imgIn);
        }
      },
      !0
    );
  const Re = o(() => {
    d();
  }, 300);
  window.addEventListener("DOMContentLoaded", () => {
    V(),
      J(document),
      dt(document),
      mt(document),
      window.theme.settings.animationsEnabled && De();
  }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      window.dispatchEvent(new Event("resize"), { bubbles: !0 }),
        J(e),
        dt(e),
        V(),
        Re(),
        L(e),
        B(),
        window.theme.settings.animationsEnabled && De();
    }),
    document.addEventListener("shopify:section:reorder", (t) => {
      const e = t.target;
      Re(), L(e), B(), window.theme.settings.animationsEnabled && De();
    }),
    document.addEventListener("shopify:section:unload", (t) => {
      const e = t.target;
      Re(), L(e), B();
    }),
    customElements.get("text-highlight") ||
      customElements.define("text-highlight", $t),
    customElements.get("deferred-loading") ||
      customElements.define("deferred-loading", Lt),
    customElements.get("loading-overlay") ||
      customElements.define("loading-overlay", Se),
    customElements.get("text-count-up") ||
      customElements.define("text-count-up", $e),
    customElements.get("hover-slideshow") ||
      customElements.define("hover-slideshow", Yt),
    customElements.get("hover-button") ||
      customElements.define("hover-button", se),
    (function () {
      function t(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          s = t.getBoundingClientRect();
        return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
      }
      function e(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          s = t.getBoundingClientRect(),
          o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
          n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
        return o && n;
      }
      window.visibilityHelper = {
        isElementTotallyVisible: t,
        isElementPartiallyVisible: e,
        inViewportPartially: function (t, i) {
          function s() {
            var s = e(t);
            s != o && ((o = s), "function" == typeof i && i(s, t));
          }
          var o = e(t);
          window.addEventListener("load", s),
            window.addEventListener("resize", s),
            window.addEventListener("scroll", s);
        },
        inViewportTotally: function (e, i) {
          function s() {
            var s = t(e);
            s != o && ((o = s), "function" == typeof i && i(s, e));
          }
          var o = t(e);
          window.addEventListener("load", s),
            window.addEventListener("resize", s),
            window.addEventListener("scroll", s);
        },
      };
    })();
  const Ve = (t, e) => {
    let i, s;
    return function o(...n) {
      const r = Date.now();
      (s = clearTimeout(s)),
        !i || r - i >= e
          ? (t.apply(null, n), (i = r))
          : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
    };
  };
  function Ne(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  Ne.prototype = Error.prototype;
  const We = "[data-collapsible]",
    Ue = "toggle-ellipsis",
    je = "[data-content]",
    Ge = "[data-actions]",
    Ke = "[data-height]",
    Qe = "[data-collapsible-content]",
    Xe = "[data-collapsible-container]",
    Ye = "[data-collapsible-single]",
    Je = "[data-collapsible-trigger]",
    Ze = "is-expanded",
    ti = "is-open",
    ei = "aria-expanded",
    ii = "aria-controls",
    si = "data-collapsible-trigger-mobile",
    oi = "data-collapsible-transition-override",
    ni = 500,
    ri = {};
  let ai = class {
    init() {
      window.addEventListener("theme:resize:width", this.onResizeEvent),
        this.triggers.forEach((t) => {
          t.addEventListener("click", this.collapsibleToggleEvent),
            t.addEventListener("keyup", this.collapsibleToggleEvent);
        }),
        this.container.addEventListener("theme:ellipsis:toggle", (t) => {
          this.handleEllipsisToggle(t);
        });
    }
    handleEllipsisToggle(t) {
      const { dropdownHeight: e = 0, isExpanded: i = !1 } = t.detail,
        s = t.target.closest(We);
      if (!s) return;
      const o = s.querySelector(Je);
      if (!o) return;
      const n = o.getAttribute(ii),
        r = document.getElementById(n);
      if (!r) return;
      const a = s.querySelector(Ke),
        l = (a && parseInt(a.dataset.height, 10)) || 0;
      this.setDropdownHeight(r, i ? e : l);
    }
    collapsibleToggle(t) {
      t.preventDefault();
      const e = t.target.matches(Je) ? t.target : t.target.closest(Je),
        i = e.getAttribute(ii),
        s = document.getElementById(i),
        o = e.hasAttribute(si),
        n = e.classList.contains(Ze),
        r = t.code === theme.keyboardKeys.SPACE,
        a = t.code === theme.keyboardKeys.ESCAPE,
        l = window.innerWidth < theme.sizes.small;
      (this.isTransitioning && !this.transitionOverride) ||
        ((!t.code || r || a) &&
          ((!n && a) ||
            (o && !l) ||
            ((this.isTransitioning = !0),
            (e.disabled = !0),
            this.single && this.closeOtherItems(e),
            requestAnimationFrame(() => {
              n ? this.closeItem(s, e) : this.openItem(s, e);
            }))));
    }
    closeOtherItems(t) {
      const e = t.closest(Ye);
      this.triggers.forEach((i) => {
        if (t === i || !i.classList.contains(Ze)) return;
        const s = i.closest(Ye);
        if (e !== s) return;
        const o = document.getElementById(i.getAttribute(ii));
        requestAnimationFrame(() => this.closeItem(o, i));
      });
    }
    openItem(t, e) {
      const i = t.querySelector(Qe).offsetHeight;
      this.setDropdownHeight(t, i),
        this.handleTransitioning(t, !0),
        this.updateAttributes(e, t, !0),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    closeItem(t, e) {
      let i = t.querySelector(Qe).offsetHeight;
      this.setDropdownHeight(t, i),
        this.handleTransitioning(t, !1),
        this.updateAttributes(e, t, !1),
        requestAnimationFrame(() => {
          (i = 0), this.setDropdownHeight(t, 0);
        });
    }
    setDropdownHeight(t, e) {
      t.style.height = `${e}px`;
    }
    handleTransitioning(t, e = !1) {
      this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
        e
          ? (this.resetHeightTimer = setTimeout(() => {
              t.querySelector(Ue) || (t.style.height = "auto"),
                (this.isTransitioning = !1);
            }, ni))
          : ((this.isTransitioning = !1),
            (this.resetHeightTimer = setTimeout(() => {
              t.style.height = "";
            }, ni)));
    }
    updateAttributes(t, e, i) {
      e.setAttribute(ei, i),
        e.classList.toggle(Ze, i),
        t.setAttribute(ei, i),
        t.classList.toggle(Ze, i),
        setTimeout(() => {
          t.disabled = !1;
        }, ni);
    }
    onResize() {
      if (!this.container.querySelector(`.${Ze}`)) return;
      const t = Array.from(document.querySelectorAll(`${We}:has(.${Ze})`)),
        e = document.querySelectorAll(`${We}:has(${Ue}.${ti})`);
      t.forEach((t) => {
        const e = t.querySelector(Ue);
        (null == e ? void 0 : e.classList.contains(ti)) &&
          this.updateDropdownHeight(t);
      }),
        e.forEach((e) => {
          t.includes(e) || this.updateDropdownHeight(e, !0);
        });
    }
    onUnload() {
      this.triggers.forEach((t) => {
        t.removeEventListener("click", this.collapsibleToggleEvent),
          t.removeEventListener("keyup", this.collapsibleToggleEvent);
      }),
        window.removeEventListener("theme:resize:width", this.onResizeEvent);
    }
    constructor(t) {
      !(function (t, e, i) {
        e in t
          ? Object.defineProperty(t, e, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (t[e] = i);
      })(this, "updateDropdownHeight", (t, e = !1) => {
        const i = t.querySelector(Xe),
          s = t.querySelector(Ue),
          o = s.querySelector(Ge),
          n = s.querySelector(je).offsetHeight + 2 * o.offsetHeight;
        e || this.setDropdownHeight(i, n),
          s.style.setProperty("--height", `${n}px`);
      }),
        (this.container = t),
        (this.single = this.container.querySelector(Ye)),
        (this.triggers = this.container.querySelectorAll(Je)),
        (this.resetHeightTimer = 0),
        (this.isTransitioning = !1),
        (this.transitionOverride = this.container.hasAttribute(oi)),
        (this.collapsibleToggleEvent = (t) =>
          Ve(this.collapsibleToggle(t), 1250)),
        (this.onResizeEvent = () => this.onResize()),
        this.init();
    }
  };
  const li = {
      onLoad() {
        ri[this.id] = new ai(this.container);
      },
      onUnload() {
        ri[this.id].onUnload();
      },
    },
    ci = {
      state: {
        firstFocusable: null,
        lastFocusable: null,
        trigger: null,
        mainTrigger: null,
      },
      trapFocus: function (t) {
        var e = Array.from(
          t.container.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
          )
        ).filter(function (t) {
          var e = t.offsetWidth,
            i = t.offsetHeight;
          return (
            0 !== e &&
            0 !== i &&
            "none" !== getComputedStyle(t).getPropertyValue("display")
          );
        });
        (e = e.filter(function (t) {
          return !t.classList.contains("deferred-media__poster");
        })),
          (this.state.firstFocusable = e[0]),
          (this.state.lastFocusable = e[e.length - 1]),
          t.elementToFocus ||
            (t.elementToFocus = this.state.firstFocusable || t.container),
          this._setupHandlers(),
          document.addEventListener("focusin", this._onFocusInHandler),
          document.addEventListener("focusout", this._onFocusOutHandler),
          t.container.setAttribute("tabindex", "-1"),
          t.elementToFocus.focus();
      },
      removeTrapFocus: function (t) {
        const e = !document.body.classList.contains("no-outline");
        t && t.container && t.container.removeAttribute("tabindex"),
          document.removeEventListener("focusin", this._onFocusInHandler),
          this.state.trigger && e && this.state.trigger.focus();
      },
      _manageFocus: function (t) {
        t.code === theme.keyboardKeys.TAB &&
          (t.target !== this.state.lastFocusable ||
            t.shiftKey ||
            (t.preventDefault(), this.state.firstFocusable.focus()),
          t.target === this.state.firstFocusable &&
            t.shiftKey &&
            (t.preventDefault(), this.state.lastFocusable.focus()));
      },
      _onFocusOut: function () {
        document.removeEventListener("keydown", this._manageFocusHandler);
      },
      _onFocusIn: function (t) {
        (t.target !== this.state.lastFocusable &&
          t.target !== this.state.firstFocusable) ||
          document.addEventListener("keydown", this._manageFocusHandler);
      },
      _setupHandlers: function () {
        this._onFocusInHandler ||
          (this._onFocusInHandler = this._onFocusIn.bind(this)),
          this._onFocusOutHandler ||
            (this._onFocusOutHandler = this._onFocusIn.bind(this)),
          this._manageFocusHandler ||
            (this._manageFocusHandler = this._manageFocus.bind(this));
      },
    };
  const hi = {};
  function di(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return hi[t.url]
        ? hi[t.url]
        : (function (t, e) {
            const i = new Promise((i, s) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      i(t);
                    })
                    .catch((t) => {
                      s(t);
                    })
                : (function (t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? i()
                            : ((o = !0), e());
                        }),
                      s.appendChild(n);
                  })(
                    t,
                    function () {
                      i();
                    },
                    function () {
                      s();
                    }
                  );
            });
            return (hi[t] = i), i;
          })(t.url, t.type);
    if (t.json)
      return hi[t.json]
        ? Promise.resolve(hi[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((hi[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return hi[e]
        ? hi[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              i = new Promise((e, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, i) {
                          i ? e(i) : t();
                        })(e, i, t);
                      },
                    },
                  ]);
                } catch (t) {
                  i(t);
                }
              });
            return (hi[e] = i), i;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const ui = "[data-video-id]",
    pi = "loaded",
    mi = "data-enable-sound",
    gi = "data-enable-background",
    fi = "data-enable-autoplay",
    yi = "data-enable-loop",
    vi = "data-video-id",
    bi = "data-video-type";
  const wi = {
      videoIframe: "[data-video-id]",
      videoWrapper: ".video-wrapper",
      youtubeWrapper: "[data-youtube-wrapper]",
    },
    Si = "data-section-id",
    Ei = "data-enable-sound",
    Li = "data-check-player-visibility",
    ki = "data-video-id",
    Ai = "data-video-type",
    Ci = "loaded",
    qi = [];
  const Ti = "[data-notification-form]",
    Pi = "[data-notification]",
    xi = "[data-popup-close]",
    Ii = "pswp--success",
    Hi = "notification-popup-visible";
  function Fi(t) {
    const i = e.data(t);
    i &&
      (i.on("dragStart", (t, e) => {
        document.ontouchmove = function (t) {
          t.preventDefault();
        };
      }),
      i.on("dragEnd", (t, e) => {
        document.ontouchmove = function (t) {
          return !0;
        };
      }));
  }
  const Mi = "html5",
    Di = "youtube",
    Oi = "vimeo",
    Bi = "[data-deferred-media]",
    zi = "[data-deferred-media-button]",
    _i = "[data-product-single-media-wrapper]",
    $i = "[data-video]",
    Ri = ".media--hidden",
    Vi = "media--hidden",
    Ni = "loaded",
    Wi = "data-section-id",
    Ui = "data-autoplay-video",
    ji = "data-media-id";
  let Gi = class {
    init() {
      this.container.querySelectorAll($i).forEach((t) => {
        const e = t.querySelector(zi);
        e && e.addEventListener("click", this.loadContent.bind(this, t)),
          this.autoplayVideo && this.loadContent(t);
      });
    }
    loadContent(t) {
      if (t.querySelector(Bi).getAttribute(Ni)) return;
      const e = document.createElement("div");
      e.appendChild(
        t.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
      const i = t.dataset.mediaId,
        s = e.querySelector("video, iframe"),
        o = this.hostFromVideoElement(s),
        n = t.querySelector(Bi);
      n.appendChild(s),
        n.setAttribute("loaded", !0),
        (this.players[i] = {
          mediaId: i,
          sectionId: this.id,
          container: t,
          element: s,
          host: o,
          ready: () => {
            this.createPlayer(i);
          },
        });
      const r = this.players[i];
      switch (r.host) {
        case Mi:
          this.loadVideo(r, Mi);
          break;
        case Oi:
          window.isVimeoAPILoaded
            ? this.loadVideo(r, Oi)
            : di({ url: "https://player.vimeo.com/api/player.js" }).then(() =>
                this.loadVideo(r, Oi)
              );
          break;
        case Di:
          window.isYoutubeAPILoaded
            ? this.loadVideo(r, Di)
            : di({ url: "https://www.youtube.com/iframe_api" }).then(() =>
                this.loadVideo(r, Di)
              );
      }
    }
    hostFromVideoElement(t) {
      if ("VIDEO" === t.tagName) return Mi;
      if ("IFRAME" === t.tagName) {
        if (
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            t.src
          )
        )
          return Di;
        if (t.src.includes("vimeo.com")) return Oi;
      }
      return null;
    }
    loadVideo(t, e) {
      t.host === e && t.ready();
    }
    createPlayer(t) {
      const e = this.players[t];
      switch (e.host) {
        case Mi:
          e.element.addEventListener("play", () => {
            e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            });
          }),
            e.element.addEventListener("pause", () => {
              e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                bubbles: !0,
              });
            }),
            this.autoplayVideo && this.observeVideo(e, t);
          break;
        case Oi:
          (e.player = new Vimeo.Player(e.element)),
            e.player.play(),
            e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            }),
            (window.isVimeoAPILoaded = !0),
            e.player.on("play", () => {
              e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                bubbles: !0,
              });
            }),
            e.player.on("pause", () => {
              e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                bubbles: !0,
              });
            }),
            this.autoplayVideo && this.observeVideo(e, t);
          break;
        case Di:
          if (e.host == Di && e.player) return;
          YT.ready(() => {
            const i = e.container.dataset.videoId;
            (e.player = new YT.Player(e.element, {
              videoId: i,
              events: {
                onReady: (t) => {
                  t.target.playVideo(),
                    e.container.dispatchEvent(
                      new CustomEvent("theme:media:play"),
                      { bubbles: !0 }
                    );
                },
                onStateChange: (t) => {
                  1 == t.data &&
                    e.container.dispatchEvent(
                      new CustomEvent("theme:media:play"),
                      { bubbles: !0 }
                    ),
                    2 == t.data &&
                      e.container.dispatchEvent(
                        new CustomEvent("theme:media:pause"),
                        { bubbles: !0 }
                      ),
                    0 == t.data &&
                      e.container.dispatchEvent(
                        new CustomEvent("theme:media:pause"),
                        { bubbles: !0 }
                      );
                },
              },
            })),
              (window.isYoutubeAPILoaded = !0),
              this.autoplayVideo && this.observeVideo(e, t);
          });
      }
      e.container.addEventListener("theme:media:visible", (t) =>
        this.onVisible(t)
      ),
        e.container.addEventListener("theme:media:hidden", (t) =>
          this.onHidden(t)
        ),
        e.container.addEventListener("xrLaunch", (t) => this.onHidden(t));
    }
    observeVideo(t) {
      new IntersectionObserver(
        (e, i) => {
          e.forEach((e) => {
            const i = 0 == e.intersectionRatio,
              s = !t.element.closest(Ri);
            i ? this.pauseVideo(t) : s && this.playVideo(t);
          });
        },
        { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] }
      ).observe(t.element);
    }
    playVideo(t) {
      t.player && t.player.playVideo
        ? t.player.playVideo()
        : t.element && t.element.play
        ? t.element.play()
        : t.player && t.player.play && t.player.play(),
        t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
          bubbles: !0,
        });
    }
    pauseVideo(t) {
      if (t.player && t.player.pauseVideo)
        "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
      else if (t.player && t.player.pause) t.player.pause();
      else if (t.element && !t.element.paused) {
        var e;
        if ("function" == typeof t.element.pause)
          null === (e = t.element) || void 0 === e || e.pause();
      }
    }
    onHidden(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        this.pauseVideo(i);
      }
    }
    onVisible(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        setTimeout(() => {
          this.playVideo(i);
        }, 50),
          this.pauseContainerMedia(e);
      }
    }
    pauseOtherMedia(t, e) {
      const i = `[${ji}="${t}"]`,
        s = e.querySelectorAll(`${_i}:not(${i})`);
      s.length &&
        s.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            t.classList.add(Vi);
        });
    }
    constructor(t) {
      (this.container = t),
        (this.id = this.container.getAttribute(Wi)),
        (this.autoplayVideo = "true" === this.container.getAttribute(Ui)),
        (this.players = {}),
        (this.pauseContainerMedia = (t, e = this.container) =>
          this.pauseOtherMedia(t, e)),
        this.init();
    }
  };
  function Ki(t, e, i = [], s = !1) {
    const o = new FormData(t),
      n = new URLSearchParams(o);
    if (!e) return n.toString();
    const r = new FormData(e),
      a = new URLSearchParams(r),
      l = [];
    for (const t of o.entries()) "" === t[1] && l.push(t[0]);
    for (const t of r.entries()) "" === t[1] && l.push(t[0]);
    for (let t = 0; t < l.length; t++) {
      const e = l[t];
      n.has(e) && n.delete(e), a.has(e) && a.delete(e);
    }
    for (const t of n.keys()) a.has(t) && a.delete(t);
    if (i.length > 0)
      for (let t = 0; t < i.length; t++) {
        const e = i[t];
        n.has(e) && n.delete(e), a.has(e) && a.delete(e);
      }
    return (
      s && (a.has("type") && a.delete("type"), n.set("type", s)),
      `${n.toString()}&${a.toString()}`
    );
  }
  const Qi = "[data-custom-scrollbar]",
    Xi = "[data-custom-scrollbar-items]",
    Yi = "[data-custom-scrollbar-thumb]",
    Ji = ".current";
  let Zi = class {
    calculateTrack(t) {
      if (!t)
        return (
          this.scrollbar.style.setProperty("--thumb-scale", 0),
          void this.scrollbar.style.setProperty("--thumb-position", "0px")
        );
      const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
        i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
      this.scrollbar.style.setProperty("--thumb-scale", e),
        this.scrollbar.style.setProperty(
          "--thumb-position",
          this.trackWidth * i + "px"
        );
    }
    calculateScrollbar() {
      if (this.scrollbarItems.children.length) {
        const t = [...this.scrollbarItems.children];
        (this.trackWidth = 0),
          t.forEach((t) => {
            this.trackWidth +=
              t.getBoundingClientRect().width +
              parseInt(window.getComputedStyle(t).marginRight);
          }),
          this.scrollbar.style.setProperty(
            "--track-width",
            `${this.trackWidth}px`
          );
      }
    }
    onScrollbarChange(t) {
      t &&
        t.detail &&
        t.detail.element &&
        this.container.contains(t.detail.element) &&
        this.calculateTrack(t.detail.element);
    }
    events() {
      document.addEventListener("theme:resize:width", this.calcScrollbarEvent),
        document.addEventListener(
          "theme:custom-scrollbar:change",
          this.onScrollbarChangeEvent
        );
    }
    unload() {
      document.removeEventListener(
        "theme:resize:width",
        this.calcScrollbarEvent
      ),
        document.removeEventListener(
          "theme:custom-scrollbar:change",
          this.onScrollbarChangeEvent
        );
    }
    constructor(t) {
      (this.container = t),
        (this.scrollbarItems = t.querySelector(Xi)),
        (this.scrollbar = t.querySelector(Qi)),
        (this.scrollbarThumb = t.querySelector(Yi)),
        (this.trackWidth = 0),
        (this.calcScrollbarEvent = () => this.calculateScrollbar()),
        (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
        this.scrollbar &&
          this.scrollbarItems &&
          (this.events(),
          this.calculateScrollbar(),
          this.scrollbarItems.children.length &&
            this.calculateTrack(this.scrollbarItems.querySelector(Ji)));
    }
  };
  const ts = "[data-tooltip]",
    es = "[data-tooltip-container]",
    is = "[data-aos]",
    ss = "tooltip-default",
    os = "is-animating",
    ns = "is-visible",
    rs = "is-hiding",
    as = "data-aos",
    ls = "data-tooltip",
    cs = "data-tooltip-container",
    hs = "data-tooltip-stop-mouseenter",
    ds = {};
  let us = class {
    init() {
      if (!document.querySelector(es)) {
        const t = `<div class="${this.rootClass}__arrow"></div><div class="${this.rootClass}__inner"><div class="${this.rootClass}__text label-typography"></div></div>`,
          e = document.createElement("div");
        (e.className = `${this.rootClass} ${this.isAnimatingClass}`),
          e.setAttribute(cs, ""),
          (e.innerHTML = t),
          document.body.appendChild(e);
      }
      this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent);
      const t = document.querySelector(es);
      theme.settings.animationsEnabled &&
        this.animatedContainer &&
        ("hero" === this.animatedContainer.getAttribute(as)
          ? this.animatedContainer.addEventListener("animationend", () => {
              t.classList.remove(os);
            })
          : this.animatedContainer.addEventListener("transitionend", (e) => {
              "transform" === e.propertyName && t.classList.remove(os);
            }));
    }
    addPin(t = !1) {
      const e = document.querySelector(es);
      if (e && ((t && !this.tooltip.hasAttribute(hs)) || !t)) {
        const t = e.querySelector(`.${this.rootClass}__arrow`),
          i = e.querySelector(`.${this.rootClass}__inner`),
          s = e.querySelector(`.${this.rootClass}__text`);
        this.label.includes("ß") &&
          (this.label = this.label.replace(
            /ß/g,
            '<span style="text-transform: lowercase;">ß</span>'
          )),
          (s.innerHTML = this.label);
        const o = i.offsetWidth,
          n = this.tooltip.getBoundingClientRect(),
          r = n.top,
          a = n.width,
          l = r + n.height + window.scrollY;
        let c = n.left - o / 2 + a / 2;
        const h = 24,
          d = c + o - Ee() + h;
        d > 0 && (c -= d),
          c < 0 && (c = 0),
          (t.style.left = `${n.left + a / 2}px`),
          e.style.setProperty("--tooltip-top", `${l}px`),
          (i.style.transform = `translateX(${c}px)`),
          e.classList.remove(rs);
        const u = (t) => {
          t.target === i &&
            (("transform" !== t.propertyName && "opacity" !== t.propertyName) ||
              requestAnimationFrame(
                () => (e.style.transform = "translate(0, -100%)")
              ),
            e.removeEventListener("transitionend", u));
        };
        e.addEventListener("transitionend", u),
          e.classList.add(ns),
          document.addEventListener("theme:scroll", this.removePinEvent);
      }
    }
    removePin(t, e = !1, i = !1) {
      const s = document.querySelector(es),
        o = s.classList.contains(ns);
      s &&
        ((e && !this.tooltip.hasAttribute(hs)) || !e) &&
        (o &&
          (i || t.detail.hideTransition) &&
          (s.classList.add(rs),
          this.hideTransitionTimeout &&
            clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            s.classList.remove(rs);
          }, this.transitionSpeed))),
        s.classList.remove(ns),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener(
          "mouseleave",
          this.removePinMouseEvent
        ),
        this.tooltip.removeEventListener(
          "theme:tooltip:init",
          this.addPinEvent
        ),
        document.removeEventListener(
          "theme:tooltip:close",
          this.removePinEvent
        ),
        document.removeEventListener("theme:scroll", this.removePinEvent);
    }
    constructor(t) {
      (this.tooltip = t),
        this.tooltip.hasAttribute(ls) &&
          ((this.rootClass = ss),
          (this.isAnimatingClass = os),
          (this.label = this.tooltip.getAttribute(ls)),
          (this.transitionSpeed = 200),
          (this.hideTransitionTimeout = 0),
          (this.animatedContainer = this.tooltip.closest(is)),
          (this.addPinEvent = () => this.addPin()),
          (this.addPinMouseEvent = () => this.addPin(!0)),
          (this.removePinEvent = (t) => Ve(this.removePin(t), 50)),
          (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
          this.init());
    }
  };
  const ps = {
      onLoad() {
        ds[this.id] = [];
        this.container.querySelectorAll(ts).forEach((t) => {
          ds[this.id].push(new us(t));
        });
      },
      onUnload() {
        ds[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    ms = "[data-range-slider]",
    gs = "[data-range-left]",
    fs = "[data-range-right]",
    ys = "[data-range-line]",
    vs = "[data-range-holder]",
    bs = "data-se-min",
    ws = "data-se-max",
    Ss = "data-se-min-value",
    Es = "data-se-max-value",
    Ls = "data-se-step",
    ks = "data-range-filter-update",
    As = "[data-field-price-min]",
    Cs = "[data-field-price-max]",
    qs = "is-initialized";
  function Ts() {
    this.entries = [];
  }
  function Ps(t, e) {
    xs(t);
    var i = (function (t, e) {
      xs(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var i = [];
      return (
        e.forEach(function (e) {
          for (var s = 0; s < t.options.length; s++) {
            if (
              (t.options[s].name || t.options[s]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              i[s] = e.value;
              break;
            }
          }
        }),
        i
      );
    })(t, e);
    return (function (t, e) {
      xs(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e);
      var i = t.variants.filter(function (t) {
        return e.every(function (e, i) {
          return t.options[i] === e;
        });
      });
      return i[0] || null;
    })(t, i);
  }
  function xs(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  (Ts.prototype.add = function (t, e, i) {
    this.entries.push({ element: t, event: e, fn: i }),
      t.addEventListener(e, i);
  }),
    (Ts.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var Is = '[name="id"]',
    Hs = '[name="selling_plan"]',
    Fs = '[name^="options"]',
    Ms = '[name="quantity"]',
    Ds = '[name^="properties"]';
  const Os = { color: "ash" },
    Bs = "[data-swatch]",
    zs = "[data-product-block]",
    _s = "[data-product-image-hover]",
    $s = "[data-button-quick-view]",
    Rs = "[data-grid-image]",
    Vs = "[data-grid-link]",
    Ns = "[data-swatches-more]",
    Ws = "[data-section-type]",
    Us = "[data-swatches-container]",
    js = "[data-swatches-label]",
    Gs = "[data-swatches-button]",
    Ks = "[data-option-position]",
    Qs = "[data-slider]",
    Xs = ".variant__labels--hide",
    Ys = {
      mediaVisible: "product__media--featured-visible",
      mediaHoverVisible: "product__media__hover-img--visible",
      noImage: "swatch__link--no-image",
      noOutline: "no-outline",
      isVisible: "is-visible",
      selectorLarge: "selector-wrapper--large",
    },
    Js = "data-swatch",
    Zs = "data-swatch-handle",
    to = "data-swatch-label",
    eo = "data-swatch-image",
    io = "data-swatch-image-id",
    so = "data-swatch-variant",
    oo = "data-variant-id",
    no = "data-variant-secondary-id";
  let ro = {};
  const ao = {};
  let lo = class {
      init() {
        this.setStyles(),
          this.variant && this.outer && this.handleClicks(),
          !this.image &&
            this.swatchLink &&
            this.swatchLink.classList.add(Ys.noImage);
      }
      setStyles() {
        "native" == window.theme.settings.colorSwatchesType ||
          (this.colorMatch &&
            this.colorMatch.hex &&
            this.element.style.setProperty(
              "--swatch",
              `${this.colorMatch.hex}`
            ),
          this.colorMatch &&
            this.colorMatch.path &&
            this.element.style.setProperty(
              "background-image",
              `url(${this.colorMatch.path})`
            ));
      }
      handleClicks() {
        this.swatchLink.addEventListener("click", (t) => {
          const e = !document.body.classList.contains(Ys.noOutline),
            i = this.swatchLink.getAttribute(so);
          e || (t.preventDefault(), this.updateImagesAndLinksOnEvent(i));
        }),
          this.swatchLink.addEventListener("keyup", (t) => {
            const e = !document.body.classList.contains(Ys.noOutline),
              i = this.swatchLink.getAttribute(so);
            (t.code !== theme.keyboardKeys.ENTER &&
              t.code !== theme.keyboardKeys.NUMPADENTER) ||
              e ||
              (t.preventDefault(),
              this.swatchLink.dispatchEvent(
                new Event("mouseenter", { bubbles: !0 })
              ),
              this.updateImagesAndLinksOnEvent(i));
          });
      }
      updateImagesAndLinksOnEvent(t) {
        this.updateLinks(), this.replaceImages(t);
      }
      updateLinks() {
        (this.linkElements = this.outer.querySelectorAll(Vs)),
          (this.quickView = this.outer.querySelector($s)),
          this.linkElements.length &&
            this.linkElements.forEach((t) => {
              const e =
                ((i = t.getAttribute("href")),
                (s = this.variant),
                /variant=/.test(i)
                  ? i.replace(/(variant=)[^&]+/, "$1" + s)
                  : /\?/.test(i)
                  ? i.concat("&variant=").concat(s)
                  : i.concat("?variant=").concat(s));
              var i, s;
              t.setAttribute("href", e);
            }),
          this.quickView &&
            "quick_buy" === theme.settings.quickBuy &&
            this.quickView.setAttribute(oo, this.variant);
      }
      replaceImages(t) {
        const e = this.outer.querySelector(`[${no}="${t}"]`),
          i = this.outer.querySelector(`[${oo}="${t}"]`),
          s = [...this.outer.querySelectorAll(Rs)].find((t) =>
            t.classList.contains(Ys.mediaVisible)
          );
        if (i && this.imageId) {
          if (!e || !s) return;
          const t = () => {
            requestAnimationFrame(() => {
              s.classList.remove(Ys.mediaVisible),
                i.classList.add(Ys.mediaVisible),
                requestAnimationFrame(() => {
                  e.classList.remove(Ys.mediaVisible);
                });
            }),
              e.removeEventListener("animationend", t);
          };
          requestAnimationFrame(() => {
            e.classList.add(Ys.mediaVisible);
          }),
            e.addEventListener("animationend", t);
        }
        "image" === theme.settings.productGridHover &&
          (this.hoverImages = this.outer.querySelectorAll(_s)),
          this.hoverImages.length > 1 &&
            this.hoverImages.forEach((t) => {
              t.classList.remove(Ys.mediaHoverVisible),
                t.getAttribute(oo) === this.variant
                  ? t.classList.add(Ys.mediaHoverVisible)
                  : this.hoverImages[0].classList.add(Ys.mediaHoverVisible);
            });
      }
      constructor(t) {
        (this.element = t),
          (this.swatchLink = this.element.nextElementSibling),
          (this.colorString = t.getAttribute(Js)),
          (this.image = this.element.getAttribute(eo)),
          (this.imageId = this.element.getAttribute(io)),
          (this.variant = this.element.getAttribute(so)),
          (this.outer = this.element.closest(zs)),
          (this.hoverImages = []);
        const e = new (class {
          getColor() {
            return this.match;
          }
          init() {
            return di({ json: theme.assets.swatches })
              .then((t) => this.matchColors(t, this.settings.color))
              .catch((t) => {
                console.log("failed to load swatch colors script"),
                  console.log(t);
              });
          }
          matchColors(t, e) {
            let i = "#E5E5E5",
              s = null;
            const o = theme.assets.base || "/",
              n = e.toLowerCase().replace(/\s/g, ""),
              r = t.colors;
            if (r) {
              let t = null;
              if (
                r.filter((e, i) => {
                  if (
                    Object.keys(e)
                      .toString()
                      .toLowerCase()
                      .replace(/\s/g, "") === n
                  )
                    return (t = i), e;
                }).length &&
                null !== t
              ) {
                const e = Object.values(r[t])[0];
                (i = e),
                  (e.includes(".jpg") ||
                    e.includes(".jpeg") ||
                    e.includes(".png") ||
                    e.includes(".svg")) &&
                    ((s = `${o}${e}`), (i = "#888888"));
              }
            }
            return { color: this.settings.color, path: s, hex: i };
          }
          constructor(t = {}) {
            (this.settings = { ...Os, ...t }), (this.match = this.init());
          }
        })({ color: this.colorString });
        e.getColor().then((t) => {
          (this.colorMatch = t), this.init();
        });
      }
    },
    co = class extends HTMLElement {
      init() {
        (this.swatchElements = this.querySelectorAll(Bs)),
          this.swatchElements.forEach((t) => {
            new lo(t);
          }),
          this.handleShowMore();
      }
      handleShowMore() {
        (this.initialHeight = this.offsetHeight),
          (this.expandedHeight = this.initialHeight);
        const t = this.closest(Ws),
          e = this.querySelector(Ns);
        e &&
          (null == e ||
            e.addEventListener("click", () => {
              this.classList.add(Ys.isVisible);
            }),
          null == t ||
            t.addEventListener("touchstart", (t) => {
              this.contains(t.target) ||
                (this.classList.remove(Ys.isVisible),
                this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
            }),
          this.addEventListener("mouseenter", () => {
            const t = (e) => {
              this.expandedHeight = this.offsetHeight;
              const i = e.target.closest(Qs);
              this.expandedHeight > this.initialHeight &&
                i &&
                requestAnimationFrame(() =>
                  i.dispatchEvent(
                    new CustomEvent("theme:slider:resize", { bubbles: !1 })
                  )
                ),
                this.removeEventListener("animationstart", t);
            };
            this.addEventListener("animationstart", t);
          }),
          this.addEventListener("mouseleave", () => {
            const t = (e) => {
              const i = e.target.closest(Qs);
              this.expandedHeight > this.initialHeight &&
                i &&
                requestAnimationFrame(() =>
                  i.dispatchEvent(
                    new CustomEvent("theme:slider:resize", { bubbles: !1 })
                  )
                ),
                this.removeEventListener("animationstart", t);
            };
            this.addEventListener("animationstart", t);
          }));
      }
      constructor() {
        super(),
          (this.handle = this.getAttribute(Zs)),
          (this.label = this.getAttribute(to).trim().toLowerCase()),
          (function (t) {
            const e = `${theme.routes.root}products/${t}.js`;
            return window
              .fetch(e)
              .then((t) => t.json())
              .catch((t) => {
                console.error(t);
              });
          })(this.handle).then((t) => {
            (this.product = t),
              (this.colorOption = t.options.find(
                (t) => t.name.toLowerCase() === this.label || null
              )),
              this.colorOption &&
                ((this.swatches = this.colorOption.values), this.init());
          });
      }
    },
    ho = class {
      checkSwatchesHeight(t) {
        const e = t.querySelector(js),
          i = Boolean(e.closest(Xs)),
          s = i ? 1 : e.offsetHeight,
          o = t.querySelector(Gs),
          n = parseInt(
            window.getComputedStyle(t).getPropertyValue("padding-top")
          ),
          r = i
            ? 0
            : parseInt(
                window.getComputedStyle(e).getPropertyValue("margin-bottom")
              ),
          a = parseInt(
            window.getComputedStyle(o).getPropertyValue("margin-bottom")
          ),
          l = t.closest(Ks);
        l.classList.remove(Ys.selectorLarge, Ys.selectorVisible),
          t.style.removeProperty("--swatches-max-height"),
          requestAnimationFrame(() => {
            t.offsetHeight - n > s + r + 2 * o.offsetHeight + 2 * a &&
              (t.style.setProperty(
                "--swatches-max-height",
                `${t.offsetHeight}px`
              ),
              l.classList.add(Ys.selectorLarge));
          });
      }
      onUnload() {
        this.swatchesContainers.forEach((t) => {
          document.removeEventListener(
            "theme:resize:width",
            this.checkSwatchesHeightOnResize
          );
        });
      }
      constructor(t) {
        (this.container = t),
          (this.swatchesContainers = this.container.querySelectorAll(Us)),
          this.swatchesContainers.forEach((t) => {
            (this.checkSwatchesHeightOnResize = () =>
              this.checkSwatchesHeight(t)),
              this.checkSwatchesHeight(t),
              document.addEventListener(
                "theme:resize:width",
                this.checkSwatchesHeightOnResize
              );
          });
      }
    };
  const uo = (t) => {
      ro = [];
      t.querySelectorAll(Bs).forEach((t) => {
        ro.push(new lo(t));
      });
    },
    po = {
      onLoad() {
        uo(this.container);
      },
    },
    mo = {
      onLoad() {
        ao[this.id] = new ho(this.container);
      },
      onUnload() {
        ao[this.id].onUnload();
      },
    },
    go = "[data-product]",
    fo = "[data-popup-close]",
    yo = "js-quick-view-visible",
    vo = {};
  let bo = class {
    popupClose() {
      const t = document.querySelector(go);
      if (t) {
        t.querySelector(fo).dispatchEvent(new Event("click"));
      }
    }
    onBlockSelect() {
      this.body.classList.contains(yo) && this.popupClose();
    }
    onDeselect() {
      this.body.classList.contains(yo) && this.popupClose();
    }
    onUnload() {
      this.body.classList.contains(yo) && this.popupClose();
    }
    constructor(t) {
      (this.container = t), (this.body = document.body), new eh(this.container);
    }
  };
  const wo = {
      onLoad() {
        vo[this.id] = new bo(this.container);
      },
      onBlockSelect() {
        vo[this.id].onBlockSelect();
      },
      onDeselect() {
        vo[this.id].onDeselect();
      },
      onUnload() {
        vo[this.id].onUnload();
      },
    },
    So = "#AjaxinateLoop",
    Eo = "#AjaxinatePagination",
    Lo = "[data-product-block]",
    ko = "[data-promo]",
    Ao = "data-ajaxinate-id",
    Co = "data-columns-tablet",
    qo = "data-columns-mobile",
    To = "is-loaded",
    Po = "loaded-item",
    xo = "collection-promo--full",
    Io = "collection-promo--two-columns",
    Ho = "collection-promo--grid-second",
    Fo = "collection-promo--grid-third",
    Mo = "collection-promo--grid-even",
    Do = "collection-promo--one-column";
  let Oo = {},
    Bo = class {
      init() {
        this.loadMoreFix(),
          (this.ajaxinateContainer = this.container.querySelectorAll(So)),
          this.ajaxinateContainer.forEach((t) => {
            const e = `${So}[${Ao}="${t.dataset.ajaxinateId}"]`,
              i = `${Eo}[${Ao}="${t.dataset.ajaxinateId}"]`;
            if (t.children.length > 0) {
              const o = new s({
                  container: e,
                  pagination: i,
                  method: "scroll",
                }),
                n = t.querySelectorAll(ko),
                r = Number(t.getAttribute(Co)),
                a = Number(t.getAttribute(qo));
              if (r >= 3) {
                let e = 0;
                if (
                  (n.forEach((t) => {
                    t.classList.contains(xo)
                      ? t.classList.contains(Fo)
                        ? (e += 1)
                        : t.classList.contains(Ho)
                        ? (e += 2)
                        : (e += 3)
                      : t.classList.contains(Io)
                      ? t.classList.contains(Fo)
                        ? (e += 1)
                        : (e += 2)
                      : (e += 1);
                  }),
                  e > 0)
                ) {
                  let i = r - (e % r);
                  i === r && (i = 0),
                    t.classList.add(`grid--empty-items-tablet-${i}`);
                }
              }
              if (2 === a) {
                let e = 0;
                if (
                  (n.forEach((t) => {
                    (t.classList.contains(Mo) || t.classList.contains(Do)) &&
                      (e += 1);
                  }),
                  e > 0)
                ) {
                  let i = a - (e % a);
                  i === a && (i = 0),
                    t.classList.add(`grid--empty-items-mobile-${i}`);
                }
              }
              t.classList.add(To), this.endlessScroll.push(o);
            }
          });
      }
      update(t) {
        this.ajaxinateContainer = this.container.querySelectorAll(So);
        const e = (e) => e.settings.container === t,
          i = this.endlessScroll.find(e);
        if (i) {
          const t = this.endlessScroll.findIndex(e);
          this.endlessScroll.splice(t, 1),
            (i.settings.method = "scroll"),
            i.destroy();
        }
        const o = [...this.ajaxinateContainer].find(
          (e) => `${So}[${Ao}="${e.dataset.ajaxinateId}"]` === t
        );
        if (!o) return;
        const n = `${So}[${Ao}="${o.dataset.ajaxinateId}"]`,
          r = `${Eo}[${Ao}="${o.dataset.ajaxinateId}"]`;
        if (!(o.children.length > 0)) return;
        const a = new s({ container: n, pagination: r, method: "scroll" });
        o.classList.add(To), this.endlessScroll.push(a);
      }
      loadMoreFix() {
        s.prototype.loadMore = function () {
          (this.request = new XMLHttpRequest()),
            (this.request.onreadystatechange = function () {
              if (!this.request.responseXML) return;
              if (
                4 === !this.request.readyState ||
                200 === !this.request.status
              )
                return;
              const t = this.request.responseXML.querySelector(
                  this.settings.container
                ),
                e = this.request.responseXML.querySelector(
                  this.settings.pagination
                );
              t.querySelectorAll(Lo).forEach((t) => t.classList.add(Po)),
                this.containerElement.insertAdjacentHTML(
                  "beforeend",
                  t.innerHTML
                ),
                null == e
                  ? this.removePaginationElement()
                  : ((this.paginationElement.innerHTML = e.innerHTML),
                    this.settings.callback &&
                      "function" == typeof this.settings.callback &&
                      this.settings.callback(this.request.responseXML),
                    this.initialize());
            }.bind(this)),
            this.request.open("GET", this.nextPageUrl, !0),
            (this.request.responseType = "document"),
            this.request.send();
        };
      }
      unload() {
        this.endlessScroll.length > 0 &&
          (this.endlessScroll.forEach((t) => {
            (t.settings.method = "scroll"), t.destroy();
          }),
          this.ajaxinateContainer.forEach((t) => t.classList.remove(To)));
      }
      constructor(t) {
        (this.container = t),
          (this.endlessScroll = []),
          theme.settings.enableInfinityScroll && this.init();
      }
    };
  const zo = {
      onLoad() {
        Oo = new Bo(this.container);
      },
      onUnload: function () {
        "function" == typeof Oo.unload && Oo.unload();
      },
    },
    _o = 300,
    $o = "[data-toggle-filters]",
    Ro = "[data-close-filters]",
    Vo = "[data-open-filters]",
    No = "[data-collection-wrapper]",
    Wo = "[data-collapsible-trigger]",
    Uo = "[data-sort-toggle]",
    jo = "[data-collection-sort-options]",
    Go = "[data-input-sort]",
    Ko = "[data-collection-filters]",
    Qo = "[data-collection-filters-list]",
    Xo = "[data-collection-sticky-bar]",
    Yo = "[data-collection-filter]",
    Jo = "[data-collection-filter-tag]",
    Zo = "[data-collection-filter-tag-button]",
    tn = "[data-collection-filters-form]",
    en = "[data-filter-reset-button]",
    sn = "[data-filter-tag-reset-button]",
    on = '[data-section-type="popups"]',
    nn = "[data-collection-products]",
    rn = "[data-products-count]",
    an = "[data-field-price-min]",
    ln = "[data-field-price-max]",
    cn = "[data-se-min-value]",
    hn = "[data-se-max-value]",
    dn = "data-se-min-value",
    un = "data-se-max-value",
    pn = "data-se-min",
    mn = "data-se-max",
    gn = "[data-tooltip]",
    fn = "[data-tooltip-container]",
    yn = "[data-show-more]",
    vn = "[data-show-more-actions]",
    bn = "[data-show-more-container]",
    wn = "[data-show-more-trigger]",
    Sn = "[data-search-performed]",
    En = "[data-search-form]",
    Ln = "[data-custom-scrollbar]",
    kn = "is-active",
    An = "is-expanded",
    Cn = "is-visible",
    qn = "is-loading",
    Tn = "popup--visible",
    Pn = "collection__filters--visible",
    xn = "collection__sort__option-wrapper--visible",
    In = "data-filter-active",
    Hn = "data-prevent-scroll-lock",
    Fn = "data-filters-default-state",
    Mn = "tabindex",
    Dn = "aria-expanded",
    On = "data-current-type",
    Bn = {};
  let zn = class {
    initFacetedFilters() {
      "tag" != this.filterMode &&
        "group" != this.filterMode &&
        this.enableFilters &&
        (this.rangeSlider = new (class {
          init() {
            if (
              ((this.slider = this.container.querySelector(ms)), !this.slider)
            )
              return;
            (this.resizeFilters = o(this.reset.bind(this), 50)),
              (this.onMoveEvent = (t) => this.onMove(t)),
              (this.onStopEvent = (t) => this.onStop(t)),
              (this.onStartEvent = (t) => this.onStart(t)),
              (this.startX = 0),
              (this.x = 0),
              (this.touchLeft = this.slider.querySelector(gs)),
              (this.touchRight = this.slider.querySelector(fs)),
              (this.lineSpan = this.slider.querySelector(ys)),
              (this.min = parseFloat(this.slider.getAttribute(bs))),
              (this.max = parseFloat(this.slider.getAttribute(ws))),
              (this.step = 0),
              (this.normalizeFact = 20);
            let t = this.min;
            this.slider.hasAttribute(Ss) &&
              (t = parseFloat(this.slider.getAttribute(Ss)));
            let e = this.max;
            this.slider.hasAttribute(Es) &&
              (e = parseFloat(this.slider.getAttribute(Es))),
              t < this.min && (t = this.min),
              e > this.max && (e = this.max),
              t > e && (t = e),
              this.slider.getAttribute(Ls) &&
                (this.step = Math.abs(
                  parseFloat(this.slider.getAttribute(Ls))
                )),
              this.reset(),
              window.addEventListener("theme:resize", this.resizeFilters),
              (this.maxX =
                this.slider.offsetWidth - this.touchRight.offsetWidth),
              (this.selectedTouch = null),
              (this.initialValue =
                this.lineSpan.offsetWidth - this.normalizeFact),
              this.setMinValue(t),
              this.setMaxValue(e),
              this.touchLeft.addEventListener("mousedown", this.onStartEvent),
              this.touchRight.addEventListener("mousedown", this.onStartEvent),
              this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
                passive: !0,
              }),
              this.touchRight.addEventListener(
                "touchstart",
                this.onStartEvent,
                { passive: !0 }
              ),
              this.slider.classList.add(qs);
          }
          reset() {
            (this.touchLeft.style.left = "0px"),
              (this.touchRight.style.left =
                this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
              (this.lineSpan.style.marginLeft = "0px"),
              (this.lineSpan.style.width =
                this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
              (this.startX = 0),
              (this.x = 0),
              (this.maxX =
                this.slider.offsetWidth - this.touchRight.offsetWidth),
              (this.initialValue =
                this.lineSpan.offsetWidth - this.normalizeFact);
          }
          setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchLeft.style.left =
              Math.ceil(
                e *
                  (this.slider.offsetWidth -
                    (this.touchLeft.offsetWidth + this.normalizeFact))
              ) + "px"),
              (this.lineSpan.style.marginLeft =
                this.touchLeft.offsetLeft + "px"),
              (this.lineSpan.style.width =
                this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
              this.slider.setAttribute(Ss, t);
          }
          setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchRight.style.left =
              Math.ceil(
                e *
                  (this.slider.offsetWidth -
                    (this.touchLeft.offsetWidth + this.normalizeFact)) +
                  this.normalizeFact
              ) + "px"),
              (this.lineSpan.style.marginLeft =
                this.touchLeft.offsetLeft + "px"),
              (this.lineSpan.style.width =
                this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
              this.slider.setAttribute(Es, t);
          }
          onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]),
              t.currentTarget === this.touchLeft
                ? (this.x = this.touchLeft.offsetLeft)
                : t.currentTarget === this.touchRight &&
                  (this.x = this.touchRight.offsetLeft),
              (this.startX = e.pageX - this.x),
              (this.selectedTouch = t.currentTarget),
              document.addEventListener("mousemove", this.onMoveEvent),
              document.addEventListener("mouseup", this.onStopEvent),
              document.addEventListener("touchmove", this.onMoveEvent, {
                passive: !0,
              }),
              document.addEventListener("touchend", this.onStopEvent, {
                passive: !0,
              });
          }
          onMove(t) {
            let e = t;
            t.touches && (e = t.touches[0]),
              (this.x = e.pageX - this.startX),
              this.selectedTouch === this.touchLeft
                ? (this.x >
                  this.touchRight.offsetLeft -
                    this.selectedTouch.offsetWidth +
                    10
                    ? (this.x =
                        this.touchRight.offsetLeft -
                        this.selectedTouch.offsetWidth +
                        10)
                    : this.x < 0 && (this.x = 0),
                  (this.selectedTouch.style.left = this.x + "px"))
                : this.selectedTouch === this.touchRight &&
                  (this.x <
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                    ? (this.x =
                        this.touchLeft.offsetLeft +
                        this.touchLeft.offsetWidth -
                        10)
                    : this.x > this.maxX && (this.x = this.maxX),
                  (this.selectedTouch.style.left = this.x + "px")),
              (this.lineSpan.style.marginLeft =
                this.touchLeft.offsetLeft + "px"),
              (this.lineSpan.style.width =
                this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
              this.calculateValue(),
              this.slider.getAttribute("on-change") &&
                new Function("min, max", this.slider.getAttribute("on-change"))(
                  this.slider.getAttribute(Ss),
                  this.slider.getAttribute(Es)
                ),
              this.onChange(
                this.slider.getAttribute(Ss),
                this.slider.getAttribute(Es)
              );
          }
          onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent),
              document.removeEventListener("mouseup", this.onStopEvent),
              document.removeEventListener("touchmove", this.onMoveEvent, {
                passive: !0,
              }),
              document.removeEventListener("touchend", this.onStopEvent, {
                passive: !0,
              }),
              (this.selectedTouch = null),
              this.calculateValue(),
              this.onChanged(
                this.slider.getAttribute(Ss),
                this.slider.getAttribute(Es)
              );
          }
          onChange(t, e) {
            const i = this.slider.closest(vs);
            if (i) {
              const s = i.querySelector(As),
                o = i.querySelector(Cs);
              s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)));
            }
          }
          onChanged(t, e) {
            this.slider.hasAttribute(ks) &&
              this.slider.dispatchEvent(
                new CustomEvent("theme:filter:range-update", { bubbles: !0 })
              );
          }
          calculateValue() {
            const t =
              (this.lineSpan.offsetWidth - this.normalizeFact) /
              this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
              i = e + t;
            if (
              ((e = e * (this.max - this.min) + this.min),
              (i = i * (this.max - this.min) + this.min),
              0 !== this.step)
            ) {
              let t = Math.floor(e / this.step);
              (e = this.step * t),
                (t = Math.floor(i / this.step)),
                (i = this.step * t);
            }
            this.selectedTouch === this.touchLeft &&
              this.slider.setAttribute(Ss, e),
              this.selectedTouch === this.touchRight &&
                this.slider.setAttribute(Es, i);
          }
          unload() {
            document.removeEventListener(
              "theme:filters:init",
              this.initListener
            ),
              window.removeEventListener("theme:resize", this.resizeFilters);
          }
          constructor(t) {
            (this.container = t),
              this.init(),
              (this.initListener = () => this.init()),
              document.addEventListener(
                "theme:filters:init",
                this.initListener
              );
          }
        })(this.container));
    }
    initTooltips() {
      var t, e;
      ((this.tooltips = this.container.querySelectorAll(gn)),
      window.innerWidth < theme.sizes.small) &&
        (this.tooltips =
          null === (e = this.productGrid) || void 0 === e
            ? void 0
            : e.querySelectorAll(gn));
      null === (t = this.tooltips) ||
        void 0 === t ||
        t.forEach((t) => {
          new us(t);
        }),
        this.handleVisibleTooltips();
    }
    handleVisibleTooltips() {
      if (this.tooltips.length > 0) {
        const t = document.querySelector(fn);
        t.classList.contains(Cn) && t.classList.remove(Cn);
      }
    }
    updateRange() {
      const t = this.filtersForm.querySelector(cn),
        e = this.filtersForm.querySelector(hn),
        i = this.filtersForm.querySelector(an),
        s = this.filtersForm.querySelector(ln);
      if (t.hasAttribute(dn) && e.hasAttribute(un)) {
        const o = parseFloat(i.placeholder, 10),
          n = parseFloat(s.placeholder, 10),
          r = parseFloat(t.getAttribute(dn), 10),
          a = parseFloat(e.getAttribute(un), 10);
        (o === r && n === a) ||
          ((i.value = parseInt(r)),
          (s.value = parseInt(a)),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
      }
    }
    onSubmitHandler(t) {
      t.preventDefault();
      const e = new FormData(this.filtersForm),
        i = new URLSearchParams(e),
        s = [];
      let o = "";
      this.isSearchPage &&
        ((this.searchForm = this.container.querySelector(En)),
        (this.currentType = this.container.getAttribute(On)));
      const n = this.filtersForm.querySelector(cn),
        r = this.filtersForm.querySelector(hn),
        a = this.filtersForm.querySelector(an),
        l = this.filtersForm.querySelector(ln);
      if (n && r && a && l && n.hasAttribute(pn) && r.hasAttribute(mn)) {
        const t = parseFloat(n.getAttribute(pn), 10),
          e = parseFloat(r.getAttribute(mn), 10),
          o = a.value ? parseFloat(a.value, 10) : t,
          c = l.value ? parseFloat(l.value, 10) : e;
        o <= t &&
          c >= e &&
          (s.push("filter.v.price.gte"),
          s.push("filter.v.price.lte"),
          i.delete("filter.v.price.gte"),
          i.delete("filter.v.price.lte"));
      }
      if (((o = i.toString()), this.isSearchPage)) {
        o = Ki(this.searchForm, this.filtersForm, s);
        let t = "";
        "all" === this.currentType && (t = "&type=product"),
          o.indexOf("&type=product") > -1 && (t = ""),
          (o += t);
      }
      this.renderSection(o, t);
    }
    onHistoryChange(t) {
      var e;
      if (!this.filters) return;
      let i =
        (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) ||
        "";
      if (this.isSearchPage) {
        t.state || (i = window.location.search);
        if (!(i.indexOf("type=product") > -1)) return;
      }
      this.renderSection(i, null, !1);
    }
    renderSection(t, e, i = !0) {
      this.startLoading();
      const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
        o = (t) => t.url === s;
      this.filterData.some(o)
        ? this.renderSectionFromCache(o, e)
        : this.renderSectionFromFetch(s, e),
        i && this.updateURLHash(t);
    }
    renderSectionFromFetch(t) {
      fetch(t)
        .then((t) => t.text())
        .then((e) => {
          const i = e;
          (this.filterData = [...this.filterData, { html: i, url: t }]),
            (this.inputSort = this.container.querySelectorAll(Go)),
            this.renderFilters(i),
            this.bindFilterButtonsEvents(),
            this.hideFiltersOnMobile(),
            this.renderProductGrid(i),
            this.updateProductsCount(i),
            this.finishLoading(),
            this.mobileFiltersScrollLock(),
            this.handleSearchPageActiveTab();
        });
    }
    renderSectionFromCache(t, e) {
      const i = this.filterData.find(t).html;
      this.renderFilters(i, e),
        this.hideFiltersOnMobile(),
        this.renderProductGrid(i),
        this.updateProductsCount(i),
        this.finishLoading(),
        this.mobileFiltersScrollLock(),
        this.handleSearchPageActiveTab();
    }
    handleSearchPageActiveTab() {
      this.isSearchPage &&
        ((this.scrollable = this.container.querySelector(Ln)),
        this.scrollable &&
          !this.customScrollbar &&
          (this.customScrollbar = new Zi(this.container)));
    }
    renderProductGrid(t) {
      const e = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector(nn);
      e &&
        ((this.productGrid.innerHTML = e.innerHTML),
        this.initProductGridEvents(theme.settings.enableInfinityScroll),
        this.filterShowMore());
    }
    updateProductsCount(t) {
      const e = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector(rn);
      e && (this.productsCount.innerHTML = e.innerHTML);
    }
    renderFilters(t) {
      const e = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector(Ko);
      e &&
        ((this.filters.innerHTML = e.innerHTML),
        (this.filtersForm = document.querySelector(tn)),
        this.bindFilterButtonsEvents(),
        this.bindToggleButtonsEvents(),
        uo(this.container),
        (this.collapsible = new ai(this.container)),
        document.dispatchEvent(
          new CustomEvent("theme:filters:init", { bubbles: !0 })
        ));
    }
    updateURLHash(t) {
      history.pushState(
        { searchParams: t },
        "",
        `${window.location.pathname}${t && "?".concat(t)}`
      );
    }
    bindFilterButtonsEvents() {
      this.inputSort.length > 0 &&
        this.inputSort.forEach((t) => {
          t.addEventListener("change", this.updateCollectionFormSortEvent);
        }),
        this.filtersForm &&
          (this.filtersForm.addEventListener(
            "input",
            this.debouncedSubmitEvent.bind(this)
          ),
          this.filtersForm.addEventListener(
            "theme:filter:range-update",
            this.updateRangeEvent
          )),
        this.collectionSortOptions &&
          this.collectionSortOptions.addEventListener(
            "keyup",
            this.onTabHandlerEvent
          ),
        "tag" != this.filterMode &&
          "group" != this.filterMode &&
          this.enableFilters &&
          this.container.querySelectorAll(en).forEach((t) => {
            t.addEventListener("click", this.onFilterResetClick, { once: !0 });
          });
    }
    onFilterResetClick(t) {
      t.preventDefault(),
        this.renderSection(
          new URL(t.currentTarget.href).searchParams.toString()
        );
    }
    bindToggleButtonsEvents() {
      var t;
      this.container.querySelectorAll($o).forEach((t) => {
        t.addEventListener("click", this.onFilterToggleClick);
      }),
        this.container.querySelectorAll(Ro).forEach((t) => {
          t.addEventListener("click", this.hideFiltersDrawer);
        }),
        this.container.querySelectorAll(Vo).forEach((t) => {
          t.addEventListener("click", this.showFiltersDrawer);
        }),
        null === (t = this.container.querySelector(No)) ||
          void 0 === t ||
          t.addEventListener("keyup", this.onKeyUpHandler);
    }
    onTabHandler(t) {
      if (
        t.code === theme.keyboardKeys.SPACE ||
        t.code === theme.keyboardKeys.ENTER ||
        t.code === theme.keyboardKeys.NUMPADENTER
      ) {
        const e = t.target.previousElementSibling.value;
        this.filtersForm.querySelectorAll(Go).forEach((t) => {
          t.checked && (t.checked = !1), t.value === e && (t.checked = !0);
        }),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
          t.target.dispatchEvent(new Event("click", { bubbles: !0 }));
      }
    }
    onKeyUpHandler(t) {
      t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
    }
    onFilterToggleClick(t) {
      t.preventDefault(), N();
      this.filters.classList.contains(Pn)
        ? this.hideFiltersDrawer()
        : this.showFiltersDrawer();
    }
    sortDropdownToggle() {
      this.collectionSortOptions &&
        this.collectionSortOptions.classList.toggle(xn);
    }
    bodyClick(t) {
      if (!this.collectionSortOptions) return;
      const e = this.sortToggle.contains(t.target);
      this.collectionSortOptions.classList.contains(xn) &&
        !e &&
        this.sortDropdownToggle();
    }
    updateCollectionFormSort(t) {
      const e = t.target,
        i = e.value,
        s = e.closest(jo);
      this.container.querySelectorAll(Go).forEach((t) => {
        t.value === i && (t.checked = !0);
      }),
        null !== s &&
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 }));
    }
    showFiltersDrawer() {
      (this.a11y.state.trigger = document.querySelector($o)),
        this.a11y.trapFocus({ container: this.filters }),
        this.mobileFiltersScrollLock();
    }
    mobileFiltersScrollLock() {
      if (window.innerWidth < theme.sizes.small) {
        const t = document.querySelector(Qo);
        this.filters.classList.contains(Pn) || this.filters.classList.add(Pn),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t })
          );
      }
    }
    hideFiltersOnMobile() {
      const t = this.container.querySelectorAll(`${Wo}:not(${wn})`);
      window.innerWidth < theme.sizes.small &&
        requestAnimationFrame(() => {
          t.forEach((t) => {
            const e = "true" === t.getAttribute(In);
            t.classList.contains(An) &&
              !e &&
              t.dispatchEvent(new Event("click"));
          });
        });
    }
    showFiltersOnDesktop() {
      const t = this.container.querySelectorAll(`${Wo}:not(${wn})`),
        e = this.container.getAttribute(Fn),
        i = "first-open" === e,
        s = "open" === e,
        o = "closed" === e,
        n = this.enableSorting ? 1 : 0;
      t.forEach((t, e) => {
        const r = t.classList.contains(An),
          a = "true" === t.getAttribute(In),
          l = a && !r && s;
        (a && !l) ||
          (((o && r) ||
            (i && !r && e === n) ||
            (i && r && e !== n) ||
            (s && !r) ||
            l) &&
            t.dispatchEvent(new Event("click")));
      });
    }
    hideFiltersDrawer() {
      let t = this.filters.classList.contains(Pn),
        e = this.container.classList.contains(qn);
      t && (this.filters.classList.remove(Pn), this.a11y.removeTrapFocus()),
        e ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: _o })
          );
    }
    filtersResizeEvents() {
      window.innerWidth >= theme.sizes.small
        ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
        : this.hideFiltersOnMobile();
    }
    filterShowMore() {
      (this.showMore = this.container.querySelectorAll(yn)),
        0 !== this.showMore.length &&
          this.showMore.forEach((t) => {
            const e = t.querySelector(Wo),
              i = t.querySelector(vn);
            if (!i) return;
            const s = i.querySelector(wn),
              o = i.querySelector(bn),
              n = o.querySelectorAll(window.theme.focusable);
            "true" === o.getAttribute(Dn) ||
              n.forEach((t) => {
                t.setAttribute(Mn, "-1");
              }),
              s.addEventListener("keyup", (t) => {
                (t.code !== theme.keyboardKeys.SPACE &&
                  t.code !== theme.keyboardKeys.ENTER &&
                  t.code !== theme.keyboardKeys.NUMPADENTER) ||
                  this.updateShowMoreFocusableElements(t, n);
              }),
              s.addEventListener("click", (t) => {
                this.updateShowMoreFocusableElements(t, n);
              }),
              e.addEventListener("keyup", (t) => {
                (t.code !== theme.keyboardKeys.SPACE &&
                  t.code !== theme.keyboardKeys.ENTER &&
                  t.code !== theme.keyboardKeys.NUMPADENTER) ||
                  this.updateCollapsedContainerFocusableElements(e, s, n);
              }),
              e.addEventListener("click", () => {
                this.updateCollapsedContainerFocusableElements(e, s, n);
              });
          });
    }
    updateCollapsedContainerFocusableElements(t, e, i) {
      requestAnimationFrame(() => {
        const s = "true" === t.getAttribute(Dn),
          o = "true" === e.getAttribute(Dn);
        i.forEach((t) => {
          !s && o && t.setAttribute(Mn, "-1"), s && o && t.removeAttribute(Mn);
        });
      });
    }
    updateShowMoreFocusableElements(t, e) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const i = "true" === t.target.getAttribute(Dn);
          e.forEach((t, e) => {
            if (i) return t.removeAttribute(Mn), void (0 === e && t.focus());
            t.setAttribute(Mn, "-1");
          });
        });
      });
    }
    initTagFilters() {
      ("tag" != this.filterMode && "group" != this.filterMode) ||
        !this.enableFilters ||
        ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)),
        this.bindFilterTagButtonsEvents(),
        this.bindSortChangeEvent());
    }
    renderTagFiltersProducts(t) {
      this.startLoading(),
        "object" == typeof this.endlessCollection &&
          this.endlessCollection.unload(),
        fetch(t)
          .then((t) => t.text())
          .then((e) => {
            const i = e,
              s = new DOMParser().parseFromString(i, "text/html"),
              o = s.querySelector(nn).innerHTML,
              n = s.querySelector(Ko).innerHTML;
            (this.productGrid.innerHTML = o),
              (this.filters.innerHTML = n),
              (this.inputSort = this.container.querySelectorAll(Go)),
              (this.filtersForm = document.querySelector(tn)),
              (this.filterData = [...this.filterData, { html: i, url: t }]),
              (this.alreadyClicked = !1),
              this.bindFilterTagButtonsEvents(),
              this.bindFilterButtonsEvents(),
              this.bindSortChangeEvent(),
              this.bindToggleButtonsEvents(),
              this.initProductGridEvents(theme.settings.enableInfinityScroll),
              this.updateProductsCount(i),
              this.mobileFiltersScrollLock(),
              this.hideFiltersOnMobile(),
              uo(this.container),
              (this.collapsible = new ai(this.container)),
              this.filterShowMore(),
              history.replaceState &&
                window.history.pushState({ path: t }, "", t);
          })
          .catch((t) => {
            this.finishLoading(), console.log(`Error: ${t}`);
          });
    }
    bindFilterTagButtonsEvents() {
      this.container.querySelectorAll(Zo).forEach((t) => {
        t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
      }),
        this.container.querySelectorAll(sn).forEach((t) => {
          t.addEventListener("click", this.onFilterTagClearClick);
        }),
        this.container.querySelectorAll(en).forEach((t) => {
          t.addEventListener("click", this.onFilterTagResetClick);
        });
    }
    bindSortChangeEvent() {
      this.container.querySelectorAll(Go).forEach((t) => {
        t.addEventListener("input", this.debouncedSortEvent.bind(this));
      });
    }
    onFilterTagButtonClick(t) {
      if ((t.preventDefault(), this.alreadyClicked)) return;
      this.alreadyClicked = !0;
      const e = t.currentTarget,
        i = e.dataset.tag;
      if (e.parentNode.classList.contains(kn)) {
        let t = this.tags.indexOf(i);
        e.parentNode.classList.remove(kn), t > -1 && this.tags.splice(t, 1);
      } else e.parentNode.classList.add(kn), this.tags.push(i);
      let s =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.container.querySelector(Yo).classList.remove(An),
        this.container.querySelector(Yo).setAttribute(Dn, !1),
        this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(s);
    }
    onFilterTagClearClick(t) {
      if ((t.preventDefault(), this.alreadyClicked)) return;
      this.alreadyClicked = !0;
      const e = t.currentTarget.dataset.tag,
        i = this.tags.indexOf(e);
      i > -1 && this.tags.splice(i, 1);
      const s =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(s);
    }
    onSortChange() {
      let t =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.renderTagFiltersProducts(t);
    }
    getSortValue() {
      let t = "";
      return (
        this.inputSort.forEach((e) => {
          e.checked && (t = e.value);
        }),
        t
      );
    }
    onFilterTagResetClick(t) {
      if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
      (this.alreadyClicked = !0),
        this.container.querySelectorAll(Jo).forEach((t) => {
          t.classList.remove(kn);
        }),
        this.container.querySelectorAll(Yo).forEach((t) => {
          t.classList.remove(An), t.setAttribute(Dn, !1);
        }),
        (this.tags = []),
        this.container.setAttribute("data-tags", "");
      let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(e);
    }
    getProductsOffsetTop() {
      return (
        this.productGrid.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        this.filtersStickyBar.offsetHeight
      );
    }
    getStickyBarOffsetTop() {
      return (
        this.filtersStickyBar.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top
      );
    }
    initProductGridEvents(t) {
      if (t)
        return this.initInfinityScroll(), void this.initProductGridEvents(!1);
      (this.productGridEvents = new bo(this.container)),
        this.initTooltips(),
        setTimeout(() => {
          this.finishLoading();
        }, 1.5 * _o);
    }
    initInfinityScroll() {
      if (this.isSearchPage) {
        if (!this.enableFilters) return;
        document.dispatchEvent(
          new CustomEvent("theme:tab:ajaxinate", {
            bubbles: !0,
            detail: "product",
          })
        );
      } else
        "object" == typeof this.endlessCollection &&
          this.endlessCollection.unload(),
          (this.endlessCollection = new Bo(this.container)),
          0 !== this.endlessCollection.endlessScroll.length &&
            (this.endlessCollection.endlessScroll[0].settings.callback = () =>
              this.initProductGridEvents(!1));
    }
    startLoading() {
      this.container.classList.add(qn),
        window.innerWidth >= theme.sizes.small &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          );
      let t = this.getProductsOffsetTop();
      window.scrollTo({ top: t, left: 0, behavior: "smooth" });
    }
    finishLoading() {
      const t = document.querySelectorAll(`${on} .${Tn}`),
        e = t.length > 0;
      if ((this.container.classList.remove(qn), e)) {
        let e = 0;
        [...t].forEach((t) => {
          t.hasAttribute(Hn) && (e += 1);
        }),
          e === t.length &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
                detail: _o,
              })
            );
      } else
        window.innerWidth >= theme.sizes.small &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: _o })
          );
    }
    onDeselect() {
      this.productGridEvents && this.productGridEvents.onDeselect();
    }
    onUnload() {
      "object" == typeof this.endlessCollection &&
        this.endlessCollection.unload(),
        this.productGridEvents && this.productGridEvents.onUnload(),
        this.collapsible && this.collapsible.onUnload(),
        this.rangeSlider && this.rangeSlider.unload(),
        this.filters &&
          document.removeEventListener("theme:resize:width", this.resizeEvent),
        document.removeEventListener("click", this.bodyClickEvent),
        this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
        this.finishLoading();
    }
    constructor(t) {
      var e;
      (this.container = t),
        (this.sectionId = t.dataset.sectionId),
        (this.enableFilters = "true" === t.dataset.enableFilters),
        (this.enableSorting = "true" === t.dataset.enableSorting),
        (this.filterMode = t.dataset.filterMode),
        (this.collectionHandle = this.container.dataset.collection),
        (this.isSearchPage = null != t.closest(Sn)),
        (this.productGrid = this.container.querySelector(nn)),
        (this.productsCount = this.container.querySelector(rn)),
        (this.groupTagFilters = this.container.querySelectorAll(Yo)),
        (this.filters = this.container.querySelector(Ko)),
        (this.filterTriggers = this.container.querySelectorAll(Wo)),
        (this.filtersStickyBar = this.container.querySelector(Xo)),
        (this.filtersForm = this.container.querySelector(tn)),
        (this.inputSort = this.container.querySelectorAll(Go)),
        (this.sortToggle = this.container.querySelector(Uo)),
        (this.collectionSortOptions = this.container.querySelector(jo)),
        (this.a11y = ci),
        (this.filterData = []),
        (this.rangeSlider = null),
        (this.sortDropdownEvent = () => this.sortDropdownToggle()),
        (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
        (this.updateCollectionFormSortEvent = (t) =>
          this.updateCollectionFormSort(t)),
        (this.bodyClickEvent = (t) => this.bodyClick(t)),
        (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
        (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
        (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
        (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
        (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
        (this.updateRangeEvent = this.updateRange.bind(this)),
        (this.debouncedSubmitEvent = o((t) => {
          this.onSubmitHandler(t);
        }, 500)),
        (this.debouncedSortEvent = o((t) => {
          this.onSortChange(t);
        }, 500)),
        (this.productGridEvents = {}),
        this.filters &&
          ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
          (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
          (this.resizeEvent = o(() => {
            this.filtersResizeEvents();
          }, 500)),
          this.filtersResizeEvents(),
          document.addEventListener("theme:resize:width", this.resizeEvent)),
        this.initTagFilters(),
        this.initFacetedFilters(),
        this.bindToggleButtonsEvents(),
        this.bindFilterButtonsEvents(),
        this.initProductGridEvents(theme.settings.enableInfinityScroll),
        uo(this.container),
        (this.collapsible = new ai(this.container)),
        N(),
        window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        null === (e = this.sortToggle) ||
          void 0 === e ||
          e.addEventListener("click", this.sortDropdownEvent),
        document.addEventListener("click", this.bodyClickEvent),
        this.filterShowMore();
    }
  };
  const _n = {
      onLoad() {
        Bn[this.id] = new zn(this.container);
      },
      onDeselect() {
        Bn[this.id].onDeselect();
      },
      onUnload() {
        Bn[this.id].onUnload();
      },
    },
    $n = "[data-aos]",
    Rn = "[data-aos-anchor]",
    Vn = "[data-tabs-link]",
    Nn = "[data-tab]",
    Wn = "[data-tab-ref]",
    Un = "[data-custom-scrollbar]",
    jn = "[data-custom-scrollbar-holder]",
    Gn = "[data-slider]",
    Kn = "[data-tabs-contents]",
    Qn = "[data-search-form]",
    Xn = "[data-all-types-container]",
    Yn = "[data-collection-filters-form]",
    Jn = "[data-current-page]",
    Zn = "[data-tooltip]",
    tr = "[data-collection-products]",
    er = "#AjaxinateLoop",
    ir = "current",
    sr = "hide",
    or = "alt",
    nr = "aos-animate",
    rr = "is-loaded",
    ar = "data-tabs-link",
    lr = "data-tab",
    cr = "data-tab-ref",
    hr = "data-start-index",
    dr = "data-search-performed",
    ur = "data-type",
    pr = "data-current-type",
    mr = "data-all-types",
    gr = "data-current-page",
    fr = "data-ajaxinate-id",
    yr = {};
  let vr = class {
    assignSearchPageArguments() {
      this.isSearchPage &&
        ((this.searchForm = this.container.querySelector(Qn)),
        (this.searchFormData = new FormData(this.searchForm)),
        (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
        (this.currentType = this.container.getAttribute(pr)),
        (this.sectionId = this.container.dataset.sectionId),
        (this.searchForAllTypes = "true" === this.container.getAttribute(mr)),
        (this.fetchURL = ""),
        (this.searchParams = ""),
        (this.cachedResults = {}),
        this.handleTabsHistory(),
        this.infiniteScrollListener(),
        this.initInfinityScroll(this.currentType));
    }
    init() {
      const t = this.container.querySelectorAll(Vn),
        e = this.container.querySelector(
          `[${ar}="${
            this.container.hasAttribute(hr)
              ? this.container.getAttribute(hr)
              : 0
          }"]`
        ),
        i = this.container.querySelector(
          `[${lr}="${
            this.container.hasAttribute(hr)
              ? this.container.getAttribute(hr)
              : 0
          }"]`
        );
      null == i || i.classList.add(ir),
        null == e || e.classList.add(ir),
        this.checkVisibleTabsLinks(),
        t.forEach((t) => {
          this.handleTabsNavListeners(t);
        });
    }
    handleTabsHistory() {
      window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
        this.tabsLink.forEach((t) => {
          t.addEventListener(
            "theme:tab:open-from-history",
            this.openTabFromHistoryEvent
          );
        });
    }
    handleTabsNavListeners(t) {
      const e = t.getAttribute(ar),
        i = this.container.querySelector(`[${lr}="${e}"]`);
      i &&
        (t.addEventListener("click", (e) => {
          this.isSearchPage && this.handleURLSearchParams(e, !0),
            this.tabChange(t, i);
        }),
        t.addEventListener("keyup", (e) => {
          (e.code !== theme.keyboardKeys.SPACE &&
            e.code !== theme.keyboardKeys.ENTER &&
            e.code !== theme.keyboardKeys.NUMPADENTER) ||
            (this.isSearchPage && this.handleURLSearchParams(e, !0),
            this.tabChange(t, i));
        }));
    }
    openTabFromHistory(t) {
      const e = t.target,
        i = this.container.querySelector(t.detail.element).getAttribute(ar),
        s = this.container.querySelector(`[${lr}="${i}"]`);
      s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
    }
    handleURLSearchParams(t, e = !0) {
      const i = t.target.matches(Vn) ? t.target : t.target.closest(Vn),
        s = i.getAttribute(ur),
        o = i.getAttribute(ar),
        n = this.container.querySelector(`[${lr}="${o}"]`).querySelector(Jn),
        r = document.querySelector(Yn);
      let a = n ? `&page=${n.getAttribute(gr)}` : "";
      if (
        ((this.searchParams = Ki(this.searchForm, r, [], s)), "product" === s)
      ) {
        const t = this.searchParams.replace("&type=product", "");
        this.searchParams = `${t}&type=product`;
      } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
      theme.settings.enableInfinityScroll ||
        "" === a ||
        (this.searchParams += a),
        (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
        e &&
          history.pushState(
            { searchParams: this.searchParams },
            "",
            `${window.location.pathname}${
              this.searchParams && "?".concat(this.searchParams)
            }`
          );
    }
    tabChangeFetchContent(t, e) {
      const i = t.getAttribute(ur),
        s = t.getAttribute(ar),
        o = this.container.querySelector(`[${lr}="${s}"]`),
        n = this.currentType === i;
      if (this.cachedResults[s] || n)
        return (
          "product" !== i ||
            this.searchFilters ||
            (this.searchFilters = new zn(this.container)),
          void requestAnimationFrame(() => {
            this.handleActiveTabClasses(t, e),
              this.scrollToCurrentTabLink(t),
              this.triggerTabAnimations(e),
              this.checkVisibleTabsLinks(),
              this.updateAjaxify(e, i);
          })
        );
      fetch(this.fetchURL)
        .then((t) => {
          if (!t.ok) {
            throw new Error(t.status);
          }
          return t.text();
        })
        .then((n) => {
          const r = new DOMParser()
            .parseFromString(n, "text/html")
            .querySelector(`[${lr}="${s}"]`).innerHTML;
          var a;
          this.searchForAllTypes &&
            (null === (a = this.container.querySelector(Xn)) ||
              void 0 === a ||
              a.remove());
          (this.cachedResults[s] = r),
            (o.innerHTML = r),
            "product" !== i ||
              this.searchFilters ||
              (this.searchFilters = new zn(this.container)),
            requestAnimationFrame(() => {
              this.handleActiveTabClasses(t, e),
                this.scrollToCurrentTabLink(t),
                this.triggerTabAnimations(e),
                this.checkVisibleTabsLinks(),
                this.initInfinityScroll(i);
            });
        })
        .catch((t) => {
          throw t;
        });
    }
    onHistoryChange(t) {
      var e;
      const i =
          (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) ||
          window.location.search,
        s = i.indexOf("type=product") > -1,
        o = i.indexOf("type=article") > -1,
        n = i.indexOf("type=page") > -1,
        r = s || o || n,
        a = this.container.querySelector(`${Vn}[${ur}="product"]`),
        l = this.container.querySelector(`${Vn}[${ur}="article"]`),
        c = this.container.querySelector(`${Vn}[${ur}="page"]`);
      r
        ? (s &&
            (null == a ||
              a.dispatchEvent(
                new CustomEvent("theme:tab:open-from-history", {
                  bubbles: !0,
                  detail: { element: `[${ur}="product"]` },
                })
              )),
          o &&
            (null == l ||
              l.dispatchEvent(
                new CustomEvent("theme:tab:open-from-history", {
                  bubbles: !0,
                  detail: { element: `[${ur}="article"]` },
                })
              )),
          n &&
            (null == c ||
              c.dispatchEvent(
                new CustomEvent("theme:tab:open-from-history", {
                  bubbles: !0,
                  detail: { element: `[${ur}="page"]` },
                })
              )))
        : (window.location = i);
    }
    initCustomScrollbar() {
      this.scrollable &&
        !this.customScrollbar &&
        (this.customScrollbar = new Zi(this.container));
    }
    infiniteScrollListener() {
      theme.settings.enableInfinityScroll &&
        ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)),
        document.addEventListener(
          "theme:tab:ajaxinate",
          this.ajaxifyFromFiltersEvent
        ));
    }
    ajaxifyFromFilters(t) {
      this.initInfinityScroll(t.detail);
    }
    initInfinityScroll(t) {
      if (!theme.settings.enableInfinityScroll) return;
      if (0 === this.container.querySelectorAll(er).length) return;
      const e = this.container.querySelector(`${Nn}.${ir}`),
        i = null == e ? void 0 : e.querySelector(er),
        s = null == i ? void 0 : i.classList.contains(rr);
      e
        ? (!i &&
            this.endlessCollection &&
            this.updateAjaxinateInstancesSettings(t),
          i && !s && this.initAjaxyfy(t))
        : this.initAjaxyfy(t);
    }
    updateAjaxinateInstancesSettings(t) {
      setTimeout(() => {
        if (0 === this.endlessCollection.endlessScroll.length) return;
        [...this.endlessCollection.endlessScroll].forEach((t) => {
          const e = t.containerElement,
            i = [...this.tab].find((t) => t.classList.contains(ir));
          !(null !== e.closest(`${Nn}.${ir}`)) &&
            i &&
            (t.settings.method = "click");
        });
        const e = () => this.initProductGridEvents();
        if ("product" === t || "all" === t) {
          const t = (t) =>
              t.settings.container.indexOf("resultsProducts") > -1 ||
              t.settings.container.indexOf("allTypes") > -1,
            i = [...this.endlessCollection.endlessScroll].find(t);
          if (!i) return;
          i.settings.callback = e;
        }
      });
    }
    initAjaxyfy(t) {
      if ("object" != typeof this.endlessCollection)
        return (
          (this.endlessCollection = new Bo(this.container)),
          void this.updateAjaxinateInstancesSettings(t)
        );
      this.endlessCollection.endlessScroll.length > 0 &&
        (this.endlessCollection.unload(),
        (this.endlessCollection = new Bo(this.container)),
        this.updateAjaxinateInstancesSettings(t));
    }
    updateAjaxify(t, e) {
      var i;
      if (
        0 ===
        (null === (i = this.endlessCollection) || void 0 === i
          ? void 0
          : i.endlessScroll.length)
      )
        return;
      const s = t.querySelector(er),
        o = `${er}[${fr}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
      s &&
        (this.endlessCollection.update(o),
        this.updateAjaxinateInstancesSettings(e));
    }
    initProductGridEvents() {
      (this.productGridEvents = new bo(this.container)), this.initTooltips();
    }
    initTooltips() {
      var t, e;
      ((this.tooltips = this.container.querySelectorAll(Zn)),
      (this.productGrid = this.container.querySelector(tr)),
      window.innerWidth < theme.sizes.small) &&
        (this.tooltips =
          null === (e = this.productGrid) || void 0 === e
            ? void 0
            : e.querySelectorAll(Zn));
      null === (t = this.tooltips) ||
        void 0 === t ||
        t.forEach((t) => {
          new us(t);
        });
    }
    tabChange(t, e) {
      t.classList.contains(ir) ||
        (this.isSearchPage
          ? this.tabChangeFetchContent(t, e)
          : (this.handleActiveTabClasses(t, e),
            this.scrollToCurrentTabLink(t),
            this.triggerTabAnimations(e),
            this.handleTabSliders(e),
            this.checkVisibleTabsLinks()));
    }
    handleActiveTabClasses(t, e) {
      var i;
      const s = this.container.querySelector(`${Nn}.${ir}`),
        o = this.container.querySelector(`${Vn}.${ir}`);
      null == s || s.classList.remove(ir),
        null == o || o.classList.remove(ir),
        t.classList.add(ir),
        e.classList.add(ir),
        t.classList.contains(sr) && e.classList.add(sr),
        null === (i = this.tabRef) ||
          void 0 === i ||
          i.forEach((t) => {
            const i = t.classList.contains(ir),
              s = t.getAttribute(cr) === e.getAttribute(lr);
            t.classList.toggle(ir, !i && s);
          });
    }
    scrollToCurrentTabLink(t) {
      const e = t.closest(jn) ? t.closest(jn) : t.parentElement,
        i = parseInt(
          window.getComputedStyle(e).getPropertyValue("padding-left")
        );
      e.scrollTo({
        top: 0,
        left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i,
        behavior: "smooth",
      }),
        t.dispatchEvent(
          new CustomEvent("theme:custom-scrollbar:change", {
            bubbles: !0,
            detail: { element: t },
          })
        );
    }
    triggerTabAnimations(t) {
      if ("false" == theme.settings.animationsEnabled) return;
      document.dispatchEvent(new CustomEvent("theme:scroll"));
      const e = this.tabsContents.querySelector(`[${lr}="resultsProducts"]`);
      if (e && e.classList.contains(ir)) {
        Ie(this.tabsContents.querySelectorAll(Rn));
      } else
        this.tabsContents.querySelectorAll($n).forEach((t) => {
          t.classList.remove(nr);
        }),
          this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
          (this.animateElementsTimer = setTimeout(() => {
            t.querySelectorAll($n).forEach((t) => {
              t.classList.add(nr);
            });
          }, 150));
    }
    handleInactiveTabsAnimations() {
      this.tab.forEach((t) => {
        t.classList.contains(ir) ||
          t.querySelectorAll($n).forEach((t) => {
            requestAnimationFrame(() => t.classList.remove(nr));
          });
      });
    }
    handleTabSliders(t) {
      const e = t.querySelector(Gn);
      e &&
        e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
    }
    checkVisibleTabsLinks() {
      const t = this.container.querySelectorAll(Vn),
        e = this.container.querySelectorAll(`${Vn}.${sr}`);
      t.length - e.length < 2
        ? this.container.classList.add(or)
        : this.container.classList.remove(or);
    }
    onBlockSelect(t) {
      const e = t.target;
      e &&
        (e.dispatchEvent(new Event("click")),
        e.parentNode.scrollTo({
          top: 0,
          left: e.offsetLeft - e.clientWidth,
          behavior: "smooth",
        }));
    }
    onUnload() {
      this.customScrollbar && this.customScrollbar.unload(),
        this.isSearchPage &&
          theme.settings.enableInfinityScroll &&
          document.removeEventListener(
            "theme:tab:ajaxinate",
            this.ajaxifyFromFiltersEvent
          ),
        document.removeEventListener(
          "theme:scroll",
          this.inactiveTabsAnimationsCallback
        );
    }
    constructor(t) {
      (this.container = t),
        (this.tabsContents = t.querySelector(Kn)),
        (this.animateElementsTimer = null),
        (this.isSearchPage = null != t.closest(`[${dr}="true"]`)),
        this.container &&
          ((this.scrollable = this.container.querySelector(Un)),
          (this.tabRef = this.container.querySelectorAll(Wn)),
          (this.tabsLink = this.container.querySelectorAll(Vn)),
          (this.tab = this.container.querySelectorAll(Nn)),
          this.assignSearchPageArguments(),
          this.init(),
          this.initCustomScrollbar(),
          this.isSearchPage || this.initTooltips(),
          (this.inactiveTabsAnimationsCallback = o(
            () => this.handleInactiveTabsAnimations(),
            200
          )),
          document.addEventListener(
            "theme:scroll",
            this.inactiveTabsAnimationsCallback
          ),
          this.container.addEventListener("mouseenter", () => {
            this.handleInactiveTabsAnimations();
          }));
    }
  };
  const br = {
      onLoad() {
        yr[this.id] = new vr(this.container);
      },
      onBlockSelect(t) {
        yr[this.id].onBlockSelect(t);
      },
      onUnload() {
        yr[this.id].onUnload();
      },
    },
    wr = "[data-drawer]",
    Sr = "[data-drawer-toggle]",
    Er = "[data-scroll]",
    Lr = "[data-quick-view-item]",
    kr = "[data-quick-view-focus]",
    Ar = "[data-mobile-menu]",
    Cr = "[data-nav-items-compress]",
    qr = "[data-popdown-toggle]",
    Tr = "[data-nav-search-open]",
    Pr = "[data-nav-link-mobile]",
    xr = "[data-mobile-menu-trigger]",
    Ir = "[data-collapsible-trigger]",
    Hr = "is-open",
    Fr = "js-drawer-open",
    Mr = "js-drawer-open--size",
    Dr = "js-drawer-open--size-qv",
    Or = "cv-h",
    Br = "shopify-section-mobile-menu",
    zr = "data-drawer",
    _r = "data-drawer-header",
    $r = "data-drawer-section",
    Rr = "aria-expanded",
    Vr = "aria-controls",
    Nr = "aria-hidden",
    Wr = "data-mobile-menu-trigger",
    Ur = "data-mobile-menu-block";
  let jr = {},
    Gr = class {
      initListeners() {
        this.drawerToggleButtons.forEach((t) => {
          t.addEventListener("click", this.drawerToggleEvent);
        }),
          this.drawers.forEach((t) => {
            t.addEventListener("keyup", this.keyPressCloseEvent),
              (this.collapsible = new ai(t)),
              (this.tabs = new vr(t));
          }),
          document.addEventListener("click", this.drawerCloseEvent),
          document.addEventListener(
            "theme:drawer:closing",
            this.drawerCloseEvent
          ),
          document.addEventListener(
            "theme:drawer:opening",
            this.drawerOpenEvent
          );
      }
      toggle(t) {
        t.preventDefault();
        const e = document.querySelector(`#${t.target.getAttribute(Vr)}`);
        if (!e) return;
        e.classList.contains(Hr) ? this.close() : this.open(t);
      }
      open(t) {
        let e = t.detail.element;
        e || (e = t.target);
        const i = e.getAttribute(Vr);
        let s;
        if (e.hasAttribute(Wr)) {
          const t = document.querySelector(`mobile-menu[${_r}]`),
            e = document.querySelector(`mobile-menu[${$r}]`);
          s = ("new" === theme.settings.mobileMenuType && e) || t;
        } else s = document.querySelector(`#${i}`);
        if (!s) return;
        const o = s.querySelector(Er) || s;
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: o })
        ),
          document.dispatchEvent(
            new CustomEvent("theme:drawer:open", { bubbles: !0 })
          ),
          this.body.classList.add(Fr),
          (null == i ? void 0 : i.includes("size-chart")) &&
            (this.body.classList.add(Mr),
            i.includes("quickview") && this.body.classList.add(Dr)),
          s.classList.add(Hr),
          s.setAttribute(Nr, !1),
          s.classList.remove(Or),
          e.setAttribute(Rr, !0);
        const n = (t) => {
          const i = "transform" === t.propertyName || "top" === t.propertyName;
          t.target === s &&
            i &&
            ((this.a11y.state.trigger = e),
            this.a11y.trapFocus({ container: s }),
            s.removeEventListener("transitionend", n));
        };
        s.addEventListener("transitionend", n);
      }
      close(t = !1) {
        if (!this.body.classList.contains(Fr)) return;
        const e = document.querySelector(`${wr}.${Hr}`);
        this.drawerToggleButtons.forEach((t) => {
          t.setAttribute(Rr, !1);
        }),
          this.a11y.removeTrapFocus({ container: e }),
          null == e || e.classList.remove(Hr);
        const i = (t) => {
          t.target === e &&
            (requestAnimationFrame(() => {
              null == e || e.classList.add(Or),
                document.dispatchEvent(
                  new CustomEvent("theme:drawer:close", { bubbles: !0 })
                ),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                ),
                this.a11y.state.trigger.focus(),
                null == e || e.setAttribute(Nr, !0);
            }),
            null == e || e.removeEventListener("transitionend", i));
        };
        if (
          (null == e || e.addEventListener("transitionend", i),
          this.body.classList.remove(Fr),
          this.body.classList.remove(Mr),
          this.body.classList.contains(Dr))
        ) {
          if (
            (this.body.classList.remove(Dr),
            t && t.code === theme.keyboardKeys.ESCAPE)
          )
            return (
              (this.a11y.state.trigger = this.a11y.state.mainTrigger),
              void this.a11y.state.trigger.focus()
            );
          const e = this.a11y.state.trigger.closest(kr);
          this.a11y.trapFocus({
            container: e,
            elementToFocus: this.a11y.state.trigger,
          }),
            (this.a11y.state.trigger = this.a11y.state.mainTrigger);
        }
      }
      onUnload() {
        this.close(),
          this.drawerToggleButtons.forEach((t) => {
            t.removeEventListener("click", this.drawerToggleEvent);
          }),
          this.drawers.forEach((t) => {
            t.removeEventListener("keyup", this.keyPressCloseEvent);
          }),
          document.removeEventListener("click", this.drawerCloseEvent),
          document.removeEventListener(
            "theme:drawer:closing",
            this.drawerCloseEvent
          ),
          document.removeEventListener(
            "theme:drawer:opening",
            this.drawerOpenEvent
          ),
          this.collapsible && this.collapsible.onUnload(),
          this.tabs && this.tabs.onUnload();
      }
      constructor(t) {
        (this.container = t),
          (this.body = document.body),
          (this.drawers = this.container.querySelectorAll(wr)),
          (this.drawerToggleButtons = this.container.querySelectorAll(Sr)),
          (this.a11y = ci),
          this.container.hasAttribute(zr) && (this.drawers = [this.container]),
          (this.drawerToggleEvent = Ve((t) => {
            this.toggle(t);
          }, 150)),
          (this.drawerOpenEvent = (t) => {
            this.open(t);
          }),
          (this.keyPressCloseEvent = Ve((t) => {
            t.code === theme.keyboardKeys.ESCAPE && this.close(t);
          }, 150)),
          (this.drawerCloseEvent = (t) => {
            const e = document.querySelector(`${wr}.${Hr}`);
            let i = !1;
            if (!e) return;
            "click" === t.type && (i = t.target.matches(Sr));
            const s = !!e && e.contains(t.target),
              o = e.closest(Lr),
              n = !!o && o.contains(t.target);
            i || s || n || this.close();
          }),
          this.initListeners();
      }
    };
  const Kr = {
    onLoad() {
      jr[this.id] = new Gr(this.container);
    },
    onUnload() {
      jr[this.id].onUnload();
    },
  };
  let Qr = class extends HTMLElement {
    connectedCallback() {
      (this.drawerInstance = new Gr(this.container)),
        this.initMobileNav(),
        document.addEventListener(
          "shopify:block:select",
          this.showDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:load",
          this.showDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.showDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.hideDrawerOnDeselect
        );
    }
    initMobileNav() {
      const t = this.container.querySelector(Sr),
        e = this.container.querySelectorAll(Tr);
      if (
        (null == e ||
          e.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault();
              const i = document.querySelector(Ar),
                s = document.querySelector(Cr);
              let o = matchMedia("(pointer:coarse)").matches;
              window.innerWidth < theme.sizes.small &&
                window.Shopify.designMode &&
                (o = !0);
              const n = o
                ? null == i
                  ? void 0
                  : i.querySelector(qr)
                : null == s
                ? void 0
                : s.querySelector(qr);
              t.dispatchEvent(new Event("click", { bubbles: !0 }));
              const r = (t) => {
                t.target === this.container &&
                  (requestAnimationFrame(() =>
                    null == n
                      ? void 0
                      : n.dispatchEvent(new Event("click", { bubbles: !0 }))
                  ),
                  this.container.removeEventListener("transitionend", r));
              };
              this.container.addEventListener("transitionend", r);
            });
          }),
        "link" === theme.settings.mobileMenuBehaviour)
      )
        return;
      const i = this.container.querySelectorAll(Pr);
      i.length &&
        i.forEach((t) => {
          t.addEventListener("click", (e) => {
            const i = t.parentNode.querySelectorAll(Ir).length,
              s = t.nextElementSibling;
            i &&
              (e.preventDefault(),
              s.dispatchEvent(new Event("click"), { bubbles: !0 }));
          });
        });
    }
    showDrawerOnSelect(t) {
      if (t.target.classList.contains(Br) || t.target.hasAttribute(Ur)) {
        if (
          !(
            t.target.querySelector("mobile-menu") ||
            t.target.closest("mobile-menu")
          ) ||
          "old" === theme.settings.mobileMenuType
        )
          return;
        const e = document.querySelector(xr);
        document.body.classList.contains(Fr) ||
          document.dispatchEvent(
            new CustomEvent("theme:drawer:opening", {
              bubbles: !0,
              detail: { element: e },
            })
          );
      }
    }
    hideDrawerOnDeselect(t) {
      if (t.target.classList.contains(Br) || t.target.hasAttribute(Ur)) {
        if (
          !(
            t.target.querySelector("mobile-menu") ||
            t.target.closest("mobile-menu")
          )
        )
          return;
        document.body.classList.contains(Fr) &&
          document.dispatchEvent(
            new CustomEvent("theme:drawer:closing", { bubbles: !0 })
          );
      }
    }
    disconnectedCallback() {
      this.drawerInstance &&
        (this.drawerInstance.onUnload(), (this.drawerInstance = null)),
        document.removeEventListener(
          "shopify:block:select",
          this.showDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:load",
          this.showDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.showDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.hideDrawerOnDeselect
        );
    }
    constructor() {
      super(),
        (this.container = this),
        (this.drawerInstance = null),
        (this.showDrawerOnSelect = this.showDrawerOnSelect.bind(this)),
        (this.hideDrawerOnDeselect = this.hideDrawerOnDeselect.bind(this));
    }
  };
  customElements.get("mobile-menu") || customElements.define("mobile-menu", Qr);
  const Xr = (t, e = !1, i = "block") => {
      t && (e ? t.style.removeProperty("display") : (t.style.display = i));
    },
    Yr = (t) => {
      t && (t.style.display = "none");
    },
    Jr = (t) => {
      const { stickyHeaderHeight: e } = R();
      window.scrollTo({
        top: t + Math.round(window.scrollY) - e,
        left: 0,
        behavior: "smooth",
      });
    },
    Zr = "[data-store-availability-list]",
    ta = {
      close: ".js-modal-close",
      open: ".js-modal-open-store-availability-modal",
      openClass: "modal--is-active",
      openBodyClass: "modal--is-visible",
      closeModalOnClick: !1,
      scrollIntoView: !1,
    };
  const ea = "body",
    ia = "[data-store-availability-modal]",
    sa = "[data-store-availability-modal-open]",
    oa = "[data-store-availability-modal-close]",
    na = "[data-store-availability-modal-product__title]",
    ra = "store-availabilities-modal--active";
  const aa = "[data-product-form]",
    la = "[data-option-position]",
    ca = '[name^="options"], [data-popout-option]',
    ha = "sold-out",
    da = "unavailable",
    ua = "data-option-position",
    pa = "data-value";
  const ma = 1,
    ga = "data-notification-popup",
    fa = {
      history: !1,
      focus: !1,
      mainClass: "pswp--notification pswp--not-close-btn",
      closeOnVerticalDrag: !1,
    };
  let ya = class {
    init() {
      const t = [{ html: this.notificationPopupHtml }];
      (this.a11y.state.trigger = this.button), new Oc(t, fa, ma);
    }
    constructor(t) {
      (this.button = t),
        (this.a11y = ci),
        (this.notificationPopupHtml = this.button.getAttribute(ga)),
        "" !== this.notificationPopupHtml.trim() && this.init();
    }
  };
  const va = "[data-product]",
    ba = "[data-product-form]",
    wa = "[data-add-to-cart]",
    Sa = "[data-add-to-cart-text]",
    Ea = "[data-buy-it-now]",
    La = "[data-compare-price]",
    ka = "[data-form-wrapper]",
    Aa = "[data-site-header]",
    Ca = "[data-item-count-for-variant]",
    qa = "[data-max-inventory]",
    Ta = "[data-product-select]",
    Pa = "_preorder",
    xa = "[data-price-wrapper]",
    Ia = "[data-price-off]",
    Ha = "[data-price-off-amount]",
    Fa = "[data-product-slide]",
    Ma = "[data-product-image]",
    Da = "[data-product-single-media-slider]",
    Oa = "[data-product-json]",
    Ba = "[data-product-price]",
    za = "[data-product-unit-price]",
    _a = "[data-product-base]",
    $a = "[data-product-unit]",
    Ra = "[data-subscription-watch-price]",
    Va = "[data-subscription-selectors]",
    Na = "[data-toggles-group]",
    Wa = "data-group-toggle",
    Ua = "[data-plan-description]",
    ja = "[data-remaining-count]",
    Ga = "[data-remaining-wrapper]",
    Ka = "[data-product-remaining-json]",
    Qa = "[data-store-availability-container]",
    Xa = "[data-upsell-btn]",
    Ya = ".shopify-section",
    Ja = "[data-quick-view-item]",
    Za = "[data-notification-button-text]",
    tl = "[data-swatches-container]",
    el = "[data-swatches-more]",
    il = "[data-option-position]",
    sl = "[data-variant-buttons]",
    ol = "[data-variant-option-image]",
    nl = ".shopify-payment-button__button--unbranded",
    rl = "[data-variant-final-sale-metafield]",
    al = "[data-final-sale-badge]",
    ll = "hidden",
    cl = "variant--soldout",
    hl = "variant--unavailabe",
    dl = "product__price--sale",
    ul = "product__price--hidden",
    pl = "count-is-low",
    ml = "count-is-in",
    gl = "count-is-out",
    fl = "count-is-unavailable",
    yl = "selector-wrapper--visible",
    vl = "data-image-id",
    bl = "data-tall-layout",
    wl = "data-enable-history-state",
    Sl = "data-notification-popup",
    El = "data-swatch-variant",
    Ll = "data-atc-button",
    kl = "data-max-inventory-reached",
    Al = "data-error-message-position",
    Cl = "data-variant-title",
    ql = "data-final-sale";
  let Tl = {},
    Pl = class {
      init() {
        let t = null;
        const e = this.container.querySelector(Oa);
        e && (t = e.innerHTML),
          t
            ? ((this.productJSON = JSON.parse(t)),
              this.linkForm(),
              (this.sellout = new (class {
                init() {
                  this.update();
                }
                update() {
                  this.getCurrentState(),
                    this.optionElements.forEach((t) => {
                      const e = t.value || t.getAttribute(pa),
                        i = t.closest(la);
                      if (!i) return;
                      const s = i.getAttribute(ua),
                        o = parseInt(s, 10) - 1;
                      let n = [...this.selections];
                      n[o] = e;
                      const r = this.productJSON.variants.find((t) => {
                        let e = !0;
                        for (let i = 0; i < n.length; i++)
                          t.options[i] !== n[i] && (e = !1);
                        return e;
                      });
                      t.parentElement.classList.remove(ha, da),
                        void 0 === r
                          ? t.parentElement.classList.add(da)
                          : !1 === (null == r ? void 0 : r.available) &&
                            t.parentElement.classList.add(ha);
                    });
                }
                getCurrentState() {
                  for (var t of ((this.formData = new FormData(this.form)),
                  (this.selections = []),
                  this.formData.entries()))
                    t[0].includes("options[") && this.selections.push(t[1]);
                }
                constructor(t, e) {
                  (this.container = t),
                    (this.productJSON = e),
                    (this.form = this.container.querySelector(aa)),
                    (this.formData = new FormData(this.form)),
                    (this.optionElements = this.container.querySelectorAll(ca)),
                    this.productJSON && this.form && this.init();
                }
              })(this.container, this.productJSON)))
            : console.error("Missing product JSON"),
          this.hasVariantOptionWithImage &&
            ((this.variantButtonsContainer =
              this.variantOptionImages[0].closest(sl)),
            this.equalizeImageOptionContainers());
      }
      resizeEvents() {
        this.hasVariantOptionWithImage && this.equalizeImageOptionContainers();
      }
      linkForm() {
        this.productForm = new (class {
          destroy() {
            this._listeners.removeAll();
          }
          options() {
            return this._serializeInputValues(this.optionInputs, function (t) {
              return (
                (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t
              );
            });
          }
          variant() {
            const t = this.options();
            return t.length ? Ps(this.product, t) : this.product.variants[0];
          }
          plan(t) {
            let e = { allocation: null, group: null, detail: null };
            const i = new FormData(this.form).get("selling_plan");
            return (
              i &&
                t &&
                (e.allocation = t.selling_plan_allocations.find(function (t) {
                  return t.selling_plan_id.toString() === i.toString();
                })),
              e.allocation &&
                (e.group = this.product.selling_plan_groups.find(function (t) {
                  return (
                    t.id.toString() ===
                    e.allocation.selling_plan_group_id.toString()
                  );
                })),
              e.group &&
                (e.detail = e.group.selling_plans.find(function (t) {
                  return t.id.toString() === i.toString();
                })),
              e && e.allocation && e.detail && e.allocation ? e : null
            );
          }
          properties() {
            return this._serializeInputValues(
              this.propertyInputs,
              function (t) {
                return (
                  (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
                );
              }
            );
          }
          quantity() {
            return this.quantityInputs[0]
              ? Number.parseInt(this.quantityInputs[0].value, 10)
              : 1;
          }
          getFormState() {
            const t = this.variant();
            return {
              options: this.options(),
              variant: t,
              properties: this.properties(),
              quantity: this.quantity(),
              plan: this.plan(t),
            };
          }
          _setIdInputValue(t) {
            t && t.id
              ? (this.variantElement.value = t.id.toString())
              : (this.variantElement.value = ""),
              this.variantElement.dispatchEvent(new Event("change"));
          }
          _onSubmit(t, e) {
            (e.dataset = this.getFormState()),
              t.onFormSubmit && t.onFormSubmit(e);
          }
          _onOptionChange(t) {
            this._setIdInputValue(t.dataset.variant);
          }
          _onFormEvent(t) {
            return void 0 === t
              ? Function.prototype.bind()
              : function (e) {
                  (e.dataset = this.getFormState()),
                    this._setIdInputValue(e.dataset.variant),
                    t(e);
                }.bind(this);
          }
          _initInputs(t, e) {
            return Array.prototype.slice
              .call(this.element.querySelectorAll(t))
              .map(
                function (t) {
                  return (
                    this._listeners.add(t, "change", this._onFormEvent(e)), t
                  );
                }.bind(this)
              );
          }
          _serializeInputValues(t, e) {
            return t.reduce(function (t, i) {
              return (
                (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                  t.push(e({ name: i.name, value: i.value })),
                t
              );
            }, []);
          }
          _validateProductObject(t) {
            if ("object" != typeof t)
              throw new TypeError(t + " is not an object.");
            if (void 0 === t.variants[0].options)
              throw new TypeError(
                "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
              );
            return t;
          }
          constructor(t, e, i) {
            (this.element = t),
              (this.form =
                "FORM" == this.element.tagName
                  ? this.element
                  : this.element.querySelector("form")),
              (this.product = this._validateProductObject(e)),
              (this.variantElement = this.element.querySelector(Is)),
              (i = i || {}),
              (this._listeners = new Ts()),
              this._listeners.add(
                this.element,
                "submit",
                this._onSubmit.bind(this, i)
              ),
              (this.optionInputs = this._initInputs(Fs, i.onOptionChange)),
              (this.planInputs = this._initInputs(Hs, i.onPlanChange)),
              (this.quantityInputs = this._initInputs(Ms, i.onQuantityChange)),
              (this.propertyInputs = this._initInputs(Ds, i.onPropertyChange));
          }
        })(this.productForm, this.productJSON, {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
          onQuantityChange: this.onQuantityChange.bind(this),
        });
        const t = this.productForm.getFormState();
        if (
          (this.pushState(t, !0),
          this.subsToggleListeners(),
          this.swatchesContainer)
        ) {
          this.observeSwatch(t);
          const e = this.swatchesContainer.closest(il),
            i = e.querySelector(el);
          null == i ||
            i.addEventListener("click", (t) => {
              t.preventDefault(),
                e.classList.contains(yl)
                  ? e.classList.remove(yl)
                  : e.classList.add(yl);
            });
        }
        (this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo()),
          document.addEventListener(
            "theme:cart:close",
            this.checkLiveCartInfoCallback
          );
      }
      onOptionChange(t) {
        this.pushState(t.dataset), this.updateProductImage(t);
      }
      onPlanChange(t) {
        this.subPrices && this.pushState(t.dataset);
      }
      onQuantityChange(t) {
        this.pushState(t.dataset);
      }
      pushState(t, e = !1) {
        var i;
        (this.productState = this.setProductState(t)),
          this.updateAddToCartState(t),
          this.updateProductPrices(t),
          this.updateSaleText(t),
          this.updateSubscriptionText(t),
          this.updateTitleAttr(t),
          this.fireHookEvent(t),
          this.updateRemaining(t),
          this.checkLiveCartInfo(t),
          null === (i = this.sellout) || void 0 === i || i.update(t),
          this.enableHistoryState && !e && this.updateHistoryState(t),
          this.storeAvailability &&
            (t.variant
              ? this.storeAvailability.updateContent(
                  t.variant.id,
                  this.productForm.product.title
                )
              : this.storeAvailability.clearContent());
      }
      updateTitleAttr(t) {
        const e = t.variant;
        if (!e) return;
        let i = this.productForm.product.title;
        e.public_title && (i += ` - ${e.title}`),
          this.productForm.element.setAttribute(Cl, i);
      }
      updateAddToCartState(t) {
        const e = t.variant,
          i = this.container.querySelectorAll(xa),
          s = this.container.querySelectorAll(wa),
          o = this.container.querySelectorAll(Sa),
          n = this.container.querySelectorAll(ka),
          r = this.container.querySelector(Ea);
        let a = theme.strings.add_to_cart;
        let b = theme.strings.preorder;
        theme.settings.atcButtonShowPrice &&
          (a = `${a}<span data-product-price class="product__price--regular"></span> <s data-compare-price class="product__price--compare"></s>`),
          this.productJSON.tags.includes(Pa) && (a = `${b}<span data-product-price class="product__price--regular"></span> <s data-compare-price class="product__price--compare"></s>`),
          null == i ||
            i.forEach((t) => {
              t.hasAttribute(Ll) || t.classList.toggle(ul, !e);
            }),
          null == s ||
            s.forEach((t) => {
              var i;
              if (t.matches(Xa)) return;
              if (((t.disabled = !0), null == r || r.classList.add(ll), !e))
                return;
              if (
                ((t.disabled = !1),
                e.available && (null == r || r.classList.remove(ll)),
                !t.hasAttribute(Sl))
              )
                return;
              const s = t.id.replace("AddToCart", "NotificationForm"),
                o = this.sessionStorage.getItem("notification_form_id");
              let n = !1,
                a = e.id,
                l = e.name,
                c = e.title;
              if (o) {
                const t = o.substring(0, o.lastIndexOf("--")),
                  e = o.split("--").slice(-1)[0];
                (n = s === t),
                  n &&
                    ((this.latestVariantId = a),
                    (this.latestVariantName = l),
                    (this.latestVariantTitle = c),
                    (a = Number(e)),
                    this.productJSON.variants.forEach((t) => {
                      t.id === a && ((l = t.name), (c = t.title));
                    }));
              }
              let h = t.getAttribute(Sl);
              const d =
                null ===
                  (i = new DOMParser()
                    .parseFromString(h, "text/html")
                    .querySelector(Za)) || void 0 === i
                  ? void 0
                  : i.innerHTML;
              if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                var u;
                (h = h.replaceAll(this.latestVariantId, a)),
                  (h = h.replaceAll(
                    `<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`,
                    `<p class='product__notification__subtitle'>${c}</p>`
                  )),
                  (h = h.replaceAll(
                    `value='${this.latestVariantName}'>`,
                    `value='${l}'>`
                  ));
                const t =
                  null ===
                    (u = new DOMParser()
                      .parseFromString(h, "text/html")
                      .querySelector(Za)) || void 0 === u
                    ? void 0
                    : u.innerHTML;
                h = h.replace(t, d);
              }
              t.setAttribute(Sl, h),
                n && (this.scrollToForm(this.product.closest(Ya)), new ya(t)),
                (this.latestVariantId = a),
                (this.latestVariantName = l),
                (this.latestVariantTitle = c);
            }),
          null == o ||
            o.forEach((t) => {
              if (e) {
                if (e.available) t.innerHTML = a;
                else if (
                  ((t.innerHTML = theme.strings.sold_out),
                  t.parentNode.hasAttribute(Sl))
                ) {
                  if (t.closest(Ja)) return;
                  t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                }
              } else t.innerHTML = theme.strings.unavailable;
            }),
          null == n ||
            n.forEach((t) => {
              if (!e) return t.classList.add(hl), void t.classList.remove(cl);
              const i = t.querySelector(Ta);
              if ((i && (i.value = e.id), !e.available))
                return t.classList.add(cl), void t.classList.remove(hl);
              t.classList.remove(cl, hl);
            });
      }
      updateHistoryState(t) {
        const e = t.variant,
          i = t.plan,
          s = window.location.href;
        if (e && s.includes("/product")) {
          const t = new window.URL(s),
            o = t.searchParams;
          o.set("variant", e.id),
            i && i.detail && i.detail.id && this.productState.hasPlan
              ? o.set("selling_plan", i.detail.id)
              : o.delete("selling_plan"),
            (t.search = o.toString());
          const n = t.toString();
          window.history.replaceState({ path: n }, "", n);
        }
      }
      updateRemaining(t) {
        const e = t.variant,
          i = [ml, gl, fl, pl];
        if (e && this.remainingWrapper && this.remainingJSON) {
          const t = this.remainingJSON[e.id];
          ("out" === t || t < 1) &&
            (this.remainingWrapper.classList.remove(...i),
            this.remainingWrapper.classList.add(gl)),
            ("in" === t || t >= this.remainingMaxInt) &&
              (this.remainingWrapper.classList.remove(...i),
              this.remainingWrapper.classList.add(ml)),
            ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
              (this.remainingWrapper.classList.remove(...i),
              this.remainingWrapper.classList.add(pl),
              this.remainingCount && (this.remainingCount.innerHTML = t));
        } else
          !e &&
            this.remainingWrapper &&
            (this.remainingWrapper.classList.remove(...i),
            this.remainingWrapper.classList.add(fl));
      }
      checkLiveCartInfo(t) {
        const e = (t || this.productForm.getFormState()).variant;
        if (!e) return;
        const i = `${theme.routes.root}products/${this.productJSON.handle}?section_id=api-live-cart-info&variant=${e.id}`;
        fetch(i)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser().parseFromString(t, "text/html"),
              i = Number(e.querySelector(Ca).innerHTML),
              s = e.querySelector(qa).innerHTML,
              o = Number(s),
              n = Boolean(this.productForm.quantity() + i > o),
              r = "" !== s && n,
              a = "" !== s && i === o ? "form" : "cart";
            this.productForm.element.setAttribute(kl, r),
              this.productForm.element.setAttribute(Al, a);
          })
          .catch((t) => console.log("error: ", t));
      }
      equalizeImageOptionContainers() {
        if (this.variantOptionImages.length <= 1) return;
        const t = [...this.variantOptionImages].map((t) =>
            Math.floor(t.offsetHeight)
          ),
          e = [...this.variantOptionImages].map((t) =>
            Math.floor(t.offsetWidth)
          ),
          i = Math.max(...e),
          s = Math.max(...t);
        this.variantButtonsContainer.style.setProperty(
          "--option-image-width",
          i + "px"
        ),
          this.variantButtonsContainer.style.setProperty(
            "--option-image-height",
            s + "px"
          );
      }
      getBaseUnit(t) {
        return 1 === t.unit_price_measurement.reference_value
          ? t.unit_price_measurement.reference_unit
          : t.unit_price_measurement.reference_value +
              t.unit_price_measurement.reference_unit;
      }
      subsToggleListeners() {
        this.container.querySelectorAll(Na).forEach((t) => {
          t.addEventListener(
            "change",
            function (t) {
              const e = t.target.value.toString(),
                i = this.container.querySelector(`[${Wa}="${e}"]`),
                s = this.container.querySelectorAll(`[${Wa}]`);
              if (i) {
                i.classList.remove(ll);
                const t = i.querySelector('[name="selling_plan"]');
                (t.checked = !0), t.dispatchEvent(new Event("change"));
              }
              s.forEach((t) => {
                if (t !== i) {
                  t.classList.add(ll);
                  t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                    (t.checked = !1), t.dispatchEvent(new Event("change"));
                  });
                }
              });
            }.bind(this)
          );
        });
      }
      updateSaleText(t) {
        this.productState.planSale
          ? this.updateSaleTextSubscription(t)
          : this.productState.onSale
          ? this.updateSaleTextStandard(t)
          : this.priceOffWrap && this.priceOffWrap.classList.add(ll);
      }
      isVariantFinalSale(t) {
        var e;
        const i =
          null === (e = document.querySelector(rl)) || void 0 === e
            ? void 0
            : e.textContent;
        if (!i) return;
        const s = JSON.parse(i);
        let o = !1;
        return (
          s.forEach((e) => {
            Number(e.variant_id) === t.id && (o = "true" === e.metafield_value);
          }),
          o
        );
      }
      updateSaleTextStandard(t) {
        var e, s;
        if (!this.priceOffWrap) return;
        const o = t.variant,
          n =
            null === (e = this.priceOffWrap) || void 0 === e
              ? void 0
              : e.querySelector(al),
          r = null == o ? void 0 : o.compare_at_price,
          a = null == o ? void 0 : o.price;
        if (window.theme.settings.showSavingBadge)
          if (
            window.theme.settings.savingBadgeType &&
            "percentage" === window.theme.settings.savingBadgeType
          ) {
            const t = (r - a) / r,
              e = Math.floor(100 * t);
            this.priceOffAmount.innerHTML = `${e}%`;
          } else {
            const t = r - a;
            this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat);
          }
        const l =
          (null === (s = this.priceOffWrap) || void 0 === s
            ? void 0
            : s.hasAttribute(ql)) || this.isVariantFinalSale(o);
        n && n.classList.toggle(ll, !l), this.priceOffWrap.classList.remove(ll);
      }
      updateSaleTextSubscription(t) {
        const e = t.variant,
          s = this.productForm.product.selling_plan_groups.find(
            (t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id
          ),
          o = t.plan
            ? t.plan.detail.price_adjustments[0]
            : s.selling_plans[0].price_adjustments[0],
          n = o.value || 0,
          r =
            "percentage" === o.value_type
              ? `${n}%`
              : i.formatMoney(e.price - n, theme.moneyFormat);
        (this.priceOffAmount.innerHTML = r),
          this.priceOffWrap.classList.remove(ll);
      }
      updateSubscriptionText(t) {
        t.plan && this.planDecription && null !== t.plan.detail.description
          ? ((this.planDecription.innerHTML = t.plan.detail.description),
            this.planDecription.classList.remove(ll))
          : this.planDecription && this.planDecription.classList.add(ll);
      }
      updateProductPrices(t) {
        const e = t.variant,
          s = t.plan;
        this.container.querySelectorAll(xa).forEach((t) => {
          const o = t.querySelector(La),
            n = t.querySelector(Ba);
          let r = "",
            a = "";
          if (
            (this.productState.available &&
              ((r = e.compare_at_price), (a = e.price)),
            this.productState.hasPlan)
          ) {
            a = s
              ? s.allocation.price
              : e.selling_plan_allocations[0].per_delivery_price;
          }
          if (this.productState.planSale) {
            const t = s
              ? s.allocation.price
              : e.selling_plan_allocations[0].per_delivery_price;
            (r = s
              ? s.allocation.compare_at_price
              : e.selling_plan_allocations[0].compare_at_price),
              (a = t);
          }
          if (
            (o &&
              (this.productState.onSale || this.productState.planSale
                ? (o.classList.remove(ll), n.classList.add(dl))
                : (o.classList.add(ll), n.classList.remove(dl)),
              (o.innerHTML = theme.settings.currency_code_enable
                ? i.formatMoney(r, theme.moneyWithCurrencyFormat)
                : i.formatMoney(r, theme.moneyFormat))),
            n)
          ) {
            if (t.hasAttribute(Ll)) {
              a *= this.productForm.quantity();
            }
            n.innerHTML =
              0 === a
                ? window.theme.strings.free
                : theme.settings.currency_code_enable
                ? i.formatMoney(a, theme.moneyWithCurrencyFormat)
                : i.formatMoney(a, theme.moneyFormat);
          }
        }),
          this.hasUnitPricing && this.updateProductUnits(t);
      }
      updateProductUnits(t) {
        const e = t.variant,
          s = t.plan;
        let o = null;
        if (
          (((e && e.unit_price) || (!s && !e.requires_selling_plan)) &&
            (o = e.unit_price),
          s &&
            (null == s ? void 0 : s.allocation) &&
            (null == s ? void 0 : s.allocation.unit_price) &&
            (o = s.allocation.unit_price),
          !s &&
            e.requires_selling_plan &&
            e.selling_plan_allocations &&
            e.selling_plan_allocations.length > 0)
        ) {
          o = e.selling_plan_allocations[0].unit_price;
        }
        if (o) {
          const t = this.getBaseUnit(e),
            s =
              0 === o
                ? window.theme.strings.free
                : i.formatMoney(o, theme.moneyFormat);
          (this.container.querySelector(za).innerHTML = s),
            (this.container.querySelector(_a).innerHTML = t),
            Xr(this.container.querySelector($a));
        } else Yr(this.container.querySelector($a));
      }
      fireHookEvent(t) {
        const e = t.variant;
        this.container.dispatchEvent(
          new CustomEvent("theme:variant:change", {
            detail: { variant: e },
            bubbles: !0,
          })
        );
      }
      setProductState(t) {
        const e = t.variant,
          i = t.plan,
          s = {
            available: !0,
            soldOut: !1,
            onSale: !1,
            showUnitPrice: !1,
            requiresPlan: !1,
            hasPlan: !1,
            planPerDelivery: !1,
            planSale: !1,
          };
        if (e) {
          const t = e.requires_selling_plan || !1;
          e.available || (s.soldOut = !0),
            e.compare_at_price > e.price && (s.onSale = !0),
            e.unit_price && (s.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (s.requiresPlan = !0),
            i &&
              this.subPrices &&
              ((s.hasPlan = !0),
              i.allocation.per_delivery_price !== i.allocation.price &&
                (s.planPerDelivery = !0),
              e.price > i.allocation.price && (s.planSale = !0)),
            !i &&
              t &&
              ((s.hasPlan = !0),
              e.selling_plan_allocations[0].per_delivery_price !==
                e.selling_plan_allocations[0].price && (s.planPerDelivery = !0),
              e.price > e.selling_plan_allocations[0].price &&
                (s.planSale = !0));
        } else s.available = !1;
        return s;
      }
      updateProductImage(t) {
        const i = t.dataset.variant;
        if (!i || !(null == i ? void 0 : i.featured_media)) return;
        const s = this.container.querySelector(
            `${Ma}[${vl}="${i.featured_media.id}"]`
          ),
          o = null == s ? void 0 : s.closest(Fa);
        if (o) {
          const t = parseInt([...o.parentElement.children].indexOf(o)),
            n = this.container.querySelector(Da),
            r = e.data(n);
          if (r && r.isActive) {
            const t = n.querySelector(`[data-id="${i.featured_media.id}"]`);
            if (t) {
              const e = parseInt([...t.parentNode.children].indexOf(t));
              r.select(e);
            }
            return;
          }
          if (this.tallLayout) {
            const e = s.getBoundingClientRect().top;
            if (0 === t && e + window.scrollY > window.pageYOffset) return;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              Jr(e);
          }
        }
      }
      observeSwatch(t) {
        const e = this.swatchesContainer.querySelector(
          `[${El}*="${t.variant.id}"]`
        );
        this.swatchesContainer.closest(il).classList.remove(yl),
          new IntersectionObserver(
            (t, e) => {
              t.forEach((t) => {
                0 == t.intersectionRatio &&
                  this.swatchesContainer.closest(il).classList.add(yl);
              });
            },
            { root: this.container, threshold: [0.95, 1] }
          ).observe(e);
      }
      observeContainer() {
        let t = this.buyItNow.querySelector(nl);
        if (t)
          return (
            t.classList.add(window.theme.settings.buynowButtonColor),
            t.classList.add(window.theme.settings.buynowButtonStyle),
            t.classList.add(window.theme.settings.buynowButtonSize),
            void this.insertHoverElement(t)
          );
        (this.mutationObserver = new MutationObserver((t) => {
          for (const i of t)
            if ("childList" === i.type) {
              const t = i.target.querySelector(nl);
              var e;
              if (t)
                this.insertHoverElement(t),
                  null === (e = this.mutationObserver) ||
                    void 0 === e ||
                    e.disconnect(),
                  (this.mutationObserver = null);
            }
        })),
          this.mutationObserver.observe(this.buyItNow, {
            childList: !0,
            subtree: !0,
          });
      }
      insertHoverElement(t) {
        const e = t.innerHTML;
        t.innerHTML = `<hover-button>${e}</hover-button>`;
      }
      scrollToForm(t) {
        var e;
        const i =
          null === (e = document.querySelector(Aa)) || void 0 === e
            ? void 0
            : e.dataset.height;
        visibilityHelper.isElementPartiallyVisible(t) ||
          visibilityHelper.isElementTotallyVisible(t) ||
          setTimeout(() => {
            const e = t.getBoundingClientRect().top - i;
            window.scrollTo({ top: e, left: 0, behavior: "smooth" });
          }, 400);
      }
      onUnload() {
        this.productForm && this.productForm.destroy(),
          this.hasVariantOptionWithImage &&
            window.removeEventListener(
              "theme:resize:width",
              this.onResizeCallback
            ),
          document.removeEventListener(
            "theme:cart:close",
            this.checkLiveCartInfoCallback
          );
      }
      constructor(t) {
        (this.container = t),
          (this.product = this.container.querySelector(va)),
          (this.productForm = this.container.querySelector(ba)),
          (this.tallLayout = "true" === this.container.getAttribute(bl)),
          (this.addToCartButton = this.container.querySelector(wa)),
          (this.buyItNow = this.container.querySelector(Ea)),
          (this.hasPaymentButton = null !== this.buyItNow),
          (this.variantOptionImages = this.container.querySelectorAll(ol)),
          (this.hasVariantOptionWithImage =
            this.variantOptionImages.length > 0),
          this.product &&
            this.productForm &&
            ((this.storeAvailabilityContainer =
              this.container.querySelector(Qa)),
            (this.enableHistoryState =
              "true" === this.container.getAttribute(wl)),
            (this.hasUnitPricing = this.container.querySelector($a)),
            (this.subSelectors = this.container.querySelector(Va)),
            (this.subPrices = this.container.querySelector(Ra)),
            (this.priceOffWrap = this.container.querySelector(Ia)),
            (this.priceOffAmount = this.container.querySelector(Ha)),
            (this.planDecription = this.container.querySelector(Ua)),
            (this.swatchesContainer = this.container.querySelector(tl)),
            (this.latestVariantId = ""),
            (this.latestVariantName = ""),
            (this.latestVariantTitle = ""),
            (this.sellout = null),
            (this.sessionStorage = window.sessionStorage),
            (this.remainingWrapper = this.container.querySelector(Ga)),
            this.remainingWrapper &&
              ((this.remainingMaxInt = parseInt(
                this.remainingWrapper.dataset.remainingMax,
                10
              )),
              (this.remainingCount = this.container.querySelector(ja)),
              (this.remainingJSONWrapper = this.container.querySelector(Ka)),
              (this.remainingJSON = null),
              this.remainingJSONWrapper &&
                "" !== this.remainingJSONWrapper.innerHTML &&
                (this.remainingJSON = JSON.parse(
                  this.remainingJSONWrapper.innerHTML
                ))),
            this.storeAvailabilityContainer &&
              (this.storeAvailability = new (class {
                updateContent(t, e) {
                  this._fetchStoreAvailabilities(t, e);
                }
                clearContent() {
                  this.container.innerHTML = "";
                }
                _initModal() {
                  return new (class {
                    init() {
                      this.openElement.addEventListener(
                        "click",
                        this.open.bind(this)
                      ),
                        this.modal
                          .querySelector(this.config.close)
                          .addEventListener(
                            "click",
                            this.closeModal.bind(this)
                          );
                    }
                    open(t) {
                      let e = !1;
                      if (
                        (t ? t.preventDefault() : (e = !0),
                        this.modalIsOpen && !e)
                      )
                        return void this.closeModal();
                      this.modal.classList.add(this.config.openClass),
                        this.nodes.parents.forEach((t) => {
                          t.classList.add(this.config.openBodyClass);
                        }),
                        (this.modalIsOpen = !0);
                      const i = document.querySelector(Zr);
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", {
                          bubbles: !0,
                          detail: i,
                        })
                      ),
                        this.config.scrollIntoView && this.scrollIntoView(),
                        this.bindEvents(),
                        this.a11y.trapFocus({ container: this.modal });
                    }
                    closeModal() {
                      if (this.modalIsOpen) {
                        document.activeElement.blur(),
                          this.modal.classList.remove(this.config.openClass);
                        var t = this;
                        this.nodes.parents.forEach(function (e) {
                          e.classList.remove(t.config.openBodyClass);
                        }),
                          (this.modalIsOpen = !1),
                          this.openElement.focus(),
                          this.unbindEvents(),
                          this.a11y.removeTrapFocus({ container: this.modal }),
                          document.dispatchEvent(
                            new CustomEvent("theme:scroll:unlock", {
                              bubbles: !0,
                              detail: 400,
                            })
                          );
                      }
                    }
                    bindEvents() {
                      (this.keyupHandler = this.keyupHandler.bind(this)),
                        (this.clickHandler = this.clickHandler.bind(this)),
                        document.body.addEventListener(
                          "keyup",
                          this.keyupHandler
                        ),
                        document.body.addEventListener(
                          "click",
                          this.clickHandler
                        );
                    }
                    unbindEvents() {
                      document.body.removeEventListener(
                        "keyup",
                        this.keyupHandler
                      ),
                        document.body.removeEventListener(
                          "click",
                          this.clickHandler
                        );
                    }
                    keyupHandler(t) {
                      t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                    }
                    clickHandler(t) {
                      !this.config.closeModalOnClick ||
                        this.modal.contains(t.target) ||
                        t.target.matches(this.config.open) ||
                        this.closeModal();
                    }
                    scrollIntoView() {
                      this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                    }
                    constructor(t, e) {
                      if (
                        ((this.modal = document.getElementById(t)), !this.modal)
                      )
                        return !1;
                      (this.nodes = {
                        parents: [
                          document.querySelector("html"),
                          document.body,
                        ],
                      }),
                        (this.config = Object.assign(ta, e)),
                        (this.modalIsOpen = !1),
                        (this.focusOnOpen = this.config.focusOnOpen
                          ? document.getElementById(this.config.focusOnOpen)
                          : this.modal),
                        (this.openElement = document.querySelector(
                          this.config.open
                        )),
                        (this.a11y = ci),
                        this.init();
                    }
                  })("StoreAvailabilityModal", {
                    close: oa,
                    open: sa,
                    closeModalOnClick: !0,
                    openClass: ra,
                    scrollIntoView: !1,
                  });
                }
                _fetchStoreAvailabilities(t, e) {
                  const i =
                    "/variants/" + t + "/?section_id=store-availability";
                  this.clearContent();
                  const s = this;
                  fetch(i)
                    .then(function (t) {
                      return t.text();
                    })
                    .then(function (t) {
                      const i = document.querySelector(ea);
                      let o = i.querySelector(ia);
                      o && o.remove(),
                        (s.container.innerHTML = t),
                        (s.container.innerHTML =
                          s.container.firstElementChild.innerHTML),
                        "" !== s.container.firstElementChild.innerHTML.trim()
                          ? s.container.querySelector(sa) &&
                            ((s.modal = s._initModal()),
                            s._updateProductTitle(e),
                            (o = s.container.querySelector(ia)),
                            o && i.appendChild(o))
                          : s.clearContent();
                    });
                }
                _updateProductTitle(t) {
                  this.container.querySelector(na).textContent = t;
                }
                constructor(t) {
                  this.container = t;
                }
              })(this.storeAvailabilityContainer)),
            this.init(),
            this.hasVariantOptionWithImage &&
              ((this.onResizeCallback = () => this.resizeEvents()),
              window.addEventListener(
                "theme:resize:width",
                this.onResizeCallback
              )),
            this.hasPaymentButton &&
              ((this.mutationObserver = null), this.observeContainer()));
      }
    };
  const xl = {
      onLoad() {
        Tl[this.id] = new Pl(this.container);
      },
      onUnload() {
        Tl[this.id].onUnload();
      },
    },
    Il = "[data-add-to-cart]",
    Hl = "[data-deferred-media]",
    Fl = "[data-deferred-media-button]",
    Ml = "[data-popup-close]",
    Dl = "[data-quick-view-inner]",
    Ol = "[data-quick-view-item-holder]",
    Bl = "[data-product]",
    zl = "[data-product-form]",
    _l = "[data-product-single-media-slider]",
    $l = "[data-product-single-media-wrapper]",
    Rl = "[data-model]",
    Vl = "[data-product-json]",
    Nl = "[data-quick-view-foot-inner]",
    Wl = "[data-shop-the-look-thumb]",
    Ul = "[data-tooltip]",
    jl = "[data-drawer-toggle]",
    Gl = "[data-quick-view-focus]",
    Kl = "has-media-active",
    Ql = "is-active",
    Xl = "is-loading",
    Yl = "media--hidden",
    Jl = "no-outline",
    Zl = "notification-popup-visible",
    tc = "popup-quick-view--animate-in",
    ec = "popup-quick-view--animate-out",
    ic = "popup-quick-view--animated",
    sc = "popup-quick-view",
    oc = "js-quick-view-visible",
    nc = "js-quick-view-from-cart",
    rc = "js-drawer-open",
    ac = "id",
    lc = "data-media-id",
    cc = "data-section-id",
    hc = "loaded",
    dc = "data-quick-view-onboarding",
    uc = "data-hotspot",
    pc = "data-hotspot-ref",
    mc = "AddToCartForm--",
    gc = "AddToCart--";
  const fc = 400,
    yc = ".pswp",
    vc = ".pswp__custom-close",
    bc = "iframe, video",
    wc = ".pswp__custom-iframe",
    Sc = ".pswp__thumbs",
    Ec = ".pswp__button, .pswp__caption-close",
    Lc = "is-current",
    kc = "pswp--custom-loader",
    Ac = "pswp--custom-opening",
    Cc = "pswp__loader",
    qc = "pswp--open",
    Tc = "pswp__button--close",
    Pc = "pswp--notification",
    xc = "popup-quick-view",
    Ic = "js-drawer-open-cart",
    Hc = "popup-quick-view--animate-out",
    Fc = "data-pswp-option-classes",
    Mc = "data-video-type",
    Dc = `<div class="${Cc}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
  let Oc = class {
    init() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
      ),
        this.pswpElement.classList.add(Ac),
        this.initLoader(),
        di({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(kc) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(Fc, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = Dc), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(Fc, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.remove(Ac),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
        this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
        this.popup.listen("imageLoadComplete", this.loadingStateCallback),
        this.popup.listen("beforeChange", this.setCurrentThumbCallback),
        this.popup.listen("close", this.onCloseCallback),
        this.popup.init(),
        this.initPopupCallback();
    }
    loadingState(t) {
      t === this.options.index &&
        this.pswpElement.classList.contains(kc) &&
        this.pswpElement.classList.remove(kc);
    }
    initPopupCallback() {
      this.isVideo && this.hideUnusedButtons(),
        this.initVideo(),
        this.thumbsActions(),
        this.a11y.trapFocus({ container: this.pswpElement }),
        this.pswpElement.classList.contains(xc) &&
          new (class {
            initTooltips() {
              (this.tooltips = this.pswpElement.querySelectorAll(Ul)),
                this.tooltips.forEach((t) => {
                  new us(t);
                });
            }
            handleDraggable(t, e) {
              t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
            }
            initItems(t, e) {
              this.addFormSuffix(t),
                this.initProductSlider(t, e),
                this.initProductVideo(t),
                this.initProductModel(t),
                this.initShopifyXrLaunch(t),
                uo(t),
                this.pswpElement.querySelectorAll(jl).length && new Gr(t),
                dt(t);
              const i = new Pl(t.parentNode);
              this.productForms.push(i),
                Shopify.PaymentButton && Shopify.PaymentButton.init(),
                t.classList.remove(Xl);
            }
            init() {
              document.addEventListener(
                "submit",
                this.prevent3dModelSubmitEvent
              ),
                this.popupCloseButtons.forEach((t) => {
                  t.addEventListener("keyup", (t) => {
                    (t.code !== theme.keyboardKeys.ENTER &&
                      t.code !== theme.keyboardKeys.NUMPADENTER &&
                      t.code !== theme.keyboardKeys.SPACE) ||
                      this.closePopup(t);
                  }),
                    t.addEventListener("click", (t) => {
                      this.closePopup(t);
                    });
                }),
                this.pswpElement.addEventListener(
                  "click",
                  this.outerCloseEvent
                ),
                document.dispatchEvent(
                  new CustomEvent("theme:popup:open", { bubbles: !0 })
                ),
                this.popup.listen("preventDragEvent", (t, e, i) => {
                  i.prevent = !1;
                }),
                this.pswpElement.addEventListener("mousedown", () => {
                  this.popup.framework.unbind(
                    window,
                    "pointermove pointerup pointercancel",
                    this.popup
                  );
                }),
                this.popup.listen("initialZoomInEnd", () => {
                  document.body.classList.add(oc);
                  const t = this.quickViewItemHolders.length > 0,
                    e = this.quickViewInner.querySelector(Gl),
                    i = this.quickViewInner.querySelector(`${Ol}.${Ql}`),
                    s = t ? i.querySelector(Gl) : e;
                  this.a11y.trapFocus({ container: s });
                }),
                this.pswpElement.addEventListener(
                  "animationend",
                  this.closeOnAnimationEndEvent
                ),
                this.popup.listen("destroy", () => {
                  this.flkty.length > 0 &&
                    requestAnimationFrame(() => {
                      this.flkty.forEach((t) => t.pausePlayer());
                    }),
                    document.body.classList.remove(oc),
                    document.removeEventListener(
                      "keyup",
                      this.closeOnEscapeEvent
                    ),
                    document.addEventListener("keyup", this.closeOnEscapeEvent),
                    this.pswpElement.removeEventListener(
                      "click",
                      this.outerCloseEvent
                    ),
                    this.pswpElement.removeEventListener(
                      "animationend",
                      this.closeOnAnimationEndEvent
                    ),
                    document.removeEventListener(
                      "submit",
                      this.prevent3dModelSubmitEvent
                    ),
                    this.deferredMedias.forEach((t) => {
                      t.removeAttribute(hc);
                      const e = t.closest($l);
                      e.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                        bubbles: !0,
                      }),
                        e.classList.add(Yl);
                    });
                }),
                document.addEventListener("keyup", this.closeOnEscapeEvent),
                document.addEventListener("theme:cart:added", () => {
                  this.pswpElement.classList.contains(sc) &&
                    this.pswpElement.classList.add(ec);
                }),
                this.animateInQuickview(),
                this.initShopTheLookListeners();
            }
            initShopTheLookListeners() {
              var t;
              null === (t = this.buttonsShopTheLookThumb) ||
                void 0 === t ||
                t.forEach((t) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const e = t.target.matches(Wl)
                        ? t.target
                        : t.target.closest(Wl),
                      i = this.pswpElement.querySelector(
                        `[${uc}="${e.getAttribute(pc)}"]`
                      ),
                      s = i.querySelector(Gl);
                    !e.classList.contains(Ql) &&
                      i &&
                      (this.flkty.length > 0 &&
                        requestAnimationFrame(() => {
                          this.flkty.forEach((t) => {
                            t.resize();
                            const e = this.quickViewInner.querySelectorAll($l);
                            e.length &&
                              e.forEach((t) => {
                                t.dispatchEvent(
                                  new CustomEvent("theme:media:hidden"),
                                  { bubbles: !0 }
                                ),
                                  t.classList.add(Yl);
                              });
                          });
                        }),
                      i.classList.add(Ql),
                      this.quickViewItemHolders.forEach((t) => {
                        t !== i && t.classList.remove(Ql);
                      }),
                      this.a11y.trapFocus({ container: s }));
                  });
                });
            }
            prevent3dModelSubmit(t) {
              t.submitter.closest(Hl) &&
                t.submitter.closest(zl) &&
                t.preventDefault();
            }
            closeQuickviewOnMobile() {
              window.innerWidth < window.theme.sizes.large &&
                document.body.classList.contains(oc) &&
                this.popup.close();
            }
            animateInQuickview() {
              this.pswpElement.classList.add(tc),
                this.quickViewFoot.addEventListener("animationend", (t) => {
                  this.handleAnimatedState(t);
                }),
                this.pswpElement.addEventListener("animationend", (t) => {
                  this.handleAnimatedState(t, !0);
                });
            }
            handleAnimatedState(t, e = !1) {
              if ("quickViewAnimateInUp" == t.animationName) {
                if (e && window.innerWidth >= window.theme.sizes.small) return;
                this.pswpElement.classList.add(ic),
                  this.pswpElement.classList.remove(tc),
                  document.body.classList.remove(nc),
                  mt(this.pswpElement);
              }
            }
            closePopup(t) {
              null == t || t.preventDefault(),
                document.body.classList.contains(rc) &&
                  document.dispatchEvent(
                    new CustomEvent("theme:drawer:closing", { bubbles: !0 })
                  ),
                this.pswpElement.classList.add(ec),
                this.swatchesContainer.onUnload();
            }
            closeOnAnimationEnd(t) {
              ("quickViewAnimateOutRight" != t.animationName &&
                "quickViewAnimateOutDown" != t.animationName) ||
                (this.popup.template.classList.remove(ec, ic),
                this.popup.close(),
                this.productForms.length > 0 &&
                  this.productForms.forEach((t) => t.onUnload()));
            }
            closeOnEscape(t) {
              const e = document.body.classList.contains(oc),
                i = document.body.classList.contains(Zl);
              t.code === theme.keyboardKeys.ESCAPE &&
                e &&
                !i &&
                this.closePopup(t);
            }
            initProductSlider(t, i) {
              const s = t.querySelector(_l),
                o = t.querySelectorAll($l);
              if (o.length > 1) {
                const n = new e(s, {
                  wrapAround: !0,
                  cellAlign: "left",
                  pageDots: !1,
                  prevNextButtons: !0,
                  adaptiveHeight: !1,
                  pauseAutoPlayOnHover: !1,
                  selectedAttraction: 0.2,
                  friction: 1,
                  autoPlay: !1,
                  on: {
                    ready: () => {
                      requestAnimationFrame(() => {
                        n.resize();
                      });
                    },
                    settle: () => {
                      const e = n.selectedElement.getAttribute(lc);
                      this.switchMedia(t, e);
                    },
                  },
                });
                this.flkty.push(n),
                  o.length &&
                    o.forEach((t) => {
                      t.addEventListener("theme:media:play", () => {
                        this.handleDraggable(this.flkty[i], !1),
                          t.closest(_l).classList.add(Kl);
                      }),
                        t.addEventListener("theme:media:pause", () => {
                          this.handleDraggable(this.flkty[i], !0),
                            t.closest(_l).classList.remove(Kl);
                        });
                    }),
                  Fi(s);
              }
            }
            switchMedia(t, e) {
              const i = this.quickViewInner.querySelectorAll($l),
                s = t.querySelector(`${$l}[${lc}="${e}"]`),
                o = !document.body.classList.contains(Jl);
              i.length &&
                i.forEach((t) => {
                  t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                    bubbles: !0,
                  }),
                    t.classList.add(Yl);
                }),
                o && s.focus(),
                s.closest(_l).classList.remove(Kl),
                s.classList.remove(Yl),
                s.dispatchEvent(new CustomEvent("theme:media:visible"), {
                  bubbles: !0,
                });
              const n = s.querySelector(Hl);
              n &&
                "true" !== n.getAttribute(hc) &&
                s.querySelector(Fl).dispatchEvent(new Event("click"));
            }
            initProductVideo(t) {
              const e = new Gi(t);
              this.videos.push(e);
            }
            initProductModel(t) {
              const e = t.getAttribute(cc),
                i = t.querySelectorAll(Rl);
              i.length &&
                i.forEach((t) => {
                  theme.ProductModel.init(t, e);
                });
            }
            initShopifyXrLaunch(t) {
              document.addEventListener("shopify_xr_launch", () => {
                t.querySelector(`${Rl}:not(.${Yl})`).dispatchEvent(
                  new CustomEvent("xrLaunch")
                );
              });
            }
            addFormSuffix(t) {
              const e = `${t.getAttribute(cc)}-${
                  JSON.parse(t.querySelector(Vl).innerHTML).handle
                }`,
                i = t.querySelector(zl),
                s = t.querySelector(Il);
              i.setAttribute(ac, mc + e), s.setAttribute(ac, gc + e);
            }
            constructor(t, e) {
              (this.popup = t),
                (this.pswpElement = e),
                (this.quickViewFoot = this.pswpElement.querySelector(Nl)),
                (this.quickViewInner = this.pswpElement.querySelector(Dl)),
                (this.product = this.pswpElement.querySelectorAll(Bl)),
                (this.flkty = []),
                (this.videos = []),
                (this.productForms = []),
                (this.deferredMedias = this.pswpElement.querySelectorAll(Hl)),
                (this.buttonsShopTheLookThumb =
                  this.pswpElement.querySelectorAll(Wl)),
                (this.quickViewItemHolders =
                  this.pswpElement.querySelectorAll(Ol)),
                (this.popupCloseButtons =
                  this.quickViewInner.querySelectorAll(Ml)),
                (this.a11y = ci),
                (this.prevent3dModelSubmitEvent = (t) =>
                  this.prevent3dModelSubmit(t)),
                (this.closeOnAnimationEndEvent = (t) =>
                  this.closeOnAnimationEnd(t)),
                (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                (this.outerCloseEvent = (t) => {
                  if (!this.quickViewInner.contains(t.target)) {
                    const e = this.quickViewInner.nextElementSibling;
                    if (e && e.contains(t.target)) return;
                    this.closePopup(t);
                  }
                }),
                this.product.forEach((t, e) => {
                  t.hasAttribute(dc) || this.initItems(t, e);
                }),
                this.init(),
                this.initTooltips(),
                (this.swatchesContainer = new ho(this.pswpElement));
            }
          })(this.popup, this.pswpElement),
        this.pswpElement.classList.contains(Pc) &&
          new (class {
            init() {
              this.popup.listen("preventDragEvent", (t, e, i) => {
                i.prevent = !1;
              });
              const t =
                -1 !== window.location.search.indexOf("?contact_posted=true");
              this.notificationForm = this.pswpElement.querySelector(Ti);
              const e = this.pswpElement.querySelector(xi);
              document.body.classList.add(Hi),
                this.pswpElement.addEventListener("mousedown", () => {
                  this.popup.framework.unbind(
                    window,
                    "pointermove pointerup pointercancel",
                    this.popup
                  );
                }),
                t && this.pswpElement.classList.add(Ii),
                this.notificationForm.addEventListener("submit", (t) =>
                  this.notificationSubmitEvent(t)
                ),
                this.pswpElement.addEventListener(
                  "click",
                  this.outerCloseEvent
                ),
                e.addEventListener("click", () => {
                  this.popup.close();
                }),
                this.popup.listen("destroy", () => {
                  this.notificationRemoveStorage(),
                    this.pswpElement.removeEventListener(
                      "click",
                      this.outerCloseEvent
                    ),
                    document.body.classList.remove(Hi);
                });
            }
            notificationSubmitEvent(t) {
              this.notificationStopSubmit &&
                (t.preventDefault(),
                this.notificationRemoveStorage(),
                this.notificationWriteStorage(),
                (this.notificationStopSubmit = !1),
                this.notificationForm.submit());
            }
            notificationWriteStorage() {
              void 0 !== this.sessionStorage &&
                this.sessionStorage.setItem(
                  "notification_form_id",
                  this.notificationForm.id
                );
            }
            notificationRemoveStorage() {
              this.sessionStorage.removeItem("notification_form_id");
            }
            constructor(t, e) {
              (this.popup = t),
                (this.pswpElement = e),
                (this.notificationForm = null),
                (this.notificationStopSubmit = !0),
                (this.sessionStorage = window.sessionStorage);
              const i = this.pswpElement.querySelector(Pi);
              (this.outerCloseEvent = (t) => {
                i.contains(t.target) || this.popup.close();
              }),
                this.init();
            }
          })(this.popup, this.pswpElement),
        (this.closePopup = () => {
          this.pswpElement.classList.contains(xc)
            ? this.pswpElement.classList.add(Hc)
            : this.popup.close();
        }),
        this.closeBtn &&
          this.closeBtn.addEventListener("click", this.closePopup),
        document.addEventListener("theme:cart:added", this.closePopup);
    }
    dispatchPopupInitEvent() {
      this.triggerBtn &&
        this.triggerBtn.dispatchEvent(
          new CustomEvent("theme:popup:init", { bubbles: !0 })
        );
    }
    initVideo() {
      const t = this.pswpElement.querySelector(wc);
      if (t) {
        const e = t.getAttribute(Mc);
        (this.isVideo = !0),
          "youtube" == e
            ? new (class {
                init() {
                  window.isYoutubeAPILoaded
                    ? this.loadYoutubePlayer()
                    : di({ url: "https://www.youtube.com/iframe_api" }).then(
                        () => this.loadYoutubePlayer()
                      );
                }
                loadYoutubePlayer() {
                  const t = {
                    height: "720",
                    width: "1280",
                    playerVars: this.videoOptionsVars,
                    events: {
                      onReady: (t) => {
                        const e = t.target.getIframe().id;
                        "true" ===
                        document.querySelector(`#${e}`).getAttribute(Ei)
                          ? t.target.unMute()
                          : t.target.mute(),
                          t.target.playVideo(),
                          this.checkPlayerVisibilityFlag &&
                            (this.checkPlayerVisibility(e),
                            window.addEventListener(
                              "scroll",
                              Ve(() => {
                                this.checkPlayerVisibility(e);
                              }, 150)
                            ));
                      },
                      onStateChange: (t) => {
                        0 == t.data && t.target.playVideo(),
                          1 == t.data &&
                            t.target
                              .getIframe()
                              .parentElement.classList.add(Ci);
                      },
                    },
                  };
                  (t.videoId = this.videoID),
                    this.videoID.length &&
                      YT.ready(() => {
                        qi[this.playerID] = new YT.Player(this.playerID, t);
                      }),
                    (window.isYoutubeAPILoaded = !0);
                }
                checkPlayerVisibility(t) {
                  let e;
                  if ("string" == typeof t) e = t;
                  else {
                    if (null == t.data) return;
                    e = t.data.id;
                  }
                  const i = document.getElementById(e + "-container");
                  if (!i) return;
                  const s = qi[e],
                    o = i.getBoundingClientRect();
                  let n =
                    visibilityHelper.isElementPartiallyVisible(i) ||
                    visibilityHelper.isElementTotallyVisible(i);
                  o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0),
                    n && s && "function" == typeof s.playVideo
                      ? s.playVideo()
                      : !n &&
                        s &&
                        "function" == typeof s.pauseVideo &&
                        s.pauseVideo();
                }
                onUnload() {
                  const t = "youtube-" + this.container.getAttribute(Si);
                  qi[t] && qi[t].destroy();
                }
                constructor(t) {
                  (this.container = t),
                    (this.player = this.container.querySelector(
                      wi.videoIframe
                    )),
                    this.player &&
                      ((this.videoOptionsVars = {}),
                      (this.videoID = this.player.getAttribute(ki)),
                      (this.videoType = this.player.getAttribute(Ai)),
                      "youtube" == this.videoType &&
                        ((this.checkPlayerVisibilityFlag =
                          "true" === this.player.getAttribute(Li)),
                        (this.playerID = this.player.querySelector(
                          wi.youtubeWrapper
                        )
                          ? this.player.querySelector(wi.youtubeWrapper).id
                          : this.player.id),
                        this.player.hasAttribute(wi.dataHideOptions) &&
                          (this.videoOptionsVars = {
                            cc_load_policy: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            autohide: 0,
                            controls: 0,
                            branding: 0,
                            showinfo: 0,
                            rel: 0,
                            fs: 0,
                            wmode: "opaque",
                          }),
                        this.init(),
                        this.container.addEventListener(
                          "touchstart",
                          function (t) {
                            if (
                              t.target.matches(wi.videoWrapper) ||
                              t.target.closest(wi.videoWrapper)
                            ) {
                              const e = t.target.querySelector(
                                wi.videoIframe
                              ).id;
                              qi[e].playVideo();
                            }
                          },
                          { passive: !0 }
                        )));
                }
              })(t.parentElement)
            : "vimeo" == e &&
              new (class {
                init() {
                  this.loadVimeoPlayer();
                }
                loadVimeoPlayer() {
                  const t = "https://vimeo.com/" + this.videoID;
                  let e = "";
                  const i = this.player,
                    s = {
                      url: t,
                      background: this.enableBackground,
                      muted: this.disableSound,
                      autoplay: this.enableAutoplay,
                      loop: this.enableLoop,
                    };
                  for (let t in s)
                    e +=
                      encodeURIComponent(t) +
                      "=" +
                      encodeURIComponent(s[t]) +
                      "&";
                  fetch(`https://vimeo.com/api/oembed.json?${e}`)
                    .then((t) => t.json())
                    .then(function (t) {
                      (i.innerHTML = t.html),
                        setTimeout(function () {
                          i.parentElement.classList.add(pi);
                        }, 1e3);
                    })
                    .catch(function () {
                      console.log("error");
                    });
                }
                constructor(t) {
                  (this.container = t),
                    (this.player = this.container.querySelector(ui)),
                    this.player &&
                      ((this.videoID = this.player.getAttribute(vi)),
                      (this.videoType = this.player.getAttribute(bi)),
                      (this.enableBackground =
                        "true" === this.player.getAttribute(gi)),
                      (this.disableSound =
                        "false" === this.player.getAttribute(mi)),
                      (this.enableAutoplay =
                        "false" !== this.player.getAttribute(fi)),
                      (this.enableLoop =
                        "false" !== this.player.getAttribute(yi)),
                      "vimeo" == this.videoType && this.init());
                }
              })(t.parentElement);
      }
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.firstChild &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${Sc} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (i) => {
            i.preventDefault(),
              t.parentElement.querySelector(`.${Lc}`).classList.remove(Lc),
              t.classList.add(Lc),
              this.popup.goTo(e);
          });
        }));
    }
    hideUnusedButtons() {
      this.pswpElement.querySelectorAll(Ec).forEach((t) => {
        t.classList.contains(Tc) || (t.style.display = "none");
      });
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    onClose() {
      const t = this.pswpElement.querySelector(bc);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(Fc, "");
      const e = this.pswpElement.querySelector(`.${Cc}`);
      e && this.pswpElement.removeChild(e),
        document.body.classList.contains(Ic) || this.a11y.removeTrapFocus(),
        document.removeEventListener("theme:cart:added", this.closePopup),
        setTimeout(() => {
          const t = this.recentlyOpenedPopupsCount(),
            e = document.body.classList.contains(Ic);
          0 !== t ||
            e ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
        }, fc);
    }
    recentlyOpenedPopupsCount() {
      let t = 0;
      return (
        this.pswpElements.forEach((e) => {
          e.classList.contains(qc) && (t += 1);
        }),
        t
      );
    }
    setCurrentThumb() {
      if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
        return;
      const t = this.pswpElement.querySelector(`${Sc} > .${Lc}`);
      if ((t && t.classList.remove(Lc), !this.popupThumbs)) return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(Lc), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        i = t.offsetLeft;
      if (e <= i + t.offsetWidth || e > i) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: i - e,
          behavior: "smooth",
        });
      }
    }
    constructor(t, e = "", i = 0, s = null) {
      (this.items = t),
        (this.triggerBtn = s),
        (this.pswpElements = document.querySelectorAll(yc)),
        (this.pswpElement = this.pswpElements[i]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(Sc)),
        (this.closeBtn = this.pswpElement.querySelector(vc));
      (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
        (this.onCloseCallback = () => this.onClose()),
        (this.dispatchPopupInitEventCallback = () =>
          this.dispatchPopupInitEvent()),
        (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
        (this.loadingStateCallback = (t) => this.loadingState(t)),
        (this.a11y = ci),
        this.init();
    }
  };
  const Bc = 0,
    zc = "[data-button-quick-view]",
    _c = "[data-quick-view-items-template]",
    $c = "[data-cart-drawer]",
    Rc = "[data-shop-the-look-quick-view-button]",
    Vc = "[data-shop-the-look-thumb]",
    Nc = "[data-quick-view-item-holder]",
    Wc = "is-loading",
    Uc = "is-active",
    jc = "js-quick-view-from-cart",
    Gc = "popup-quick-view pswp--not-close-btn",
    Kc = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
    Qc = "data-handle",
    Xc = "data-variant-id",
    Yc = "data-shop-the-look-quick-view",
    Jc = "data-hotspot",
    Zc = "data-initialized",
    th = {
      history: !1,
      focus: !1,
      mainClass: Gc,
      showHideOpacity: !1,
      closeOnVerticalDrag: !1,
      closeOnScroll: !1,
      modal: !1,
      escKey: !1,
    };
  let eh = class {
    popupInit(t) {
      var e, i;
      const s = this.loadPhotoswipe.pswpElement.querySelector(
          `[${Jc}="${t.getAttribute(Jc)}"]`
        ),
        o = this.loadPhotoswipe.pswpElement.querySelectorAll(Nc);
      s.classList.add(Uc),
        o.forEach((t) => {
          t !== s && t.classList.remove(Uc);
        }),
        this.toggleQuickViewButtonsLoadingClasses(!0),
        this.toggleQuickViewThumbsLoadingClasses(!0);
      const n = (t) => {
        "quickViewAnimateInUp" === t.animationName &&
          requestAnimationFrame(() => {
            this.toggleQuickViewThumbsLoadingClasses(!1);
          }),
          "quickViewAnimateOutDown" === t.animationName &&
            this.loadPhotoswipe.pswpElement.removeEventListener(
              "animationend",
              n
            );
      };
      this.loadPhotoswipe.pswpElement.addEventListener("animationend", n),
        null === (e = this.loadPhotoswipe) ||
          void 0 === e ||
          null === (i = e.popup) ||
          void 0 === i ||
          i.listen("destroy", () => {
            this.toggleQuickViewButtonsLoadingClasses(!1),
              this.toggleQuickViewThumbsLoadingClasses(!1);
          });
    }
    toggleQuickViewButtonsLoadingClasses(t = !0) {
      var e, i;
      t
        ? null === (i = this.buttonsQuickView) ||
          void 0 === i ||
          i.forEach((t) => {
            t.classList.add(Wc);
          })
        : null === (e = this.buttonsQuickView) ||
          void 0 === e ||
          e.forEach((t) => {
            t.classList.remove(Wc);
          });
    }
    toggleQuickViewThumbsLoadingClasses(t = !0) {
      var e, i, s;
      ((this.buttonsShopTheLookThumb =
        null === (e = this.loadPhotoswipe) || void 0 === e
          ? void 0
          : e.pswpElement.querySelectorAll(Vc)),
      t)
        ? null === (s = this.buttonsShopTheLookThumb) ||
          void 0 === s ||
          s.forEach((t) => {
            t.classList.add(Wc);
          })
        : null === (i = this.buttonsShopTheLookThumb) ||
          void 0 === i ||
          i.forEach((t) => {
            t.classList.remove(Wc);
          });
    }
    initPhotoswipe(t) {
      t.preventDefault();
      const e = t.target.matches(zc) ? t.target : t.target.closest(zc),
        i = window.innerWidth < theme.sizes.small;
      let s = "",
        o = !1;
      if (e.hasAttribute(Yc)) {
        if (!i) return;
        o = !0;
      }
      (th.mainClass = Gc),
        e.classList.add(Wc),
        e.closest($c) && document.body.classList.add(jc),
        (this.a11y.state.trigger = e),
        (this.a11y.state.mainTrigger = this.a11y.state.trigger),
        e.hasAttribute(Xc) && (s = `&variant=${e.getAttribute(Xc)}`);
      const n = `${theme.routes.root}products/${e.getAttribute(
        Qc
      )}?section_id=api-quickview${s}`;
      if (o) {
        (th.mainClass = Kc),
          this.buttonsQuickView.forEach((t) => {
            t.classList.add(Wc);
          });
        const t = new XMLSerializer(),
          i = this.container
            .querySelector(_c)
            .content.firstElementChild.cloneNode(!0),
          s = t.serializeToString(i);
        this.loadPhotoswipeWithTemplate(s, e);
      } else this.loadPhotoswipeFromFetch(n, e);
    }
    loadPhotoswipeWithTemplate(t, e) {
      const i = [{ html: t }];
      this.loadPhotoswipe = new Oc(i, th, Bc, e);
    }
    loadPhotoswipeFromFetch(t, e) {
      fetch(t)
        .then((t) => t.text())
        .then((t) => {
          const i = [{ html: t }];
          this.loadPhotoswipe = new Oc(i, th, Bc, e);
        })
        .catch((t) => console.log("error: ", t));
    }
    constructor(t) {
      var e, i;
      (this.container = t),
        (this.a11y = ci),
        (this.buttonsQuickView = this.container.querySelectorAll(zc)),
        (this.buttonsShopTheLookQuickView =
          this.container.querySelectorAll(Rc)),
        (this.popupInitCallback = (t) => this.popupInit(t)),
        null === (e = this.buttonsQuickView) ||
          void 0 === e ||
          e.forEach((t) => {
            t.hasAttribute(Zc) ||
              (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
              t.addEventListener("theme:popup:init", () => {
                t.classList.remove(Wc),
                  t.hasAttribute(Yc) && this.popupInitCallback(t);
              }),
              t.setAttribute(Zc, ""));
          }),
        null === (i = this.buttonsShopTheLookQuickView) ||
          void 0 === i ||
          i.forEach((t) => {
            t.addEventListener("click", () => {
              const t = [...this.buttonsQuickView].find((t) =>
                t.hasAttribute(Yc)
              );
              null == t || t.dispatchEvent(new Event("click"));
            });
          });
    }
  };
  const ih = {
      cartDrawerEnabled: "drawer" === window.theme.settings.cartType,
      timers: { addProductTimeout: 1e3 },
      animations: { data: "data-aos", method: "fade-up" },
    },
    sh = {
      outerSection: "[data-section-id]",
      aos: "[data-aos]",
      additionalCheckoutButtons: "[data-additional-checkout-button]",
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      apiCartPrice: "[data-api-cart-price]",
      buttonAddToCart: "[data-add-to-cart]",
      upsellButtonByHandle: "[data-handle]",
      cartCloseError: "[data-cart-error-close]",
      cartDrawer: "[data-cart-drawer]",
      cartDrawerTemplate: "[data-cart-drawer-template]",
      cartDrawerToggle: "[data-cart-drawer-toggle]",
      cartDrawerBody: "[data-cart-drawer-body]",
      cartErrors: "[data-cart-errors]",
      cartForm: "[data-cart-form]",
      cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
      cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
      cartCheckoutButton: "[data-cart-checkout-button]",
      cartItemRemove: "[data-item-remove]",
      cartItemsQty: "[data-cart-items-qty]",
      cartTotal: "[data-cart-total]",
      cartTotalPrice: "[data-cart-total-price]",
      cartMessage: "[data-cart-message]",
      cartMessageDefault: "[data-message-default]",
      cartPage: "[data-cart-page]",
      cartProgress: "[data-cart-message-progress]",
      emptyMessage: "[data-empty-message]",
      emptyMessageBottom: "[data-empty-message-bottom]",
      buttonHolder: "[data-foot-holder]",
      item: "[data-cart-item]",
      itemsHolder: "[data-items-holder]",
      itemsWrapper: "[data-items-wrapper]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      upsellHolder: "[data-upsell-holder]",
      errorMessage: "[data-error-message]",
      termsErrorMessage: "[data-terms-error-message]",
      pairProductsHolder: "[data-pair-products-holder]",
      cartNoteHolder: "[data-cart-notes-holder]",
      pairProducts: "[data-pair-products]",
      priceHolder: "[data-cart-price-holder]",
      leftToSpend: "[data-left-to-spend]",
      quickBuyForm: "[data-quickbuy-form]",
      qtyInput: "[data-quantity-field]",
      productItem: "[data-product-block]",
      productMediaContainer: "[data-product-media-container]",
      formWrapper: "[data-form-wrapper]",
      productForm: "[data-product-form], [data-product-form-upsell]",
      popupQuickView: ".popup-quick-view",
      popupClose: "[data-popup-close]",
      error: "[data-error]",
      quickViewOnboarding: "[data-quick-view-onboarding]",
      flickityEnabled: ".flickity-enabled",
      noscript: "noscript",
      qtySelect: "[data-quantity-select]",
    },
    oh = "hidden",
    nh = "is-hidden",
    rh = "js-drawer-open-cart",
    ah = "is-open",
    lh = "is-visible",
    ch = "is-expanded",
    hh = "is-loading",
    dh = "is-disabled",
    uh = "is-success",
    ph = "cart__toggle--has-items",
    mh = "variant--soldout",
    gh = "is-removed",
    fh = "aos-animate",
    yh = "is-updated",
    vh = "no-outline",
    bh = "product-grid-item__image--error",
    wh = "cv-h",
    Sh = "data-limit",
    Eh = "data-cart-message",
    Lh = "data-cart-total",
    kh = "aria-expanded",
    Ah = "disabled",
    Ch = "name",
    qh = "value",
    Th = "data-id",
    Ph = "data-item",
    xh = "data-item-index",
    Ih = "data-item-title",
    Hh = "data-atc-trigger",
    Fh = "data-notification-popup",
    Mh = "data-recipient-errors",
    Dh = "data-max-inventory-reached",
    Oh = "data-error-message-position",
    Bh = "data-variant-title",
    zh = "data-quantity-max";
  let _h = {},
    $h = class {
      init() {
        var t;
        (this.cartToggleButtons = document.querySelectorAll(
          sh.cartDrawerToggle
        )),
          (this.cartPage = document.querySelector(sh.cartPage)),
          (this.cartDrawer = document.querySelector(sh.cartDrawer)),
          (this.cart = this.cartDrawer || this.cartPage),
          (this.cartCount = this.getCartItemCount()),
          this.assignArguments(),
          (this.recipientErrors =
            "true" ===
            (null === (t = this.form) || void 0 === t
              ? void 0
              : t.getAttribute(Mh))),
          (this.flktyUpsell = null),
          (this.form = null),
          (this.variantTitle = null),
          (this.collapsible = null),
          (this.a11y = ci),
          (this.build = this.build.bind(this)),
          (this.addToCart = this.addToCart.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.openCartDrawer = this.openCartDrawer.bind(this)),
          (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
          (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
          (this.formSubmitHandler = Ve(this.formSubmitHandler.bind(this), 50)),
          (this.closeCartError = () => {
            this.cartErrorHolder.classList.remove(ch);
          }),
          (this.cartDrawerCloseEvent = null),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = 0),
          (this.isCartDrawerOpen = !1),
          (this.isCartDrawerLoaded = !1),
          (this.cartDiscounts = 0),
          (this.cartDrawerEnabled = ih.cartDrawerEnabled),
          (this.cartUpdateFailed = !1),
          (this.showCannotAddMoreInCart = !1),
          this.cartEvents(),
          this.cartAddEvent(),
          this.cartDrawerToggleEvents(),
          this.initCartUpdate(),
          this.buttonHolder && (this.collapsible = new ai(this.buttonHolder)),
          this.isCartPage && this.renderPairProducts(),
          document.addEventListener("theme:popup:open", this.closeCartDrawer);
      }
      assignArguments() {
        var t;
        (this.outerSection =
          null === (t = this.cart) || void 0 === t
            ? void 0
            : t.closest(sh.outerSection)),
          (this.cartDrawerBody = document.querySelector(sh.cartDrawerBody)),
          (this.emptyMessage = document.querySelector(sh.emptyMessage)),
          (this.emptyMessageBottom = document.querySelector(
            sh.emptyMessageBottom
          )),
          (this.buttonHolder = document.querySelector(sh.buttonHolder)),
          (this.itemsHolder = document.querySelector(sh.itemsHolder)),
          (this.cartItemsQty = document.querySelector(sh.cartItemsQty)),
          (this.itemsWrapper = document.querySelector(sh.itemsWrapper)),
          (this.items = document.querySelectorAll(sh.item)),
          (this.cartTotal = document.querySelector(sh.cartTotal)),
          (this.cartTotalPrice = document.querySelector(sh.cartTotalPrice)),
          (this.cartMessage = document.querySelectorAll(sh.cartMessage)),
          (this.cartOriginalTotal = document.querySelector(
            sh.cartOriginalTotal
          )),
          (this.cartErrorHolder = document.querySelector(sh.cartErrors)),
          (this.cartCloseErrorMessage = document.querySelector(
            sh.cartCloseError
          )),
          (this.pairProductsHolder = document.querySelector(
            sh.pairProductsHolder
          )),
          (this.cartNoteHolder = document.querySelector(sh.cartNoteHolder)),
          (this.pairProducts = document.querySelector(sh.pairProducts)),
          (this.priceHolder = document.querySelector(sh.priceHolder)),
          (this.upsellHolders = document.querySelectorAll(sh.upsellHolder)),
          (this.cartTermsCheckbox = document.querySelector(
            sh.cartTermsCheckbox
          )),
          (this.cartCheckoutButtonWrapper = document.querySelector(
            sh.cartCheckoutButtonWrapper
          )),
          (this.cartCheckoutButton = document.querySelector(
            sh.cartCheckoutButton
          )),
          (this.cartForm = document.querySelector(sh.cartForm)),
          (this.cartItemCount = 0),
          (this.subtotal = window.theme.subtotal),
          (this.button = null);
        const { headerInitialHeight: e, announcementBarHeight: i } = R();
        (this.headerInitialHeight = e),
          (this.announcementBarHeight = i),
          this.cartMessage.length > 0 &&
            (this.cartFreeLimitShipping =
              100 *
              Number(this.cartMessage[0].getAttribute(Sh)) *
              window.Shopify.currency.rate),
          this.updateProgress();
      }
      initCartUpdate() {
        var t;
        (this.items = document.querySelectorAll(sh.item)),
          null === (t = this.items) ||
            void 0 === t ||
            t.forEach((t) => {
              this.cartUpdateEvent(t);
            });
      }
      cartUpdateEvent(t) {
        t.addEventListener("theme:cart:update", (e) => {
          this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
        });
      }
      cartEvents() {
        const t = document.querySelectorAll(sh.cartItemRemove);
        (this.totalItems = t.length),
          null == t ||
            t.forEach((t) => {
              const e = t.closest(sh.item);
              t.addEventListener("click", (i) => {
                i.preventDefault(),
                  t.classList.contains(dh) ||
                    this.updateCart({ id: e.getAttribute(Th), quantity: 0 }, e);
              });
            }),
          this.cartCloseErrorMessage &&
            (this.cartCloseErrorMessage.removeEventListener(
              "click",
              this.closeCartError
            ),
            this.cartCloseErrorMessage.addEventListener(
              "click",
              this.closeCartError
            )),
          this.cartTermsCheckbox &&
            (this.cartTermsCheckbox.removeEventListener(
              "change",
              this.formSubmitHandler
            ),
            this.cartCheckoutButtonWrapper.removeEventListener(
              "click",
              this.formSubmitHandler
            ),
            this.cartForm.removeEventListener("submit", this.formSubmitHandler),
            this.cartTermsCheckbox.addEventListener(
              "change",
              this.formSubmitHandler
            ),
            this.cartCheckoutButtonWrapper.addEventListener(
              "click",
              this.formSubmitHandler
            ),
            this.cartForm.addEventListener("submit", this.formSubmitHandler));
      }
      cartAddEvent() {
        document.addEventListener("click", (t) => {
          const e = t.target,
            i = null == e ? void 0 : e.matches(sh.buttonAddToCart),
            s = null == e ? void 0 : e.closest(sh.buttonAddToCart);
          if (i || s) {
            var o, n, r;
            t.preventDefault(),
              (this.button = i ? e : s),
              (this.form = e.closest("form")),
              (this.recipientErrors =
                "true" ===
                (null === (o = this.form) || void 0 === o
                  ? void 0
                  : o.getAttribute(Mh))),
              (this.formWrapper = this.button.closest(sh.formWrapper));
            const a =
                null === (n = this.formWrapper) || void 0 === n
                  ? void 0
                  : n.classList.contains(mh),
              l = this.button.hasAttribute(Ah),
              c = this.button.closest(sh.quickViewOnboarding),
              h = this.button.hasAttribute(Hh),
              d = this.button.hasAttribute(Fh),
              u =
                null === (r = this.form) || void 0 === r
                  ? void 0
                  : r.querySelector('[type="file"]');
            if (l || u || c) return;
            if (a && d) return void new ya(this.button);
            h && (this.a11y.state.trigger = this.button);
            let p = new FormData(this.form);
            [...this.form.elements].some((t) => t.closest(sh.noscript)) &&
              (p = this.handleFormDataDuplicates([...this.form.elements], p));
            const m = this.form.getAttribute(Dh),
              g = this.form.getAttribute(Oh);
            (this.variantTitle = this.form.getAttribute(Bh)),
              (this.showCannotAddMoreInCart = !1),
              "true" === m &&
                "cart" === g &&
                (this.showCannotAddMoreInCart = !0),
              this.addToCart(p),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  bubbles: !0,
                  detail: { selector: e },
                })
              );
          }
        });
      }
      handleFormDataDuplicates(t, e) {
        return t.length && "object" == typeof e
          ? (t.forEach((t) => {
              if (t.closest(sh.noscript)) {
                const i = t.getAttribute(Ch),
                  s = t.value;
                if (i) {
                  const t = e.getAll(i);
                  t.length > 1 && t.splice(t.indexOf(s), 1),
                    e.delete(i),
                    e.set(i, t[0]);
                }
              }
            }),
            e)
          : e;
      }
      getCart() {
        if (this.cartDrawer && !this.isCartDrawerLoaded) {
          const t = !1;
          this.renderCartDrawer(t);
        }
        fetch(theme.routes.cart_url + "?section_id=api-cart-items")
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((t) => {
            const e = document.createElement("div");
            e.innerHTML = t;
            const i = e.querySelector(sh.apiContent);
            this.build(i);
          })
          .catch((t) => console.log(t));
      }
      addToCart(t) {
        this.cartDrawerEnabled &&
          this.button &&
          (this.button.classList.add(hh), this.button.setAttribute(Ah, !0)),
          fetch(theme.routes.cart_add_url, {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
            body: t,
          })
            .then((t) => t.json())
            .then((t) => {
              (this.button.disabled = !0),
                this.addLoadingClass(),
                (t.status &&
                  (this.addToCartError(t),
                  this.removeLoadingClass(),
                  !this.showCannotAddMoreInCart)) ||
                  (this.hideAddToCartErrorMessage(),
                  this.cartDrawerEnabled
                    ? (this.getCart(),
                      this.showCannotAddMoreInCart &&
                        this.updateErrorText(this.variantTitle),
                      this.scrollToCartTop())
                    : (window.location = theme.routes.cart_url));
            })
            .catch((t) => console.log(t));
      }
      updateCart(t = {}, e = null) {
        let i = t.quantity;
        null !== e && (i ? e.classList.add(hh) : e.classList.add(gh)),
          this.disableCartButtons(),
          this.addLoadingClass();
        const s = this.cart.querySelector(`[${Ph}="${t.id}"]`) || e,
          o = (null == s ? void 0 : s.hasAttribute(xh))
            ? parseInt(s.getAttribute(xh))
            : 0,
          n = (null == s ? void 0 : s.hasAttribute(Ih))
            ? s.getAttribute(Ih)
            : null;
        if (0 === o) return;
        const r = { line: o, quantity: i };
        fetch(theme.routes.cart_change_url, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(r),
        })
          .then((t) => {
            if (400 === t.status) {
              const e = new Error(t.status);
              throw (
                (this.cartDrawerEnabled
                  ? this.getCart()
                  : (window.location = theme.routes.cart_url),
                e)
              );
            }
            return t.text();
          })
          .then((t) => {
            if (JSON.parse(t).errors)
              return (
                (this.cartUpdateFailed = !0),
                this.updateErrorText(n),
                this.toggleErrorMessage(),
                this.resetLineItem(e),
                this.enableCartButtons(),
                this.removeLoadingClass(),
                void this.scrollToCartTop()
              );
            this.getCart();
          })
          .catch((t) => {
            console.log(t), this.enableCartButtons(), this.removeLoadingClass();
          });
      }
      resetLineItem(t) {
        const e = t.querySelector(sh.qtyInput),
          i = t.querySelector(sh.qtySelect);
        let s = e.getAttribute(qh);
        const o = e.getAttribute(zh);
        e && (e.value > o && (s = o), (e.value = s), i && (i.innerText = s)),
          t.classList.remove(hh);
      }
      disableCartButtons() {
        const t = this.cart.querySelectorAll("input"),
          e = this.cart.querySelectorAll(`button, ${sh.cartItemRemove}`);
        t.length &&
          t.forEach((t) => {
            t.classList.add(dh), t.blur(), (t.disabled = !0);
          }),
          e.length &&
            e.forEach((t) => {
              t.setAttribute(Ah, !0);
            });
      }
      enableCartButtons() {
        const t = this.cart.querySelectorAll("input"),
          e = this.cart.querySelectorAll(`button, ${sh.cartItemRemove}`);
        t.length &&
          t.forEach((t) => {
            t.classList.remove(dh), (t.disabled = !1);
          }),
          e.length &&
            e.forEach((t) => {
              t.removeAttribute(Ah);
            });
      }
      updateErrorText(t) {
        this.cartErrorHolder.querySelector(sh.errorMessage).innerText = t;
      }
      toggleErrorMessage() {
        if (this.cartErrorHolder) {
          if (
            (this.cartErrorHolder.classList.toggle(
              ch,
              this.cartUpdateFailed || this.showCannotAddMoreInCart
            ),
            this.cartUpdateFailed)
          ) {
            const t = this.cartErrorHolder.querySelector(sh.cartCloseError);
            this.focusOnErrorMessage(this.cartErrorHolder, t);
          }
          (this.showCannotAddMoreInCart = !1), (this.cartUpdateFailed = !1);
        }
      }
      handleErrors(t) {
        return t.ok
          ? t
          : t.json().then(function (e) {
              throw new Ne({
                status: t.statusText,
                headers: t.headers,
                json: e,
              });
            });
      }
      addToCartError(t) {
        const e = this.button.closest(sh.quickBuyForm),
          i = this.button.closest(sh.upsellHolder),
          s = !document.body.classList.contains(vh);
        let o = (
          this.button.closest(sh.productForm)
            ? this.button.closest(sh.productForm)
            : this.button.closest(sh.upsellHolder)
        ).querySelector(sh.formErrorsContainer);
        i && (o = i.querySelector(sh.formErrorsContainer)),
          this.cartDrawerEnabled &&
            this.button &&
            null !== this.button.closest(sh.cartDrawer) &&
            !this.button.closest(sh.cartDrawer) &&
            this.closeCartDrawer(),
          this.button.classList.remove(hh),
          this.button.removeAttribute(Ah);
        const n = e
          ? ""
          : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
        let r = `${t.message}: ${t.description}`;
        if (
          (t.message === t.description && (r = t.message),
          this.recipientErrors &&
            t.description &&
            "object" == typeof t.description &&
            (r = Object.entries(t.description)
              .map(([t, e]) => `${e}`)
              .join("<br>")),
          (o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
          e)
        ) {
          const t = o.closest(sh.productItem);
          if (!t) return;
          const e = t.querySelector(sh.productMediaContainer);
          if (!e) return;
          e.classList.add(bh),
            o.querySelector(sh.error).addEventListener("animationend", () => {
              e.classList.remove(bh),
                (o.innerHTML = ""),
                s || document.activeElement.blur();
            });
        } else
          o.classList.add(lh),
            o.addEventListener("transitionend", () => {
              this.resizeSliders(o),
                o.scrollIntoView({ behavior: "smooth", block: "end" });
            }),
            this.handleCloseErrorMessages(o);
      }
      handleCloseErrorMessages(t) {
        const e = t.querySelector(sh.formCloseError);
        null == e ||
          e.addEventListener("click", (e) => {
            const i = e.target;
            (i.matches(sh.formCloseError) || i.closest(sh.formCloseError)) &&
              (e.preventDefault(),
              t.classList.remove(lh),
              t
                .querySelector(sh.error)
                .addEventListener("transitionend", () => {
                  (t.innerHTML = ""), this.resizeSliders(i);
                }));
          }),
          this.focusOnErrorMessage(t, e);
      }
      focusOnErrorMessage(t, e) {
        !document.body.classList.contains(vh) &&
          t.addEventListener("transitionend", () => {
            requestAnimationFrame(() =>
              null == e ? void 0 : e.focus({ focusVisible: !0 })
            );
          });
      }
      hideAddToCartErrorMessage() {
        const t = this.button.closest(sh.upsellHolder)
            ? this.button.closest(sh.upsellHolder)
            : this.button.closest(sh.productForm),
          e = null == t ? void 0 : t.querySelector(sh.formErrorsContainer);
        null == e || e.classList.remove(lh);
      }
      resizeSliders(t) {
        const i = t.closest(sh.flickityEnabled);
        if (!i) return;
        const s = e.data(i);
        requestAnimationFrame(() => s.resize());
      }
      renderCartDrawer(t = !0) {
        const e = document.querySelector(sh.cartDrawerTemplate);
        e &&
          ((this.cartDrawer.innerHTML = e.innerHTML),
          this.assignArguments(),
          this.initCartUpdate(),
          this.cartEvents(),
          this.cartDrawerBody &&
            (this.collapsible = new ai(this.cartDrawerBody)),
          (this.cartDrawerToggle = this.cartDrawer.querySelector(
            sh.cartDrawerToggle
          )),
          this.cartDrawerToggle.addEventListener(
            "click",
            this.cartDrawerToggleClickEvent
          ),
          (this.isCartDrawerLoaded = !0),
          this.renderPairProducts(),
          document.dispatchEvent(
            new CustomEvent("theme:cart:loaded", { bubbles: !0 })
          ),
          t && this.openCartDrawer());
      }
      openCartDrawer() {
        this.isCartDrawerOpen ||
          (this.isCartDrawerLoaded
            ? (document.dispatchEvent(
                new CustomEvent("theme:cart:open", { bubbles: !0 })
              ),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: this.cartDrawer,
                })
              ),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: this.cartDrawerBody,
                })
              ),
              this.scrollToCartTop(),
              document.body.classList.add(rh),
              this.cartDrawer.classList.add(ah),
              this.cartDrawer.classList.remove(wh),
              requestAnimationFrame(() => this.animateCartItems("in")),
              this.cartToggleButtons.forEach((t) => {
                t.setAttribute(kh, !0);
              }),
              this.a11y.trapFocus({ container: this.cartDrawer }),
              this.observeAdditionalCheckoutButtons(),
              (this.isCartDrawerOpen = !0))
            : this.renderCartDrawer());
      }
      animateCartItems(t = "in") {
        const e = this.cart.querySelectorAll(sh.aos);
        "in" === t &&
          e.forEach((t) => requestAnimationFrame(() => t.classList.add(fh))),
          "out" === t && e.forEach((t) => t.classList.remove(fh));
      }
      closeCartDrawer() {
        if (!this.isCartDrawerOpen) return;
        document.dispatchEvent(
          new CustomEvent("theme:cart:close", { bubbles: !0 })
        ),
          this.cartErrorHolder.classList.remove(ch),
          this.a11y.removeTrapFocus(),
          this.cartToggleButtons.forEach((t) => {
            t.setAttribute(kh, !1);
          }),
          document.body.classList.remove(rh),
          this.cartDrawer.classList.remove(ah),
          this.itemsHolder.classList.remove(yh);
        const t = (e) => {
          e.target === this.cartDrawer &&
            (this.animateCartItems("out"),
            this.cartDrawer.removeEventListener("transitionend", t));
        };
        this.cartDrawer.addEventListener("transitionend", t);
        !document.body.classList.contains(vh) ||
          requestAnimationFrame(() => {
            document.activeElement.blur();
          });
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })
        ),
          (this.isCartDrawerOpen = !1);
      }
      toggleCartDrawer() {
        this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
      }
      cartDrawerToggleEvents() {
        this.cartDrawer &&
          (this.cartDrawer.addEventListener("keyup", (t) => {
            t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
          }),
          (this.cartDrawerToggleClickEvent = (t) => {
            t.preventDefault();
            const e = t.target;
            "false" === e.getAttribute(kh) && (this.a11y.state.trigger = e),
              this.toggleCartDrawer();
          }),
          (this.cartDrawerCloseEvent = (t) => {
            const e = t.target.matches(sh.cartDrawerToggle),
              i = document.querySelector(sh.cartDrawer).contains(t.target),
              s = t.target.closest(sh.popupQuickView);
            e || i || s || this.closeCartDrawer();
          }),
          this.cartToggleButtons.forEach((t) => {
            t.addEventListener("click", this.cartDrawerToggleClickEvent);
          }),
          document.addEventListener("mousedown", this.cartDrawerCloseEvent));
      }
      toggleClassesOnContainers() {
        const t = this;
        this.isCartPage
          ? this.buttonHolder.classList.toggle(oh, !t.hasItemsInCart())
          : (this.pairProductsHolder.classList.toggle(oh, !t.hasItemsInCart()),
            this.cartForm.classList.toggle(oh, !t.hasItemsInCart()),
            this.emptyMessageBottom.classList.toggle(oh, t.hasItemsInCart()),
            this.cartNoteHolder.classList.toggle(oh, !t.hasItemsInCart())),
          this.emptyMessage.classList.toggle(oh, t.hasItemsInCart()),
          this.itemsHolder.classList.toggle(oh, !t.hasItemsInCart()),
          this.cartItemsQty.classList.toggle(oh, !t.hasItemsInCart());
      }
      build(t) {
        const e = t.querySelector(sh.apiLineItems),
          s = t.querySelector(sh.apiUpsellItems),
          o = Boolean(null === e && null === s),
          n = t.querySelector(sh.apiCartPrice),
          r = t.querySelector(sh.cartTotal);
        if (
          (this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
          this.animateCartItems("out"),
          o
            ? ((this.itemsHolder.innerHTML = ""),
              this.pairProductsHolder &&
                (this.pairProductsHolder.innerHTML = ""))
            : ((this.itemsHolder.innerHTML = e.innerHTML),
              this.pairProductsHolder &&
                (this.pairProductsHolder.innerHTML = s.innerHTML),
              this.renderPairProducts()),
          (this.newTotalItems =
            e && e.querySelectorAll(sh.item).length
              ? e.querySelectorAll(sh.item).length
              : 0),
          (this.subtotal =
            r && r.hasAttribute(Lh) ? parseInt(r.getAttribute(Lh)) : 0),
          (this.cartCount = this.getCartItemCount()),
          this.cartMessage.length > 0 && this.updateProgress(),
          this.cartToggleButtons.forEach((t) => {
            t.classList.remove(ph),
              this.newTotalItems > 0 && t.classList.add(ph);
          }),
          this.toggleErrorMessage(),
          this.updateItemsQuantity(this.cartCount),
          (this.cartTotalPrice.innerHTML =
            0 === this.subtotal
              ? window.theme.strings.free
              : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
          this.totalItems !== this.newTotalItems &&
            ((this.totalItems = this.newTotalItems),
            this.toggleClassesOnContainers()),
          (this.isCartDrawerOpen || this.isCartPage) &&
            this.itemsHolder.classList.add(yh),
          this.cartEvents(),
          this.initCartUpdate(),
          this.enableCartButtons(),
          this.resetButtonClasses(),
          this.removeLoadingClass(),
          document.dispatchEvent(
            new CustomEvent("theme:cart:added", { bubbles: !0 })
          ),
          this.cartDrawer)
        ) {
          this.openCartDrawer();
          const t = (e) => {
            e.target === this.cartDrawer &&
              (this.animateCartItems("in"),
              this.cartDrawer.removeEventListener("transitionend", t));
          };
          this.cartDrawer.addEventListener("transitionend", t);
        }
        requestAnimationFrame(() => this.animateCartItems("in"));
      }
      getCartItemCount() {
        return this.cart
          ? Array.from(this.cart.querySelectorAll(sh.qtyInput)).reduce(
              (t, e) => t + parseInt(e.value),
              0
            )
          : 0;
      }
      hasItemsInCart() {
        return this.totalItems > 0;
      }
      freeShippingMessageHandle(t) {
        this.cartMessage.length > 0 &&
          document.querySelectorAll(sh.cartMessage).forEach((e) => {
            const i =
                e.hasAttribute(Eh) && "true" === e.getAttribute(Eh) && 0 !== t,
              s = e.querySelector(sh.cartMessageDefault);
            e.classList.toggle(uh, t >= this.cartFreeLimitShipping && i),
              e.classList.toggle(nh, 0 === t),
              s && s.classList.toggle(nh, t >= this.cartFreeLimitShipping);
          });
      }
      updateProgress() {
        const t = (this.subtotal / this.cartFreeLimitShipping) * 100;
        let e = i.formatMoney(
          this.cartFreeLimitShipping - this.subtotal,
          theme.moneyFormat
        );
        (e.endsWith(".00") || e.endsWith(",00")) && (e = e.slice(0, -3)),
          theme.settings.currency_code_enable &&
            (e += ` ${theme.current_iso_code}`),
          this.cartMessage.length > 0 &&
            document.querySelectorAll(sh.cartMessage).forEach((i) => {
              const s = i.querySelectorAll(sh.cartProgress),
                o = i.querySelector(sh.leftToSpend);
              o && (o.innerHTML = e),
                s.length &&
                  s.forEach((e, i) => {
                    e.classList.toggle(
                      nh,
                      this.subtotal / this.cartFreeLimitShipping >= 1
                    ),
                      e.style.setProperty("--progress-width", `${t}%`),
                      0 === i && e.setAttribute(qh, t);
                  }),
                this.freeShippingMessageHandle(this.subtotal);
            });
      }
      renderPairProducts() {
        if (
          ((this.flktyUpsell = null),
          (this.pairProductsHolder = document.querySelector(
            sh.pairProductsHolder
          )),
          (this.pairProducts = document.querySelector(sh.pairProducts)),
          (this.upsellHolders = document.querySelectorAll(sh.upsellHolder)),
          null === this.pairProductsHolder ||
            void 0 === this.pairProductsHolder)
        )
          return;
        const t = this;
        this.upsellHolders.length > 1
          ? (this.flktyUpsell = new e(this.pairProducts, {
              wrapAround: !0,
              pageDots: !0,
              adaptiveHeight: !0,
              prevNextButtons: !1,
              on: {
                ready: function () {
                  new eh(t.cart),
                    this.reloadCells(),
                    requestAnimationFrame(() => this.resize());
                },
              },
            }))
          : new eh(this.cart);
      }
      updateItemsQuantity(t) {
        let e = theme.strings.cart_items_one,
          i = theme.strings.cart_items_many;
        (e = e.split("}}")[1]),
          (i = i.split("}}")[1]),
          this.cartItemsQty &&
            (this.cartItemsQty.textContent =
              1 === t ? `${t} ${e}` : `${t} ${i}`);
      }
      observeAdditionalCheckoutButtons() {
        const t = this.cart.querySelector(sh.additionalCheckoutButtons);
        if (t) {
          const e = new MutationObserver(() => {
            this.a11y.removeTrapFocus(),
              this.a11y.trapFocus({ container: this.cart }),
              e.disconnect();
          });
          e.observe(t, { subtree: !0, childList: !0 });
        }
      }
      formSubmitHandler() {
        const t = document.querySelector(sh.cartTermsCheckbox).checked,
          e = document.querySelector(sh.termsErrorMessage);
        if (t)
          e.classList.remove(ch), this.cartCheckoutButton.removeAttribute(Ah);
        else {
          if (document.querySelector(sh.termsErrorMessage).length > 0) return;
          (e.innerText = theme.strings.cart_acceptance_error),
            this.cartCheckoutButton.setAttribute(Ah, !0),
            e.classList.add(ch);
        }
      }
      resetButtonClasses() {
        const t = document.querySelectorAll(sh.buttonAddToCart);
        t &&
          t.forEach((t) => {
            t.classList.contains(hh) &&
              (t.classList.remove(hh),
              t.classList.add(uh),
              setTimeout(() => {
                t.removeAttribute(Ah), t.classList.remove(uh);
              }, ih.timers.addProductTimeout));
          });
      }
      addLoadingClass() {
        this.cartDrawer
          ? this.cartDrawer.classList.add(hh)
          : this.itemsWrapper && this.itemsWrapper.classList.add(hh);
      }
      removeLoadingClass() {
        this.cartDrawer
          ? this.cartDrawer.classList.remove(hh)
          : this.itemsWrapper && this.itemsWrapper.classList.remove(hh);
      }
      scrollToCartTop() {
        var t;
        this.cartDrawer
          ? this.cartDrawerBody.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant",
            })
          : window.scrollTo({
              top:
                (null === (t = this.outerSection) || void 0 === t
                  ? void 0
                  : t.offsetTop) -
                this.headerInitialHeight -
                this.announcementBarHeight,
              left: 0,
              behavior: "smooth",
            });
      }
      unload() {
        this.cartDrawerToggle &&
          this.cartDrawerToggle.removeEventListener(
            "click",
            this.cartDrawerToggleClickEvent
          ),
          this.cartToggleButtons.forEach((t) => {
            t.removeEventListener("click", this.cartDrawerToggleClickEvent);
          }),
          document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
          null !== this.collapsible && this.collapsible.onUnload();
      }
      constructor() {
        "/password" !== window.location.pathname && this.init();
      }
    };
  P("cart-template", {
    onLoad() {
      _h[this.id] = new $h();
    },
    onUnload() {
      "function" == typeof _h[this.id].unload && _h[this.id].unload();
    },
  });
  const Rh = "is-visible",
    Vh = document.querySelector("[data-scroll-top-button]");
  Vh &&
    (Vh.addEventListener("click", () => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }),
    document.addEventListener(
      "scroll",
      Ve(() => {
        Vh.classList.toggle(Rh, window.pageYOffset > window.innerHeight);
      }, 150)
    ));
  const Nh = "details",
    Wh = "[data-popdown-body]",
    Uh = "[data-popdown-close]",
    jh = "[data-popdown-toggle]",
    Gh = "[data-search-form-inner]",
    Kh = "[data-popular-searches-link]",
    Qh = "[data-site-header]",
    Xh = "[data-nav]",
    Yh = "[data-nav-items-compress]",
    Jh = "[data-nav-icons]",
    Zh = "[data-mobile-menu]",
    td = "predictive-search",
    ed = "search-form",
    id = "data-popdown-in-header",
    sd = "data-popdown-in-page",
    od = "aria-activedescendant",
    nd = "aria-expanded",
    rd = "open",
    ad = "role",
    ld = "search-opened",
    cd = "site-header--menu-opened",
    hd = "site-header--compress",
    dd = "is-open";
  let ud = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.isPopdownInHeader &&
        (this.searchFormInner.addEventListener(
          "transitionend",
          this.popdownTransitionCallbackEvent
        ),
        this.details.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.details.addEventListener(
          "toggle",
          this.detailsToggleCallbackEvent
        ),
        this.popdownClose.addEventListener("click", (t) => this.close(t)),
        this.popdownToggle.addEventListener("click", (t) =>
          this.onPopdownToggleClick(t)
        ),
        this.popdownToggle.setAttribute(ad, "button")),
      this.isPopdownInPage) &&
        (this.popdownClose.addEventListener("click", () =>
          this.triggerPopdownClose()
        ),
        this.searchFormWrapper.addEventListener("focusout", () =>
          this.onFocusOut()
        ),
        null === (t = this.searchFormWrapper.input) ||
          void 0 === t ||
          t.addEventListener("click", (t) => this.triggerPopdownOpen(t)));
      this.popularSearchesLink.forEach((t) => {
        t.addEventListener("click", (t) => {
          t.preventDefault();
          const e = t.target.textContent;
          (this.searchFormWrapper.input.value = e),
            this.searchFormWrapper.submit();
        });
      });
    }
    onPopdownToggleClick(t) {
      const e = navigator.userAgent.includes("Chrome"),
        i = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      e && !i && t.target.closest(Nh).setAttribute(rd, ""),
        t.target.closest(Nh).hasAttribute(rd) &&
          (t.preventDefault(), this.close());
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute(rd) && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.searchFormInner &&
        (this.details.classList.contains(dd)
          ? "transform" === t.propertyName &&
            this.a11y.trapFocus({ container: this.searchFormInner })
          : this.onClose());
    }
    onBodyClick(t) {
      var e;
      const i = this.contains(t.target);
      (null === (e = this.header) || void 0 === e
        ? void 0
        : e.classList.contains(cd)) ||
        i ||
        i ||
        this.close();
    }
    onFocusOut() {
      this.predictiveSearch &&
        requestAnimationFrame(() => {
          this.searchFormWrapper.contains(document.activeElement) ||
            this.searchFormWrapper.close();
        });
    }
    triggerPopdownOpen(t) {
      let e = matchMedia("(pointer:coarse)").matches;
      const i = window.innerWidth < theme.sizes.small,
        s = e || i;
      if (
        (i && window.Shopify.designMode && (e = !0),
        this.nav && this.mobileMenu && s)
      ) {
        t.preventDefault();
        const i = this.header.classList.contains(hd);
        let s = this.mobileMenu.querySelector(jh);
        e ||
          (s = i
            ? this.nav.querySelector(`${Yh} ${jh}`)
            : this.nav.querySelector(`${Jh} ${jh}`)),
          setTimeout(() => {
            null == s || s.dispatchEvent(new Event("click", { bubbles: !0 }));
          }, 300);
      }
    }
    open() {
      (this.onBodyClickEvent = (t) => this.onBodyClick(t)),
        this.searchFormWrapper.input.setAttribute(nd, !0),
        document.body.classList.add(ld),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.addEventListener(
          "theme:resize",
          this.ensureClosingOnResizeEvent
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          this.details.classList.add(dd);
        });
    }
    close(t) {
      const e = this.searchFormWrapper.input.getAttribute(od);
      (t && t.target === this.popdownClose && e && "" !== e) ||
        (this.a11y.removeTrapFocus(),
        this.details.classList.remove(dd),
        this.predictiveSearch && this.searchFormWrapper.close(),
        this.searchFormWrapper.handleFocusableDescendants(!0));
    }
    triggerPopdownClose() {
      this.predictiveSearch && this.searchFormWrapper.close(),
        this.searchFormWrapper.popularSearches &&
          requestAnimationFrame(() => document.activeElement.blur());
    }
    onClose() {
      this.details.removeAttribute(rd),
        document.dispatchEvent(
          new CustomEvent("theme:search:close", { bubbles: !0 })
        ),
        document.body.classList.remove(ld),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.removeEventListener(
          "theme:resize",
          this.ensureClosingOnResizeEvent
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    ensureClosingOnResize() {
      null === this.offsetParent && this.onClose();
    }
    constructor() {
      var t, e, i;
      super(),
        (this.isPopdownInHeader = this.hasAttribute(id)),
        (this.isPopdownInPage = this.hasAttribute(sd)),
        (this.popdownBody = this.querySelector(Wh)),
        (this.popdownClose = this.querySelector(Uh)),
        (this.searchFormInner = this.querySelector(Gh)),
        (this.popularSearchesLink = this.querySelectorAll(Kh)),
        (this.searchFormWrapper = this.querySelector(ed)
          ? this.querySelector(ed)
          : this.querySelector(td)),
        (this.predictiveSearch = this.searchFormWrapper.matches(td)),
        (this.header = document.querySelector(Qh)),
        (this.headerSection =
          null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
        (this.nav =
          null === (e = this.header) || void 0 === e
            ? void 0
            : e.querySelector(Xh)),
        (this.mobileMenu =
          null === (i = this.headerSection) || void 0 === i
            ? void 0
            : i.querySelector(Zh)),
        (this.a11y = ci),
        (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
        (this.popdownTransitionCallbackEvent = (t) =>
          this.popdownTransitionCallback(t)),
        (this.detailsToggleCallbackEvent = (t) =>
          this.detailsToggleCallback(t)),
        this.isPopdownInHeader &&
          ((this.details = this.querySelector(Nh)),
          (this.popdownToggle = this.querySelector(jh)));
    }
  };
  customElements.define("search-popdown", ud),
    (Shopify.Products = (function () {
      const t = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        section: null,
        onComplete: null,
      };
      let e = [],
        i = null,
        s = null;
      const o = new Date(),
        n = new Date();
      n.setTime(o.getTime() + 7776e6);
      const r = {
          configuration: {
            expires: n.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          },
          name: "shopify_recently_viewed",
          write: function (t) {
            const e = t.join(" ");
            document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
          },
          read: function () {
            let t = [],
              e = null;
            return (
              -1 !== document.cookie.indexOf("; ") &&
                document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name)) &&
                (e = document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]),
              null !== e && (t = e.split(" ")),
              t
            );
          },
          destroy: function () {
            document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
          },
          remove: function (t) {
            const e = this.read(),
              i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
          },
        },
        a = (e, i, o, n) => {
          i.length && e < t.howManyToShow
            ? fetch(
                `${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`
              )
                .then((t) => t.text())
                .then((t) => {
                  const s = 150 * e,
                    l = o.id ? `#${o.id}` : "",
                    c = document.createElement("div");
                  let h = t;
                  if (h.includes("data-unpublished"))
                    return r.remove(i[0]), i.shift(), void a(e, i, o, n);
                  (h = h.includes("||itemAosDelay||")
                    ? h.replaceAll("||itemAosDelay||", s)
                    : h),
                    (h = h.includes("||itemAosAnchor||")
                      ? h.replaceAll("||itemAosAnchor||", l)
                      : h),
                    (c.innerHTML = h),
                    (o.innerHTML +=
                      c.querySelector("[data-api-content]").innerHTML),
                    i.shift(),
                    e++,
                    a(e, i, o, n);
                })
                .catch(() => {
                  r.remove(i[0]), i.shift(), a(e, i, o, n);
                })
            : ((e, i) => {
                Xr(e, !0);
                const o = r.read().length;
                if (
                  Shopify.recentlyViewed &&
                  s &&
                  o &&
                  o < s &&
                  e.children.length
                ) {
                  let t = [],
                    i = [],
                    s = 0;
                  for (const e in Shopify.recentlyViewed) {
                    s += 1;
                    const o = Shopify.recentlyViewed[e].split(" "),
                      n = parseInt(e.split("_")[1]);
                    (t = [...t, ...o]),
                      (r.read().length === n ||
                        (s === Object.keys(Shopify.recentlyViewed).length &&
                          !i.length)) &&
                        (i = [...i, ...o]);
                  }
                  for (let s = 0; s < e.children.length; s++) {
                    const o = e.children[s];
                    t.length && o.classList.remove(...t),
                      i.length && o.classList.add(...i);
                  }
                }
                if (t.onComplete)
                  try {
                    t.onComplete(e, i);
                  } catch (t) {
                    console.log(t);
                  }
              })(o, n);
        };
      return {
        showRecentlyViewed: function (o) {
          const n = o || {};
          Object.assign(t, n),
            (e = r.read()),
            (i = document.querySelector(`#${t.wrapperId}`)),
            (s = t.howManyToShow),
            (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
            t.howManyToShow && i && a(0, e, i, t.section);
        },
        getConfig: function () {
          return t;
        },
        clearList: function () {
          r.destroy();
        },
        recordRecentlyViewed: function (e) {
          const i = e || {};
          Object.assign(t, i);
          let s = r.read();
          if (-1 !== window.location.pathname.indexOf("/products/")) {
            let e = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
              )[0]
              .split("/products/")[1];
            t.handle && (e = t.handle);
            const i = s.indexOf(e);
            -1 === i
              ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
              : (s.splice(i, 1), s.unshift(e)),
              r.write(s);
          }
        },
        hasProducts: r.read().length > 0,
      };
    })());
  const pd = "[data-actions]",
    md = "[data-button]",
    gd = "[data-content]",
    fd = "[data-collapsible-container]",
    yd = "data-height",
    vd = "aria-expanded",
    bd = "is-open",
    wd = "is-enabled";
  let Sd = class extends HTMLElement {
    connectedCallback() {
      this.button.addEventListener("click", this.toggle),
        this.content.offsetHeight < this.initialHeight
          ? this.setHeight(this.content.offsetHeight)
          : this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener(
          "theme:resize",
          this.toggleActionsEvent.bind(this)
        );
    }
    toggle() {
      const t = !this.classList.contains(bd),
        e = this.content.offsetHeight + 2 * this.actions.offsetHeight;
      this.setHeight(t ? e : this.initialHeight),
        this.classList.toggle(bd, t),
        this.updateTabIndex(),
        this.dispatchEvent(
          new CustomEvent("theme:ellipsis:toggle", {
            bubbles: !0,
            detail: { isExpanded: t, dropdownHeight: e },
          })
        );
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        wd,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      ),
        this.updateTabIndex();
    }
    toggleActionsEvent() {
      "true" === this.closest(fd).getAttribute(vd) && this.toggleActions();
    }
    updateTabIndex() {
      const t = this.content.querySelectorAll("a"),
        e = this.actions.offsetHeight;
      this.observer && this.observer.disconnect(),
        (this.observer = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              t.isIntersecting
                ? t.target.setAttribute("tabindex", "0")
                : t.target.setAttribute("tabindex", "-1");
            });
          },
          { root: this, threshold: 1, rootMargin: `0px 0px -${e}px 0px` }
        )),
        t.forEach((t) => {
          this.observer.observe(t);
        });
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(yd)),
        (this.content = this.querySelector(gd)),
        (this.actions = this.querySelector(pd)),
        (this.button = this.querySelector(md)),
        (this.toggle = this.toggle.bind(this)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", Sd);
  const Ed = "form",
    Ld = "[data-selector-wrapper]",
    kd = "[data-popout-list]",
    Ad = "[data-popout-toggle]",
    Cd = "[data-popout-input]",
    qd = "[data-popout-option]",
    Td = "[data-popout-text]",
    Pd = "[aria-current]",
    xd = "[data-product-image]",
    Id = "[data-product-grid-item]",
    Hd = "[data-quick-view-item]",
    Fd = "[data-quick-view-foot]",
    Md = "[data-cart-item]",
    Dd = "[data-quantity-field]",
    Od = "[data-cart-drawer]",
    Bd = "[data-cart-message]",
    zd = "[data-cart-errors]",
    _d = "[data-cart-drawer-body]",
    $d = "[data-items-holder]",
    Rd = "selector-wrapper--open",
    Vd = "select-popout__list--top",
    Nd = "select-popout__list--visible",
    Wd = "is-active",
    Ud = "--current",
    jd = "is-visible",
    Gd = "cart__item--open",
    Kd = "aria-current",
    Qd = "aria-expanded",
    Xd = "data-value",
    Yd = "data-popout-prevent",
    Jd = "data-quantity-field",
    Zd = "data-quick-view-inner",
    tu = "data-quick-view-focus",
    eu = "data-popout-initialized",
    iu = "data-quantity-holder";
  customElements.get("popout-select") ||
    customElements.define(
      "popout-select",
      class extends HTMLElement {
        connectedCallback() {
          (this.popout = this),
            (this.selectorWrapper = this.popout.closest(Ld)),
            (this.popoutList = this.popout.querySelector(kd)),
            (this.popoutToggle = this.popout.querySelector(Ad)),
            (this.popoutText = this.popout.querySelector(Td)),
            (this.popoutInput = this.popout.querySelector(Cd)),
            (this.popoutOptions = this.popout.querySelectorAll(qd)),
            (this.popoutPrevent = "true" === this.popout.getAttribute(Yd)),
            (this.cartItem = this.popoutList.closest(Md)),
            (this.popupToggleFocusoutEvent = (t) =>
              this.popupToggleFocusout(t)),
            (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
            (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
            (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
            (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
            (this._connectOptionsDispatchEvent = (t) =>
              this._connectOptionsDispatch(t)),
            (this.bodyClick = this.bodyClick.bind(this)),
            (this.popoutTop = !1),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut(),
            this.popupListSetDimensions();
        }
        popupToggleClick(t) {
          const e = "true" === t.currentTarget.getAttribute(Qd);
          if (this.popoutList.closest(Id)) {
            const t = this.popoutList.closest(Id).querySelector(xd);
            t && t.classList.toggle(jd, !e);
          }
          this.cartItem && this.cartItem.classList.toggle(Gd),
            t.currentTarget.setAttribute(Qd, !e),
            this.popoutList.classList.toggle(Nd),
            this.toggleListPosition(),
            this.popupListSetDimensions();
        }
        popupToggleFocusout(t) {
          const e = "true" === this.popoutToggle.getAttribute(Qd);
          if (!t.relatedTarget) return;
          const i = this.popout.contains(t.relatedTarget),
            s =
              t.relatedTarget.hasAttribute(Zd) ||
              t.relatedTarget.hasAttribute(tu);
          i || s || !e || this._hideList();
        }
        popupListFocusout(t) {
          const e = t.currentTarget.contains(t.relatedTarget);
          this.popoutList.classList.contains(Nd) && !e && this._hideList();
        }
        calc(t = "shouldBeOnTop") {
          const {
              headerHeight: e,
              stickyHeaderHeight: i,
              announcementBarHeight: s,
            } = R(),
            o = this.popout.closest(Hd),
            n = this.popout.closest(Od);
          let r = Math.floor(this.popout.getBoundingClientRect().top),
            a = e || 0,
            l = 0;
          0 !== s && window.scrollY < s && (l = s),
            window.scrollY > l + e && (a = i);
          let c = window.innerHeight,
            h = a + l;
          if (o) {
            const t = o.querySelector(Fd),
              e = (null == t ? void 0 : t.offsetHeight) || 0,
              i = Math.floor(o.getBoundingClientRect().top);
            (r -= i), (c -= e), (h = i), ke() && (c = o.offsetHeight - e);
          }
          if (n) {
            const t = n.querySelector(Bd),
              e = n.querySelector(zd),
              i = n.querySelector(_d),
              s = n.querySelector($d),
              o = (null == t ? void 0 : t.offsetHeight) || 0,
              a = (null == e ? void 0 : e.offsetHeight) || 0,
              l = (null == i ? void 0 : i.scrollHeight) || 0;
            (r -= Math.floor(
              null == s ? void 0 : s.getBoundingClientRect().top
            )),
              (c = l - o - a),
              (h = 0);
          }
          let d = c - h;
          if ((o && ke() && (d = c), "shouldBeOnTop" === t)) return d / 2 < r;
          if ("availableHeightAbove" === t) {
            const t = Math.floor(
              this.popoutToggle.getBoundingClientRect().top - 1
            );
            return (h += 10), `${parseInt(t - h)}px`;
          }
          if ("availableHeightBelow" === t) {
            const t = Math.floor(
              this.popoutList.getBoundingClientRect().top - 1
            );
            return (h = 10), `${parseInt(c - t - h)}px`;
          }
        }
        toggleListPosition() {
          const t = "true" === this.popoutToggle.getAttribute(Qd),
            e = () => {
              var t;
              null === (t = this.selectorWrapper) ||
                void 0 === t ||
                t.classList.remove(Rd),
                this.popoutList.classList.remove(Vd),
                (this.popoutTop = !1),
                this.popoutList.removeEventListener("transitionend", e);
            };
          var i;
          t
            ? (null === (i = this.selectorWrapper) ||
                void 0 === i ||
                i.classList.add(Rd),
              this.calc("shouldBeOnTop") &&
                (this.popoutList.classList.add(Vd), (this.popoutTop = !0)))
            : this.popoutList.addEventListener("transitionend", e);
        }
        popupListSetDimensions() {
          this.popoutList.style.setProperty("--max-height", "100vh"),
            requestAnimationFrame(() => {
              this.popoutTop
                ? this.popoutList.style.setProperty(
                    "--max-height",
                    this.calc("availableHeightAbove")
                  )
                : this.popoutList.style.setProperty(
                    "--max-height",
                    this.calc("availableHeightBelow")
                  );
            });
        }
        popupOptionsClick(t) {
          if ("#" === t.target.closest(qd).attributes.href.value) {
            t.preventDefault();
            let e = "";
            if (
              (t.currentTarget.getAttribute(Xd) &&
                (e = t.currentTarget.getAttribute(Xd)),
              !this.popoutInput &&
                this.popout.nextSibling.hasAttribute(iu) &&
                (this.popoutInput = this.popout.nextSibling.querySelector(Dd)),
              (this.popoutInput.value = e),
              this.popoutPrevent)
            ) {
              this.popoutInput.dispatchEvent(new Event("change")),
                this.cartItem &&
                  this.popoutInput.dispatchEvent(new Event("input")),
                this.switchQuantityInputBehavior(t.detail.preventTrigger);
              const i = this.popoutList.querySelector(`[class*="${Ud}"]`);
              let s = Ud;
              if (i && i.classList.length)
                for (const t of i.classList)
                  if (t.includes(Ud)) {
                    s = t;
                    break;
                  }
              const o = this.popoutList.querySelector(`.${s}`);
              o &&
                (o.classList.remove(`${s}`),
                t.currentTarget.parentElement.classList.add(`${s}`));
              const n = this.popoutList.querySelector(Pd);
              n &&
                (n.removeAttribute(Kd),
                t.currentTarget.setAttribute(Kd, "true")),
                "" !== e && (this.popoutText.textContent = e),
                this.popupToggleFocusout(t),
                this.popupListFocusout(t);
            } else this._submitForm(e);
          }
        }
        switchQuantityInputBehavior(t = !0) {
          var e;
          if (t || !this.popoutInput.hasAttribute(Jd)) return;
          const i = this.popoutList.querySelector(
            `[${Xd}="${this.popoutInput.value}"]`
          );
          i &&
            (i.parentElement.nextSibling ||
              (this.popout.classList.add(Wd),
              null === (e = this.selectorWrapper) ||
                void 0 === e ||
                e.classList.remove(Rd)));
        }
        popoutKeyup(t) {
          t.code === theme.keyboardKeys.ESCAPE &&
            (this._hideList(), this.popoutToggle.focus());
        }
        bodyClick(t) {
          const e = this.popout.contains(t.target);
          this.popoutList.classList.contains(Nd) && !e && this._hideList();
        }
        _connectToggle() {
          this.popout.setAttribute(eu, ""),
            this.popoutToggle.addEventListener(
              "click",
              this.popupToggleClickEvent
            );
        }
        _connectOptions() {
          this.popoutOptions.length &&
            this.popoutOptions.forEach((t) => {
              t.addEventListener(
                "theme:popout:click",
                this.popupOptionsClickEvent
              ),
                t.addEventListener("click", this._connectOptionsDispatchEvent);
            });
        }
        _connectOptionsDispatch(t) {
          const e = new CustomEvent("theme:popout:click", {
            cancelable: !0,
            bubbles: !0,
            detail: { preventTrigger: !1 },
          });
          t.target.dispatchEvent(e) || t.preventDefault();
        }
        _onFocusOut() {
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
            this.popoutList.addEventListener(
              "focusout",
              this.popupListFocusoutEvent
            ),
            this.popout.addEventListener("keyup", this.popoutKeyupEvent),
            document.body.addEventListener("click", this.bodyClick);
        }
        _submitForm() {
          const t = this.popout.closest(Ed);
          t && t.submit();
        }
        _hideList() {
          this.popoutList.classList.remove(Nd),
            this.popoutToggle.setAttribute(Qd, !1),
            this.toggleListPosition(),
            this.cartItem && this.cartItem.classList.remove(Gd);
        }
        disconnectedCallback() {
          this.popoutOptions.length &&
            this.popoutOptions.forEach((t) => {
              t.removeEventListener(
                "theme:popout:click",
                this.popupOptionsClickEvent
              ),
                t.removeEventListener(
                  "click",
                  this._connectOptionsDispatchEvent
                );
            }),
            this.popoutToggle.removeEventListener(
              "click",
              this.popupToggleClickEvent
            ),
            this.popoutToggle.removeEventListener(
              "focusout",
              this.popupToggleFocusoutEvent
            ),
            this.popoutList.removeEventListener(
              "focusout",
              this.popupListFocusoutEvent
            ),
            this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
            document.body.removeEventListener("click", this.bodyClick);
        }
        constructor() {
          super();
        }
      }
    );
  const su = "[data-quantity-field]",
    ou = "[data-quantity-button]",
    nu = "[data-quantity-minus]",
    ru = "[data-quantity-plus]",
    au = "[data-cart-item]",
    lu = "read-only",
    cu = "is-disabled";
  customElements.get("quantity-counter") ||
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        connectedCallback() {
          (this.quantity = this),
            (this.cartItem = this.quantity.closest(au)),
            this.quantity &&
              ((this.field = this.quantity.querySelector(su)),
              (this.buttons = this.quantity.querySelectorAll(ou)),
              (this.increaseButton = this.quantity.querySelector(ru)),
              (this.quantityValue = Number(this.field.value || 0)),
              (this.cartItemID = this.field.getAttribute("data-id")),
              (this.maxValue =
                Number(this.field.getAttribute("max")) > 0
                  ? Number(this.field.getAttribute("max"))
                  : null),
              (this.minValue =
                Number(this.field.getAttribute("min")) > 0
                  ? Number(this.field.getAttribute("min"))
                  : 0),
              (this.disableIncrease = this.disableIncrease.bind(this)),
              (this.emptyField = !1),
              (this.updateQuantity = this.updateQuantity.bind(this)),
              (this.decrease = this.decrease.bind(this)),
              (this.increase = this.increase.bind(this)),
              this.disableIncrease(),
              this.quantity.classList.contains(lu) ||
                (this.changeValueOnClick(), this.changeValueOnInput()));
        }
        changeValueOnClick() {
          this.buttons.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault(),
                (this.quantityValue = Number(this.field.value || 0));
              const e = t.target,
                i = e.matches(nu) || e.closest(nu),
                s = e.matches(ru) || e.closest(ru);
              i && this.decrease(), s && this.increase(), this.updateQuantity();
            });
          });
        }
        changeValueOnInput() {
          this.field.addEventListener("input", () => {
            (this.quantityValue = this.field.value), this.updateQuantity();
          });
        }
        updateQuantity() {
          this.maxValue < this.quantityValue &&
            null !== this.maxValue &&
            (this.quantityValue = this.maxValue),
            this.minValue > this.quantityValue &&
              (this.quantityValue = this.minValue),
            (this.field.value = this.quantityValue),
            this.disableIncrease(),
            this.cartItem
              ? (document.dispatchEvent(new CustomEvent("theme:cart:update")),
                this.updateCart())
              : this.triggerInputChange();
        }
        decrease() {
          this.quantityValue > this.minValue
            ? this.quantityValue--
            : (this.quantityValue = 0);
        }
        increase() {
          this.quantityValue++;
        }
        disableIncrease() {
          this.increaseButton.classList.toggle(
            cu,
            this.quantityValue >= this.maxValue && null !== this.maxValue
          );
        }
        updateCart() {
          if ("" === this.quantityValue) return;
          const t = new CustomEvent("theme:cart:update", {
            bubbles: !0,
            detail: { id: this.cartItemID, quantity: this.quantityValue },
          });
          this.cartItem && this.cartItem.dispatchEvent(t);
        }
        triggerInputChange() {
          this.field.dispatchEvent(new Event("change"));
        }
        constructor() {
          super();
        }
      }
    ),
    (theme.ProductModel = (function () {
      let t = {},
        e = {},
        i = {};
      const s = {
          productMediaWrapper: "[data-product-single-media-wrapper]",
          mediaGroup: "[data-product-single-media-group]",
          productXr: "[data-shopify-xr]",
          mediaId: "data-media-id",
          model3d: "data-shopify-model3d-id",
          modelViewer: "model-viewer",
          modelJson: "#ModelJson-",
          deferredMedia: "[data-deferred-media]",
          deferredMediaButton: "[data-deferred-media-button]",
        },
        o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
      function n(t, n) {
        if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
        t.classList.add(o.isLoading);
        const l = document.createElement("div");
        l.appendChild(
          t.querySelector("template").content.firstElementChild.cloneNode(!0)
        );
        const c = l.querySelector("model-viewer"),
          h = t.querySelector(s.deferredMedia);
        h.appendChild(c), h.setAttribute("loaded", !0);
        const d = t.dataset.mediaId,
          u = c.dataset.modelId,
          p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
        (i[n] = { element: p, defaultId: u }),
          (e[d] = {
            modelId: u,
            mediaId: d,
            sectionId: n,
            container: t,
            element: c,
          }),
          window.ShopifyXR
            ? a()
            : window.Shopify.loadFeatures([
                { name: "shopify-xr", version: "1.0", onLoad: r },
                { name: "model-viewer-ui", version: "1.0", onLoad: a },
              ]);
      }
      function r(e) {
        if (e) console.warn(e);
        else if (window.ShopifyXR) {
          for (const e in t)
            if (t.hasOwnProperty(e)) {
              const i = t[e];
              if (i.loaded) continue;
              const o = document.querySelector(`${s.modelJson}${e}`);
              o &&
                (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                (i.loaded = !0));
            }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            r();
          });
      }
      function a(t) {
        if (t) console.warn(t);
        else
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              const i = e[t];
              i.modelViewerUi ||
                ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)),
                l(i));
            }
      }
      function l(t) {
        const e = i[t.sectionId];
        t.container.addEventListener("theme:media:visible", function () {
          e.element.setAttribute(s.model3d, t.modelId),
            window.theme.touch ||
              (t.modelViewerUi.play(),
              t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                bubbles: !0,
              }));
        }),
          t.container.addEventListener("theme:media:hidden", function () {
            t.modelViewerUi.pause();
          }),
          t.container.addEventListener("xrLaunch", function () {
            t.modelViewerUi.pause();
          }),
          t.element.addEventListener("load", () => {
            e.element.setAttribute(s.model3d, t.modelId),
              t.container.classList.remove(o.isLoading),
              t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                bubbles: !0,
              });
          }),
          t.element.addEventListener(
            "shopify_model_viewer_ui_toggle_play",
            function () {
              c(t.mediaId),
                setTimeout(() => {
                  t.container.dispatchEvent(
                    new CustomEvent("theme:media:play"),
                    { bubbles: !0 }
                  );
                }, 50);
            }
          ),
          t.element.addEventListener(
            "shopify_model_viewer_ui_toggle_pause",
            function () {
              t.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                bubbles: !0,
              });
            }
          ),
          c(t.mediaId);
      }
      function c(t) {
        const e = `[${s.mediaId}="${t}"]`,
          i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
        i.length &&
          i.forEach((t) => {
            t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
              bubbles: !0,
            }),
              t.classList.add(o.mediaHidden);
          });
      }
      return {
        init: function (e, i) {
          t[i] = { loaded: !1 };
          const o = e.querySelector(s.deferredMediaButton);
          o && o.addEventListener("click", n.bind(this, e, i));
        },
        loadContent: n,
        removeSectionModels: function (i) {
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              e[t].sectionId === i && delete e[t];
            }
          delete t[i], delete theme.mediaInstances[i];
        },
      };
    })()),
    P("collection-template", _n);
  const hu = ".template-customers-addresses",
    du = "[data-form]",
    uu = "[data-form-new]",
    pu = "[data-button-new]",
    mu = "[data-button-edit]",
    gu = "[data-button-delete]",
    fu = "[data-button-cancel]",
    yu = "data-form-edit",
    vu = "AddressCountryNew",
    bu = "AddressProvinceNew",
    wu = "AddressProvinceContainerNew",
    Su = "[data-country-option]",
    Eu = "AddressCountry",
    Lu = "AddressProvince",
    ku = "AddressProvinceContainer",
    Au = 'input[type="text"]:not(.optional)',
    Cu = "data-form-id",
    qu = "is-hidden",
    Tu = "validation--showup";
  const Pu = document.querySelector(hu);
  Pu &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const i = t.querySelectorAll(pu);
          i.length &&
            i.forEach((t) => {
              t.addEventListener("click", function (i) {
                i.preventDefault(), t.classList.add(qu), e.classList.remove(qu);
              });
            });
          const s = t.querySelectorAll(mu);
          s.length &&
            s.forEach((e) => {
              e.addEventListener("click", function (e) {
                e.preventDefault();
                const i = this.getAttribute(Cu);
                t.querySelector(`[${yu}="${i}"]`).classList.toggle(qu);
              });
            });
          const o = t.querySelectorAll(gu);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function (t) {
                t.preventDefault();
                const e = this.getAttribute(Cu);
                confirm(theme.strings.delete_confirm) &&
                  Shopify.postLink("/account/addresses/" + e, {
                    parameters: { _method: "delete" },
                  });
              });
            });
          const n = t.querySelectorAll(fu);
          n.length &&
            n.forEach((t) => {
              t.addEventListener("click", function (t) {
                t.preventDefault(),
                  this.closest(du).classList.add(qu),
                  document.querySelector(pu).classList.remove(qu);
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(vu, bu, { hideElement: wu }),
          this.section.querySelectorAll(Su).forEach((t) => {
            const e = t.getAttribute(Cu),
              i = `${Eu}_${e}`,
              s = `${Lu}_${e}`,
              o = `${ku}_${e}`;
            new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
          });
      }
      validate() {
        this.accountForms.forEach((t) => {
          const e = t.querySelector("form"),
            i = e.querySelectorAll(Au);
          e.addEventListener("submit", (t) => {
            let e = !1;
            i.forEach((t) => {
              t.value
                ? t.nextElementSibling.classList.remove(Tu)
                : (t.nextElementSibling.classList.add(Tu), (e = !0));
            }),
              e && t.preventDefault();
          });
        });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector(uu)),
          (this.accountForms = this.section.querySelectorAll(du)),
          this.init(),
          this.validate();
      }
    })(Pu);
  const xu = "[data-account-form]",
    Iu = "[data-show-reset]",
    Hu = "[data-hide-reset]",
    Fu = "[data-recover-password]",
    Mu = "[data-login-form]",
    Du = "[data-recover-success]",
    Ou = "[data-recover-success-text]",
    Bu = "#recover",
    zu = "is-hidden";
  const _u = document.querySelector(xu);
  _u &&
    new (class {
      init() {
        window.location.hash == Bu
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.success && this.successText.classList.remove(zu),
          this.showButton.addEventListener(
            "click",
            (t) => {
              t.preventDefault(), this.showRecoverPasswordForm();
            },
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            (t) => {
              t.preventDefault(), this.hideRecoverPasswordForm();
            },
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.recover.classList.remove(zu),
          this.login.classList.add(zu),
          (window.location.hash = Bu),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.login.classList.remove(zu),
          this.recover.classList.add(zu),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector(Iu)),
          (this.hideButton = t.querySelector(Hu)),
          (this.recover = t.querySelector(Fu)),
          (this.login = t.querySelector(Mu)),
          (this.success = t.querySelector(Du)),
          (this.successText = t.querySelector(Ou)),
          this.init();
      }
    })(_u),
    P("search-template", [_n, br]);
  const $u = "[data-ticker-scale]",
    Ru = "[data-ticker-text]",
    Vu = "data-clone",
    Nu = "data-marquee-speed",
    Wu = "ticker--animated",
    Uu = "ticker--unloaded",
    ju = "ticker__comparitor",
    Gu = 1.63,
    Ku = 100;
  let Qu = class {
    listen() {
      document.addEventListener("theme:resize:width", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      const t =
        2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
      if (
        this.frame.clientWidth - t < this.comparitor.clientWidth ||
        this.stopClone
      ) {
        if (1 === this.scale.childElementCount) {
          if (
            (this.text.classList.add(Wu),
            (this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(Vu, ""),
            this.scale.appendChild(this.clone),
            this.stopClone)
          )
            for (let t = 0; t < 10; t++) {
              const t = this.text.cloneNode(!0);
              t.setAttribute(Vu, ""), this.scale.appendChild(t);
            }
          let t = this.frame.getAttribute(Nu);
          null === t && (t = 100);
          const e = Gu * (100 / parseInt(t, 10)),
            i = (this.text.clientWidth / Ku) * e;
          this.scale.style.setProperty("--animation-time", `${i}s`);
        }
      } else {
        this.text.classList.add(Wu);
        let t = this.scale.querySelector(`[${Vu}]`);
        t && this.scale.removeChild(t), this.text.classList.remove(Wu);
      }
    }
    unload() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor(t, e = !1) {
      (this.frame = t),
        (this.stopClone = e),
        (this.scale = this.frame.querySelector($u)),
        (this.text = this.frame.querySelector(Ru)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(ju),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(Uu),
        (this.resizeEvent = o(() => this.checkWidth(), 100)),
        this.listen();
    }
  };
  const Xu = "[data-parallax]",
    Yu = ".shopify-section",
    Ju = "[data-main]",
    Zu = "is-disabled",
    tp = "main-content",
    ep = "shopify-section",
    ip = "section-footer--visible",
    sp = "card-scrolling-hidden",
    op = "sticky-top-zero",
    np = "data-parallax",
    rp = "data-parallax-intensity",
    ap = "data-parallax-static",
    lp = "data-parallax-single",
    cp = "data-parallax-disable-on-mobile",
    hp = "data-parallax-rounded-corners",
    dp = "data-parallax-rounded-corners-large",
    up = {};
  let pp = class {
    assignFooterArguments() {
      this.animations.includes("footer") &&
        ((this.shopifySection = this.container.closest(Yu)),
        (this.footerPrevSectionOffset = 0),
        this.container.hasAttribute(hp) &&
          ((this.footerPrevSectionOffset = 8),
          this.container.hasAttribute(dp) &&
            (this.footerPrevSectionOffset = 34)),
        (this.prevSection = this.container.parentNode.previousElementSibling),
        !this.prevSection ||
          this.prevSection.classList.contains(ep) ||
          this.prevSection.classList.contains(tp) ||
          (this.prevSection = this.main),
        requestAnimationFrame(() => {
          (this.containerHeight = this.container.offsetHeight),
            (this.footerOffset = 0.15 * this.containerHeight),
            (this.cachedPosition = this.footerOffset),
            (this.cachedPercentage = 0);
        }));
    }
    assignCardScrollingArguments() {
      if (!this.animations.includes("card-scrolling")) return;
      let { stickyHeaderHeight: t } = R();
      if (
        ((this.headerHeight = t || 0),
        (this.shopifySection = this.container.closest(Yu)),
        (this.nextSection = this.shopifySection.nextElementSibling),
        (this.cardScrollingStickyTop = this.headerHeight || 0),
        (this.cardScrollingMarginTop = this.nextSection
          ? parseInt(
              window
                .getComputedStyle(this.nextSection)
                .getPropertyValue("margin-top")
            )
          : 0),
        (this.after = !1),
        (this.prevSection = this.shopifySection.previousElementSibling),
        this.prevSection)
      ) {
        const t = this.firstSection.id,
          e = this.prevSection.matches(`#${t}`),
          i = this.prevSection.offsetHeight;
        this.shopifySection.classList.toggle(
          op,
          e && i <= 2 * this.headerHeight
        );
      }
      this.opacityValue = (t) =>
        t
          ? Boolean(t <= 0)
            ? 0
            : Boolean(t > 0 && t <= 100)
            ? Number(t / 100).toFixed(4)
            : Boolean(t > 100)
            ? 1
            : void 0
          : 0;
    }
    init() {
      this.updateParallax(),
        document.addEventListener("theme:scroll", this.scrollEvent),
        document.addEventListener("theme:resize", this.resizeEvent),
        document.addEventListener("theme:parallax:refresh", this.refreshEvent);
    }
    updateParallax() {
      this.container.classList.contains(Zu) ||
        (this.disableOnMobile && ke()) ||
        ((this.scrollTop = Math.round(window.scrollY)),
        (this.scrollBottom = this.scrollTop + this.viewportHeight),
        (this.elementOffsetTopPoint = Math.round(
          this.container.getBoundingClientRect().top + this.scrollTop
        )),
        window.Shopify.designMode &&
          (this.assignCardScrollingArguments(),
          (this.containerHeight = this.container.offsetHeight)),
        (this.elementOffsetBottomPoint =
          this.elementOffsetTopPoint + this.containerHeight),
        (this.isBottomOfElementPassed =
          this.elementOffsetBottomPoint < this.scrollTop),
        (this.isTopOfElementReached =
          this.elementOffsetTopPoint < this.scrollBottom),
        (this.isInView =
          this.isTopOfElementReached && !this.isBottomOfElementPassed),
        this.adjustCalculations(),
        this.toggleVisibility(),
        this.isInView &&
          ((this.scrollProgress =
            this.scrollBottom - this.elementOffsetTopPoint),
          (this.percentage =
            (100 * (this.scrollProgress - this.containerHeight / 2)) /
            this.viewportHeight),
          (this.percentageFull = Number(
            this.scrollProgress / this.containerHeight
          ).toFixed(2)),
          (this.percentageVisible = Number(
            (100 * this.scrollProgress) /
              (this.viewportHeight + this.containerHeight)
          ).toFixed(2)),
          this.animations.includes("circle") && this.animateCircleText(),
          (this.animations.includes("horizontal") ||
            this.animations.includes("vertical") ||
            this.animations.includes("diagonal")) &&
            this.animateOverlappingImages(),
          (this.animations.includes("offset-ltr") ||
            this.animations.includes("offset-rtl")) &&
            this.offsetX(),
          this.animations.includes("card-scrolling") &&
            this.cardScrollingEffect(),
          this.animations.includes("zoom-on-scroll") && this.zoomInOut(),
          this.animations.includes("footer") && this.animateFooter()));
    }
    adjustCalculations() {
      var t;
      (this.animations.includes("card-scrolling") &&
        ((this.currentSectionTop =
          this.shopifySection.getBoundingClientRect().top),
        this.nextSection
          ? ((this.nextSectionTop =
              this.nextSection.getBoundingClientRect().top),
            (this.offsetTop =
              this.nextSectionTop -
              this.containerHeight -
              this.cardScrollingMarginTop))
          : ((this.nextSectionTop =
              this.currentSectionTop + this.containerHeight),
            (this.offsetTop = this.currentSectionTop)),
        (this.distance = Math.floor(
          this.currentSectionTop - this.headerHeight
        )),
        (this.after = Boolean(
          Math.round(
            this.nextSectionTop -
              this.headerHeight -
              this.cardScrollingMarginTop +
              0.1 * this.viewportHeight
          ) < 0
        )),
        (this.isInView = this.isTopOfElementReached && !this.after)),
      this.animations.includes("footer")) &&
        ((this.elementOffsetTopPoint = Math.round(
          (null === (t = this.prevSection) || void 0 === t
            ? void 0
            : t.getBoundingClientRect().bottom) -
            this.footerPrevSectionOffset +
            this.scrollTop
        )),
        (this.elementOffsetBottomPoint =
          this.elementOffsetTopPoint + this.containerHeight),
        (this.isBottomOfElementPassed =
          this.elementOffsetBottomPoint < this.scrollTop),
        (this.isTopOfElementReached =
          this.elementOffsetTopPoint < this.scrollBottom),
        (this.isInView =
          this.isTopOfElementReached && !this.isBottomOfElementPassed),
        (this.isApproaching =
          Math.round(this.elementOffsetTopPoint - this.viewportHeight / 2) <
          this.scrollBottom));
    }
    toggleVisibility() {
      this.animations.includes("card-scrolling") &&
        this.shopifySection.classList.toggle(sp, this.after),
        this.animations.includes("footer") &&
          (Boolean(this.isApproaching || this.isInView)
            ? this.shopifySection.classList.add(ip)
            : this.shopifySection.classList.remove(ip));
    }
    cardScrollingEffect() {
      const t = (this.offsetTop / this.containerHeight) * -100;
      this.container.style.setProperty(
        "--card-scrolling-overlay",
        this.opacityValue(t)
      );
    }
    zoomInOut() {
      if (this.animations.includes("card-scrolling") && this.nextSection) {
        const t =
            this.nextSectionTop -
            this.headerHeight -
            this.cardScrollingMarginTop -
            this.containerHeight,
          e = Math.round(t + this.scrollTop),
          i = this.scrollBottom - e;
        this.percentageVisible = Number(
          (100 * i) /
            (this.viewportHeight +
              this.containerHeight +
              this.cardScrollingMarginTop)
        ).toFixed(2);
      }
      const t = (0.2 * this.percentageVisible) / 100;
      let e = Number(1 + t).toFixed(4);
      (e = e > 1 ? e : 1), this.container.style.setProperty("--scale", e);
    }
    offsetX() {
      const t = this.container.hasAttribute(ap),
        e = this.container.getAttribute(rp) || 100;
      let i = this.animations.includes("offset-ltr") ? e : 0;
      t && (i = e / 2);
      const s = this.animations.includes("offset-ltr") ? 1 : -1,
        o = (e * this.percentageVisible) / 100 - i,
        n = Number(o * s).toFixed(2);
      this.container.style.setProperty("--offsetX", `${n}%`);
    }
    updateHeight() {
      if (this.animations.includes("card-scrolling")) {
        let { stickyHeaderHeight: t } = R();
        if (
          ((this.headerHeight = t || 0),
          (this.cardScrollingStickyTop = this.headerHeight || 0),
          (this.cardScrollingMarginTop = this.nextSection
            ? parseInt(
                window
                  .getComputedStyle(this.nextSection)
                  .getPropertyValue("margin-top")
              )
            : 0),
          (this.containerHeight = this.container.offsetHeight),
          (this.prevSection = this.shopifySection.previousElementSibling),
          this.prevSection)
        ) {
          const t = this.firstSection.id,
            e = this.prevSection.matches(`#${t}`),
            i = this.prevSection.offsetHeight;
          this.shopifySection.classList.toggle(
            op,
            e && i <= 2 * this.headerHeight
          );
        }
      }
      const t = matchMedia("(min-width: 1024px)").matches;
      (this.orientation !== K() || t) &&
        ((this.viewportHeight = Math.round(
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          )
        )),
        (this.containerHeight = this.container.offsetHeight),
        (this.orientation = K()));
    }
    animateCircleText() {
      const t = ((70 * this.percentage) / 100) * -1;
      this.percentage > 0 &&
        this.container.style.setProperty("--rotate", `${35 + t}deg`);
    }
    animateOverlappingImages() {
      const t = 0.25 * this.container.getAttribute(rp),
        e = t / 2,
        i = this.container.hasAttribute(lp),
        s = (t * this.percentage) / 100;
      let o = 0,
        n = 0,
        r = 0,
        a = 0;
      (this.animations.includes("horizontal") ||
        this.animations.includes("diagonal")) &&
        ((o = -1 * e + s), (r = e - s)),
        (this.animations.includes("vertical") ||
          this.animations.includes("diagonal")) &&
          ((n = e - s), (a = -1 * e + s)),
        this.container.style.setProperty("--transformX-primary", `${o}%`),
        this.container.style.setProperty("--transformY-primary", `${n}%`),
        i ||
          (this.container.style.setProperty("--transformX-secondary", `${r}%`),
          this.container.style.setProperty("--transformY-secondary", `${a}%`));
    }
    animateFooter() {
      const t = this.footerOffset * this.percentageFull,
        e = Number((t / this.footerOffset) * 100).toFixed(2),
        i = new WebKitCSSMatrix(
          window.getComputedStyle(this.container).transform
        ),
        s = Number(i.m42).toFixed(2);
      let o = Number(this.footerOffset - t).toFixed(2);
      this.percentageFull >= 1 && (o = 0),
        s !== o &&
          this.cachedPercentage !== e &&
          (this.container.style.setProperty("--transformY", `${o}`),
          (this.cachedPercentage = e),
          (this.cachedPosition = o));
    }
    unload() {
      document.removeEventListener("theme:scroll", this.scrollEvent),
        document.removeEventListener("theme:resize", this.resizeEvent),
        document.removeEventListener(
          "theme:parallax:refresh",
          this.refreshEvent
        );
    }
    refresh() {
      this.assignFooterArguments(),
        this.assignCardScrollingArguments(),
        this.updateParallax();
    }
    constructor(t) {
      (this.container = t),
        (this.percentage = 0),
        (this.percentageFull = 0),
        (this.animation = this.container.getAttribute(np)),
        (this.animations = this.animation.split(",")),
        (this.disableOnMobile = this.container.hasAttribute(cp)),
        (this.viewportHeight = Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        )),
        (this.containerHeight = this.container.offsetHeight),
        (this.main = document.querySelector(Ju)),
        (this.firstSection = this.main.children[0]),
        (this.orientation = K()),
        (this.scrollEvent = () => this.updateParallax()),
        (this.resizeEvent = () => this.updateHeight()),
        (this.refreshEvent = () => this.refresh()),
        this.assignFooterArguments(),
        this.assignCardScrollingArguments(),
        requestAnimationFrame(() => this.init());
    }
  };
  const mp = {
      onLoad() {
        up[this.id] = [];
        this.container.querySelectorAll(Xu).forEach((t) => {
          up[this.id].push(new pp(t));
        });
      },
      onUnload() {
        up[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    gp = "[data-announcement]",
    fp = "[data-announcement-slide]",
    yp = "[data-ticker-frame]",
    vp = "[data-slide]",
    bp = "[data-slider]",
    wp = "[data-static]",
    Sp = "[data-ticker-scale]",
    Ep = "[data-ticker-text]",
    Lp = "[data-parallax]",
    kp = "text-highlight",
    Ap = "data-slide",
    Cp = "data-slider-speed",
    qp = "data-slider-arrows",
    Tp = "data-stop",
    Pp = "style",
    xp = "data-target-referrer",
    Ip = "clip-path",
    Hp = "desktop",
    Fp = "mobile",
    Mp = "ticker--animated",
    Dp = "is-disabled",
    Op = "clipPath",
    Bp = {};
  const zp = {
    onLoad() {
      Bp[this.id] = [];
      const t = this.container.querySelector(gp);
      t &&
        Bp[this.id].push(
          new (class {
            init() {
              this.removeAnnouncement(),
                this.slider &&
                  (this.initSlider(),
                  document.addEventListener(
                    "theme:resize:width",
                    this.initSlider.bind(this)
                  )),
                this.static &&
                  (this.initTickers(), this.tickerAnimationPause()),
                this.slider ||
                  this.static ||
                  (this.initTickers(!0), this.tickerAnimationPause()),
                this.updateSVGClipPathIDs();
            }
            removeAnnouncement() {
              for (let t = 0; t < this.slides.length; t++) {
                const e = this.slides[t];
                e.hasAttribute(xp) &&
                  (-1 !== this.locationPath.indexOf(e.getAttribute(xp)) ||
                    window.Shopify.designMode ||
                    e.parentNode.removeChild(e));
              }
            }
            checkSlidesClasses(t, e) {
              if (0 !== t.length) {
                const i = e.querySelectorAll(`${vp}.${Fp}`),
                  s = e.querySelectorAll(`${vp}.${Hp}`);
                t.length === i.length
                  ? e.parentNode.classList.add(Fp)
                  : t.length === s.length && e.parentNode.classList.add(Hp);
              }
            }
            initSlider() {
              const t = this.slider.querySelectorAll(vp),
                i = this.slider.hasAttribute(qp);
              if ((this.checkSlidesClasses(t, this.barHolder), t)) {
                let t = `${vp}`;
                (t =
                  window.innerWidth < theme.sizes.small
                    ? `${vp}:not(.${Hp})`
                    : `${vp}:not(.${Fp})`),
                  null != this.flkty && this.flkty.destroy(),
                  (this.flkty = new e(this.slider, {
                    cellSelector: t,
                    pageDots: !1,
                    prevNextButtons: i,
                    wrapAround: !0,
                    autoPlay: parseInt(this.slider.getAttribute(Cp), 10),
                    on: {
                      ready: () => {
                        setTimeout(() => {
                          this.slider.dispatchEvent(
                            new CustomEvent("slider-is-loaded", {
                              bubbles: !0,
                              detail: { slider: this },
                            })
                          );
                        }, 10);
                      },
                      change: (t) => {
                        this.flkty.cells.forEach((e, i) => {
                          e.element.querySelectorAll(kp).forEach((e) => {
                            e.setTriggerAttribute(Boolean(i === t));
                          });
                        });
                      },
                    },
                  })),
                  this.flkty.reposition();
              }
              this.slider.addEventListener("slider-is-loaded", () => {
                this.initTickers(), this.updateSVGClipPathIDs();
              });
            }
            initTickers(t = !1) {
              this.barHolder.querySelectorAll(yp).forEach((e) => {
                const i = new Qu(e, t);
                this.tickers.push(i);
                const s = e.querySelectorAll(vp);
                this.checkSlidesClasses(s, this.barHolder);
              });
            }
            toggleTicker(t, e) {
              const i = t.target.closest(Sp),
                s = document.querySelector(`[${Ap}="${t.detail.blockId}"]`);
              e &&
                s &&
                (i.setAttribute(Tp, ""),
                i.querySelectorAll(Ep).forEach((t) => {
                  t.classList.remove(Mp),
                    (t.style.transform = `translate3d(${-(
                      s.offsetLeft -
                      parseInt(getComputedStyle(s).marginLeft, 10)
                    )}px, 0, 0)`);
                })),
                !e &&
                  s &&
                  (i.querySelectorAll(Ep).forEach((t) => {
                    t.classList.add(Mp), t.removeAttribute(Pp);
                  }),
                  i.removeAttribute(Tp),
                  this.static &&
                    document.dispatchEvent(
                      new CustomEvent("theme:resize:width", { bubbles: !0 })
                    ));
            }
            tickerAnimationPause() {
              let t = 0,
                e = !1;
              const i = this.barHolder.querySelector(fp);
              i.addEventListener("mouseenter", () => {
                (e = !0),
                  (t = setTimeout(() => {
                    e &&
                      i.querySelectorAll(Ep).forEach((t) => {
                        t.style.animationPlayState = "paused";
                      }),
                      clearTimeout(t);
                  }, 500));
              }),
                i.addEventListener("mouseleave", () => {
                  (e = !1),
                    i.querySelectorAll(Ep).forEach((t) => {
                      t.style.animationPlayState = "running";
                    });
                });
            }
            updateSVGClipPathIDs() {
              this.barHolder.querySelectorAll(vp).forEach((t, e) => {
                const i = t.querySelector(Op);
                if (i) {
                  const s = `${i.id}_${e}`;
                  i.id = s;
                  const o = t.querySelector(`g[${Ip}]`);
                  o && o.setAttribute(Ip, `url(#${s})`);
                }
              });
            }
            onBlockSelect(t) {
              const e = parseInt(
                [...t.target.parentNode.children].indexOf(t.target)
              );
              this.slider &&
                null !== this.flkty &&
                (this.flkty.select(e), this.flkty.pausePlayer()),
                this.slider || this.toggleTicker(t, !0),
                this.parallax &&
                  (this.parallax.style.setProperty("--offsetX", "0%"),
                  this.parallax.classList.add(Dp));
            }
            onBlockDeselect(t) {
              this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
                this.slider || this.toggleTicker(t, !1),
                this.parallax &&
                  (this.parallax.classList.remove(Dp),
                  document.dispatchEvent(new CustomEvent("theme:scroll")));
            }
            onUnload() {
              document.removeEventListener(
                "theme:resize:width",
                this.initSlider.bind(this)
              ),
                this.tickers.length > 0 &&
                  this.tickers.forEach((t) => {
                    t.unload();
                  });
            }
            constructor(t) {
              (this.barHolder = t),
                (this.locationPath = location.href),
                (this.slides = this.barHolder.querySelectorAll(vp)),
                (this.slider = this.barHolder.querySelector(bp)),
                (this.static = this.barHolder.querySelector(wp)),
                (this.parallax = this.barHolder.querySelector(Lp)),
                (this.tickers = []),
                (this.flkty = null),
                this.init();
            }
          })(t)
        );
    },
    onBlockSelect(t) {
      Bp[this.id].length &&
        Bp[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
    },
    onBlockDeselect(t) {
      Bp[this.id].length &&
        Bp[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
        });
    },
    onUnload() {
      Bp[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  P("announcement-bar", zp), P("marquee", [zp, mp]);
  const _p = "[data-hover-disclosure]",
    $p = "[data-site-header]",
    Rp = "[data-top-link]",
    Vp = "[data-header-background]",
    Np = "[data-nav-item]",
    Wp = "is-visible",
    Up = "grandparent",
    jp = "site-header--menu-opened",
    Gp = "has-scrolled",
    Kp = "site-header--hovered",
    Qp = "site-header--compress",
    Xp = "megamenu-opened",
    Yp = "data-hover-disclosure-toggle",
    Jp = "aria-haspopup",
    Zp = "aria-expanded",
    tm = "aria-controls";
  let em = {};
  const im = {
      onLoad() {
        em[this.id] = [];
        this.container.querySelectorAll(_p).forEach((t) => {
          em[this.id].push(
            new (class {
              setBackgroundHeight() {
                (this.hasScrolled = this.body.classList.contains(Gp)),
                  (this.headerHeight = this.hasScrolled
                    ? window.stickyHeaderHeight
                    : this.header.offsetHeight),
                  this.grandparent
                    ? ((this.dropdown.style.height = "auto"),
                      (this.dropdownHeight =
                        this.dropdown.offsetHeight + this.headerHeight))
                    : (this.dropdownHeight = this.headerHeight),
                  this.background.style.setProperty(
                    "--header-background-height",
                    `${this.dropdownHeight}px`
                  ),
                  window.innerWidth < theme.sizes.small &&
                    this.hideDisclosure();
              }
              showDisclosure() {
                this.setBackgroundHeight(),
                  document.addEventListener(
                    "theme:resize",
                    this.setBackgroundHeightEvent
                  ),
                  this.trigger.setAttribute(Zp, !0),
                  this.trigger.classList.add(Wp),
                  this.header.classList.add(jp),
                  this.trigger.classList.contains(Up) &&
                    this.body.classList.add(Xp),
                  this.updateHeaderHover();
              }
              hideDisclosure() {
                this.background.style.removeProperty(
                  "--header-background-height"
                ),
                  document.removeEventListener(
                    "theme:resize",
                    this.setBackgroundHeightEvent
                  ),
                  this.trigger.classList.remove(Wp),
                  this.trigger.setAttribute(Zp, !1),
                  this.header.classList.remove(jp),
                  this.body.classList.remove(Xp);
              }
              updateHeaderHover() {
                requestAnimationFrame(() => {
                  const t = this.header.matches(":hover"),
                    e = this.header.classList.contains(Kp);
                  t && !e && this.header.classList.add(Kp);
                });
              }
              handleTablets() {
                this.trigger.addEventListener("touchstart", (t) => {
                  if (!this.trigger.classList.contains(Wp)) {
                    t.preventDefault();
                    const e = this.header.querySelectorAll(`.${Wp}${Np}`);
                    if (e.length > 0)
                      return void e.forEach((t) => {
                        if (t !== this.trigger) {
                          t.dispatchEvent(
                            new Event("mouseleave", { bubbles: !0 })
                          );
                          const e = () => {
                            requestAnimationFrame(() => {
                              this.showDisclosure();
                            }),
                              t.removeEventListener("transitionend", e);
                          };
                          t.addEventListener("transitionend", e);
                        }
                      });
                    this.showDisclosure();
                  }
                });
              }
              connectHoverToggle() {
                this.trigger.addEventListener("mouseenter", () =>
                  this.showDisclosure()
                ),
                  this.link.addEventListener("focus", () =>
                    this.showDisclosure()
                  ),
                  this.trigger.addEventListener("mouseleave", () =>
                    this.hideDisclosure()
                  ),
                  this.trigger.addEventListener("focusout", (t) => {
                    this.trigger.contains(t.relatedTarget) ||
                      this.hideDisclosure();
                  }),
                  this.disclosure.addEventListener("keyup", (t) => {
                    t.code === theme.keyboardKeys.ESCAPE &&
                      this.hideDisclosure();
                  });
              }
              onBlockSelect(t) {
                if (this.disclosure.contains(t.target)) {
                  const e = matchMedia("(pointer:coarse)").matches;
                  let i = !1;
                  ((window.innerWidth < theme.sizes.small &&
                    window.Shopify.designMode) ||
                    this.header.classList.contains(Qp)) &&
                    (i = !0),
                    e || i || this.showDisclosure(t);
                }
              }
              onBlockDeselect(t) {
                this.disclosure.contains(t.target) && this.hideDisclosure();
              }
              constructor(t) {
                (this.disclosure = t),
                  (this.body = document.body),
                  (this.header = t.closest($p)),
                  (this.key = this.disclosure.id),
                  (this.trigger = document.querySelector(
                    `[${Yp}='${this.key}']`
                  )),
                  (this.link = this.trigger.querySelector(Rp)),
                  (this.grandparent = this.trigger.classList.contains(Up)),
                  (this.background = document.querySelector(Vp)),
                  this.trigger.setAttribute(Jp, !0),
                  this.trigger.setAttribute(Zp, !1),
                  this.trigger.setAttribute(tm, this.key),
                  (this.dropdown = this.trigger.querySelector(_p)),
                  (this.setBackgroundHeightEvent = () =>
                    this.setBackgroundHeight()),
                  this.connectHoverToggle(),
                  this.handleTablets();
              }
            })(t)
          );
        });
      },
      onBlockSelect(t) {
        em[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        em[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    sm = "[data-site-header]",
    om = "[data-announcement-wrapper]",
    nm = "[data-collection-filters]",
    rm = "[data-logo-text-link]",
    am = "[data-mobile-menu-trigger]",
    lm = "[data-nav]",
    cm = "[data-nav-item]",
    hm = "[data-wrapper]",
    dm = "[data-header-background]",
    um = "[data-cart-page]",
    pm = "[data-takes-space]",
    mm = {
      jsDrawerOpenAll: [
        "js-drawer-open",
        "js-drawer-open-cart",
        "js-quick-view-visible",
        "js-quick-view-from-cart",
      ],
      headerTransparent: "site-header--transparent",
      headerHovered: "site-header--hovered",
      headerMenuOpened: "site-header--menu-opened",
      hasScrolled: "has-scrolled",
      hideHeader: "hide-header",
      headerCompress: "site-header--compress",
      isVisible: "is-visible",
      isOpen: "is-open",
      searchOpened: "search-opened",
      noOutline: "no-outline",
      cloneClass: "js__header__clone",
      drawerOpen: "js-drawer-open",
    },
    gm = "data-nav-alignment",
    fm = "data-header-sticky",
    ym = {};
  const vm = {
    onLoad() {
      ym[this.id] = new (class {
        updateHeaderHover() {
          requestAnimationFrame(() => {
            const t = this.header.matches(":hover"),
              e = this.header.classList.contains(mm.headerHovered);
            t && !e && this.header.classList.add(mm.headerHovered);
          });
        }
        handleTouchstart(t) {
          const e = this.header.contains(t.target),
            i = this.header.querySelector(`.${mm.isVisible}${cm}`);
          !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
        }
        handleTextLinkLogos() {
          if (null === this.logoTextLink) return;
          const t = this.header.offsetHeight;
          document.documentElement.style.setProperty(
            "--header-height",
            `${t}px`
          ),
            document.documentElement.style.setProperty(
              "--header-sticky-height",
              `${t}px`
            );
        }
        initStickyHeader() {
          if (
            ((this.headerSticky = this.header.hasAttribute(fm)),
            (this.hasScrolled = !1),
            (this.hasCollectionFilters = document.querySelector(nm)),
            (this.position = this.header.dataset.position),
            "fixed" === this.position && !this.hasCollectionFilters)
          )
            return (
              this.headerState(),
              void document.addEventListener(
                "theme:scroll",
                this.headerStateEvent
              )
            );
          document.body.classList.remove(mm.hasScrolled),
            window.isHeaderTransparent &&
              this.header.classList.add(mm.headerTransparent);
        }
        headerState(t) {
          const e = parseInt(
              this.header.dataset.height || this.header.offsetHeight
            ),
            i = document.querySelector(om),
            s = e + (i ? i.offsetHeight : 0),
            o = window.pageYOffset || document.documentElement.scrollTop,
            n = t && t.detail && t.detail.up;
          (this.hasScrolled = o > s),
            document.body.classList.toggle(mm.hasScrolled, this.hasScrolled);
          const r = o < s + window.stickyHeaderHeight && n;
          if (
            (document.body.classList.toggle(mm.hideHeader, r),
            window.isHeaderTransparent)
          ) {
            const t = !this.hasScrolled || r;
            this.header.classList.toggle(mm.headerTransparent, t);
          }
          if (this.header.classList.contains(mm.headerHovered)) {
            const t = this.hasScrolled ? window.stickyHeaderHeight : e;
            this.background.style.setProperty(
              "--header-background-height",
              `${t}px`
            );
            const i = this.header.querySelector(`.${mm.isVisible}${cm}`);
            i && i.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
          }
        }
        handleBackgroundEvents() {
          this.headerWrapper.addEventListener(
            "mouseenter",
            this.updateBackgroundHeightEvent
          ),
            this.headerWrapper.addEventListener(
              "mouseleave",
              this.updateBackgroundHeightEvent
            ),
            this.header.addEventListener(
              "focusout",
              this.updateBackgroundHeightEvent
            ),
            document.addEventListener(
              "theme:cart:close",
              this.updateBackgroundHeightEvent
            ),
            document.addEventListener(
              "theme:search:close",
              this.updateBackgroundHeightEvent
            );
        }
        updateBackgroundHeight(t) {
          const e = matchMedia("(pointer:fine)").matches,
            i = !document.body.classList.contains(mm.noOutline),
            s = e && !i;
          if (!t) return;
          let o = mm.jsDrawerOpenAll.some((t) =>
            document.body.classList.contains(t)
          );
          ("mouseenter" === t.type || o) &&
            ((this.headerHeight = this.hasScrolled
              ? window.stickyHeaderHeight
              : this.header.offsetHeight),
            this.header.classList.add(mm.headerHovered),
            this.header.classList.contains(mm.headerMenuOpened) ||
              this.background.style.setProperty(
                "--header-background-height",
                `${this.headerHeight}px`
              )),
            "mouseenter" !== t.type &&
              requestAnimationFrame(() => {
                if (
                  ((o = mm.jsDrawerOpenAll.some((t) =>
                    document.body.classList.contains(t)
                  )),
                  o)
                )
                  return;
                if ("focusout" === t.type && !e) return;
                if ("theme:search:close" === t.type && !s) return;
                if (this.hasScrolled) return;
                const n = null === document.activeElement.closest(sm),
                  r = document.body.classList.contains(mm.searchOpened),
                  a = this.header.classList.contains(mm.headerMenuOpened);
                r ||
                  a ||
                  (("focusout" !== t.type || n) &&
                    (this.header.classList.remove(mm.headerHovered),
                    this.background.style.setProperty(
                      "--header-background-height",
                      "0px"
                    ),
                    i || document.activeElement.blur()));
              });
        }
        listenWidth() {
          document.addEventListener("theme:resize", this.checkWidthEvent),
            this.checkWidth();
        }
        checkWidth() {
          window.innerWidth < this.minWidth
            ? this.header.classList.add(mm.headerCompress)
            : this.header.classList.remove(mm.headerCompress);
        }
        getMinWidth() {
          const t =
              this.headerWrapper.currentStyle ||
              window.getComputedStyle(this.headerWrapper),
            e = 2 * parseInt(t.paddingLeft),
            i = this.header.cloneNode(!0);
          i.classList.add(mm.cloneClass), document.body.appendChild(i);
          const s = i.querySelectorAll(pm),
            o = (function (t, e) {
              let i = [];
              t.forEach((t) => {
                i.push(t.clientWidth);
              });
              let [s, o, n] = i;
              if ("left" === e) {
                const t = s;
                (s = o), (o = t);
              }
              return "right" !== e && (s > n ? (n = s) : (s = n)), s + o + n;
            })(s, this.header.getAttribute(gm));
          return document.body.removeChild(i), o + 20 * s.length + e;
        }
        initMobileNavToggle() {
          var t;
          null === (t = this.mobileMenuTrigger) ||
            void 0 === t ||
            t.addEventListener("click", () => {
              if (!document.body.classList.contains(mm.drawerOpen)) {
                if (document.body.classList.contains(mm.searchOpened))
                  return void document.addEventListener(
                    "theme:search:close",
                    this.triggerDrawerOpeningEvent
                  );
                this.triggerDrawerOpening(this.mobileMenuTrigger);
              }
            });
        }
        triggerDrawerOpening(t) {
          document.dispatchEvent(
            new CustomEvent("theme:drawer:opening", {
              bubbles: !0,
              detail: { element: t },
            })
          ),
            document.removeEventListener(
              "theme:search:close",
              this.triggerDrawerOpeningEvent
            );
        }
        onUnload() {
          document.documentElement.style.removeProperty("--header-height"),
            document.documentElement.style.removeProperty(
              "--header-sticky-height"
            ),
            this.initStickyHeader(),
            document.body.classList.remove(...mm.jsDrawerOpenAll),
            document.removeEventListener("theme:scroll", this.headerStateEvent),
            document.removeEventListener("theme:resize", this.checkWidthEvent),
            document.removeEventListener(
              "theme:cart:close",
              this.updateBackgroundHeightEvent
            ),
            document.removeEventListener(
              "theme:search:close",
              this.updateBackgroundHeightEvent
            ),
            document.body.removeEventListener(
              "touchstart",
              this.handleTouchstartEvent
            ),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
            "function" == typeof window.cart.unload && window.cart.unload();
        }
        constructor(t) {
          (this.container = t),
            (this.background = document.querySelector(dm)),
            (this.header = t),
            (this.headerWrapper = t.querySelector(hm)),
            (this.logoTextLink = t.querySelector(rm)),
            (this.nav = t.querySelector(lm)),
            (this.mobileMenuTrigger = t.querySelector(am)),
            (this.headerStateEvent = (t) => this.headerState(t)),
            (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
            (this.updateBackgroundHeightEvent = (t) =>
              this.updateBackgroundHeight(t)),
            (this.triggerDrawerOpeningEvent = () =>
              this.triggerDrawerOpening(this.mobileMenuTrigger)),
            d(),
            (this.minWidth = this.getMinWidth()),
            (this.checkWidthEvent = () => this.checkWidth()),
            this.listenWidth(),
            this.initMobileNavToggle(),
            this.handleTextLinkLogos(),
            this.initStickyHeader(),
            this.handleBackgroundEvents(),
            document.querySelector(um) || (window.cart = new $h()),
            document.body.addEventListener(
              "touchstart",
              this.handleTouchstartEvent,
              { passive: !0 }
            ),
            this.updateHeaderHover();
        }
      })(this.container);
    },
    onUnload() {
      ym[this.id].onUnload();
    },
  };
  P("header", [vm, im]);
  const bm = "[data-collapsible-trigger]",
    wm = "is-expanded";
  P("accordions", [
    {
      onBlockSelect(t) {
        const e = t.target.querySelector(bm);
        requestAnimationFrame(() => {
          e.classList.contains(wm) || e.dispatchEvent(new Event("click"));
        });
      },
    },
    li,
  ]);
  const Sm = "[data-share-button]",
    Em = "[data-share-button-tooltip]",
    Lm = "is-visible",
    km = "is-hiding",
    Am = {};
  const Cm = {
    onLoad() {
      Am[this.id] = new (class {
        init() {
          this.button &&
            this.button.addEventListener("click", () => {
              let t = window.location.href;
              this.button.dataset.shareLink &&
                (t = this.button.dataset.shareLink),
                this.tooltip.classList.contains(Lm) ||
                  navigator.clipboard.writeText(t).then(() => {
                    this.tooltip.classList.add(Lm),
                      setTimeout(() => {
                        this.tooltip.classList.add(km),
                          this.tooltip.classList.remove(Lm),
                          this.hideTransitionTimeout &&
                            clearTimeout(this.hideTransitionTimeout),
                          (this.hideTransitionTimeout = setTimeout(() => {
                            this.tooltip.classList.remove(km);
                          }, this.transitionSpeed));
                      }, 1500);
                  });
            });
        }
        constructor(t) {
          (this.container = t),
            (this.button = this.container.querySelector(Sm)),
            (this.tooltip = this.container.querySelector(Em)),
            (this.transitionSpeed = 200),
            (this.hideTransitionTimeout = 0),
            this.init();
        }
      })(this.container);
    },
  };
  P("article", [Cm]);
  const qm = "[data-video-play]",
    Tm = "data-video-play";
  const Pm = {
      onLoad() {
        new (class {
          init() {
            this.videoPlay.length &&
              this.videoPlay.forEach((t) => {
                t.addEventListener("click", (e) => {
                  if (t.hasAttribute(Tm) && "" !== t.getAttribute(Tm).trim()) {
                    e.preventDefault();
                    const i = [{ html: t.getAttribute(Tm) }],
                      s = { mainClass: "pswp--video" };
                    (this.a11y.state.trigger = t), new Oc(i, s);
                  }
                });
              });
          }
          constructor(t) {
            (this.container = t),
              (this.videoPlay = this.container.querySelectorAll(qm)),
              (this.a11y = ci),
              this.init();
          }
        })(this.container);
      },
    },
    xm = "[data-banner-image]",
    Im = "[data-banner-title]",
    Hm = ".lazy-image",
    Fm =
      '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    Mm = ".text-reveal__cropper",
    Dm = "[data-aos]",
    Om = "banner--no-cached-images",
    Bm = "banner--img-loaded",
    zm = "img-in",
    _m = "overflow-hidden",
    $m = "text-highlight-wrapper",
    Rm = {};
  P("banner-image", [
    {
      onLoad() {
        Rm[this.id] = new (class {
          init() {
            if (
              (this.handleImageAnimation(!0),
              this.container.matches(Fm) &&
                (this.parallax = new pp(this.container)),
              this.title && !this.title.classList.contains($m))
            ) {
              const t = this.title.querySelector(Dm);
              if (!t) return;
              const e = t.closest(Mm);
              null == e || e.classList.add(_m),
                kt(t).then(() => {
                  null == e || e.classList.remove(_m);
                });
            }
          }
          handleImageAnimation(t = !1) {
            if (!t)
              return (
                this.container.classList.remove(Om),
                void this.container.classList.remove(Bm)
              );
            const e = this.container.querySelector(xm).querySelectorAll(Hm),
              i = this.container.classList.contains(zm);
            if (e.length && !i) {
              this.container.classList.add(Om);
              const t = (i) => {
                requestAnimationFrame(() => this.container.classList.add(Bm)),
                  e[0].removeEventListener("transitionend", t);
              };
              e[0].addEventListener("transitionend", t);
            }
          }
          onReorder() {
            this.handleImageAnimation(!1);
          }
          onUnload() {
            this.handleImageAnimation(!1),
              this.parallax && (this.parallax.unload(), (this.parallax = null));
          }
          constructor(t) {
            (this.container = t.container),
              (this.title = this.container.querySelector(Im)),
              (this.parallax = null),
              this.init();
          }
        })(this);
      },
      onReorder(t) {
        Rm[this.id].onReorder(t);
      },
      onUnload(t) {
        Rm[this.id].onUnload(t);
      },
    },
    Pm,
  ]);
  const Vm = "[data-scroll-spy]",
    Nm = "is-selected",
    Wm = "is-full-height",
    Um = "data-scroll-spy",
    jm = "data-scroll-spy-prevent",
    Gm = "data-scroll-spy-mobile",
    Km = "data-scroll-spy-desktop",
    Qm = {};
  const Xm = {
      onLoad() {
        Qm[this.id] = [];
        this.container.querySelectorAll(Vm).forEach((t) => {
          const e = this.container.querySelector(t.getAttribute(Um));
          Qm[this.id].push(
            new (class {
              init() {
                this.onScroll(),
                  document.addEventListener(
                    "theme:scroll",
                    this.scrollCallback
                  ),
                  document.addEventListener(
                    "theme:resize:width",
                    this.scrollCallback
                  );
              }
              isEligible() {
                return (
                  !this.container.hasAttribute(jm) &&
                  ((ke() && this.anchor.hasAttribute(Gm)) ||
                    (Le() && this.anchor.hasAttribute(Km)) ||
                    (!this.anchor.hasAttribute(Km) &&
                      !this.anchor.hasAttribute(Gm)))
                );
              }
              onScroll() {
                if (!this.isEligible()) return;
                (this.top = this.element.getBoundingClientRect().top),
                  (this.bottom = this.element.getBoundingClientRect().bottom);
                const t = Math.round(window.innerHeight),
                  e = Math.round(window.scrollY),
                  i = e + t,
                  s = Math.round(this.top + e),
                  o = this.element.offsetHeight;
                if (!(s < i) || s + o < e) return;
                this.anchor.parentNode.offsetHeight <= o
                  ? this.container.style.setProperty(
                      "--sticky-position",
                      window.innerHeight / 2 - o / 2 + "px"
                    )
                  : this.container.classList.add(Wm),
                  (this.anchorTop = this.anchor.getBoundingClientRect().top),
                  (this.anchorBottom =
                    this.anchor.getBoundingClientRect().bottom);
                const n = this.top < this.anchorTop,
                  r = this.bottom < this.anchorBottom;
                n &&
                  !r &&
                  (this.anchors.forEach((t) => {
                    t.matches(this.anchorSelector) || t.classList.remove(Nm);
                  }),
                  this.anchor.classList.add(Nm));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:scroll",
                  this.scrollCallback
                ),
                  document.removeEventListener(
                    "theme:resize:width",
                    this.scrollCallback
                  );
              }
              constructor(t, e) {
                (this.container = t),
                  (this.element = e),
                  this.element &&
                    ((this.anchorSelector = `[${Um}="#${this.element.id}"]`),
                    (this.anchor = this.container.querySelector(
                      this.anchorSelector
                    )),
                    (this.anchors = this.container.querySelectorAll(`[${Um}]`)),
                    this.anchor &&
                      ((this.scrollCallback = () => this.onScroll()),
                      this.init()));
              }
            })(this.container, e)
          );
        });
      },
      onUnload() {
        Qm[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Ym = "[data-banner]",
    Jm = "[data-slider-content]",
    Zm = "[data-slider-media]",
    tg = "a, button",
    eg = "data-index",
    ig = "tabindex",
    sg = "data-slider-single-image",
    og = "data-scroll-spy-prevent",
    ng = "is-selected",
    rg = "row",
    ag = "columns";
  let lg = {};
  P("banner-with-text-columns", [
    {
      onLoad() {
        lg[this.id] = new (class {
          listen() {
            document.addEventListener(
              "theme:resize:width",
              this.onResizeCallback
            ),
              this.links.forEach((t) => {
                t.addEventListener("focus", () => {
                  const e = Number(t.closest(Ym).getAttribute(eg));
                  window.innerWidth >= theme.sizes.small && this.sync(e);
                });
              }),
              this.banners.forEach((t) => {
                t.addEventListener("mouseenter", () => {
                  const e = Number(t.getAttribute(eg));
                  window.innerWidth >= theme.sizes.small &&
                    !window.theme.touch &&
                    this.sync(e);
                }),
                  t.addEventListener("pointerup", () => {
                    const e = Number(t.getAttribute(eg));
                    window.innerWidth >= theme.sizes.small &&
                      window.theme.touch &&
                      this.sync(e);
                  });
              });
          }
          handleColumnsLayout() {
            if (this.sliderContent.children.length <= 1) return;
            let t = window.innerWidth < window.theme.sizes.small;
            this.sliderMedia.children.length > 1 &&
              ((this.flktyMedia = new e(this.sliderMedia, {
                draggable: !1,
                wrapAround: !1,
                fade: !0,
                prevNextButtons: !1,
                adaptiveHeight: !1,
                pageDots: !1,
                setGallerySize: !1,
                on: {
                  change: (t) => {
                    this.handleGroupItemsNavigation(t, this.flktyContent);
                  },
                },
              })),
              Fi(this.sliderMedia)),
              (this.flktyContent = new e(this.sliderContent, {
                draggable: t,
                prevNextButtons: !1,
                pageDots: !0,
                cellAlign: "left",
                adaptiveHeight: !1,
                imagesLoaded: !0,
                on: {
                  ready: () => {
                    this.listen(), this.slidesTabIndex();
                  },
                  change: (t) => {
                    window.innerWidth < theme.sizes.small &&
                      !this.singleImageEnabled &&
                      this.flktyMedia.select(t),
                      this.slidesTabIndex(),
                      this.handleGroupItemsNavigation(t, this.flktyMedia);
                  },
                },
              })),
              Fi(this.sliderContent);
          }
          handleRowLayout() {
            if (this.sliderMedia.children.length <= 1 || ke())
              return this.updateState(0), void this.listen();
            this.initMediaSlider();
          }
          initMediaSlider() {
            (this.flktyMedia = new e(this.sliderMedia, {
              draggable: !0,
              wrapAround: !1,
              fade: !0,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pageDots: !1,
              setGallerySize: !1,
              on: {
                ready: () => {
                  this.updateState(0), this.listen();
                },
                change: (t) => {
                  this.updateState(t);
                },
              },
            })),
              Fi(this.sliderMedia);
          }
          handleGroupItemsNavigation(t, e = null) {
            null !== e &&
              requestAnimationFrame(() => {
                t !== e.selectedIndex && e.select(t);
              });
          }
          slidesTabIndex() {
            this.sliderContent &&
              e.data(this.sliderContent).cells.forEach((t) => {
                let e = "-1";
                t.element.classList.contains(ng) && (e = "0"),
                  t.element.querySelectorAll(tg).forEach((t) => {
                    t.setAttribute(ig, e);
                  });
              });
          }
          sync(t = 0) {
            this.appearance === ag
              ? this.flktyContent.selectCell(t)
              : this.updateState(t),
              this.flktyMedia && this.flktyMedia.selectCell(t);
          }
          updateState(t = 0) {
            this.banners.forEach((e) => {
              const i = Number(e.getAttribute(eg));
              e.classList.toggle(ng, i === t);
            });
          }
          handleSlidersOnResize() {
            if (this.appearance === rg) {
              if (ke() && this.flktyMedia)
                return this.flktyMedia.destroy(), void (this.flktyMedia = null);
              if (Le() && !this.flktyMedia) return void this.initMediaSlider();
            }
            this.flktyContent &&
              (this.flktyContent.resize(), this.toggleDraggable()),
              this.flktyMedia && this.flktyMedia.resize();
          }
          toggleDraggable() {
            (this.flktyContent.options.draggable =
              window.innerWidth < window.theme.sizes.small),
              this.flktyContent.updateDraggable();
          }
          onBlockSelect(t) {
            const e = parseInt(
              [...t.target.parentNode.children].indexOf(t.target)
            );
            if ((this.sync(e), this.appearance === rg)) {
              const t = this.sliderMedia.children[e],
                i = Math.round(t.getBoundingClientRect().top);
              this.container.setAttribute(og, ""),
                setTimeout(() => Jr(i), 400),
                setTimeout(() => this.container.removeAttribute(og), 1e3);
            }
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize:width",
              this.onResizeCallback
            );
          }
          constructor(t) {
            var e;
            (this.container = t.container),
              (this.sliderContent = this.container.querySelector(Jm)),
              (this.singleImageEnabled =
                null === (e = this.sliderContent) || void 0 === e
                  ? void 0
                  : e.hasAttribute(sg)),
              (this.banners = this.container.querySelectorAll(Ym)),
              (this.links = this.container.querySelectorAll("a")),
              (this.sliderMedia = this.container.querySelector(Zm)),
              (this.flktyContent = null),
              (this.flktyMedia = null),
              (this.onResizeCallback = () => this.handleSlidersOnResize()),
              (this.appearance = this.container.dataset.appearance),
              this.appearance === ag
                ? this.handleColumnsLayout()
                : this.handleRowLayout();
          }
        })(this);
      },
      onBlockSelect(t) {
        lg[this.id].onBlockSelect(t);
      },
    },
    Xm,
  ]),
    P("blog-posts", zo);
  const cg = "[data-slider]",
    hg = "[data-slider-item]",
    dg = "[data-media-container]",
    ug = "a, button",
    pg = ".flickity-button",
    mg = "carousel--inactive",
    gg = "carousel--resize",
    fg = "tabindex",
    yg = {};
  const vg = {
    onLoad() {
      yg[this.id] = new (class {
        initSlider() {
          this.slider.classList.remove(mg),
            (this.flkty = new e(this.slider, {
              pageDots: !1,
              cellAlign: "left",
              groupCells: !0,
              contain: !0,
              on: {
                ready: () => {
                  this.setSliderArrowsPosition(this.slider),
                    setTimeout(() => {
                      this.changeTabIndex(), this.flkty.resize();
                    }, 0);
                },
                change: () => {
                  this.changeTabIndex();
                },
              },
            })),
            (e.prototype._createResizeClass = function () {
              this.element.classList.add(gg);
            }),
            e.createMethods.push("_createResizeClass");
          const t = e.prototype.resize;
          e.prototype.resize = function () {
            this.element.classList.remove(gg),
              t.call(this),
              this.element.classList.add(gg);
          };
        }
        destroySlider() {
          this.slider.classList.add(mg),
            null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
        }
        checkSlidesSize() {
          const t =
            this.container.querySelector(hg).currentStyle ||
            window.getComputedStyle(this.container.querySelector(hg));
          this.gutter = parseInt(t.marginRight);
          const e = this.slider.offsetWidth < this.getItemsWidth();
          window.innerWidth >= theme.sizes.small && e
            ? this.initSlider()
            : this.destroySlider();
        }
        changeTabIndex() {
          const t = this.flkty.selectedIndex;
          this.flkty.slides.forEach((e, i) => {
            e.cells.forEach((e) => {
              e.element.querySelectorAll(ug).forEach((e) => {
                e.setAttribute(fg, t === i ? "0" : "-1");
              });
            });
          });
        }
        getItemsWidth() {
          let t = 0;
          const e = this.slider.querySelectorAll(hg);
          return (
            e.length &&
              e.forEach((e) => {
                t += e.offsetWidth + this.gutter;
              }),
            t
          );
        }
        listen() {
          this.slider &&
            (this.checkSlidesSize(),
            document.addEventListener(
              "theme:resize:width",
              this.checkSlidesSizeOnResize
            ));
        }
        setSliderArrowsPosition(t) {
          const e = t.querySelectorAll(pg),
            i = t.querySelector(dg);
          e.length &&
            i &&
            e.forEach((t) => {
              t.style.top = i.offsetHeight / 2 + "px";
            });
        }
        onBlockSelect(t) {
          if (null !== this.flkty) {
            const e = parseInt(
                [...t.target.parentNode.children].indexOf(t.target)
              ),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i),
              o = t.target.closest(cg),
              n = () => {
                requestAnimationFrame(() => {
                  this.flkty.select(s), this.setSliderArrowsPosition(o);
                }),
                  this.flkty.element.removeEventListener("transitionend", n);
              };
            this.flkty.element.addEventListener("transitionend", n);
          } else {
            const e =
                this.slider.currentStyle ||
                window.getComputedStyle(this.slider),
              i = parseInt(e.paddingLeft),
              s = t.target.offsetLeft - i;
            this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
          }
        }
        onUnload() {
          document.removeEventListener(
            "theme:resize:width",
            this.checkSlidesSizeOnResize
          );
        }
        constructor(t) {
          (this.container = t.container),
            (this.slider = this.container.querySelector(cg)),
            (this.flkty = null),
            (this.gutter = 0),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            this.listen();
        }
      })(this);
    },
    onUnload(t) {
      yg[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      yg[this.id].onBlockSelect(t);
    },
  };
  P("columns-with-image", [vg, Pm]);
  const bg = "[data-form-message-close]",
    wg = "[data-form-message]",
    Sg = "hide-down",
    Eg = "notification-visible";
  let Lg = {};
  P("contact-form", {
    onLoad() {
      Lg[this.id] = new (class {
        hidePopups() {
          document.body.classList.add(Eg);
        }
        showPopups() {
          document.body.classList.remove(Eg);
        }
        closeFormMessage() {
          this.closeButton.addEventListener(
            "click",
            this.closeMessage.bind(this)
          );
        }
        closeMessage(t) {
          t.preventDefault(),
            this.messageWrapper.classList.add(Sg),
            this.showPopups();
        }
        autoHideMessage() {
          setTimeout(() => {
            this.messageWrapper.classList.add(Sg), this.showPopups();
          }, 1e4);
        }
        constructor(t) {
          (this.container = t.container),
            (this.closeButton = this.container.querySelector(bg)),
            (this.messageWrapper = this.container.querySelector(wg)),
            this.messageWrapper &&
              (this.hidePopups(),
              this.closeFormMessage(),
              this.autoHideMessage());
        }
      })(this);
    },
  });
  const kg = "time",
    Ag = "[data-days]",
    Cg = "[data-hours]",
    qg = "[data-minutes]",
    Tg = "[data-seconds]",
    Pg = "[data-section-type]",
    xg = ".shopify-section",
    Ig = "[data-product-timer]",
    Hg = "[data-aos]",
    Fg = "countdown-timer--show-message",
    Mg = "aos-animate",
    Dg = "countdown",
    Og = "data-expiration-behavior",
    Bg = "data-leading-zero",
    zg = "hide",
    _g = "show-message";
  let $g = class extends HTMLElement {
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    init() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.section.classList.contains(Dg) && this.onLoad(!0),
          (this.interval = setInterval(this.update, 1e3)));
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= i * this.hoursInMs;
      const s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= s * this.minutesInMs;
      return {
        days: e,
        hours: i,
        minutes: s,
        seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
      };
    }
    formatDigits(t) {
      return t < 10 && this.leadingZero && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    onComplete() {
      this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete &&
          !window.Shopify.designMode &&
          (this.productTimer
            ? this.productTimer.remove()
            : this.shopifySection.remove(),
          document.dispatchEvent(new CustomEvent("theme:parallax:refresh"))),
        this.shouldShowMessage && this.classList.add(Fg);
    }
    triggerAnimations() {
      "false" != theme.settings.animations &&
        this.section.querySelectorAll(Hg).forEach((t) => {
          this.isAnimated && t.classList.add(Mg);
        });
    }
    removeAnimations() {
      this.section.querySelectorAll(Hg).forEach((t) => {
        requestAnimationFrame(() => {
          t.classList.contains(Mg) &&
            (t.classList.remove(Mg), (this.isAnimated = !0));
        });
      });
    }
    onLoad(t) {
      t
        ? this.removeAnimations()
        : ((this.isLoading = !1), this.triggerAnimations());
    }
    update() {
      const t = Date.now(),
        e = this.endDate - t;
      if (e <= 0) return this.stopTimer(), void this.onComplete();
      const i = this.convertTime(e);
      this.render(i), this.isLoading && this.onLoad(!1);
    }
    constructor() {
      super(),
        (this.section = this.closest(Pg)),
        (this.shopifySection = this.closest(xg)),
        (this.productTimer = this.closest(Ig)),
        (this.expirationBehavior = this.getAttribute(Og)),
        (this.leadingZero = this.hasAttribute(Bg)),
        (this.time = this.querySelector(kg)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.days = this.querySelector(Ag)),
        (this.hours = this.querySelector(Cg)),
        (this.minutes = this.querySelector(qg)),
        (this.seconds = this.querySelector(Tg)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.isLoading = !0),
        (this.shouldHideOnComplete = this.expirationBehavior === zg),
        (this.shouldShowMessage = this.expirationBehavior === _g),
        (this.isAnimated = !1),
        (this.update = this.update.bind(this));
    }
  };
  P("countdown", [Pm, mp]),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", $g);
  const Rg = "[data-video-id]",
    Vg = "[data-video-player]",
    Ng = "[data-video-template]",
    Wg = "[data-video-autoplay]",
    Ug = "[data-video-wrapper]",
    jg = "[data-video-bg-play]",
    Gg = "is-loading",
    Kg = "is-paused",
    Qg = {};
  const Xg = {
    onLoad() {
      Qg[this.id] = [];
      this.container.querySelectorAll(Ug).forEach((t) => {
        Qg[this.id].push(
          new (class {
            init() {
              this.videoId &&
                (new IntersectionObserver(
                  (t, e) => {
                    t.forEach((t) => {
                      if (t.isIntersecting) {
                        const i = this.videoTemplate.innerHTML;
                        (this.videoPlayer.innerHTML = i),
                          (this.video = this.container.querySelector(Wg)),
                          this.videoPlayer.classList.remove(Gg),
                          this.container.classList.add(Kg),
                          this.listen(),
                          e.unobserve(t.target);
                      }
                    });
                  },
                  {
                    root: null,
                    rootMargin: "300px",
                    threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
                  }
                ).observe(this.videoPlayer),
                this.videoPlayButton.addEventListener("click", (t) => {
                  var e;
                  t.preventDefault(),
                    null === (e = this.video) || void 0 === e || e.play();
                }));
            }
            listen() {
              this.video.addEventListener("play", () => {
                this.container.classList.remove(Kg);
              }),
                this.container.addEventListener(
                  "touchstart",
                  () => {
                    this.video.play();
                  },
                  { passive: !0 }
                );
            }
            constructor(t) {
              (this.container = t),
                (this.videoId = this.container.querySelector(Rg)),
                (this.videoPlayer = this.container.querySelector(Vg)),
                (this.videoTemplate = this.container.querySelector(Ng)),
                (this.videoPlayButton = this.container.querySelector(jg)),
                this.init();
            }
          })(t)
        );
      });
    },
  };
  let Yg = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    constructor(t, e) {
      (this.configuration = {
        expires: null,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: !0,
      }),
        (this.name = t),
        (this.value = e);
    }
  };
  const Jg = "[data-newsletter-form]",
    Zg = "[data-popup]",
    tf = "section",
    ef = "footer",
    sf = ".shopify-section",
    of = "has-success",
    nf = "has-error",
    rf = "section-footer--parallax",
    af = "newsletter_form_id",
    lf = {};
  const cf = {
      onLoad() {
        lf[this.id] = [];
        this.container.querySelectorAll(Jg).forEach((t) => {
          lf[this.id].push(
            new (class {
              init() {
                this.newsletter.addEventListener(
                  "submit",
                  this.newsletterSubmit
                ),
                  this.showMessage();
              }
              newsletterSubmitEvent(t) {
                this.stopSubmit &&
                  (t.preventDefault(),
                  this.removeStorage(),
                  this.writeStorage(),
                  (this.stopSubmit = !1),
                  this.newsletter.submit());
              }
              checkForChallengePage() {
                this.isChallengePage =
                  window.location.pathname === theme.routes.root + "challenge";
              }
              writeStorage() {
                void 0 !== this.sessionStorage &&
                  this.sessionStorage.setItem(af, this.newsletter.id);
              }
              readStorage() {
                this.formID = this.sessionStorage.getItem(af);
              }
              removeStorage() {
                this.sessionStorage.removeItem(af);
              }
              showMessage() {
                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                  const t = document.getElementById(this.formID),
                    e =
                      -1 !==
                      window.location.search.indexOf("?customer_posted=true"),
                    i =
                      -1 !==
                      window.location.search.indexOf("accepts_marketing");
                  e
                    ? (t.classList.remove(nf),
                      t.classList.add(of),
                      this.popup &&
                        ((this.cookie = new Yg(
                          this.popup.dataset.cookieName,
                          "user_has_closed"
                        )),
                        this.cookie.write()))
                    : i && (t.classList.remove(of), t.classList.add(nf)),
                    (e || i) && this.scrollToForm(t);
                }
              }
              scrollToForm(t) {
                let { stickyHeaderHeight: e } = R();
                const i = e || 0,
                  s = t.closest(tf),
                  o = t.closest(ef);
                visibilityHelper.isElementPartiallyVisible(t) ||
                  visibilityHelper.isElementTotallyVisible(t) ||
                  setTimeout(() => {
                    let e = window.scrollY,
                      n = t.getBoundingClientRect().top;
                    s
                      ? (n = s.getBoundingClientRect().top)
                      : o &&
                        o.closest(sf).classList.contains(rf) &&
                        ((n = document.body.scrollHeight), (e = 0));
                    const r = n - i + e;
                    window.scrollTo({ top: r, left: 0, behavior: "smooth" });
                  }, 400);
              }
              onUnload() {
                this.newsletter.removeEventListener(
                  "submit",
                  this.newsletterSubmit
                );
              }
              constructor(t) {
                (this.newsletter = t),
                  (this.sessionStorage = window.sessionStorage),
                  (this.popup = this.newsletter.closest(Zg)),
                  (this.stopSubmit = !0),
                  (this.isChallengePage = !1),
                  (this.formID = null),
                  (this.formIdSuccess = null),
                  this.checkForChallengePage(),
                  (this.newsletterSubmit = (t) =>
                    this.newsletterSubmitEvent(t)),
                  this.isChallengePage || this.init();
              }
            })(t)
          );
        });
      },
      onUnload() {
        lf[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    hf = "[data-product]",
    df = "[data-slider]",
    uf = "[data-slide]",
    pf = "[data-product-media-container]",
    mf = ".flickity-button",
    gf = "a, button",
    ff = "tabindex",
    yf = {};
  const vf = {
    onLoad() {
      yf[this.id] = new (class {
        checkSlider() {
          window.innerWidth >= theme.sizes.small
            ? this.productSlider.forEach((t) => {
                this.initProductSlider(t);
              })
            : this.productSlider.forEach((t) => {
                this.destroyProductSlider(t);
              });
        }
        initProductSlider(t) {
          const i = t.querySelectorAll(uf).length,
            s = t.dataset.slider;
          i > 1 &&
            (void 0 !== this.flkty[s] && this.flkty[s].isActive
              ? this.setSliderArrowsPosition(t)
              : (this.flkty[s] = new e(t, {
                  prevNextButtons: !0,
                  adaptiveHeight: !0,
                  pageDots: !0,
                  wrapAround: !0,
                  on: {
                    ready: () => {
                      this.setSliderArrowsPosition(t);
                    },
                    change: (t) => {
                      this.flkty[s].cells.forEach((e, i) => {
                        e.element.querySelectorAll(gf).forEach((e) => {
                          e.setAttribute(ff, i === t ? "0" : "-1");
                        });
                      });
                    },
                  },
                })));
        }
        destroyProductSlider(t) {
          const e = t.dataset.slider;
          "object" == typeof this.flkty[e] && this.flkty[e].destroy();
        }
        setSliderArrowsPosition(t) {
          const e = t.querySelectorAll(mf),
            i = t.querySelector(pf);
          e.length &&
            i &&
            e.forEach((t) => {
              t.style.top = i.offsetHeight / 2 + "px";
            });
        }
        resizeSlider(t) {
          const i = t.target,
            s = e.data(i) || null;
          s && s.resize();
        }
        listen() {
          this.checkSlider(),
            document.addEventListener(
              "theme:resize:width",
              this.checkSliderOnResize
            ),
            this.productSlider.forEach((t) => {
              t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
            });
        }
        onUnload() {
          if (this.flkty)
            for (const t in this.flkty)
              this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
          document.removeEventListener(
            "theme:resize:width",
            this.checkSliderOnResize
          ),
            this.productSlider.forEach((t) => {
              t.removeEventListener(
                "theme:slider:resize",
                this.resizeSliderEvent
              );
            });
        }
        constructor(t) {
          (this.container = t),
            (this.product = this.container.querySelectorAll(hf)),
            (this.productSlider = this.container.querySelectorAll(df)),
            (this.checkSliderOnResize = () => this.checkSlider()),
            (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
            (this.flkty = []),
            (this.videoObj = []),
            (this.quickViewObj = []),
            this.listen();
        }
      })(this.container);
    },
    onUnload(t) {
      yf[this.id].onUnload(t);
    },
  };
  P("custom-content", [vf, cf, Pm, ps, Xg, wo]);
  const bf = "[data-slider]",
    wf = "[data-slide]",
    Sf = "[data-product-media-container]",
    Ef = "a, button",
    Lf = ".flickity-button",
    kf = "[data-promo]",
    Af = "[data-product-block]",
    Cf = "carousel",
    qf = "carousel--inactive",
    Tf = "is-last-slide-visible",
    Pf = "featured-collection",
    xf = "collection-promo--full",
    If = "collection-promo--two-columns",
    Hf = "data-slider-id",
    Ff = "data-slider-show-image",
    Mf = "tabindex",
    Df = {};
  let Of = class {
    initSlider(t) {
      const i = t.getAttribute(Hf);
      t.classList.remove(qf),
        void 0 !== this.flkty[i] && this.flkty[i].isActive
          ? this.setSliderArrowsPosition(t)
          : ((this.flkty[i] = new e(t, {
              pageDots: !1,
              cellSelector: wf,
              cellAlign: "left",
              groupCells: !0,
              contain: !0,
              wrapAround: !1,
              adaptiveHeight: !1,
              on: {
                ready: () => {
                  this.setSliderArrowsPosition(t),
                    setTimeout(() => {
                      this.changeTabIndex(t);
                    }, 0);
                },
                change: () => {
                  this.changeTabIndex(t);
                },
              },
            })),
            this.handleLastSlideOverlayOnTablet(t));
    }
    destroySlider(t) {
      const e = t.getAttribute(Hf);
      t.classList.contains(Cf) && t.classList.add(qf),
        "object" == typeof this.flkty[e] && this.flkty[e].destroy();
    }
    resetSlider(t) {
      const e = t.target,
        i = e.getAttribute(Hf);
      "object" == typeof this.flkty[i]
        ? this.flkty[i].select(0, !1, !0)
        : e.scrollTo({ left: 0, behavior: "instant" });
    }
    resizeSlider(t) {
      const i = t.target,
        s = e.data(i) || null;
      s && s.resize();
    }
    checkSlidesSize() {
      this.sliders.length &&
        this.sliders.forEach((t) => {
          const e = this.columns,
            i = window.innerWidth >= theme.sizes.large,
            s =
              window.innerWidth >= theme.sizes.large &&
              window.innerWidth < theme.sizes.widescreen,
            o =
              window.innerWidth >= theme.sizes.small &&
              window.innerWidth < theme.sizes.large;
          let n = t.querySelectorAll(wf).length;
          const r = t.querySelectorAll(kf);
          r.length &&
            i &&
            r.forEach((t) => {
              t.classList.contains(xf)
                ? (n += e - 1)
                : t.classList.contains(If) && (n += 1);
            }),
            t.hasAttribute(Ff) && (n += 1),
            (i && n > e) || (s && n > 3) || (o && n > 2)
              ? (this.initSlider(t), this.getTallestProductGridItem(t))
              : this.destroySlider(t);
        });
    }
    changeTabIndex(t) {
      const e = t.getAttribute(Hf),
        i = this.flkty[e].selectedIndex;
      this.flkty[e].slides.forEach((t, e) => {
        t.cells.forEach((t) => {
          t.element.querySelectorAll(Ef).forEach((t) => {
            t.setAttribute(Mf, i === e ? "0" : "-1");
          });
        });
      });
    }
    setSliderArrowsPosition(t) {
      const e = t.querySelectorAll(Lf),
        i = t.querySelector(Sf);
      e.length &&
        i &&
        e.forEach((t) => {
          t.style.top = i.offsetHeight / 2 + "px";
        });
    }
    handleLastSlideOverlayOnTablet(t) {
      const e = t.getAttribute(Hf);
      this.flkty[e].on("select", () => {
        if (
          !(
            window.innerWidth >= theme.sizes.small &&
            window.innerWidth < theme.sizes.large
          )
        )
          return;
        const i = this.flkty[e].selectedIndex,
          s = this.flkty[e].slides.length - 1 === i;
        t.parentNode.classList.toggle(Tf, s);
      });
    }
    getTallestProductGridItem(t) {
      if (t.querySelectorAll(kf).length) {
        const e = t.querySelectorAll(Af),
          i = Math.max(...Array.from(e).map((t) => t.offsetHeight));
        t.style.setProperty("--carousel-promo-height", `${i}px`);
      }
    }
    handleLastSlideOverlayOnMobile() {
      this.sliders.forEach((t) => {
        t.addEventListener("scroll", (e) => {
          if (!(window.innerWidth < theme.sizes.small)) return;
          const i = e.target.offsetWidth,
            s =
              Array.from(t.children).pop().getBoundingClientRect().left + 80 <
              i;
          t.parentNode.classList.toggle(Tf, s);
        });
      });
    }
    listen() {
      this.sliders.length &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ),
        this.sliders.forEach((t) => {
          t.addEventListener("theme:tab:change", this.resetSliderEvent),
            t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
        }));
    }
    onBlockSelect(t) {
      const i = t.target.closest(bf),
        s = e.data(i) || null;
      if (!i) return;
      let o = t.target.parentNode,
        n = t.target;
      if (
        (this.container.classList.contains(Pf) &&
          ((o = o.parentNode), (n = n.parentNode)),
        null !== s && s.isActive)
      ) {
        const t = parseInt([...o.children].indexOf(n)),
          e = parseInt(s.slides[0].cells.length),
          r = Math.floor(t / e),
          a = () => {
            requestAnimationFrame(() => {
              s.select(r), this.setSliderArrowsPosition(i);
            }),
              s.element.removeEventListener("transitionend", a);
          };
        s.element.addEventListener("transitionend", a);
      } else {
        const t = i.currentStyle || window.getComputedStyle(i),
          e = parseInt(t.paddingLeft),
          s = n.offsetLeft - e;
        i.scrollTo({ top: 0, left: s, behavior: "smooth" });
      }
    }
    onUnload() {
      if (this.flkty)
        for (const t in this.flkty)
          this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      ),
        this.sliders.length &&
          this.sliders.forEach((t) => {
            t.removeEventListener("theme:tab:change", this.resetSliderEvent),
              t.removeEventListener(
                "theme:slider:resize",
                this.resizeSliderEvent
              );
          });
    }
    constructor(t) {
      (this.container = t),
        (this.columns = parseInt(this.container.dataset.columns)),
        (this.sliders = this.container.querySelectorAll(bf)),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.resetSliderEvent = (t) => this.resetSlider(t)),
        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
        (this.flkty = []),
        this.listen(),
        this.handleLastSlideOverlayOnMobile();
    }
  };
  const Bf = {
    onLoad() {
      Df[this.id] = [];
      this.container.querySelectorAll(bf).forEach((t) => {
        Df[this.id].push(new Of(this.container));
      });
    },
    onUnload() {
      Df[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      Df[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  P("featured-collection", [wo, ps, Bf]), P("featured-video", [Pm, Xg]);
  const zf = "[data-shop-pay-wrapper]",
    _f = "shop-login-button",
    $f = "shop-follow-button",
    Rf = "follow-on-shop-button",
    Vf = "heart-icon",
    Nf = "shop-logo",
    Wf = {};
  const Uf = {
      onLoad() {
        Wf[this.id] = new (class {
          init() {
            if (!this.shopLoginButton || !this.shopPayWrapper) return;
            const t = this.shopPayWrapper.dataset.bg || "transparent",
              e = this.shopPayWrapper.dataset.text || "#fff",
              i = this.shopPayWrapper.dataset.hover || "#fff";
            (this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
              (this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
              customElements.whenDefined(_f).then((t) => {
                requestAnimationFrame(() => {
                  const t = this.shopLoginButton.shadowRoot,
                    e = null == t ? void 0 : t.querySelector($f),
                    i = null == e ? void 0 : e.shadowRoot,
                    s = null == i ? void 0 : i.querySelector(Rf),
                    o = null == s ? void 0 : s.shadowRoot;
                  o &&
                    this.overwriteStyles(
                      o.host.shadowRoot,
                      this.mainButtonStyles
                    );
                  const n = o.querySelector(Vf),
                    r = null == n ? void 0 : n.shadowRoot,
                    a = o.querySelector(Nf),
                    l = null == a ? void 0 : a.shadowRoot;
                  r &&
                    this.overwriteStyles(
                      r.host.shadowRoot,
                      this.svgIconsStyles
                    ),
                    l &&
                      this.overwriteStyles(
                        l.host.shadowRoot,
                        this.svgIconsStyles
                      );
                });
              });
          }
          overwriteStyles(t, e) {
            let i = document.createElement("style");
            (i.innerHTML = e), t.appendChild(i);
          }
          constructor(t) {
            (this.container = t),
              (this.shopPayWrapper = document.querySelector(zf)),
              (this.shopLoginButton = document.querySelector(_f)),
              this.init();
          }
        })(this.container);
      },
    },
    jf = ":scope > [data-wave]",
    Gf = "[data-main]",
    Kf = "[data-collapsible-trigger-mobile]",
    Qf = '[data-parallax="footer"]',
    Xf = "is-expanded",
    Yf = "wavy",
    Jf = "parallax-shadow",
    Zf = "parallax-rounded-corners",
    ty = "main-content--parallax",
    ey = "section-footer--parallax",
    iy = "section-footer--visible",
    sy = "main-content",
    oy = "shopify-section",
    ny = "body--rounded-corners-large",
    ry = "--bg",
    ay = "--footer-bg",
    ly = "data-parallax",
    cy = "data-parallax-wavy",
    hy = "data-parallax-rounded-corners",
    dy = "data-parallax-rounded-corners-large",
    uy = "data-parallax-disable-on-safari",
    py = {};
  P("footer", [
    cf,
    li,
    {
      onLoad() {
        py[this.id] = new (class {
          init() {
            const t =
                /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
                this.container.hasAttribute(uy),
              e =
                this.isViewportSmaller() ||
                window.innerWidth < theme.sizes.small ||
                t,
              i = document.body;
            i.classList.remove(ny);
            const s = getComputedStyle(this.container).getPropertyValue(ry);
            this.parentContainer.style.setProperty(
              "--footer-parallax-height",
              "auto"
            );
            let o = this.parentContainer.previousElementSibling;
            if (o) {
              if (
                (o.classList.contains(oy) ||
                  o.classList.contains(sy) ||
                  (o = this.main),
                this.wavyEnabled && !e)
              ) {
                [...o.querySelectorAll(jf)].map((t) => t.remove());
                const t = this.container.querySelector(jf);
                o.append(t.cloneNode(!0)),
                  o.classList.add(Yf),
                  this.container.classList.remove(Yf);
              } else
                this.container.hasAttribute(hy) && !this.wavyEnabled
                  ? (o.classList.toggle(Zf, !e),
                    o.classList.toggle(Jf, !e),
                    this.container.hasAttribute(dy) &&
                      i.classList.toggle(ny, !e))
                  : e || o.classList.add(Jf);
              o.style.setProperty(ay, s);
            }
            e ||
              (this.main.classList.add(ty),
              this.parentContainer.classList.add(ey),
              this.parentContainer.style.setProperty(
                "--footer-parallax-height",
                `${this.container.clientHeight}px`
              ),
              (this.footerParallax = new pp(this.container)));
          }
          resize() {
            this.parentContainer.style.setProperty(
              "--footer-parallax-height",
              "auto"
            ),
              (this.isViewportSmaller() ||
                window.innerWidth < theme.sizes.small ||
                !this.footerParallax) &&
                this.onUnload(!0),
              this.parentContainer.style.setProperty(
                "--footer-parallax-height",
                `${this.container.clientHeight}px`
              );
          }
          isViewportSmaller() {
            const t = Math.round(
                Math.max(
                  document.documentElement.clientHeight,
                  window.innerHeight || 0
                )
              ),
              e = this.container.clientHeight;
            let i = 0;
            return this.wavyEnabled && (i = 50), t < e + i;
          }
          onBlockSelect(t) {
            const e = t.target.querySelector(Kf);
            requestAnimationFrame(() => {
              e &&
                !e.classList.contains(Xf) &&
                e.dispatchEvent(new Event("click"));
            });
          }
          onBlockDeselect(t) {
            const e = t.target.querySelector(Kf);
            requestAnimationFrame(() => {
              e &&
                e.classList.contains(Xf) &&
                e.dispatchEvent(new Event("click"));
            });
          }
          onUnload(t = !1) {
            document.removeEventListener("theme:resize", this.resizeEvent),
              document.removeEventListener(
                "theme:footer:unload",
                this.unloadEvent
              ),
              this.footerParallax &&
                (this.footerParallax.unload(), t && L(this.parentContainer)),
              (this.footerParallax || t) &&
                setTimeout(() => {
                  const t = Shopify.theme.sections.instances,
                    e = document.querySelectorAll(Qf),
                    i = t.filter((t) => t.container === e[0]);
                  this.main.classList.remove(ty),
                    this.parentContainer.classList.remove(ey),
                    this.parentContainer.classList.remove(iy),
                    i[0] && i[0].onLoad();
                });
          }
          constructor(t) {
            (this.container = t.container),
              (this.main = document.querySelector(Gf)),
              (this.footerParallax = null),
              (this.wavyEnabled = this.container.hasAttribute(cy)),
              (this.parentContainer = this.container.parentNode),
              (this.resizeEvent = () => this.resize()),
              (this.unloadEvent = () => this.onUnload()),
              requestIdleCallback(() => {
                this.container.hasAttribute(ly) &&
                  !this.main.classList.contains(ty) &&
                  (this.init(),
                  document.addEventListener("theme:resize", this.resizeEvent),
                  document.addEventListener(
                    "theme:footer:unload",
                    this.unloadEvent
                  ));
              });
          }
        })(this);
      },
      onBlockSelect(t) {
        py[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        py[this.id].onBlockDeselect(t);
      },
      onReorder() {
        py[this.id].onUnload();
      },
      onUnload() {
        py[this.id].onUnload();
      },
    },
    Uf,
  ]);
  const my = "[data-slider]";
  let gy = {};
  P("icons-row", {
    onLoad() {
      gy[this.id] = new (class {
        onBlockSelect(t) {
          const e =
              this.slider.currentStyle || window.getComputedStyle(this.slider),
            i = parseInt(e.paddingLeft),
            s = t.target.offsetLeft - i;
          this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
        }
        constructor(t) {
          (this.container = t.container),
            (this.slider = this.container.querySelector(my));
        }
      })(this);
    },
    onBlockSelect(t) {
      gy[this.id].onBlockSelect(t);
    },
  });
  const fy = "[data-accordion-item]",
    yy = "[data-accordion-button]",
    vy = "is-active",
    by = "to-animate",
    wy = "is-animating",
    Sy = {};
  P("image-accordions", {
    onLoad() {
      Sy[this.id] = new (class {
        init() {
          this.triggerLoadingAnimation(),
            this.imageAccordionsItems.forEach((t) => {
              t.addEventListener(
                "mouseenter",
                this.accordionExpandEvent.bind(this, t)
              );
            }),
            this.buttons.forEach((t) => {
              t.addEventListener(
                "focusin",
                this.accordionFocusEvent.bind(this, t)
              );
            });
        }
        triggerLoadingAnimation() {
          if ("false" == theme.settings.animationsEnabled || ke()) return;
          const t = (e) => {
              "expandAccordion" === e.animationName &&
                (this.accordionExpand(this.imageAccordionsItems[0]),
                this.container.classList.remove(by),
                this.container.classList.remove(wy),
                this.container.removeEventListener("animationend", t));
            },
            e = (t) => {
              requestAnimationFrame(() => {
                t.target === this.container &&
                  (this.container.classList.add(wy),
                  this.container.removeEventListener("transitionend", e));
              });
            };
          this.container.addEventListener("transitionend", e, {
            signal: this.controller.signal,
          }),
            this.container.addEventListener("animationend", t, {
              signal: this.controller.signal,
            });
        }
        accordionExpand(t) {
          t.classList.contains(vy) ||
            (this.imageAccordionsItems.forEach((t) => {
              t.classList.remove(vy);
            }),
            t.classList.add(vy));
        }
        accordionFocus(t) {
          t.closest(fy).dispatchEvent(new Event("mouseenter"));
        }
        onBlockSelect(t) {
          const e = t.target;
          e &&
            (this.controller.abort(),
            this.container.classList.remove(by, wy),
            this.accordionExpand(e),
            ke() &&
              e.parentNode.scrollTo({
                top: 0,
                left: e.offsetLeft,
                behavior: "smooth",
              }));
        }
        constructor(t) {
          (this.container = t.container),
            (this.controller = new AbortController()),
            (this.imageAccordionsItems = this.container.querySelectorAll(fy)),
            (this.buttons = this.container.querySelectorAll(yy)),
            (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
            (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
            this.init();
        }
      })(this);
    },
    onBlockSelect(t) {
      Sy[this.id].onBlockSelect(t);
    },
  });
  const Ey = "[data-collapsible-trigger]",
    Ly = "is-expanded",
    ky = {};
  P("image-with-text", [
    Pm,
    {
      onLoad() {
        ky[this.id] = new (class {
          onBlockSelect(t) {
            const e = t.target.querySelector(Ey);
            requestAnimationFrame(() => {
              e &&
                !e.classList.contains(Ly) &&
                e.dispatchEvent(new Event("click"));
            });
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        ky[this.id].onBlockSelect(t);
      },
    },
    li,
  ]),
    P("list-collections", Bf);
  const Ay = {},
    Cy = "[data-slider-gallery]",
    qy = "[data-slider-info]",
    Ty = "[data-slide-item]";
  P("locations", {
    onLoad() {
      Ay[this.id] = new (class {
        initSlider() {
          const t = this.container.querySelectorAll(Ty).length;
          (this.flkty = e.data(this.slider)),
            (this.flktyNav = e.data(this.sliderNav)),
            t <= 1 ||
              ((this.flkty = new e(this.slider, {
                fade: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                prevNextButtons: !1,
                pageDots: !1,
              })),
              Fi(this.slider),
              (this.flktyNav = new e(this.sliderNav, {
                fade: !0,
                wrapAround: !0,
                imagesLoaded: !0,
                asNavFor: this.slider,
                prevNextButtons: !0,
                pageDots: !1,
              })),
              this.enableAdaptiveHeight(),
              document.addEventListener("theme:resize", this.resizeEvent),
              this.flktyNav.on("change", () => {
                if (
                  (this.flkty.selectCell(this.flktyNav.selectedIndex), ke())
                ) {
                  let { stickyHeaderHeight: t } = R();
                  const e = t || 0,
                    i = Math.round(window.scrollY),
                    s = Math.round(
                      this.container.getBoundingClientRect().top + i - e
                    );
                  window.scrollTo({ top: s, left: 0, behavior: "smooth" });
                }
              }),
              this.flkty.on("change", () => {
                this.flktyNav.selectCell(this.flkty.selectedIndex);
              }));
        }
        enableAdaptiveHeight() {
          (this.flktyNav.options.adaptiveHeight = !1),
            ke() && (this.flktyNav.options.adaptiveHeight = !0),
            this.flktyNav.resize();
        }
        onBlockSelect(t) {
          const e = parseInt(
            [...t.target.parentNode.children].indexOf(t.target)
          );
          null !== this.flkty && this.flkty.select(e),
            null !== this.flktyNav && this.flktyNav.select(e);
        }
        onUnload() {
          document.removeEventListener("theme:resize", this.resizeEvent);
        }
        constructor(t) {
          (this.container = t.container),
            (this.slider = this.container.querySelector(Cy)),
            (this.sliderNav = this.container.querySelector(qy)),
            (this.flkty = null),
            (this.flktyNav = null),
            (this.resizeEvent = () => this.enableAdaptiveHeight()),
            this.initSlider();
        }
      })(this);
    },
    onBlockSelect(t) {
      Ay[this.id].onBlockSelect(t);
    },
    onUnload() {
      Ay[this.id].onUnload();
    },
  });
  const Py = {},
    xy = "[data-slider]",
    Iy = "[data-slide-item]",
    Hy = "[data-stl-hotspots-item]",
    Fy = "[data-pointer]",
    My = "[data-pointer-bubble]",
    Dy = "[data-product-media-container]",
    Oy = "[data-quick-view-item-holder]",
    By = ".flickity-button",
    zy = "a, button",
    _y = "[data-tooltip]",
    $y = "data-products",
    Ry = "data-pointer",
    Vy = "data-hotspot",
    Ny = "tabindex",
    Wy = "product-grid-item__image--hovered",
    Uy = "is-selected",
    jy = "is-active",
    Gy = "on-hover",
    Ky = "pswp--open";
  const Qy = {
    onLoad() {
      Py[this.id] = new (class {
        listen() {
          this.slider &&
            (this.checkSlidesSize(),
            document.addEventListener(
              "theme:resize:width",
              this.checkSlidesSizeOnResize
            ),
            this.slider.addEventListener(
              "theme:slider:resize",
              this.resizeSliderEvent
            )),
            this.pointers.forEach((t) => {
              t.addEventListener("click", this.pointersInit),
                t.addEventListener("mouseover", this.pointersOver),
                t.addEventListener("mouseleave", this.pointersOut);
            }),
            this.pointerBubbles.forEach((t, e) => {
              t.addEventListener("click", (t) =>
                [...this.pointers][e].dispatchEvent(new Event(t.type))
              ),
                t.addEventListener("mouseover", (t) =>
                  [...this.pointers][e].dispatchEvent(new Event(t.type))
                ),
                t.addEventListener("mouseleave", (t) =>
                  [...this.pointers][e].dispatchEvent(new Event(t.type))
                );
            });
        }
        checkSlidesSize() {
          const t = window.innerWidth < theme.sizes.small,
            e = window.innerWidth >= theme.sizes.large,
            i =
              window.innerWidth >= theme.sizes.small &&
              window.innerWidth < theme.sizes.large,
            s = Boolean(e && this.slides.length > this.productOnRow),
            o = Boolean(i && this.slides.length > 2);
          this.initTooltips(),
            t
              ? this.destroySlider()
              : s || o
              ? this.initSlider()
              : (this.destroySlider(), this.slidesTabIndex());
        }
        initTooltips() {
          (this.tooltips = this.container.querySelectorAll(_y)),
            this.tooltips.forEach((t) => {
              new us(t);
            });
        }
        initSlider() {
          null !== this.flkty
            ? this.setSliderArrowsPosition()
            : (this.flkty = new e(this.slider, {
                prevNextButtons: !0,
                wrapAround: !0,
                adaptiveHeight: !1,
                cellAlign: "left",
                groupCells: !1,
                contain: !0,
                on: {
                  ready: () => {
                    this.slidesTabIndex(),
                      this.setSliderArrowsPosition(),
                      this.dotPointers();
                  },
                  change: () => {
                    this.slidesTabIndex(), this.dotPointers();
                  },
                },
              }));
        }
        setSliderArrowsPosition() {
          if (!(window.innerWidth >= theme.sizes.small)) return;
          const t = this.slider.querySelectorAll(By),
            e = this.slider.querySelector(Dy);
          t.length &&
            e &&
            t.forEach((t) => {
              t.style.top = e.offsetHeight / 2 + "px";
            });
        }
        slidesTabIndex() {
          this.slides.length < this.productOnRow + 1
            ? this.slider.querySelectorAll(zy).forEach((t) => {
                t.setAttribute(Ny, "0");
              })
            : e.data(this.slider).cells.forEach((t) => {
                let e = "-1";
                t.element.classList.contains(Uy) && (e = "0"),
                  t.element.querySelectorAll(zy).forEach((t) => {
                    t.setAttribute(Ny, e);
                  });
              });
        }
        destroySlider() {
          "object" == typeof this.flkty &&
            null !== this.flkty &&
            (this.flkty.destroy(), (this.flkty = null));
        }
        resizeSlider(t) {
          const i = t.target,
            s = e.data(i) || null;
          s && s.resize();
        }
        dotPointers(t) {
          if (0 === this.pointers.length) return;
          if (
            (this.sTLHotspotsItems.forEach((t) => t.classList.remove(Gy)), t)
          ) {
            var e;
            const i = t.target.getAttribute(Ry);
            return void (
              null === (e = this.flkty) ||
              void 0 === e ||
              e.select(i)
            );
          }
          const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
          i >= 0 && this.sTLHotspotsItems[i].classList.add(Gy);
        }
        dotPointerIn(t) {
          const e = t.target.getAttribute(Ry),
            i = this.slides[e].querySelector(Dy),
            s = matchMedia("(pointer:coarse)").matches;
          window.innerWidth < theme.sizes.small || s || this.observeImage(i),
            this.pointers[e].style.setProperty("--target-animation", "none");
        }
        dotPointerOut(t) {
          const e = t.target.getAttribute(Ry),
            i = this.slides[e].querySelector(Dy);
          i.classList.remove(Wy),
            i.dispatchEvent(new Event("mouseleave")),
            this.observer && this.observer.disconnect(),
            this.pointers.forEach((t) => {
              t.style.removeProperty("--target-animation");
            });
        }
        observeImage(t) {
          (this.observer = new IntersectionObserver(
            (t, e) => {
              t.forEach((t) => {
                const e = t.target;
                0 == t.intersectionRatio ||
                  (e.dispatchEvent(new Event("mouseenter")),
                  e.classList.add(Wy));
              });
            },
            { root: this.slider, threshold: [0.95, 1] }
          )),
            this.observer.observe(t);
        }
        triggerClick(t) {
          requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
        }
        destroyQuickViewPopup() {
          var t, e;
          const i =
            null === (t = this.quickViewPopup) ||
            void 0 === t ||
            null === (e = t.loadPhotoswipe) ||
            void 0 === e
              ? void 0
              : e.pswpElement;
          i &&
            i.classList.contains(Ky) &&
            this.quickViewPopup.loadPhotoswipe.popup.close();
        }
        onBlockSelect(t) {
          this.debouncedBlockSelectCallback(t);
        }
        debouncedBlockSelect(t) {
          var e, i;
          const s =
            null === (e = this.quickViewPopup) ||
            void 0 === e ||
            null === (i = e.loadPhotoswipe) ||
            void 0 === i
              ? void 0
              : i.pswpElement;
          s
            ? setTimeout(() => {
                if (s.classList.contains(Ky)) {
                  const e =
                      this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
                        `[${Vy}="${t.target.getAttribute(Vy)}"]`
                      ),
                    i =
                      this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(
                        Oy
                      );
                  e.classList.add(jy),
                    i.forEach((t) => {
                      t !== e && t.classList.remove(jy);
                    });
                } else this.triggerClick(t.target);
              })
            : setTimeout(() => this.triggerClick(t.target), 400);
        }
        onUnload() {
          this.destroyQuickViewPopup(),
            document.removeEventListener(
              "theme:resize:width",
              this.checkSlidesSizeOnResize
            ),
            this.slider &&
              this.slider.removeEventListener(
                "theme:slider:resize",
                this.resizeSliderEvent
              );
        }
        onDeselect() {
          this.destroyQuickViewPopup();
        }
        constructor(t) {
          var e;
          (this.container = t),
            (this.slider = this.container.querySelector(xy)),
            (this.productOnRow =
              Number(
                null === (e = this.slider) || void 0 === e
                  ? void 0
                  : e.getAttribute($y)
              ) || 3),
            (this.slides = this.container.querySelectorAll(Iy)),
            (this.sTLHotspotsItems = this.container.querySelectorAll(Hy)),
            (this.pointers = this.container.querySelectorAll(Fy)),
            (this.pointerBubbles = this.container.querySelectorAll(My)),
            (this.flkty = null),
            (this.observer = null),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
            (this.pointersInit = (t) => this.dotPointers(t)),
            (this.pointersOver = (t) => this.dotPointerIn(t)),
            (this.pointersOut = (t) => this.dotPointerOut(t)),
            (this.debouncedBlockSelectCallback = o(
              (t) => this.debouncedBlockSelect(t),
              500
            )),
            (this.quickViewPopup = new eh(this.container)),
            this.listen();
        }
      })(this.container);
    },
    onUnload() {
      Py[this.id].onUnload();
    },
    onBlockSelect(t) {
      Py[this.id].onBlockSelect(t);
    },
    onDeselect() {
      Py[this.id].onDeselect();
    },
  };
  P("look", [Qy]);
  const Xy = "[data-grid]",
    Yy = "[data-item]",
    Jy = "[data-item-content-inner]",
    Zy = ".carousel--mobile",
    tv = "[data-aos], [data-aos-anchor]",
    ev = "data-aos-anchor",
    iv = "data-aos-trigger",
    sv = "data-slider-mobile",
    ov = "aos-animate";
  let nv = {};
  P("mosaic", {
    onLoad() {
      nv[this.id] = new (class {
        onResize() {
          this.updateAOSAnchors();
        }
        updateAOSAnchors() {
          if (
            "false" != theme.settings.animationsEnabled &&
            ke() &&
            this.hasSliderMobile &&
            this.carouselMobile &&
            this.items.length > 1
          ) {
            const t = this.items[0],
              e = t.querySelector(Jy),
              i = t.id,
              s = e ? e.id : i;
            t.setAttribute(iv, `#${i}`),
              null == e || e.setAttribute(iv, `#${s}`),
              this.items.forEach((t) => {
                const e = t.querySelectorAll(tv),
                  o = t.querySelector(Jy);
                t.setAttribute(ev, `#${i}`),
                  null == o || o.setAttribute(ev, `#${s}`),
                  e.forEach((t) => t.setAttribute(ev, `#${s}`));
              });
          }
        }
        triggerAOS(t) {
          "false" != theme.settings.animationsEnabled &&
            t &&
            ([...t.querySelectorAll(tv)].some((t) =>
              t.classList.contains(ov)
            ) ||
              this.items.forEach((t) => {
                const e = t.querySelectorAll(tv);
                t.classList.add(ov), e.forEach((t) => t.classList.add(ov));
              }));
        }
        onBlockSelect(t) {
          const e = t.target,
            i = e.closest(Xy),
            s = i.currentStyle || window.getComputedStyle(i),
            o = parseInt(s.paddingLeft),
            n = e.offsetLeft - o,
            r = this.items[0];
          e.matches(`#${r.id}`) || this.triggerAOS(e),
            setTimeout(() => {
              i.scrollTo({ top: 0, left: n, behavior: "smooth" });
            }, 500);
        }
        onUnload() {
          document.removeEventListener(
            "theme:resize:width",
            this.onResizeCallback
          );
        }
        constructor(t) {
          (this.container = t.container),
            (this.hasSliderMobile = this.container.hasAttribute(sv)),
            (this.carouselMobile = this.container.querySelector(Zy)),
            (this.items = this.container.querySelectorAll(Yy)),
            (this.onResizeCallback = () => this.onResize()),
            this.updateAOSAnchors(),
            document.addEventListener(
              "theme:resize:width",
              this.onResizeCallback
            );
        }
      })(this);
    },
    onUnload() {
      nv[this.id].onUnload();
    },
    onBlockSelect(t) {
      nv[this.id].onBlockSelect(t);
    },
  });
  const rv = "[data-slider]",
    av = "[data-slide]",
    lv = "a, button",
    cv = "flickity-enabled",
    hv = "carousel",
    dv = "carousel--resize",
    uv = "carousel--inactive",
    pv = "is-selected",
    mv = "text-center",
    gv = "data-section-id",
    fv = "tabindex",
    yv = {};
  P("multicolumns", {
    onLoad() {
      yv[this.id] = new (class {
        init() {
          this.handleSliderState(), this.listen();
        }
        onResize() {
          this.handleSliderState(),
            null !== this.flkty &&
              (this.flkty.resize(),
              this.flkty.size.width >= this.flkty.slideableWidth &&
                this.destroySlider());
        }
        handleSliderState() {
          !this.slider.classList.contains(uv) || ke()
            ? 1 === this.slides.length && ke()
              ? this.destroySlider()
              : (this.flkty || this.initSlider(),
                this.flkty.slideableWidth < this.flkty.size.width &&
                  this.destroySlider())
            : this.destroySlider();
        }
        initSlider() {
          const t = this.slider.classList.contains(mv);
          this.slider.classList.remove(uv),
            (this.flkty = new e(this.slider, {
              cellSelector: av,
              prevNextButtons: !0,
              pageDots: !0,
              groupCells: !0,
              cellAlign: t ? "center" : "left",
              contain: !0,
              adaptiveHeight: !1,
              draggable: !0,
              on: {
                ready: () => {
                  this.slidesTabIndex();
                },
                change: () => {
                  this.slidesTabIndex();
                },
              },
            })),
            this.createResizeClass();
        }
        createResizeClass() {
          if ("function" == typeof e.prototype._createResizeClass) return;
          (e.prototype._createResizeClass = function () {
            this.element.classList.add(dv);
          }),
            e.createMethods.push("_createResizeClass");
          const t = e.prototype.resize;
          e.prototype.resize = function () {
            this.element.classList.remove(dv),
              t.call(this),
              this.element.classList.add(dv);
          };
        }
        slidesTabIndex() {
          e.data(this.slider).cells.forEach((t) => {
            let e = "-1";
            t.element.classList.contains(pv) && (e = "0"),
              t.element.querySelectorAll(lv).forEach((t) => {
                t.setAttribute(fv, e);
              });
          });
        }
        destroySlider() {
          this.slider.classList.contains(cv) &&
            (this.slider.classList.contains(hv) &&
              this.slider.classList.add(uv),
            null !== this.flkty && (this.flkty.destroy(), (this.flkty = null)));
        }
        listen() {
          document.addEventListener(
            "theme:resize:width",
            this.onResizeCallback
          );
        }
        onBlockSelect(t) {
          if (this.flkty && this.flkty.isActive) {
            const e = parseInt(
                [...t.target.parentNode.children].indexOf(t.target)
              ),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i),
              o = () => {
                requestAnimationFrame(() => {
                  this.flkty.select(s);
                }),
                  this.flkty.element.removeEventListener("transitionend", o);
              };
            this.flkty.element.addEventListener("transitionend", o);
          }
        }
        onUnload() {
          document.removeEventListener(
            "theme:resize:width",
            this.onResizeCallback
          );
        }
        constructor(t) {
          (this.container = t.container),
            (this.sectionId = this.container.getAttribute(gv)),
            (this.slider = this.container.querySelector(rv)),
            this.slider &&
              ((this.slides = this.slider.querySelectorAll(av)),
              (this.flkty = null),
              (this.onResizeCallback = () => this.onResize()),
              this.init());
        }
      })(this);
    },
    onUnload(t) {
      yv[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      yv[this.id].onBlockSelect(t);
    },
  }),
    P("newsletter", cf),
    P("overlapping-images", [Pm, mp]);
  const vv = "[data-toggle-admin]",
    bv = "[data-toggle-newsletter]",
    wv = "[data-form-admin]",
    Sv = "[data-form-newsletter]";
  let Ev = {};
  P("password-template", {
    onLoad() {
      Ev[this.id] = new (class {
        init() {
          this.toggleAdmin.addEventListener("click", (t) => {
            t.preventDefault(), this.showPasswordForm();
          }),
            this.toggleNewsletter.addEventListener("click", (t) => {
              t.preventDefault(), this.hidePasswordForm();
            }),
            "#login" == window.location.hash || this.adminErrors
              ? this.showPasswordForm()
              : this.hidePasswordForm();
        }
        showPasswordForm() {
          Xr(this.adminForm),
            Yr(this.newsletterForm),
            (window.location.hash = "#login");
        }
        hidePasswordForm() {
          Xr(this.newsletterForm),
            Yr(this.adminForm),
            (window.location.hash = "");
        }
        constructor(t) {
          (this.container = t.container),
            (this.toggleAdmin = this.container.querySelector(vv)),
            (this.toggleNewsletter = this.container.querySelector(bv)),
            (this.adminForm = this.container.querySelector(wv)),
            (this.newsletterForm = this.container.querySelector(Sv)),
            (this.adminErrors = this.adminForm.querySelector(".errors")),
            (this.newsletterErrors =
              this.newsletterForm.querySelector(".errors")),
            this.init();
        }
      })(this);
    },
  });
  const Lv = "[data-large-promo]",
    kv = "[data-large-promo-inner]",
    Av = "[data-tracking-consent]",
    Cv = "[data-tracking-consent-inner]",
    qv = "[data-confirm-cookies]",
    Tv = "[data-popup-bar]",
    Pv = "[data-popup-bar-holder]",
    xv = "[data-popup-bar-toggle]",
    Iv = "[data-popup-body]",
    Hv = "[data-popup-close]",
    Fv = "[data-popup-underlay]",
    Mv = "[data-newsletter-form]",
    Dv = "data-target-referrer",
    Ov = "data-prevent-scroll-lock",
    Bv = "has-success",
    zv = "has-error",
    _v = "selected",
    $v = "has-block-selected",
    Rv = "popup--expanded",
    Vv = "popup--visible",
    Nv = "mobile",
    Wv = "desktop",
    Uv = "popup--bar",
    jv = "popup-bar-is-visible";
  let Gv = {},
    Kv = 0,
    Qv = 0,
    Xv = [],
    Yv = class {
      always() {
        this.showPopup();
      }
      delayed(t = 10) {
        setTimeout(() => {
          this.showPopup();
        }, 1e3 * t);
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      idle() {
        if (!(!0 === this.checkPopupTarget())) return;
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          i = ["load", "resize", "scroll"],
          s = () => {
            (t = setTimeout(() => {
              (t = 0), this.showPopup();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              i.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              i.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              s();
          };
        s();
      }
      showPopup() {
        const t = { id: this.popup.id, body: this.popupBody };
        Xv.push(t);
        if (!0 === this.checkPopupTarget()) {
          if (
            ((Qv += 1),
            this.popup.classList.add(Vv),
            this.popup.classList.contains(Uv) &&
              document.body.classList.add(jv),
            this.a11y.trapFocus({ container: this.popupBody }),
            this.popup.hasAttribute(Ov))
          )
            return !1;
          this.scrollLock();
        }
      }
      checkPopupTarget() {
        const t = this.popup.parentNode.classList.contains(Nv),
          e = this.popup.parentNode.classList.contains(Wv);
        return !(
          (t && window.innerWidth >= theme.sizes.small) ||
          (e && window.innerWidth < theme.sizes.small)
        );
      }
      scrollLock() {
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupBody,
          })
        );
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.showPopup(),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e) {
        if (
          ((this.popupContainer = t),
          (this.popup = e),
          (this.popupBody = e.querySelector(Iv)),
          (this.delay = t.dataset.popupDelay),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.a11y = ci),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(t);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    Jv = class {
      constructor(t) {
        if (
          ((this.popupContainer = t),
          (this.locationPath = location.href),
          !this.popupContainer.hasAttribute(Dv))
        )
          return !1;
        -1 !==
          this.locationPath.indexOf(this.popupContainer.getAttribute(Dv)) ||
          window.Shopify.designMode ||
          this.popupContainer.parentNode.removeChild(this.popupContainer);
      }
    };
  P("popups", [
    {
      onLoad() {
        (Gv[this.id] = []), window.Shopify.designMode && (Qv = 0);
        const t = this.container.querySelectorAll(Lv);
        t.length &&
          t.forEach((t) => {
            Gv[this.id].push(
              new (class {
                init() {
                  (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                    (window.Shopify.designMode
                      ? this.showPopup()
                      : new Yv(this.popupContainer, this.popup),
                    this.form &&
                      setTimeout(() => {
                        this.form.classList.contains(Bv) &&
                          (this.showPopupIfNoCookie(), (Qv -= 1));
                      }),
                    this.initClosers());
                }
                checkPopupTarget() {
                  const t = this.popup.parentNode.classList.contains(Nv),
                    e = this.popup.parentNode.classList.contains(Wv);
                  return !(
                    (t && window.innerWidth >= theme.sizes.small) ||
                    (e && window.innerWidth < theme.sizes.small)
                  );
                }
                showPopupIfNoCookie() {
                  this.showPopup();
                }
                initClosers() {
                  this.close.addEventListener(
                    "click",
                    this.closePopup.bind(this)
                  ),
                    this.underlay.addEventListener(
                      "click",
                      this.closePopup.bind(this)
                    ),
                    this.popupContainer.addEventListener("keyup", (t) => {
                      t.code === theme.keyboardKeys.ESCAPE &&
                        this.closePopup(t);
                    });
                }
                closePopup(t) {
                  t.preventDefault(), this.hidePopup(), this.cookie.write();
                }
                scrollLock() {
                  this.resetScrollUnlock(),
                    this.a11y.trapFocus({ container: this.popupBody }),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:lock", {
                        bubbles: !0,
                        detail: this.popupBody,
                      })
                    );
                }
                scrollUnlock() {
                  this.resetScrollUnlock(),
                    (Kv = setTimeout(() => {
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                      );
                    }, 300));
                }
                resetScrollUnlock() {
                  Kv && clearTimeout(Kv);
                }
                showPopup() {
                  const t = !0 === this.checkPopupTarget(),
                    e = { id: this.popupId, body: this.popup };
                  Xv.push(e),
                    t &&
                      ((Qv += 1),
                      this.popup.classList.add(Vv),
                      this.scrollLock());
                }
                hidePopup() {
                  this.popup.classList.remove(Vv);
                  const t = Xv.findIndex((t) => t.id === this.popupId);
                  if (
                    ((Qv -= 1),
                    Xv.splice(t, 1),
                    1 == Qv && document.body.classList.contains(jv))
                  )
                    this.scrollUnlock();
                  else if (Qv < 1)
                    this.scrollUnlock(), this.a11y.removeTrapFocus();
                  else if (Xv.length > 0) {
                    const t = Xv[Xv.length - 1].body;
                    this.a11y.trapFocus({ container: t });
                  }
                }
                onBlockSelect(t) {
                  this.popupContainer.contains(t.target) &&
                    !this.popup.classList.contains(Vv) &&
                    (this.popup.classList.add(_v),
                    this.popupContainer.classList.add($v),
                    this.showPopup());
                }
                onBlockDeselect(t) {
                  this.popupContainer.contains(t.target) &&
                    (this.popup.classList.remove(_v),
                    this.popupContainer.classList.remove($v),
                    this.hidePopup());
                }
                onUnload() {
                  this.scrollUnlock();
                }
                onDeselect() {
                  this.popup.classList.remove(_v),
                    this.popupContainer.classList.remove($v),
                    this.hidePopup();
                }
                constructor(t) {
                  (this.popupContainer = t),
                    (this.popup = this.popupContainer.querySelector(kv)),
                    (this.popupBody = this.popup.querySelector(Iv)),
                    (this.popupId = this.popup.id),
                    (this.close = this.popup.querySelector(Hv)),
                    (this.underlay = this.popup.querySelector(Fv)),
                    (this.form = this.popup.querySelector(Mv)),
                    (this.cookie = new Yg(
                      this.popupContainer.dataset.cookieName,
                      "user_has_closed"
                    )),
                    (this.isTargeted = new Jv(this.popupContainer)),
                    (this.a11y = ci),
                    this.init();
                }
              })(t)
            );
          });
        const e = this.container.querySelectorAll(Tv);
        e.length &&
          e.forEach((t) => {
            Gv[this.id].push(
              new (class {
                init() {
                  (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                    (window.Shopify.designMode
                      ? this.showPopup()
                      : new Yv(this.popupContainer, this.popup),
                    this.initPopupToggleButton(),
                    this.initClosers(),
                    this.form &&
                      setTimeout(() => {
                        this.form.classList.contains(Bv) &&
                          this.showPopupIfNoCookie(),
                          this.form.classList.contains(zv) &&
                            this.toggle.dispatchEvent(new Event("click"));
                      }));
                }
                checkPopupTarget() {
                  const t = this.popup.parentNode.classList.contains(Nv),
                    e = this.popup.parentNode.classList.contains(Wv);
                  return !(
                    (t && window.innerWidth >= theme.sizes.small) ||
                    (e && window.innerWidth < theme.sizes.small)
                  );
                }
                showPopupIfNoCookie() {
                  this.showPopup(),
                    this.toggle.dispatchEvent(new Event("click"));
                }
                initPopupToggleButton() {
                  this.toggle.addEventListener("click", (t) => {
                    t.preventDefault(),
                      this.popup.classList.toggle(Rv),
                      this.popup.classList.contains(Rv)
                        ? this.scrollLock()
                        : this.scrollUnlock();
                  });
                }
                showPopup() {
                  const t = { id: this.popupId, body: this.popup };
                  Xv.push(t),
                    this.a11y.trapFocus({ container: this.popupBody }),
                    !0 === this.checkPopupTarget() &&
                      ((Qv += 1),
                      document.body.classList.add(jv),
                      this.popup.classList.add(Vv));
                }
                hidePopup() {
                  this.popup.classList.remove(Vv),
                    document.body.classList.remove(jv);
                  const t = Xv.findIndex((t) => t.id === this.popupId);
                  if ((Xv.splice(t, 1), Qv >= 1 && (Qv -= 1), Qv < 1))
                    this.scrollUnlock(), this.a11y.removeTrapFocus();
                  else if (Xv.length > 0) {
                    const t = Xv[Xv.length - 1].body;
                    this.a11y.trapFocus({ container: t });
                  }
                }
                initClosers() {
                  this.close.addEventListener(
                    "click",
                    this.closePopup.bind(this)
                  ),
                    this.underlay.addEventListener("click", () =>
                      this.toggle.dispatchEvent(new Event("click"))
                    ),
                    this.popupContainer.addEventListener("keyup", (t) => {
                      t.code === theme.keyboardKeys.ESCAPE &&
                        (this.popup.classList.remove(Rv), this.scrollUnlock());
                    });
                }
                closePopup(t) {
                  t.preventDefault(), this.cookie.write(), this.hidePopup();
                }
                scrollLock() {
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", {
                      bubbles: !0,
                      detail: this.popupBody,
                    })
                  );
                }
                scrollUnlock() {
                  this.resetScrollUnlock(),
                    (Kv = setTimeout(() => {
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                      );
                    }, 300));
                }
                resetScrollUnlock() {
                  Kv && clearTimeout(Kv);
                }
                onBlockSelect(t) {
                  this.popupContainer.contains(t.target) &&
                    !this.popup.classList.contains(Vv) &&
                    (this.showPopup(),
                    this.popup.classList.add(Rv),
                    this.popup.classList.add(_v),
                    this.popup.parentNode.classList.add($v),
                    this.resetScrollUnlock(),
                    this.scrollLock());
                }
                onBlockDeselect(t) {
                  this.popupContainer.contains(t.target) &&
                    (this.popup.classList.remove(Rv),
                    this.popup.classList.remove(_v),
                    this.popup.parentNode.classList.remove($v),
                    this.hidePopup());
                }
                onUnload() {
                  this.scrollUnlock();
                }
                onDeselect() {
                  this.popup.classList.remove(Rv),
                    this.popup.classList.remove(_v),
                    this.popup.parentNode.classList.remove($v),
                    this.hidePopup();
                }
                constructor(t) {
                  (this.popupContainer = t),
                    (this.popup = this.popupContainer.querySelector(Pv)),
                    (this.popupBody = this.popup.querySelector(Iv)),
                    (this.popupId = this.popup.id),
                    (this.close = this.popup.querySelector(Hv)),
                    (this.underlay = this.popup.querySelector(Fv)),
                    (this.toggle = this.popup.querySelector(xv)),
                    (this.cookie = new Yg(
                      this.popupContainer.dataset.cookieName,
                      "user_has_closed"
                    )),
                    (this.form = this.popup.querySelector(Mv)),
                    (this.isTargeted = new Jv(this.popupContainer)),
                    (this.a11y = ci),
                    this.init();
                }
              })(t)
            );
          });
        const i = this.container.querySelectorAll(Av);
        i.length &&
          i.forEach((t) => {
            Gv[this.id].push(
              new (class {
                init() {
                  this.enableTracking && this.showPopup(), this.clickEvents();
                }
                clickEvents() {
                  this.close.addEventListener("click", (t) => {
                    t.preventDefault(),
                      window.Shopify.customerPrivacy.setTrackingConsent(
                        !1,
                        () => this.hidePopup()
                      );
                  }),
                    this.acceptButton.addEventListener("click", (t) => {
                      t.preventDefault(),
                        window.Shopify.customerPrivacy.setTrackingConsent(
                          !0,
                          () => this.hidePopup()
                        );
                    }),
                    document.addEventListener("trackingConsentAccepted", () => {
                      console.log("trackingConsentAccepted event fired");
                    });
                }
                showPopup() {
                  const t = { id: this.popupId, body: this.popup };
                  Xv.push(t),
                    this.popup.classList.add(Vv),
                    this.a11y.trapFocus({ container: this.popup });
                }
                hidePopup() {
                  this.popup.classList.remove(Vv);
                  const t = Xv.findIndex((t) => t.id === this.popupId);
                  if ((Xv.splice(t, 1), Qv < 1)) this.a11y.removeTrapFocus();
                  else if (Xv.length > 0) {
                    const t = Xv[Xv.length - 1].body;
                    this.a11y.trapFocus({ container: t });
                  }
                }
                onBlockSelect(t) {
                  this.popupContainer.contains(t.target) &&
                    this.enableTracking &&
                    !this.popup.classList.contains(Vv) &&
                    (this.showPopup(),
                    this.popup.classList.add(_v),
                    this.popup.parentNode.classList.add($v));
                }
                onBlockDeselect(t) {
                  this.popupContainer.contains(t.target) &&
                    (this.popup.classList.remove(_v),
                    this.popupContainer.classList.remove($v),
                    this.hidePopup());
                }
                onDeselect() {
                  this.popup.classList.remove(_v),
                    this.popupContainer.classList.remove($v),
                    this.hidePopup();
                }
                constructor(t) {
                  (this.popupContainer = t),
                    (this.popup = this.popupContainer.querySelector(Cv)),
                    (this.popupId = this.popup.id),
                    (this.close = this.popup.querySelector(Hv)),
                    (this.acceptButton = this.popup.querySelector(qv)),
                    (this.enable =
                      "true" === this.popupContainer.dataset.enable),
                    (this.a11y = ci),
                    window.Shopify.loadFeatures(
                      [{ name: "consent-tracking-api", version: "0.1" }],
                      (t) => {
                        if (t) throw t;
                        const e =
                            window.Shopify.customerPrivacy.userCanBeTracked(),
                          i =
                            window.Shopify.customerPrivacy.getTrackingConsent();
                        (this.enableTracking =
                          !e && "no_interaction" === i && this.enable),
                          window.Shopify.designMode &&
                            (this.enableTracking = !0),
                          this.init();
                      }
                    );
                }
              })(t)
            );
          });
      },
      onDeselect() {
        Gv[this.id].forEach((t) => {
          "function" == typeof t.onDeselect && t.onDeselect();
        });
      },
      onBlockSelect(t) {
        Gv[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Gv[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
      onUnload(t) {
        Gv[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload(t);
        });
      },
    },
    cf,
  ]);
  const Zv = "[data-press-items]",
    tb = "[data-logo-slider]",
    eb = "[data-logo-slide]",
    ib = "a, button",
    sb = "data-logo-index",
    ob = "tabindex";
  let nb = {};
  const rb = {
    onLoad() {
      nb[this.id] = new (class {
        checkSlides() {
          const t = this.container.offsetWidth,
            i = this.container.querySelectorAll(eb),
            s = e.data(this.sliderNav) || null;
          null !== s &&
            ((s.options.draggable = !1),
            (s.options.wrapAround = !1),
            (s.options.contain = !0),
            this.getSlidesWidth() > t &&
              i.length > 2 &&
              ((s.options.draggable = !0),
              (s.options.wrapAround = !0),
              (s.options.contain = !1)),
            s.resize(),
            s.updateDraggable());
        }
        getSlidesWidth() {
          const t = this.container.querySelectorAll(eb);
          let e = 0;
          return (
            t.length &&
              t.forEach((t) => {
                e += t.offsetWidth;
              }),
            e
          );
        }
        initSlider() {
          let t = e.data(this.slider) || null,
            i = e.data(this.sliderNav) || null;
          const s = parseInt(this.container.dataset.duration),
            o = "true" === this.container.dataset.autoplay && s;
          (t = new e(this.slider, {
            fade: !0,
            wrapAround: !0,
            adaptiveHeight: !1,
            prevNextButtons: !1,
            pageDots: !1,
            autoPlay: o,
          })),
            (i = new e(this.sliderNav, {
              draggable: !1,
              wrapAround: !1,
              contain: !0,
              imagesLoaded: !0,
              asNavFor: this.slider,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pageDots: !1,
              on: {
                ready: () => {
                  this.container.querySelectorAll(eb).forEach((e) => {
                    e.addEventListener("keyup", (i) => {
                      if (
                        i.code === theme.keyboardKeys.ENTER ||
                        i.code === theme.keyboardKeys.NUMPADENTER ||
                        i.code === theme.keyboardKeys.SPACE
                      ) {
                        const i = Number(e.getAttribute(sb));
                        t.selectCell(i);
                      }
                    });
                  });
                },
              },
            })),
            Fi(this.slider),
            Fi(this.sliderNav),
            i.on("change", (e) => {
              t.selectCell(e);
            }),
            t.on("change", (e) => {
              i.selectCell(e),
                t.cells.forEach((t, i) => {
                  t.element.querySelectorAll(ib).forEach((t) => {
                    t.setAttribute(ob, i === e ? "0" : "-1");
                  });
                });
            });
        }
        resizeSlider() {
          const t = e.data(this.slider);
          t && t.resize();
        }
        onBlockSelect(t) {
          const i = e.data(this.slider) || null,
            s = e.data(this.sliderNav) || null,
            o = parseInt([...t.target.parentNode.children].indexOf(t.target));
          null !== i && (i.select(o), i.pausePlayer()),
            null !== s && s.select(o);
        }
        onBlockDeselect() {
          const t = e.data(this.slider) || null;
          "true" === this.container.dataset.autoplay &&
            null !== t &&
            t.playPlayer();
        }
        onUnload() {
          document.removeEventListener(
            "theme:resize:width",
            this.sliderResizeEvent
          );
        }
        constructor(t) {
          (this.container = t.container),
            (this.slider = this.container.querySelector(Zv)),
            (this.sliderNav = this.container.querySelector(tb)),
            (this.sliderResizeEvent = () => this.checkSlides()),
            this.initSlider(),
            this.checkSlides(),
            window.addEventListener("load", this.resizeSlider.bind(this)),
            document.addEventListener(
              "theme:resize:width",
              this.sliderResizeEvent
            );
        }
      })(this);
    },
    onUnload(t) {
      nb[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      nb[this.id].onBlockSelect(t);
    },
    onBlockDeselect() {
      nb[this.id].onBlockDeselect();
    },
  };
  P("press", rb);
  const ab = "[data-product-single-media-slider]",
    lb = "[data-product-info]",
    cb = "[data-header-sticky]",
    hb = "[data-header-height]",
    db = "is-sticky",
    ub = "data-sticky-enabled";
  window.theme.variables = { productPageSticky: !1 };
  const pb = {};
  const mb = {
      onLoad() {
        pb[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.productInfo.addEventListener("theme:form:sticky", (t) => {
                this.removeAnimationFrame(),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  ));
              }),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            null !== t.detail &&
              ((this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down)),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents() {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.initSticky();
          }
          stickyScrollCheck() {
            const t =
                (window.innerWidth ||
                  document.documentElement.clientWidth ||
                  document.body.clientWidth) >= window.theme.sizes.large,
              e = this.container.querySelector(lb);
            if (e)
              if (t) {
                const t = this.container.querySelector(lb),
                  i = this.container.querySelector(ab);
                if (!t || !i) return;
                t.offsetHeight < i.offsetHeight
                  ? ((theme.variables.productPageSticky = !0),
                    e.classList.add(db))
                  : ((theme.variables.productPageSticky = !1),
                    e.classList.remove(db));
              } else
                (theme.variables.productPageSticky = !1),
                  e.classList.remove(db);
          }
          calculateStickyPosition(t = null) {
            const e = Boolean(t && t.detail),
              i = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              s = this.productInfo.offsetHeight,
              o = window.innerHeight - s - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            this.scrollDirectionDown
              ? (this.stickyScrollTop -= n)
              : (this.stickyScrollTop += n),
              this.stickyFormLoad &&
                (document.querySelector(cb) && document.querySelector(hb)
                  ? (this.stickyDefaultTop = parseInt(
                      document.querySelector(hb).getBoundingClientRect().height
                    ))
                  : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                (this.stickyScrollTop = this.stickyDefaultTop)),
              (this.stickyScrollTop = Math.min(
                Math.max(this.stickyScrollTop, o),
                this.stickyDefaultTop
              ));
            const r = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * r),
              this.productInfo.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (i && this.onChangeCounter <= 10) ||
              (i && this.stickyFormLastHeight !== s) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (i && (this.onChangeCounter += 1),
                  i &&
                    this.stickyFormLastHeight !== s &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.stickyFormLastHeight = s);
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(ub)),
              (this.productInfo = this.container.querySelector(lb)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              this.init();
          }
        })(this);
      },
      onUnload() {
        pb[this.id].onUnload();
      },
    },
    gb = "[data-product-single-media-group]",
    fb = "[data-product-single-media-slider]",
    yb = "[data-zoom-wrapper]",
    vb = "pswp-zoom-gallery",
    bb = "pswp-zoom-gallery--single",
    wb = "is-moving",
    Sb = "data-image-width",
    Eb = "data-image-height";
  const Lb = "[data-complementary-products]",
    kb = "[data-button-quick-view]",
    Ab = "data-url";
  let Cb = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((t, e) => {
          t[0].isIntersecting &&
            (e.unobserve(this),
            this.hasAttribute(Ab) &&
              "" !== this.getAttribute(Ab) &&
              fetch(this.getAttribute(Ab))
                .then((t) => t.text())
                .then((t) => {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const i = e.querySelector(Lb);
                  i &&
                    i.innerHTML.trim().length &&
                    (this.innerHTML = i.innerHTML),
                    e.querySelector(kb) && new eh(this);
                })
                .catch((t) => {
                  console.error(t);
                }));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
    }
    constructor() {
      super();
    }
  };
  const qb = "[data-recipient-checkbox]",
    Tb = "[data-recipient-email]",
    Pb = "[data-recipient-name]",
    xb = "[data-recipient-message]",
    Ib = "[data-recipient-send-on]",
    Hb = "[data-recipient-control]",
    Fb = "[data-recipient-offset]",
    Mb = "[data-product-form]",
    Db = "[data-cart-drawer]",
    Ob = "js-quick-view-visible";
  let Bb = class extends HTMLElement {
    connectedCallback() {
      this.recipientCheckbox &&
        (this.disableInputFields(),
        this.recipientCheckbox.addEventListener("change", this.onChangeEvent),
        document.addEventListener("theme:cart:added", this.onCartAddedEvent));
    }
    onChange(t) {
      if (!t.target.checked)
        return this.clearInputFields(), void this.disableInputFields();
      this.enableInputFields();
    }
    onCartAdded() {
      const t = this.closest(Mb).offsetTop,
        e = document.body.classList.contains(Ob);
      if (!(!0 === this.recipientCheckbox.checked)) return;
      e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
      const i = (t) => {
        t.target === this.cartDrawer &&
          (requestAnimationFrame(() => {
            (this.recipientCheckbox.checked = !1),
              this.recipientCheckbox.dispatchEvent(new Event("change"));
          }),
          this.cartDrawer.removeEventListener("transitionend", i));
      };
      this.cartDrawer.addEventListener("transitionend", i);
    }
    inputFields() {
      return [
        this.recipientEmail,
        this.recipientName,
        this.recipientMessage,
        this.recipientSendOn,
      ];
    }
    disableableFields() {
      return [...this.inputFields(), this.recipientOffset];
    }
    clearInputFields() {
      this.inputFields().forEach((t) => (t.value = ""));
    }
    enableInputFields() {
      this.disableableFields().forEach((t) => (t.disabled = !1));
    }
    disableInputFields() {
      this.disableableFields().forEach((t) => (t.disabled = !0));
    }
    disconnectedCallback() {
      this.recipientCheckbox.removeEventListener("change", this.onChangeEvent),
        document.removeEventListener("theme:cart:added", this.onCartAddedEvent);
    }
    constructor() {
      super(),
        (this.recipientCheckbox = this.querySelector(qb)),
        (this.recipientControl = this.querySelector(Hb)),
        (this.recipientControl.disabled = !0),
        (this.recipientEmail = this.querySelector(Tb)),
        (this.recipientName = this.querySelector(Pb)),
        (this.recipientMessage = this.querySelector(xb)),
        (this.recipientSendOn = this.querySelector(Ib)),
        (this.recipientOffset = this.querySelector(Fb)),
        this.recipientOffset &&
          (this.recipientOffset.value = new Date().getTimezoneOffset()),
        (this.cartDrawer = document.querySelector(Db)),
        (this.onChangeEvent = (t) => this.onChange(t)),
        (this.onCartAddedEvent = () => this.onCartAdded());
    }
  };
  const zb = "[data-product-single-media-slider]",
    _b = "[data-thumbnail-id]",
    $b = "[data-product-single-media-thumbs]",
    Rb = "[data-product-single-media-wrapper]",
    Vb = "[data-model]",
    Nb = ".product-single__thumbnail-link",
    Wb = "[data-deferred-media]",
    Ub = "[data-deferred-media-button]",
    jb = "a, button",
    Gb = "[data-upsell-holder]",
    Kb = "[data-upsell-slider]",
    Qb = "[data-slider]",
    Xb = "[data-product-json]",
    Yb = "featured-product",
    Jb = "featured-product--onboarding",
    Zb = "has-media-active",
    tw = "is-selected",
    ew = "media--hidden",
    iw = "no-outline",
    sw = "is-moving",
    ow = "data-media-id",
    nw = "data-section-id",
    rw = "data-thumbnail-id",
    aw = "data-tall-layout",
    lw = "loaded",
    cw = "tabindex",
    hw = "aria-hidden",
    dw = {};
  const uw = {
    onLoad() {
      dw[this.id] = new (class {
        productSlider() {
          this.checkSlider(),
            document.addEventListener(
              "theme:resize:width",
              this.checkSliderOnResize
            );
        }
        checkSlider() {
          !this.tallLayout || window.innerWidth < theme.sizes.large
            ? this.initProductSlider()
            : this.destroyProductSlider();
        }
        resizeFlickityNav() {
          null !== this.flktyNav && this.flktyNav.resize();
        }
        initProductSlider() {
          const t = this.container.querySelector(zb),
            i = this.container.querySelector($b),
            s = this.container.querySelectorAll(Rb);
          if (
            s.length > 1 &&
            ((this.flkty = new e(t, {
              wrapAround: !0,
              pageDots: !1,
              adaptiveHeight: !0,
              on: {
                ready: () => {
                  t.setAttribute(cw, "-1"),
                    this.slidesAriaHidden(t),
                    s.forEach((t) => {
                      if (!t.classList.contains(tw)) {
                        const e = t.querySelectorAll(jb);
                        e.length &&
                          e.forEach((t) => {
                            t.setAttribute(cw, "-1");
                          });
                      }
                    });
                },
                dragStart: () => {
                  t.classList.add(sw);
                },
                dragMove: () => {
                  this.isFlickityDragging = !0;
                },
                staticClick: () => {
                  this.isFlickityDragging = !1;
                },
                change: () => {
                  this.slidesAriaHidden(t);
                },
                settle: (e) => {
                  const i = this.flkty.selectedElement.getAttribute(ow);
                  this.flkty.cells.forEach((t, i) => {
                    const s = t.element.querySelectorAll(jb);
                    s.length &&
                      s.forEach((t) => {
                        t.setAttribute(cw, i === e ? "0" : "-1");
                      });
                  }),
                    this.switchMedia(i),
                    t.classList.remove(sw);
                },
              },
            })),
            s.length &&
              s.forEach((t) => {
                t.addEventListener("theme:media:play", () => {
                  (this.flkty.options.draggable = !1),
                    this.flkty.updateDraggable(),
                    t.closest(zb).classList.add(Zb);
                }),
                  t.addEventListener("theme:media:pause", () => {
                    (this.flkty.options.draggable = !0),
                      this.flkty.updateDraggable(),
                      t.closest(zb).classList.remove(Zb);
                  });
              }),
            Fi(t),
            null !== i)
          ) {
            this.flktyNav = new e(i, {
              asNavFor: t,
              contain: !0,
              pageDots: !1,
              prevNextButtons: !1,
              resize: !0,
              on: {
                ready: () => {
                  i.setAttribute(cw, "-1"),
                    this.slidesAriaHidden(i),
                    requestAnimationFrame(this.flktyNavOnResize);
                },
                change: () => {
                  this.slidesAriaHidden(i);
                },
              },
            });
            const s = () => {
              requestAnimationFrame(this.flktyNavOnResize),
                this.flktyNav.viewport.removeEventListener("transitionend", s);
            };
            null !== this.flktyNav &&
              (document.addEventListener(
                "theme:resize:width",
                this.flktyNavOnResize
              ),
              this.flktyNav.viewport.addEventListener("transitionend", s)),
              Fi(i);
            const o = this.container.querySelectorAll(Nb);
            o.length &&
              o.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault();
                });
              });
          }
        }
        slidesAriaHidden(t) {
          e.data(t).cells.forEach((t) => t.element.setAttribute(hw, "false"));
        }
        destroyProductSlider() {
          null !== this.flkty &&
            (this.flkty.destroy(),
            this.flktyNav.destroy(),
            (this.flkty = null),
            (this.flktyNav = null));
        }
        initUpsellSlider() {
          const t = this.container.querySelector(Kb);
          if (this.container.querySelectorAll(Gb).length > 1) {
            const i = new e(t, {
              wrapAround: !0,
              pageDots: !0,
              adaptiveHeight: !0,
              prevNextButtons: !1,
            });
            i.on("change", (t) => {
              i.cells.forEach((e, i) => {
                const s = e.element.querySelectorAll(jb);
                s.length &&
                  s.forEach((e) => {
                    e.setAttribute(cw, i === t ? "0" : "-1");
                  });
              });
            });
          }
        }
        initFeatureSlider() {
          this.featureSliders.forEach((t) => {
            Array.from(t.children).length > 1 &&
              (this.flktyFeature = new e(t, {
                wrapAround: !0,
                pageDots: !0,
                adaptiveHeight: !0,
                prevNextButtons: !1,
              }));
          });
        }
        handleMediaFocus(t) {
          if (
            t.code !== theme.keyboardKeys.ENTER &&
            t.code !== theme.keyboardKeys.TAB
          )
            return;
          const i = t.currentTarget.getAttribute(rw),
            s = this.container.querySelector(`[${ow}="${i}"]`),
            o = parseInt([...s.parentNode.children].indexOf(s)),
            n = this.container.querySelector(zb),
            r = this.container.querySelector($b),
            a = e.data(n) || null,
            l = e.data(r) || null;
          a &&
            a.isActive &&
            o > -1 &&
            (t.code === theme.keyboardKeys.ENTER ||
              t.code === theme.keyboardKeys.NUMPADENTER) &&
            a.select(o),
            l && l.isActive && o > -1 && l.select(o);
        }
        switchMedia(t) {
          const e = document.querySelectorAll(`${Rb}`),
            i = this.container.querySelector(`${Rb}[${ow}="${t}"]`),
            s = !document.body.classList.contains(iw);
          e.length &&
            e.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                bubbles: !0,
              }),
                t.classList.add(ew);
            }),
            s && i.focus(),
            i.closest(zb).classList.remove(Zb),
            i.classList.remove(ew),
            i.dispatchEvent(new CustomEvent("theme:media:visible"), {
              bubbles: !0,
            });
          const o = i.querySelector(Wb);
          o &&
            "true" !== o.getAttribute(lw) &&
            i.querySelector(Ub).dispatchEvent(new Event("click"));
        }
        initMediaSwitch() {
          const t = this.container.querySelectorAll(_b);
          t.length &&
            t.forEach((t) => {
              t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                t.addEventListener("click", (t) => {
                  t.preventDefault();
                });
            });
        }
        initProductVideo() {
          this.videos = new Gi(this.container);
        }
        initProductModel() {
          const t = this.container.querySelectorAll(Vb);
          t.length &&
            t.forEach((t) => {
              theme.ProductModel.init(t, this.sectionId);
            });
        }
        initShopifyXrLaunch() {
          document.addEventListener("shopify_xr_launch", () => {
            this.container
              .querySelector(`${Vb}:not(.${ew})`)
              .dispatchEvent(new CustomEvent("xrLaunch"));
          });
        }
        onUnload() {
          null !== this.flktyNav &&
            document.removeEventListener(
              "theme:resize:width",
              this.flktyNavOnResize
            ),
            document.removeEventListener(
              "theme:resize:width",
              this.checkSliderOnResize
            );
        }
        onBlockSelect(t) {
          const i = e.data(t.target.closest(Qb)),
            s = parseInt([...t.target.parentNode.children].indexOf(t.target));
          i && i.select(s);
        }
        constructor(t) {
          if (
            ((this.container = t.container),
            (this.sectionId = this.container.getAttribute(nw)),
            (this.tallLayout = "true" === this.container.getAttribute(aw)),
            (this.featureSliders = this.container.querySelectorAll(Qb)),
            (this.flkty = null),
            (this.flktyNav = null),
            (this.isFlickityDragging = !1),
            (this.enableHistoryState = !this.container.classList.contains(Yb)),
            (this.checkSliderOnResize = () => this.checkSlider()),
            (this.flktyNavOnResize = () => this.resizeFlickityNav()),
            this.initUpsellSlider(),
            this.initFeatureSlider(),
            new eh(this.container),
            this.container.classList.contains(Jb))
          )
            return;
          const e = this.container.querySelector(Xb);
          if (e && e.innerHTML) {
            const t = JSON.parse(e.innerHTML).handle;
            let i = {};
            t && (i = { handle: t }), Shopify.Products.recordRecentlyViewed(i);
          } else Shopify.Products.recordRecentlyViewed();
          new (class {
            init() {
              this.zoomWrappers.length &&
                this.zoomWrappers.forEach((t, e) => {
                  t.addEventListener("click", (i) => {
                    i.preventDefault(),
                      (this.slider && this.slider.classList.contains(wb)) ||
                        ((this.a11y.state.trigger = t), this.createZoom(e));
                  });
                });
            }
            createZoom(t) {
              const e = this;
              let i = [],
                s = 0;
              this.zoomWrappers.forEach((o) => {
                const n = o.getAttribute("href"),
                  r = parseInt(o.getAttribute(Sb)),
                  a = parseInt(o.getAttribute(Eb));
                if (
                  (i.push({ src: n, w: r, h: a, msrc: n }),
                  (s += 1),
                  e.zoomWrappers.length === s)
                ) {
                  let e = `${vb}`;
                  1 === s && (e = `${vb} ${bb}`),
                    new Oc(i, {
                      barsSize: { top: 60, bottom: 60 },
                      history: !1,
                      focus: !1,
                      index: t,
                      mainClass: e,
                      showHideOpacity: !0,
                      showAnimationDuration: 250,
                      hideAnimationDuration: 250,
                      closeOnScroll: !1,
                      closeOnVerticalDrag: !1,
                      captionEl: !1,
                      closeEl: !0,
                      closeElClasses: ["caption-close"],
                      tapToClose: !1,
                      clickToCloseNonZoomable: !1,
                      maxSpreadZoom: 2,
                      loop: !0,
                      spacing: 0,
                      allowPanToNext: !0,
                      pinchToClose: !1,
                    });
                }
              });
            }
            constructor(t) {
              (this.container = t),
                (this.mediaContainer = this.container.querySelector(gb)),
                (this.slider = this.container.querySelector(fb)),
                (this.zoomWrappers = this.container.querySelectorAll(yb)),
                (this.zoomEnable =
                  "true" === this.mediaContainer.dataset.gallery),
                (this.a11y = ci),
                this.zoomEnable && this.init();
            }
          })(this.container),
            this.productSlider(),
            this.initMediaSwitch(),
            this.initProductVideo(),
            this.initProductModel(),
            this.initShopifyXrLaunch();
        }
      })(this);
    },
    onUnload: function () {
      dw[this.id].onUnload();
    },
    onBlockSelect(t) {
      dw[this.id].onBlockSelect(t);
    },
  };
  P("product-template", [xl, uw, po, mo, Cm, li, ps, Kr, mb]),
    P("featured-product", [xl, uw, po, mo, Cm, li, ps, Kr, mb]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", Cb),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", Bb);
  const pw = "href",
    mw = "data-media-id",
    gw = "data-deferred-media-loaded",
    fw = "[data-product-content-wrapper]",
    yw = "[data-product-single-media-wrapper]",
    vw = "[data-model]",
    bw = "[data-product-link]",
    ww = "[data-product-single-media-image]",
    Sw = "[data-slider-contents]",
    Ew = "[data-slider-images]",
    Lw = "[data-tab-button]",
    kw = "[data-tab-item]",
    Aw = "[data-circle-text]",
    Cw = {
      aosAnimate: "aos-animate",
      tabButtonActive: "products-list__nav__button--active",
      tabItemActive: "products-list__item--active",
      mediaHidden: "media--hidden",
      isDisabled: "is-disabled",
    },
    qw = {};
  P("products-list", [
    {
      onLoad() {
        qw[this.id] = new (class {
          listen() {
            (this.slidersImages.length > 0 ||
              this.slidersContents.length > 0) &&
              document.addEventListener("theme:resize", this.sliderResizeEvent);
          }
          resizeSlider() {
            this.flktyImages.length > 0 &&
              requestAnimationFrame(() => {
                this.flktyImages.forEach((t) => t.resize());
              }),
              this.flktyContent.length > 0 &&
                requestAnimationFrame(() => {
                  this.flktyContent.forEach((t) => t.resize());
                });
          }
          initButtons() {
            this.tabButtons.length &&
              this.tabButtons.forEach((t) => {
                t.addEventListener("click", (e) => {
                  if (t.classList.contains(Cw.tabButtonActive)) return;
                  const i = t.getAttribute(pw),
                    s = this.container.querySelector(i),
                    o = s.querySelector(yw),
                    n = o ? o.dataset.mediaId : null,
                    r = s.querySelector(Aw);
                  this.tabButtons.forEach((t) => {
                    t.classList.remove(Cw.tabButtonActive);
                  }),
                    this.tabItems.forEach((t) => {
                      const e = t.querySelector(Aw);
                      t.classList.remove(Cw.tabItemActive),
                        null == e || e.classList.add(Cw.isDisabled),
                        theme.settings.animationsEnabled &&
                          t
                            .querySelectorAll(`.${Cw.aosAnimate}`)
                            .forEach((t) => {
                              t.classList.remove(Cw.aosAnimate),
                                setTimeout(() => {
                                  t.classList.add(Cw.aosAnimate);
                                });
                            });
                    }),
                    t.classList.add(Cw.tabButtonActive),
                    s.classList.add(Cw.tabItemActive),
                    document.dispatchEvent(new CustomEvent("theme:resize")),
                    r &&
                      (r.classList.remove(Cw.isDisabled),
                      document.dispatchEvent(new CustomEvent("theme:scroll"))),
                    this.handleProductVideos(s, n),
                    e.preventDefault();
                });
              });
          }
          initSliders() {
            this.slidersImages.forEach((t, i) => {
              const s = t.closest(kw).querySelector(Sw),
                o = new e(t, {
                  fade: !0,
                  pageDots: !1,
                  prevNextButtons: !0,
                  wrapAround: !0,
                  adaptiveHeight: !0,
                  asNavFor: s,
                  on: {
                    change: (t) => {
                      this.flktyContent.length > 0 &&
                        this.flktyContent[i].select(t);
                    },
                  },
                });
              o.on("settle", (e) => {
                const i = t.querySelectorAll(yw);
                for (let t = 0; t < i.length; t++)
                  t === e
                    ? i[t].querySelector(ww).removeAttribute("tabindex")
                    : i[t].querySelector(ww).setAttribute("tabindex", "-1");
              }),
                this.flktyImages.push(o);
            }),
              this.slidersContents.forEach((t) => {
                const i = new e(t, {
                  fade: !0,
                  pageDots: !1,
                  prevNextButtons: !1,
                  wrapAround: !0,
                  adaptiveHeight: !0,
                });
                i.on("settle", (e) => {
                  const i = t.querySelectorAll(fw);
                  for (let t = 0; t < i.length; t++)
                    t === e
                      ? i[t].querySelectorAll(bw).forEach((t) => {
                          t.removeAttribute("tabindex");
                        })
                      : i[t].querySelectorAll(bw).forEach((t) => {
                          t.setAttribute("tabindex", "-1");
                        });
                }),
                  this.flktyContent.push(i);
              });
          }
          initProductVideos() {
            this.tabItems.forEach((t) => {
              t.classList.contains(Cw.tabItemActive) &&
                this.handleProductVideos(t);
            });
          }
          loadVideos(t, e = null) {
            new IntersectionObserver(
              (i, s) => {
                i.forEach((i) => {
                  if (i.isIntersecting) {
                    const o = new Gi(t);
                    this.videos.push(o),
                      t.setAttribute(gw, ""),
                      this.playToggle(e),
                      s.unobserve(i.target);
                  }
                });
              },
              {
                root: null,
                rootMargin: "300px",
                threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
              }
            ).observe(t);
          }
          handleProductVideos(t, e = null) {
            t.hasAttribute(gw) ? this.playToggle(e) : this.loadVideos(t, e);
          }
          playToggle(t) {
            this.videos.forEach((e) => {
              "function" == typeof e.pauseContainerMedia &&
                t &&
                (e.pauseContainerMedia(t, this.container), this.switchMedia(t)),
                t ||
                  0 !== Object.keys(e.players).length ||
                  this.pauseContainerMedia(this.container);
            });
          }
          switchMedia(t) {
            const e = this.container.querySelector(`${yw}[${mw}="${t}"]`);
            !document.body.classList.contains(Cw.noOutline) && e.focus(),
              e.classList.remove(Cw.mediaHidden),
              e.dispatchEvent(new CustomEvent("theme:media:visible"), {
                bubbles: !0,
              });
          }
          pauseContainerMedia(t) {
            const e = t.querySelectorAll(yw);
            0 !== e.length &&
              e.forEach((t) => {
                t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                  bubbles: !0,
                }),
                  t.classList.add(Cw.mediaHidden);
              });
          }
          initProductModel() {
            const t = this.container.querySelectorAll(vw);
            t.length &&
              t.forEach((t) => {
                theme.ProductModel.init(t, this.sectionId);
              });
          }
          initShopifyXrLaunch() {
            document.addEventListener("shopify_xr_launch", () => {
              this.container
                .querySelector(`${vw}:not(.${Cw.mediaHidden})`)
                .dispatchEvent(new CustomEvent("xrLaunch"));
            });
          }
          onBlockSelect(t) {
            t.target.dispatchEvent(new Event("click"));
          }
          onUnload() {
            (this.slidersImages.length > 0 ||
              this.slidersContents.length > 0) &&
              document.removeEventListener(
                "theme:resize",
                this.sliderResizeEvent
              );
          }
          constructor(t) {
            (this.container = t.container),
              (this.sectionId = this.container.dataset.sectionId),
              (this.tabButtons = this.container.querySelectorAll(Lw)),
              (this.tabItems = this.container.querySelectorAll(kw)),
              (this.slidersImages = this.container.querySelectorAll(Ew)),
              (this.slidersContents = this.container.querySelectorAll(Sw)),
              (this.videos = []),
              (this.flktyImages = []),
              (this.flktyContent = []),
              (this.sliderResizeEvent = () => this.resizeSlider()),
              this.initButtons(),
              this.initSliders(),
              this.initProductVideos(),
              this.initProductModel(),
              this.initShopifyXrLaunch(),
              this.listen();
          }
        })(this);
      },
      onUnload() {
        qw[this.id].onUnload();
      },
      onBlockSelect(t) {
        qw[this.id].onBlockSelect(t);
      },
    },
    mp,
  ]);
  const Tw = "[data-product-block]",
    Pw = "[data-related-products]",
    xw = "[data-recent-wrapper]",
    Iw = "[data-recently-viewed-wrapper]",
    Hw = "[data-slider]",
    Fw = "[data-slide]",
    Mw = "[data-aos]",
    Dw = "[data-tabs-holder]",
    Ow = "[data-tabs-link]",
    Bw = "[data-tab]",
    zw = "[data-tooltip]",
    _w = "data-section-id",
    $w = "data-product-id",
    Rw = "data-limit",
    Vw = "data-minimum",
    Nw = "data-tabs-link",
    Ww = "data-column-mobile",
    Uw = "hidden",
    jw = "aos-animate",
    Gw = "mobile--one-whole",
    Kw = "mobile--one-half",
    Qw = {};
  const Xw = {
    onLoad() {
      Qw[this.id] = new (class {
        related() {
          if (
            ((this.relatedProducts = this.container.querySelector(Pw)),
            !this.relatedProducts)
          )
            return;
          const t = this.container.getAttribute(_w),
            e = this.container.getAttribute($w),
            i = this.container.getAttribute(Rw),
            s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
          fetch(s)
            .then((t) => {
              if (!t.ok) {
                const e = new Error(t.status);
                throw (this.hideRelated(), e);
              }
              return t.text();
            })
            .then((t) => {
              const e = document.createElement("div");
              e.innerHTML = t;
              const i = e.querySelector(Pw);
              i &&
                i.querySelectorAll(Tw).length &&
                ((this.relatedProducts.innerHTML = i.innerHTML),
                (this.relatedProductGrid = new bo(this.relatedProducts)),
                (this.relatedGridSlider = new Of(this.container)),
                this.initTooltips(this.relatedProducts));
            });
        }
        recent() {
          const t = this.container.querySelector(xw),
            e = t ? parseInt(t.getAttribute(Rw)) : 4;
          Shopify.Products.showRecentlyViewed({
            howManyToShow: e,
            wrapperId: `recently-viewed-products-${this.sectionId}`,
            section: this.section,
            onComplete: (t, e) => {
              const i = e.container,
                s = i.querySelector(xw),
                o = i.querySelector(Iw),
                n = t.querySelectorAll(Tw),
                r = s.querySelectorAll(Mw),
                a = s.querySelector(Hw),
                l = s.hasAttribute(Vw) ? parseInt(s.getAttribute(Vw)) : 1,
                c = !o && n.length > 0,
                h = o && n.length >= l,
                d = a.getAttribute(Ww);
              if (c || h) {
                (this.recentProductGrid = new bo(s)),
                  this.initTooltips(s),
                  h && i.classList.remove(Uw),
                  a &&
                    ((this.recentGridSlider = new Of(i)),
                    requestAnimationFrame(() => {
                      this.recentGridSlider.sliders.forEach((t) => {
                        t.dispatchEvent(
                          new CustomEvent("theme:slider:resize", {
                            bubbles: !0,
                          })
                        ),
                          this.recentGridSlider.setSliderArrowsPosition(t);
                      });
                    }),
                    a.querySelectorAll(Fw).forEach((t) => {
                      2 == d
                        ? (t.classList.add(Kw), t.classList.remove(Gw))
                        : (t.classList.add(Gw), t.classList.remove(Kw));
                    }));
                let t = [];
                s.addEventListener("theme:target:animate", (e) => {
                  t.push(e.detail),
                    t.length === r.length &&
                      requestAnimationFrame(() =>
                        r.forEach((t) => t.classList.add(jw))
                      );
                });
              }
            },
          });
        }
        hideRelated() {
          const t = this.relatedProducts.closest(Bw),
            e = this.relatedProducts.closest(Dw),
            i = e.querySelector(`[${Nw}="${t.dataset.tab}"]`);
          t.remove(),
            i &&
              (i.remove(),
              e.querySelector(Ow).dispatchEvent(new Event("click")),
              this.tabs.customScrollbar.unload(),
              requestAnimationFrame(() => {
                this.tabs.customScrollbar = new Zi(this.tabs.container);
              }));
        }
        initTooltips(t) {
          (this.tooltips = t.querySelectorAll(zw)),
            this.tooltips.forEach((t) => {
              new us(t);
            });
        }
        onDeselect() {
          this.relatedProductGrid && this.relatedProductGrid.onDeselect(),
            this.recentProductGrid && this.recentProductGrid.onDeselect();
        }
        onBlockSelect(t) {
          const e = t.target,
            i = this.container.querySelectorAll(Bw);
          !e ||
            i.length < 2 ||
            (e.dispatchEvent(new Event("click")),
            e.parentNode.scrollTo({
              top: 0,
              left: e.offsetLeft - e.clientWidth,
              behavior: "smooth",
            }));
        }
        onUnload() {
          this.relatedProductGrid && this.relatedProductGrid.onUnload(),
            this.relatedGridSlider && this.relatedGridSlider.onUnload(),
            this.recentProductGrid && this.recentProductGrid.onUnload(),
            this.recentGridSlider && this.recentGridSlider.onUnload();
        }
        constructor(t) {
          (this.section = t),
            (this.sectionId = t.id),
            (this.container = t.container),
            this.related(),
            this.recent(),
            (this.tabs = new vr(this.container));
        }
      })(this);
    },
    onDeselect() {
      Qw[this.id].onDeselect();
    },
    onBlockSelect(t) {
      Qw[this.id].onBlockSelect(t);
    },
    onUnload() {
      Qw[this.id].onUnload();
    },
  };
  P("related-products", Xw), P("recent-products", Xw);
  const Yw = "[data-stl-hotspots-item]",
    Jw = "[data-stl-hotspots-target]",
    Zw = "[data-stl-hotspots-trigger]",
    tS = ".shopify-section",
    eS = "[data-quick-view-item-holder]",
    iS = "[data-product-block] a, [data-product-block] button",
    sS = "data-hotspot",
    oS = "data-stl-initial-open",
    nS = "tabindex",
    rS = "aria-expanded",
    aS = "aos-animate",
    lS = "is-active",
    cS = "is-loading",
    hS = "pswp--open",
    dS = "block-selected";
  let uS = class extends HTMLElement {
    get items() {
      return [...this.querySelectorAll(Yw)];
    }
    get targets() {
      return [...this.querySelectorAll(Jw)];
    }
    get triggers() {
      return [...this.querySelectorAll(Zw)];
    }
    attributeChangedCallback(t, e, i) {
      const s = "class" === t,
        o = i.includes(aS);
      let n = !0;
      e && e.includes(aS) && (n = !1), s && o && n && this.animate();
    }
    connectedCallback() {
      (this.animationsTimeout = null),
        (this.resetAnimations = !1),
        this.init(),
        this.listen();
    }
    init() {
      theme.settings.animationsEnabled || this.animate(),
        this.initialOpen || this.focusables();
    }
    listen() {
      if (Shopify.designMode) {
        const t = this.closest(tS);
        t.addEventListener("shopify:section:select", () =>
          this.restoreAnimations()
        ),
          t.addEventListener("shopify:section:deselect", (t) =>
            this.deselectAll(t)
          ),
          t.addEventListener("shopify:block:deselect", () =>
            this.restoreAnimations()
          ),
          this.addEventListener("shopify:block:select", (t) => {
            this.animationsTimeout &&
              (clearTimeout(this.animationsTimeout),
              (this.animationsTimeout = null)),
              this.removeAnimations(),
              this.deselectAll(t),
              this.select(this.targets.indexOf(t.target));
          });
      }
      this.targets.forEach((t) => {
        t.addEventListener("click", (t) => {
          this.select(this.targets.indexOf(t.target)), this.restoreAnimations();
        });
      }),
        this.triggers.forEach((t) => {
          t.addEventListener("click", (t) => {
            const e = this.triggers.indexOf(t.target);
            this.select(e),
              this.restoreAnimations(),
              ke() &&
                this.dispatchEvent(
                  new CustomEvent("stl:open-quick-view", {
                    bubbles: !0,
                    detail: { index: e },
                  })
                );
          });
        }),
        this.addEventListener("keyup", (t) => this.onKeyup(t));
    }
    animate() {
      if (!this.initialOpen) return;
      let t = 600;
      Shopify.designMode && (t = 300),
        this.resetAnimations || setTimeout(() => this.select(0), t);
    }
    removeAnimations() {
      this.items.forEach((t) => {
        t.style.setProperty("--duration", "0s"), t.classList.add(dS);
      }),
        (this.resetAnimations = !0);
    }
    restoreAnimations() {
      Shopify.designMode &&
        (this.items.forEach((t) => t.classList.remove(dS)),
        (this.animationsTimeout = setTimeout(() => {
          this.items.forEach((t) => {
            t.style.removeProperty("--duration");
          }),
            (this.resetAnimations = !1);
        }, 1e3)));
    }
    deselectAll(t = !1) {
      this.items.forEach((e, i) => {
        e.classList.remove(lS),
          0 === i &&
            this.initialOpen &&
            t &&
            !this.resetAnimations &&
            e.classList.add(lS);
      }),
        setTimeout(() => this.focusables());
    }
    select(t) {
      this.items.forEach((e, i) => {
        e.setAttribute("aria-current", t === i ? "true" : "false"),
          e.classList.toggle(lS, t === i);
      }),
        this.focusables();
    }
    focusables() {
      this.items.forEach((t, e) => {
        const i = t.classList.contains(lS),
          s = i ? "0" : "-1",
          o = !!i;
        t.querySelectorAll(iS).forEach((t) => t.setAttribute(nS, s)),
          this.targets[e].setAttribute(rS, o);
      });
    }
    onKeyup(t) {
      t.code === theme.keyboardKeys.ESCAPE &&
        (this.deselectAll(), t.target.closest(Yw).querySelector(Jw).focus());
    }
    constructor() {
      super(), (this.initialOpen = this.hasAttribute(oS));
    }
  };
  !(function (t, e, i) {
    e in t
      ? Object.defineProperty(t, e, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[e] = i);
  })(uS, "observedAttributes", ["class"]),
    customElements.get("stl-hotspots") ||
      customElements.define("stl-hotspots", uS);
  let pS = class extends HTMLElement {
    get hotspots() {
      return this.querySelector("stl-hotspots");
    }
    get hotspotsTargets() {
      return [...this.querySelectorAll(Jw)];
    }
    get hotspotsTriggers() {
      return [...this.querySelectorAll(Zw)];
    }
    connectedCallback() {
      this.init(), this.listen();
    }
    disconnectedCallback() {}
    init() {
      (this.quickViewPopup = new eh(this)),
        (this.openQuickViewPopupCallback = o(
          (t) => this.openQuickViewPopup(t),
          500
        ));
    }
    listen() {
      if (Shopify.designMode) {
        const t = this.closest(tS);
        t.addEventListener(
          "shopify:section:unload",
          this.destroyQuickViewPopup.bind(this)
        ),
          t.addEventListener(
            "shopify:section:deselect",
            this.destroyQuickViewPopup.bind(this)
          ),
          this.addEventListener("shopify:block:select", (t) =>
            this.openQuickViewPopupCallback(t.target)
          );
      }
      this.hotspots &&
        (this.addEventListener("click", (t) => {
          Boolean(null !== t.target.closest(Yw)) ||
            (this.hotspots.deselectAll(), this.hotspots.restoreAnimations());
        }),
        this.hotspots.addEventListener("stl:open-quick-view", (t) => {
          if (!ke()) return;
          const e = this.hotspotsTargets[t.detail.index];
          this.openQuickViewPopup(e);
          const i = () => {
            var t, s;
            this.hotspotsTriggers.forEach((t) => t.classList.add(cS)),
              null === (t = this.quickViewPopup.loadPhotoswipe) ||
                void 0 === t ||
                null === (s = t.popup) ||
                void 0 === s ||
                s.listen("destroy", () => {
                  this.hotspotsTriggers.forEach((t) => t.classList.remove(cS)),
                    e.removeEventListener("theme:popup:init", i);
                });
          };
          e.addEventListener("theme:popup:init", i);
        }));
    }
    openQuickViewPopup(t) {
      var e, i;
      if (!ke()) return;
      const s =
        null === (e = this.quickViewPopup) ||
        void 0 === e ||
        null === (i = e.loadPhotoswipe) ||
        void 0 === i
          ? void 0
          : i.pswpElement;
      s
        ? setTimeout(() => {
            if (s.classList.contains(hS)) {
              const e =
                  this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
                    `[${sS}="${t.getAttribute(sS)}"]`
                  ),
                i =
                  this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(
                    eS
                  );
              e.classList.add(lS),
                i.forEach((t) => {
                  t !== e && t.classList.remove(lS);
                });
            } else this.triggerClick(t);
          })
        : setTimeout(() => this.triggerClick(t), 400);
    }
    triggerClick(t) {
      requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
    }
    destroyQuickViewPopup() {
      var t, e;
      const i =
        null === (t = this.quickViewPopup) ||
        void 0 === t ||
        null === (e = t.loadPhotoswipe) ||
        void 0 === e
          ? void 0
          : e.pswpElement;
      i &&
        i.classList.contains(hS) &&
        this.quickViewPopup.loadPhotoswipe.popup.close();
    }
    constructor() {
      super();
    }
  };
  customElements.get("shop-the-look") ||
    customElements.define("shop-the-look", pS);
  const mS = {},
    gS = "[data-slider]",
    fS = "[data-item]",
    yS = "[data-button-show]",
    vS = "[data-button-hide]",
    bS = "[data-item-products]",
    wS = "[data-item-products-slider]",
    SS = "[data-item-product]",
    ES = "a, button",
    LS = "blog-item--active",
    kS = "blog-item__products--visible",
    AS = "flickity-enabled",
    CS = "is-selected",
    qS = {
      slider: "data-slider",
      slidePosition: "data-slide-position",
      sectionId: "data-section-id",
      tabIndex: "tabindex",
      ariaHidden: "aria-hidden",
    };
  const TS = {
    onLoad() {
      mS[this.id] = new (class {
        initSlider() {
          (this.flkty = new e(this.slider, {
            prevNextButtons: !0,
            pageDots: !1,
            cellAlign: "left",
            wrapAround: !1,
            groupCells: !0,
            contain: !0,
            on: {
              ready: () => {
                this.handleFocus();
              },
            },
          })),
            this.flkty.on("change", () => {
              const t = this.container.querySelectorAll(fS);
              this.handleFocus(),
                t.length &&
                  t.forEach((t) => {
                    const e = t.querySelector(bS);
                    t.classList.remove(LS),
                      e && t.querySelector(bS).classList.remove(kS);
                  }),
                this.flkty &&
                  !this.flkty.options.draggable &&
                  ((this.flkty.options.draggable = !0),
                  this.flkty.updateDraggable());
            });
        }
        destroySlider() {
          null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
        }
        checkSlidesSize() {
          const t =
            this.container.querySelector(fS).currentStyle ||
            window.getComputedStyle(this.container.querySelector(fS));
          this.gutter = parseInt(t.marginRight);
          const e =
            this.slider.offsetWidth + this.gutter < this.getItemsWidth();
          window.innerWidth >= theme.sizes.small && e
            ? this.initSlider()
            : this.destroySlider();
        }
        getItemsWidth() {
          let t = 0;
          const e = this.slider.querySelectorAll(fS);
          return (
            e.length &&
              e.forEach((e) => {
                t += e.offsetWidth + this.gutter;
              }),
            t
          );
        }
        bindButtons() {
          const t = this.container.querySelectorAll(wS),
            i = this.container.querySelectorAll(yS),
            s = this.container.querySelectorAll(vS);
          i.length &&
            i.forEach((t) => {
              t.addEventListener("click", (e) => {
                e.preventDefault(),
                  this.container.querySelectorAll(fS).forEach((t) => {
                    const e = t.querySelector(bS);
                    t.classList.remove(LS),
                      e &&
                        (e.classList.remove(kS),
                        this.changeTabIndex(e),
                        this.changeAriaHidden(e, !0));
                  });
                const i = t.closest(fS),
                  s = i.querySelector(bS);
                if ((i.classList.add(LS), s)) {
                  s.classList.add(kS),
                    this.changeTabIndex(s, "enable"),
                    this.changeAriaHidden(s, !1);
                  const t = s.querySelector(wS),
                    e = t.querySelectorAll(SS);
                  t.classList.contains(AS) &&
                    e.forEach((t) => {
                      const e = t.classList.contains(CS);
                      t.setAttribute(qS.tabIndex, e ? "0" : "-1"),
                        this.changeAriaHidden(t, !e);
                    });
                }
                null !== this.flkty &&
                  ((this.flkty.options.draggable = !1),
                  this.flkty.updateDraggable()),
                  (this.a11y.state.trigger = t);
              });
            }),
            s.length &&
              s.forEach((t) => {
                t.addEventListener("click", (e) => {
                  e.preventDefault();
                  const i = t.closest(fS),
                    s = i.querySelector(bS);
                  i.classList.remove(LS),
                    s &&
                      (s.classList.remove(kS),
                      this.changeTabIndex(s),
                      this.changeAriaHidden(s, !0)),
                    null !== this.flkty &&
                      ((this.flkty.options.draggable = !0),
                      this.flkty.updateDraggable()),
                    this.a11y.state.trigger.focus();
                });
              }),
            t.length &&
              t.forEach((t) => {
                t.querySelectorAll(SS).length > 1 &&
                  new e(t, {
                    prevNextButtons: !0,
                    contain: !0,
                    pageDots: !1,
                    wrapAround: !0,
                    on: {
                      change: (e) => {
                        t.querySelectorAll(SS).forEach((t, i) => {
                          const s = i === e;
                          t.setAttribute(qS.tabIndex, s ? "0" : "-1"),
                            this.changeAriaHidden(t, !s);
                        });
                      },
                    },
                  });
              }),
            this.slider.addEventListener("keyup", (t) => {
              if (t.code === theme.keyboardKeys.ESCAPE) {
                const e = t.target.hasAttribute(qS.slider)
                  ? t.target.querySelectorAll(fS)
                  : t.target.closest(gS).querySelectorAll(fS);
                e.length &&
                  (e.forEach((t) => {
                    const e = t.querySelector(bS);
                    t.classList.remove(LS),
                      e &&
                        (e.classList.remove(kS),
                        this.changeTabIndex(e),
                        this.changeAriaHidden(e, !0));
                  }),
                  this.flkty &&
                    ((this.flkty.options.draggable = !0),
                    this.flkty.updateDraggable())),
                  this.a11y.state.trigger.focus();
              }
            });
        }
        handleFocus() {
          const t = this.container.querySelectorAll(fS);
          t.length &&
            t.forEach((t) => {
              const e = t.classList.contains(CS),
                i = t.querySelector(bS);
              e
                ? (this.changeTabIndex(t, "enable"),
                  i && this.changeTabIndex(i))
                : (this.changeTabIndex(t), i && i.classList.remove(kS));
            });
        }
        listen() {
          this.slider &&
            (this.checkSlidesSize(),
            document.addEventListener(
              "theme:resize:width",
              this.checkSlidesSizeOnResize
            )),
            document.addEventListener("mousedown", this.clickOutsideItemEvent);
        }
        changeAriaHidden(t, e) {
          t.setAttribute(qS.ariaHidden, !!e);
        }
        changeTabIndex(t, e = "") {
          const i = "enable" === e ? "0" : "-1";
          t.querySelectorAll(ES).forEach((t) => {
            t.setAttribute(qS.tabIndex, i);
          });
          const s = t.querySelectorAll(wS),
            o = t.querySelector(bS),
            n = t.classList.contains(kS);
          s.forEach((t) => {
            t.setAttribute(qS.tabIndex, n ? "0" : "-1"),
              t.querySelectorAll(SS).forEach((t) => {
                this.changeAriaHidden(t, !n);
              });
          }),
            o && this.changeAriaHidden(o, !n);
        }
        onBlockSelect(t) {
          if (null !== this.flkty) {
            const e = parseInt(
                [...t.target.parentNode.children].indexOf(t.target)
              ),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i),
              o = () => {
                requestAnimationFrame(() => {
                  this.flkty.select(s);
                }),
                  this.flkty.element.removeEventListener("transitionend", o);
              };
            this.flkty.element.addEventListener("transitionend", o);
          } else {
            const e =
                this.slider.currentStyle ||
                window.getComputedStyle(this.slider),
              i = parseInt(e.paddingLeft),
              s = t.target.offsetLeft - i;
            this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
          }
        }
        onUnload() {
          document.removeEventListener(
            "theme:resize:width",
            this.checkSlidesSizeOnResize
          ),
            document.removeEventListener(
              "mousedown",
              this.clickOutsideItemEvent
            );
        }
        constructor(t) {
          (this.container = t.container),
            (this.flkty = null),
            (this.slider = this.container.querySelector(gS)),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            (this.isFullWidth = this.container.hasAttribute(qS.fullWidth)),
            (this.gutter = 0),
            (this.a11y = ci),
            (this.clickOutsideItemEvent = (t) => {
              if (!t.target.matches(fS) && !t.target.closest(fS)) {
                const t = this.container.querySelectorAll(fS);
                t.length &&
                  t.forEach((t) => {
                    const e = t.querySelector(bS);
                    e &&
                      (e.classList.remove(kS),
                      this.changeTabIndex(e),
                      this.changeAriaHidden(e, !0)),
                      t.classList.remove(LS);
                  });
              }
            }),
            this.bindButtons(),
            this.listen();
        }
      })(this);
    },
    onUnload(t) {
      mS[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      mS[this.id].onBlockSelect(t);
    },
  };
  P("shoppable-blog", TS);
  const PS = "[data-scroll-down]",
    xS = "[data-site-header]",
    IS = "[data-slide]",
    HS = "a, button",
    FS = "[data-slider]",
    MS = ".lazy-image",
    DS = "text-highlight",
    OS =
      '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    BS = "data-style",
    zS = "data-current-style",
    _S = "tabindex",
    $S = "site-header--fixed",
    RS = "slider--no-cached-images",
    VS = "slider--img-loaded",
    NS = "img-in",
    WS = "original-height",
    US = "original-height-mobile",
    jS = "has-mobile-height",
    GS = {};
  P("slider", [
    {
      onLoad() {
        GS[this.id] = new (class {
          initSlider() {
            const t = this.items.length,
              i = parseInt(this.container.dataset.duration),
              s = "true" === this.container.dataset.pageDots && t > 1,
              o = "true" === this.container.dataset.navArrows && t > 1;
            let n = "true" === this.container.dataset.autoplay;
            if ((n && (n = i), t > 1))
              (this.flkty = new e(this.container, {
                fade: !0,
                cellSelector: IS,
                autoPlay: n,
                wrapAround: !0,
                adaptiveHeight: !0,
                setGallerySize: !0,
                imagesLoaded: !0,
                pageDots: s,
                prevNextButtons: o,
                dragThreshold: 25,
                on: {
                  ready: () => {
                    const t = this.items[0].getAttribute(BS);
                    this.container.setAttribute(zS, t),
                      requestAnimationFrame(this.resizeEvent),
                      document.addEventListener("theme:vars", this.resizeEvent),
                      this.handleFirstSlideAnimation(!0);
                  },
                  change: (t) => {
                    const e = this.flkty.selectedElement.getAttribute(BS);
                    this.container.setAttribute(zS, e),
                      this.handleFirstSlideAnimation(!1),
                      this.flkty.cells.forEach((e, i) => {
                        e.element.querySelectorAll(HS).forEach((e) => {
                          e.setAttribute(_S, i === t ? "0" : "-1");
                        }),
                          e.element.querySelectorAll(DS).forEach((e) => {
                            e.setTriggerAttribute(Boolean(i === t));
                          });
                      });
                  },
                },
              })),
                Fi(this.container);
            else if (1 === t) {
              const t = this.items[0].getAttribute(BS);
              this.container.setAttribute(zS, t);
            }
          }
          getTallestSlideItem() {
            if (this.items.length <= 1) return;
            this.container.style.removeProperty("--item-min-h");
            const t = [...this.items].map((t) => Math.floor(t.offsetHeight)),
              e = Math.max(...t),
              i = [...this.items].some((t) => t.classList.contains(WS)),
              s = [...this.items].some((t) => t.classList.contains(US)),
              o = this.container.classList.contains(jS);
            ((Le() && !i) || (ke() && !s && o) || (ke() && !i && !o)) &&
              [...this.items].some((t) => Math.floor(t.offsetHeight) !== e) &&
              this.container.style.setProperty("--item-min-h", `${e}px`);
          }
          handleFirstSlideAnimation(t = !1) {
            if (!t)
              return (
                this.container.classList.remove(RS),
                void this.container.classList.remove(VS)
              );
            const e = this.items[0].querySelectorAll(MS),
              i = this.container.classList.contains(NS);
            if (e.length && !i) {
              this.container.classList.add(RS);
              const t = (i) => {
                requestAnimationFrame(() => this.container.classList.add(VS)),
                  e[0].removeEventListener("transitionend", t);
              };
              e[0].addEventListener("transitionend", t);
            }
          }
          bindScrollButton() {
            const t = this.container.querySelector(PS);
            t &&
              t.addEventListener("click", (t) => {
                t.preventDefault();
                const e = this.header.classList.contains($S) ? 60 : 0,
                  i = parseInt(
                    Math.ceil(
                      this.container.offsetTop + this.container.offsetHeight - e
                    )
                  );
                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
              });
          }
          onBlockSelect(t) {
            const e = parseInt(
              [...t.target.parentNode.children].indexOf(t.target)
            );
            null !== this.flkty &&
              (this.flkty.select(e), this.flkty.pausePlayer());
          }
          onBlockDeselect(t) {
            "true" === t.target.closest(FS).dataset.autoplay &&
              null !== this.flkty &&
              this.flkty.playPlayer();
          }
          onReorder() {
            this.handleFirstSlideAnimation(!1),
              null !== this.flkty && this.flkty.resize();
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize:width",
              this.getTallestSlideItemOnResize
            ),
              this.handleFirstSlideAnimation(!1),
              null !== this.flkty &&
                (document.removeEventListener("theme:vars", this.resizeEvent),
                this.flkty.destroy(),
                (this.flkty = null)),
              this.parallax && (this.parallax.unload(), (this.parallax = null));
          }
          constructor(t) {
            (this.container = t.container),
              (this.header = document.querySelector(xS)),
              (this.items = this.container.querySelectorAll(IS)),
              (this.flkty = null),
              (this.parallax = null),
              (this.resizeEvent = () => {
                this.flkty.resize();
              }),
              this.getTallestSlideItem(),
              this.initSlider(),
              this.bindScrollButton(),
              (this.getTallestSlideItemOnResize = () =>
                this.getTallestSlideItem()),
              document.addEventListener(
                "theme:resize:width",
                this.getTallestSlideItemOnResize
              ),
              this.container.matches(OS) &&
                (this.parallax = new pp(this.container));
          }
        })(this);
      },
      onReorder(t) {
        GS[this.id].onReorder(t);
      },
      onUnload(t) {
        GS[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        GS[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        GS[this.id].onBlockDeselect(t);
      },
    },
    Pm,
  ]);
  const KS = "[data-sticky-card-body]",
    QS = "[data-sticky-card-wrapper]",
    XS = "[data-sticky-card-content]",
    YS = "[data-sticky-card-aside]",
    JS = "[data-sticky-card-text]",
    ZS = "[data-sticky-card-media]",
    tE = "[data-sticky-vh]",
    eE = "is-stuck-up",
    iE = "has-passed-sticky",
    sE = "spillover",
    oE = "data-sticky-card-layout-mobile",
    nE = {};
  P("sticky-image-cards", {
    onLoad() {
      nE[this.id] = new (class {
        init() {
          requestAnimationFrame(() => {
            this.calculateHeights(), this.onScroll();
          }),
            document.addEventListener("theme:scroll", this.onScrollCallback),
            document.addEventListener("theme:resize", this.onResizeCallback);
        }
        onScroll() {
          this.isEligible() && this.detectStickyPositions();
        }
        isEligible() {
          const t = Math.round(
              this.container.getBoundingClientRect().top + window.scrollY
            ),
            e = t + this.container.offsetHeight < Math.round(window.scrollY);
          return t < Math.round(window.scrollY + window.innerHeight) && !e;
        }
        detectStickyPositions() {
          const t = Math.round(
            this.body.getBoundingClientRect().top -
              this.headerHeight -
              this.wrapperTop
          );
          [...this.wrapper].forEach((e, i) => {
            const s = Math.floor(
              e.getBoundingClientRect().top - this.headerHeight
            );
            if (this.isMobile) {
              if (i !== this.lastIndex) {
                const t = Math.floor(
                  this.wrapper[i + 1].getBoundingClientRect().top -
                    this.headerHeight
                );
                e.classList.toggle(iE, t <= this.stickyTop);
              }
              this.container.classList.toggle(
                `checkpoint-${i + 1}`,
                t <= -1 * this.cumulativeHeights[i]
              );
            }
            e.classList.toggle(eE, s <= this.stickyTop);
          });
        }
        calculateHeights() {
          let { stickyHeaderHeight: t } = R();
          (this.headerHeight = t || 0),
            (this.spacingTop =
              parseInt(
                window
                  .getComputedStyle(this.container)
                  .getPropertyValue("--padding")
              ) || 20),
            (this.wrapperTop =
              parseInt(
                window.getComputedStyle(this.wrapper[0]).getPropertyValue("top")
              ) || 0),
            (this.stickyTop = Math.floor(this.wrapperTop - this.headerHeight)),
            (this.gap =
              parseInt(
                window.getComputedStyle(this.aside).getPropertyValue("gap")
              ) || 0),
            (this.viewportHeight = this.vh.offsetHeight),
            (this.lastIndex = [...this.wrapper].length - 1),
            (this.cumulativeHeights = []),
            this.isMobile &&
              ((this.wrapperTop = this.spacingTop),
              (this.stickyTop = this.spacingTop)),
            this.textInContent &&
              (this.isDesktop &&
                this.textInContent.length > 0 &&
                this.textInContent.forEach((t, e) => {
                  t.style.setProperty("--row-height", "auto"),
                    this.wrapper[e].style.setProperty("--row-height", "auto");
                  const i = t.offsetHeight,
                    s = this.media[e].offsetHeight,
                    o = Math.max(i, s);
                  t.style.setProperty("--row-height", `${o}px`),
                    this.wrapper[e].style.setProperty("--row-height", `${o}px`);
                }),
              [...this.wrapper].forEach((t, e) => {
                t.style.setProperty("--item-height", "auto"),
                  t.style.setProperty("--item-double-height", "auto"),
                  requestAnimationFrame(() => {
                    const i = t.offsetHeight,
                      s =
                        i + this.wrapperTop + this.headerHeight >
                        this.viewportHeight,
                      o = [...this.wrapper].map((t) =>
                        Number(t.dataset.index) >= e ? 0 : t.offsetHeight
                      );
                    this.cumulativeHeights.push(o.reduce((t, e) => t + e, 0)),
                      t.classList.toggle(sE, s),
                      s &&
                        this.isMobile &&
                        (t.style.setProperty("--item-height", `${i}px`),
                        t.style.setProperty(
                          "--item-double-height",
                          2 * i + "px"
                        ));
                  });
              }));
        }
        onResize() {
          requestAnimationFrame(() => {
            (this.isDesktop = Boolean(Ee() >= window.theme.sizes.large)),
              (this.isMobile = ke());
            const t = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            let e = this.isDesktop || (!t && this.isMobile);
            this.orientation !== K() &&
              t &&
              ((e = !0), (this.orientation = K())),
              e && this.calculateHeights();
          });
        }
        onUnload() {
          document.removeEventListener("theme:scroll", this.onScrollCallback),
            document.removeEventListener("theme:resize", this.onResizeCallback);
        }
        onBlockSelect(t) {
          requestAnimationFrame(() => {
            const e = Number(t.target.dataset.index),
              i =
                Math.round(
                  this.body.getBoundingClientRect().top + window.scrollY
                ) +
                [...this.wrapper]
                  .map((t) =>
                    Number(t.dataset.index) >= e ? 0 : t.offsetHeight
                  )
                  .reduce((t, e) => t + e, 0) -
                (() =>
                  this.isMobile && "stacked" === this.layoutMobile
                    ? this.gap * e * -1 + this.gap / 2
                    : this.stickyTop)() -
                this.headerHeight;
            setTimeout(() => {
              window.scrollTo({ top: i, left: 0, behavior: "smooth" });
            }, 400);
          });
        }
        constructor(t) {
          var e;
          (this.container = t.container),
            (this.body = this.container.querySelector(KS)),
            (this.wrapper = this.container.querySelectorAll(QS)),
            (this.content = this.container.querySelector(XS)),
            (this.aside = this.container.querySelector(YS)),
            (this.text = this.container.querySelectorAll(JS)),
            (this.media = this.container.querySelectorAll(ZS)),
            (this.textInContent =
              null === (e = this.content) || void 0 === e
                ? void 0
                : e.querySelectorAll(JS)),
            (this.vh = this.container.querySelector(tE)),
            (this.layoutMobile = this.container.getAttribute(oE)),
            (this.isDesktop = Boolean(Ee() >= window.theme.sizes.large)),
            (this.isMobile = ke()),
            (this.orientation = K()),
            0 !== this.media.length &&
              ((this.onScrollCallback = () => this.onScroll()),
              (this.onResizeCallback = () => this.onResize()),
              this.init());
        }
      })(this);
    },
    onUnload() {
      nE[this.id].onUnload();
    },
    onBlockSelect(t) {
      nE[this.id].onBlockSelect(t);
    },
  });
  const rE = "[data-sticky-wrapper]",
    aE = "[data-sticky-aside]",
    lE = "[data-sticky-inner]",
    cE = "[data-sticky-content]",
    hE = ".js-only [data-sticky-text]",
    dE = ".js-only [data-sticky-text-inner]",
    uE = ".js-only [data-sticky-image]",
    pE = "[data-sticky-images]",
    mE = ".image-wrapper",
    gE = ".sticky-images-and-text__video-wrapper",
    fE = "[data-sticky-dot]",
    yE = "text-highlight",
    vE = "data-sticky-with-gaps",
    bE = "data-sticky-single-text",
    wE = "data-index",
    SE = 0.5,
    EE = {
      horizontal: "horizontal",
      horizontalReversed: "horizontal-reversed",
      vertical: "vertical",
      verticalReversed: "vertical-reversed",
    },
    LE = {
      maxVisibility: "maximum-visibility-of-each-image-in-viewport",
      middleOfViewport: "image-in-the-middle-of-viewport",
    },
    kE = "is-active",
    AE = {};
  P("sticky-images-and-text", [
    {
      onLoad() {
        AE[this.id] = new (class {
          init() {
            this.getTypeOfIntersecting(),
              this.observeImagesIntersecting(),
              this.calculateHeights(),
              (this.performAnimation = requestAnimationFrame(
                this.calculateImagesOffsetCallback
              )),
              requestAnimationFrame(() => {
                requestAnimationFrame(() => this.calculateHeights());
              }),
              document.addEventListener("theme:scroll", this.onScrollCallback),
              document.addEventListener(
                "theme:resize:width",
                this.onResizeCallback
              ),
              this.syncDots();
          }
          getTypeOfIntersecting() {
            (this.typeOfIntersecting = LE.maxVisibility),
              (this.fractionOfViewport =
                this.image[0].offsetHeight / window.innerHeight),
              this.verticalScroll &&
                !ke() &&
                this.fractionOfViewport < 0.6 &&
                (this.typeOfIntersecting = LE.middleOfViewport);
          }
          observeImagesIntersecting() {
            (this.observersCollection = new Set()),
              (this.compareIntersectionRatio = []),
              (this.maxVisibility = 0),
              (this.observer = new IntersectionObserver(
                (t, e) => {
                  t.forEach((t) => {
                    const e = t.target.offsetHeight,
                      i = t.intersectionRatio,
                      s = t.isIntersecting,
                      o = {
                        target: t.target,
                        intersectionRatio: t.intersectionRatio,
                      },
                      n = this.typeOfIntersecting === LE.maxVisibility;
                    let r = SE;
                    this.windowHeight <= e && (r = 0),
                      n &&
                        s &&
                        (this.observersCollection.forEach((e) => {
                          e.target === t.target &&
                            this.observersCollection.delete(e);
                        }),
                        this.observersCollection.add(o),
                        (this.compareIntersectionRatio = [
                          ...this.observersCollection,
                        ].map((t) => t.intersectionRatio)),
                        (this.maxVisibility = Math.max(
                          ...this.compareIntersectionRatio
                        ))),
                      s &&
                        i > r &&
                        n &&
                        this.maxVisibility === i &&
                        ((this.maxVisibilityItem = [
                          ...this.observersCollection,
                        ].find(
                          (t) => t.intersectionRatio === this.maxVisibility
                        )),
                        (this.activeIndex = Number(
                          this.maxVisibilityItem.target.dataset.index
                        )),
                        this.lastActiveIndex !== this.activeIndex &&
                          (this.sync(),
                          (this.lastActiveIndex = this.activeIndex)));
                  });
                },
                {
                  root: null,
                  rootMargin: "0px",
                  threshold: [
                    0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7,
                    0.85, 1,
                  ],
                }
              )),
              this.image.forEach((t) => this.observer.observe(t));
          }
          onScroll() {
            this.performAnimation ||
              (this.performAnimation = requestAnimationFrame(
                this.calculateImagesOffsetCallback
              )),
              this.typeOfIntersecting === LE.middleOfViewport &&
                this.image.forEach((t) => this.checkImagePositionInViewport(t));
          }
          removeAnimationFrame() {
            this.performAnimation &&
              (cancelAnimationFrame(this.performAnimation),
              (this.performAnimation = null));
          }
          checkImagePositionInViewport(t) {
            if (!t) return;
            const e = window.innerHeight,
              i = window.scrollY,
              s = i + e / 2,
              o = i + e,
              n = Math.round(t.getBoundingClientRect().top + i),
              r = n + t.offsetHeight;
            n < o &&
              !(r < i) &&
              s > n &&
              r > s &&
              ((this.activeIndex = Number(t.dataset.index)),
              this.lastActiveIndex !== this.activeIndex &&
                (this.sync(), (this.lastActiveIndex = this.activeIndex)));
          }
          calculateImagesOffset() {
            const t =
                this.aside.getBoundingClientRect().top - this.headerHeight,
              e = t - this.innerStickyTop;
            let i = 0,
              s = 0;
            const o = this.hasShortImages ? e : t;
            (i =
              o < 0
                ? (o / this.bottomEndingPoint) * -1 * 100
                : o >= 0
                ? 0
                : 100),
              (s = i > 100 ? 100 : i),
              (s *= this.image.length - 1),
              (ke() || this.horizontalScroll) &&
                this.aside.style.setProperty(
                  "--translateX",
                  `${Number(s * this.direction).toFixed(2)}%`
                ),
              this.lastOffset !== s
                ? (this.performAnimation = requestAnimationFrame(
                    this.calculateImagesOffsetCallback
                  ))
                : this.performAnimation && this.removeAnimationFrame(),
              (this.lastOffset = s);
          }
          calculateHeights() {
            let { stickyHeaderHeight: t, windowHeight: e } = R();
            if (
              ((this.headerHeight = t || 0),
              (this.windowHeight = e || window.innerHeight),
              this.text.length > 0)
            ) {
              const t = this.content
                  ? parseInt(
                      window
                        .getComputedStyle(this.content)
                        .getPropertyValue("padding-top")
                    )
                  : 0,
                e = this.content
                  ? parseInt(
                      window
                        .getComputedStyle(this.content)
                        .getPropertyValue("padding-bottom")
                    )
                  : 0,
                i = [...this.text].map((i) => i.offsetHeight + t + e),
                s = [...this.textInner].map((t) => t.offsetHeight),
                o = Math.max(...i),
                n = Math.max(...s),
                r = ke() ? n : o,
                a = i.reduce((t, e) => t + e, 0),
                l = Math.floor(a / i.length) || this.text[0].offsetHeight;
              this.container.style.removeProperty("--average-text-height"),
                this.container.style.setProperty(
                  "--average-text-height",
                  `${l}px`
                ),
                this.container.style.removeProperty("--highest-text"),
                this.container.style.setProperty("--highest-text", `${r}px`);
            }
            if (
              ((this.imagesHeight = this.images.offsetHeight),
              (this.hasShortImages = !1),
              this.image.length > 0)
            ) {
              const t = this.image[0].querySelector(mE),
                e = this.image[0].querySelector(gE),
                i = t || e;
              (this.imgHeight = i ? i.offsetHeight : 0),
                (this.imgPadding = parseInt(
                  window
                    .getComputedStyle(this.image[0])
                    .getPropertyValue("padding-top")
                )),
                this.container.style.removeProperty("--images-height"),
                this.container.style.setProperty(
                  "--images-height",
                  `${this.imagesHeight}px`
                ),
                this.container.style.removeProperty("--img-height"),
                this.container.style.setProperty(
                  "--img-height",
                  `${this.imgHeight + 2 * this.imgPadding}px`
                );
            }
            (this.asideHeight = this.aside.offsetHeight),
              (this.asidePadding = parseInt(
                window
                  .getComputedStyle(this.aside)
                  .getPropertyValue("padding-top")
              )),
              (this.breathingSpace =
                (this.windowHeight - this.imagesHeight) / 2 / 2),
              (this.innerStickyTop =
                parseInt(
                  window.getComputedStyle(this.inner).getPropertyValue("top")
                ) -
                this.headerHeight -
                this.breathingSpace),
              (this.gutters = this.withGaps ? 2 * this.asidePadding : 0),
              (this.additionalSpace = ke()
                ? this.withGaps
                  ? this.asidePadding + 10
                  : 10
                : this.gutters),
              (this.minHeightForEndingPoing =
                this.imagesHeight + this.additionalSpace),
              !ke() &&
                this.horizontalScroll &&
                ((this.minHeightForEndingPoing =
                  this.windowHeight - this.headerHeight),
                (this.hasShortImages = this.fractionOfViewport <= 0.6),
                this.hasShortImages &&
                  (this.minHeightForEndingPoing =
                    this.imagesHeight -
                    this.innerStickyTop +
                    3 * this.breathingSpace)),
              (this.bottomEndingPoint =
                this.asideHeight - this.minHeightForEndingPoing);
          }
          refreshImagesOffsetValues() {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                document.dispatchEvent(new CustomEvent("theme:scroll"));
              });
            });
          }
          onResize() {
            this.calculateHeights(),
              requestAnimationFrame(() => this.calculateHeights()),
              this.getTypeOfIntersecting(),
              this.refreshImagesOffsetValues();
          }
          sync() {
            const t = this.singleText ? [] : this.text;
            [...this.image, ...t, ...this.dot].forEach((t) => {
              const e = Number(t.getAttribute(wE));
              t.classList.toggle(kE, e === Number(this.activeIndex));
            }),
              this.textHighlight.forEach((t) => t.shouldAnimate());
          }
          syncDots() {
            this.dot.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(),
                  this.scrollTo(this.image[Number(t.target.dataset.index)]);
              });
            });
          }
          scrollTo(t, e = 0) {
            if (!t) return;
            const i = Number(t.dataset.index),
              s = Math.round(t.getBoundingClientRect().top + window.scrollY),
              o = t.offsetHeight,
              n = Math.round(
                this.wrapper.getBoundingClientRect().top + window.scrollY
              ),
              r = this.aside.getBoundingClientRect().top - this.headerHeight,
              a = n + this.images.offsetHeight * i,
              l = Boolean(
                (this.image[0].offsetHeight + this.gutters) /
                  (window.innerHeight - this.headerHeight) >=
                  1
              );
            let c = a - this.headerHeight;
            if (
              (ke() &&
                (c =
                  r +
                  window.scrollY +
                  (this.bottomEndingPoint / (this.image.length - 1)) * i),
              this.horizontalScroll && Le() && !l)
            ) {
              const t = r - this.innerStickyTop;
              c =
                (this.hasShortImages
                  ? t + window.scrollY
                  : r + window.scrollY) +
                (this.bottomEndingPoint / (this.image.length - 1)) * i;
            }
            this.verticalScroll &&
              Le() &&
              ((c = s - this.headerHeight),
              this.typeOfIntersecting === LE.middleOfViewport &&
                (c = s - window.innerHeight / 2 + o / 2 - this.headerHeight));
            const h = { top: c, left: 0, behavior: "smooth" };
            e > 0
              ? setTimeout(() => window.scrollTo(h), e)
              : window.scrollTo(h);
          }
          onUnload() {
            this.image.forEach((t) => this.observer.unobserve(t)),
              document.removeEventListener(
                "theme:scroll",
                this.onScrollCallback
              ),
              document.removeEventListener(
                "theme:resize:width",
                this.onResizeCallback
              );
          }
          onBlockSelect(t) {
            this.scrollTo(t.target, 500);
          }
          constructor(t) {
            (this.container = t.container),
              (this.scrollDirection = this.container.dataset.scrollDirection),
              (this.horizontalScroll =
                this.scrollDirection === EE.horizontal ||
                this.scrollDirection === EE.horizontalReversed),
              (this.verticalScroll =
                this.scrollDirection === EE.vertical ||
                this.scrollDirection === EE.verticalReversed),
              (this.reverseDirection =
                this.scrollDirection === EE.horizontalReversed ||
                this.scrollDirection === EE.verticalReversed),
              (this.direction = this.reverseDirection ? 1 : -1),
              (this.withGaps = this.container.hasAttribute(vE)),
              (this.singleText = this.container.hasAttribute(bE)),
              (this.image = this.container.querySelectorAll(uE)),
              (this.text = this.container.querySelectorAll(hE)),
              (this.textInner = this.container.querySelectorAll(dE)),
              (this.images = this.container.querySelector(pE)),
              (this.dot = this.container.querySelectorAll(fE)),
              (this.aside = this.container.querySelector(aE)),
              (this.inner = this.container.querySelector(lE)),
              (this.content = this.container.querySelector(cE)),
              (this.wrapper = this.container.querySelector(rE)),
              (this.textHighlight = this.container.querySelectorAll(yE)),
              (this.performAnimation = null),
              (this.lastOffset = 0),
              (this.activeIndex = 0),
              (this.lastActiveIndex = this.activeIndex),
              this.wrapper &&
                ((this.onScrollCallback = () => this.onScroll()),
                (this.onResizeCallback = () => this.onResize()),
                (this.calculateImagesOffsetCallback = () =>
                  this.calculateImagesOffset()),
                this.init());
          }
        })(this);
      },
      onUnload() {
        AE[this.id].onUnload();
      },
      onBlockSelect(t) {
        AE[this.id].onBlockSelect(t);
      },
    },
    Pm,
  ]),
    P("subcollections", Bf),
    P("tab-collections", [wo, Bf, br]);
  const CE = {},
    qE = "[data-slider]",
    TE = "[data-item]",
    PE = "a, button",
    xE = ".flickity-button",
    IE = "flickity-enabled",
    HE = "has-arrows",
    FE = "carousel--resize",
    ME = "flickity-button-holder",
    DE = "is-selected",
    OE = "data-section-id",
    BE = "tabindex";
  P("testimonials", {
    onLoad() {
      CE[this.id] = new (class {
        init() {
          this.checkSlideCount(), this.listen();
        }
        onResize() {
          this.checkSlideCount(),
            null !== this.flkty &&
              (this.flkty.resize(),
              this.flkty.size.width >= this.flkty.slideableWidth &&
                this.destroySlider());
        }
        checkSlideCount() {
          const t = this.slides.length,
            e = Boolean(2 == t && window.innerWidth >= theme.sizes.small),
            i = Boolean(1 == t);
          if (!e && !i)
            return this.flkty
              ? void (
                  this.flkty &&
                  (this.flkty.isActive || this.initSlider(),
                  this.flkty.slideableWidth > this.flkty.size.width
                    ? this.initSlider()
                    : this.destroySlider())
                )
              : (this.initSlider(), void this.onResize());
          this.destroySlider();
        }
        initSlider() {
          (this.flkty = new e(this.slider, {
            cellSelector: TE,
            prevNextButtons: !0,
            pageDots: !0,
            groupCells: !0,
            cellAlign: this.alignment,
            contain: !0,
            adaptiveHeight: !1,
            on: {
              ready: () => {
                this.slidesTabIndex(),
                  requestAnimationFrame(() => {
                    this.slider.querySelectorAll(xE).forEach((t) => {
                      ht(t, ME);
                    });
                  });
              },
              change: () => {
                this.slidesTabIndex();
              },
            },
          })),
            ke()
              ? this.container.classList.remove(HE)
              : this.container.classList.add(HE),
            this.createResizeClass();
        }
        createResizeClass() {
          if ("function" == typeof e.prototype._createResizeClass) return;
          (e.prototype._createResizeClass = function () {
            this.element.classList.add(FE);
          }),
            e.createMethods.push("_createResizeClass");
          const t = e.prototype.resize;
          e.prototype.resize = function () {
            this.element.classList.remove(FE),
              t.call(this),
              this.element.classList.add(FE);
          };
        }
        slidesTabIndex() {
          e.data(this.slider).cells.forEach((t) => {
            let e = "-1";
            t.element.classList.contains(DE) && (e = "0"),
              t.element.querySelectorAll(PE).forEach((t) => {
                t.setAttribute(BE, e);
              });
          });
        }
        destroySlider() {
          var t;
          this.slider.classList.contains(IE) &&
            (null !== this.flkty &&
              (null === (t = this.slider.querySelectorAll(xE)) ||
                void 0 === t ||
                t.forEach((t) => {
                  const e = t.parentNode;
                  e &&
                    e.classList.contains(ME) &&
                    (e.parentNode.insertBefore(t, e),
                    e.parentNode.removeChild(e));
                }),
              this.flkty.destroy()),
            this.container.classList.remove(HE));
        }
        listen() {
          document.addEventListener(
            "theme:resize:width",
            this.onResizeCallback
          );
        }
        onBlockSelect(t) {
          if (null !== this.flkty && this.flkty.isActive) {
            const e = parseInt(
                [...t.target.parentNode.children].indexOf(t.target)
              ),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i),
              o = () => {
                requestAnimationFrame(() => {
                  this.flkty.select(s);
                }),
                  this.flkty.element.removeEventListener("transitionend", o);
              };
            this.flkty.element.addEventListener("transitionend", o);
          }
        }
        onUnload() {
          document.removeEventListener(
            "theme:resize:width",
            this.onResizeCallback
          );
        }
        constructor(t) {
          (this.container = t.container),
            (this.sectionId = this.container.getAttribute(OE)),
            (this.slider = this.container.querySelector(qE)),
            (this.alignment = this.slider.dataset.sliderAlignment),
            this.slider &&
              ((this.slides = this.slider.querySelectorAll(TE)),
              (this.flkty = null),
              (this.onResizeCallback = () => this.onResize()),
              this.init());
        }
      })(this);
    },
    onUnload(t) {
      CE[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      CE[this.id].onBlockSelect(t);
    },
  });
  const zE = "[data-hero-scrolling]",
    _E = "[data-banner-title]",
    $E = ".lazy-image",
    RE =
      '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    VE = ".text-reveal__cropper",
    NE = "[data-aos]",
    WE = "[data-ticker-frame]",
    UE = "[data-ticker-scale]",
    jE = "[data-ticker-text]",
    GE = "data-shopify-editor-block",
    KE = "banner--no-cached-images",
    QE = "banner--img-loaded",
    XE = "img-in",
    YE = "overflow-hidden",
    JE = "text-highlight-wrapper",
    ZE = "ticker--animated",
    tL = "data-stop",
    eL = "style",
    iL = {};
  P("hero-scrolling", [
    {
      onLoad() {
        iL[this.id] = new (class {
          init() {
            if (
              (this.handleImageAnimation(!0),
              this.initTickers(!0),
              this.tickerAnimationPause(),
              this.container.matches(RE) &&
                (this.parallax = new pp(this.container)),
              this.title && !this.title.classList.contains(JE))
            ) {
              const t = this.title.querySelector(NE);
              if (!t) return;
              const e = t.closest(VE);
              null == e || e.classList.add(YE),
                kt(t).then(() => {
                  null == e || e.classList.remove(YE);
                });
            }
          }
          initTickers(t = !1) {
            this.container.querySelectorAll(WE).forEach((e) => {
              const i = new Qu(e, t);
              this.tickers.push(i);
            });
          }
          toggleTicker(t, e) {
            if ("scrolling_text" !== t.target.blockData.type) return;
            const i = t.target.closest(UE),
              s = i.querySelector(`[${GE}*="${t.target.blockData.id}"]`);
            e &&
              s &&
              (i.setAttribute(tL, ""),
              i.querySelectorAll(jE).forEach((t) => {
                t.classList.remove(ZE),
                  (t.style.transform = `translate3d(${-s.offsetLeft}px, 0, 0)`);
              })),
              !e &&
                s &&
                (i.querySelectorAll(jE).forEach((t) => {
                  t.classList.add(ZE), t.removeAttribute(eL);
                }),
                i.removeAttribute(tL),
                this.static &&
                  document.dispatchEvent(
                    new CustomEvent("theme:resize:width", { bubbles: !0 })
                  ));
          }
          onBlockSelect(t) {
            this.toggleTicker(t, !0);
          }
          onBlockDeselect(t) {
            this.toggleTicker(t, !1);
          }
          handleImageAnimation(t = !1) {
            if (!t)
              return (
                this.container.classList.remove(KE),
                void this.container.classList.remove(QE)
              );
            const e = this.container.querySelector(zE).querySelectorAll($E),
              i = this.container.classList.contains(XE);
            if (e.length && !i) {
              this.container.classList.add(KE);
              const t = (i) => {
                requestAnimationFrame(() => this.container.classList.add(QE)),
                  e[0].removeEventListener("transitionend", t);
              };
              e[0].addEventListener("transitionend", t);
            }
          }
          onReorder() {
            this.handleImageAnimation(!1);
          }
          onUnload() {
            this.handleImageAnimation(!1),
              this.parallax && (this.parallax.unload(), (this.parallax = null)),
              this.tickers.length > 0 &&
                this.tickers.forEach((t) => {
                  t.unload();
                });
          }
          tickerAnimationPause() {
            let t = 0,
              e = !1;
            const i = this.container.querySelector(WE);
            i &&
              (i.addEventListener("mouseenter", () => {
                (e = !0),
                  (t = setTimeout(() => {
                    e &&
                      i.querySelectorAll(jE).forEach((t) => {
                        t.style.animationPlayState = "paused";
                      }),
                      clearTimeout(t);
                  }, 500));
              }),
              i.addEventListener("mouseleave", () => {
                (e = !1),
                  i.querySelectorAll(jE).forEach((t) => {
                    t.style.animationPlayState = "running";
                  });
              }));
          }
          constructor(t) {
            (this.container = t.container),
              (this.title = this.container.querySelector(_E)),
              (this.parallax = null),
              (this.tickers = []),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        iL[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        iL[this.id].onBlockDeselect(t);
      },
      onReorder(t) {
        iL[this.id].onReorder(t);
      },
      onUnload(t) {
        iL[this.id].onUnload(t);
      },
    },
    Pm,
  ]);
  const sL = "no-outline",
    oL = "[data-skip-content]",
    nL = 'a[href="#"]';
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${(() => {
      const t = document.createElement("div");
      (t.style.visibility = "hidden"),
        (t.style.overflow = "scroll"),
        (t.style.msOverflowStyle = "scrollbar"),
        document.body.appendChild(t);
      const e = document.createElement("div");
      t.appendChild(e);
      const i = t.offsetWidth - e.offsetWidth;
      return t.parentNode.removeChild(t), i;
    })()}px`
  ),
    document.addEventListener("DOMContentLoaded", function () {
      x("*"),
        new (class {
          init() {
            (this.body = document.body),
              (this.inPageLink = document.querySelector(oL)),
              (this.linkesWithOnlyHash = document.querySelectorAll(nL)),
              (this.isFocused = !1),
              this.focusHash(),
              this.bindInPageLinks(),
              this.clickEvents(),
              this.focusEvents(),
              this.focusEventsOff();
          }
          clickEvents() {
            this.inPageLink &&
              this.inPageLink.addEventListener("click", (t) => {
                t.preventDefault();
              }),
              this.linkesWithOnlyHash &&
                this.linkesWithOnlyHash.forEach((t) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                  });
                });
          }
          focusEvents() {
            document.addEventListener("keyup", (t) => {
              t.code === theme.keyboardKeys.TAB &&
                (this.body.classList.remove(sL), (this.isFocused = !0));
            });
          }
          focusEventsOff() {
            document.addEventListener("mousedown", () => {
              this.body.classList.add(sL), (this.isFocused = !1);
            });
          }
          forceFocus(t, e) {
            e = e || {};
            var i = t.tabIndex;
            (t.tabIndex = -1),
              (t.dataset.tabIndex = i),
              t.focus(),
              void 0 !== e.className && t.classList.add(e.className),
              t.addEventListener("blur", function s(o) {
                o.target.removeEventListener(o.type, s),
                  (t.tabIndex = i),
                  delete t.dataset.tabIndex,
                  void 0 !== e.className && t.classList.remove(e.className);
              });
          }
          focusHash(t) {
            t = t || {};
            let e = window.location.hash;
            void 0 !== theme.settings.newHash &&
              ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
            const i = document.getElementById(e.slice(1));
            if (i && t.ignore && i.matches(t.ignore)) return !1;
            e && i && this.forceFocus(i, t);
          }
          bindInPageLinks(t) {
            return (
              (t = t || {}),
              Array.prototype.slice
                .call(document.querySelectorAll('a[href^="#"]'))
                .filter((e) => {
                  if ("#" === e.hash || "" === e.hash) return !1;
                  if (t.ignore && e.matches(t.ignore)) return !1;
                  if (
                    ((i = e.hash.substr(1)),
                    null === document.getElementById(i))
                  )
                    return !1;
                  var i,
                    s = document.querySelector(e.hash);
                  return (
                    !!s &&
                    (e.addEventListener("click", () => {
                      this.forceFocus(s, t);
                    }),
                    !0)
                  );
                })
            );
          }
          constructor() {
            this.init();
          }
        })(),
        customElements.get("product-grid-item-swatch") ||
          "disabled" == window.theme.settings.colorSwatchesType ||
          customElements.define("product-grid-item-swatch", co);
      "scrollBehavior" in document.documentElement.style ||
        di({ url: theme.assets.smoothscroll });
    });
})(
  themeVendor.ScrollLock,
  themeVendor.Flickity,
  themeVendor.themeCurrency,
  themeVendor.ajaxinate
);
